webpackJsonp([49],{

/***/ 102:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return curriedTranslate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeLocaleFromHref; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return toLocalized; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return injectLocationIntoHref; });
/* unused harmony export disableLocation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return setActiveLocations; });
/* unused harmony export getCurrentLocation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return replaceRegion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAllLocations; });
/* unused harmony export getDateFnsLocale */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getFormattedDateFns; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_intl_messageformat__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_intl_messageformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_intl_messageformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_constants_locale__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_regions_cities_json__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_regions_cities_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shared_constants_json_regions_cities_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_locale_uk__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_locale_ru__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_format__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_helpers_arrays__ = __webpack_require__(104);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }









var translateBasic = function translateBasic(string, messages) {
  return typeof string === 'string' && messages[string] ? messages[string] : string;
};

var curriedTranslate = function curriedTranslate(messages) {
  return function (string, data) {
    if (data) {
      var dat = {};
      Object.keys(data).map(function (a) {
        dat[a] = String(data[a]);
        return '';
      });
      return new __WEBPACK_IMPORTED_MODULE_0_intl_messageformat___default.a(translateBasic.call(null, string, messages)).format(dat);
    }
    return translateBasic.call(null, string, messages);
  };
};
var removeLocaleFromHref = function removeLocaleFromHref(href) {
  var regexp = new RegExp('/(' + __WEBPACK_IMPORTED_MODULE_1_shared_constants_locale__["a" /* AVAILABLE_LOCALES */].join('|') + ')/');
  return href.replace(regexp, '/');
};

var toLocalized = function toLocalized(href, locale) {
  if (!href || !locale || locale === __WEBPACK_IMPORTED_MODULE_1_shared_constants_locale__["a" /* AVAILABLE_LOCALES */][0] || __WEBPACK_IMPORTED_MODULE_1_shared_constants_locale__["a" /* AVAILABLE_LOCALES */].find(function (l) {
    return href.startsWith('/' + l + '/');
  })) {
    return href ? href.replace(/\/\//g, '/') : href;
  }

  return href.startsWith('/') ? ('/' + locale + href).replace(/\/\//g, '/') : href.replace(/\/\//g, '/');
};

var injectLocationIntoHref = function injectLocationIntoHref(href, locationSlug) {
  return (href + '/' + locationSlug + '/').replace(/\/\//g, '/');
};

var disableLocation = function disableLocation(seoLocations, location) {
  if (!seoLocations) return true;

  if (location.is_region) {
    var arr = location.children.map(function (regItem) {
      return seoLocations.find(function (seoItem) {
        return seoItem.id === regItem.id;
      });
    });
    return arr.filter(function (res) {
      return res;
    }).length;
  }
  return !!seoLocations.find(function (item) {
    return item.id === location.id;
  });
};

var setActiveLocations = function setActiveLocations(seoLocations, selectedLocation) {
  return function (location) {
    return _extends({}, location, {
      disabled: !disableLocation(seoLocations, location),
      selectedLocation: selectedLocation && selectedLocation.id === location.id
    });
  };
};

var getCurrentLocation = function getCurrentLocation(Geocode, _this, coords, LOCATIONS, Cookies) {
  var KYIV_PLACE_ID = 'ChIJBUVa4U7P1EARcgG8M175HHk';
  var COOKIES_LOCATION = 'current_location';
  var latitude = coords.latitude,
      longitude = coords.longitude;


  Geocode.setApiKey('AIzaSyBPak0kWjgy0cLE5vtaHXdbzECMkGu54S0');
  Geocode.setLanguage('ru');

  var cityName = '';

  Geocode.fromLatLng(latitude, longitude).then(function (response) {
    response.results.map(function (item) {
      if (item.types && item.types.includes('administrative_area_level_2') && item.place_id === KYIV_PLACE_ID) response.results.map(function (value) {
        if (value.types && value.types.includes('postal_code')) {
          value.address_components.map(function (data) {
            if (data.types && data.types.includes('locality')) cityName = data.long_name;
          });
        }
      });else if (item.types && item.types.includes('postal_code')) response.results.map(function (value) {
        value.address_components.map(function (data) {
          if (data.types && data.types.includes('locality')) cityName = data.long_name;
        });
      });
    });
    var selLocation = null;

    if (cityName) selLocation = LOCATIONS.find(function (item) {
      return item.title && item.title === cityName;
    });
    if (selLocation) {
      Cookies.set(COOKIES_LOCATION, selLocation);
      _this.props.selectedActions.set.location(selLocation);
    }
  }, function (error) {});
};

var replaceRegion = function replaceRegion(string) {
  return string.includes('область') ? string.replace('область', 'обл.') : string;
};

var getAllLocations = function getAllLocations() {
  var _allLocations;

  var hideRegions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var allLocations = [];

  allLocations = (_allLocations = allLocations).concat.apply(_allLocations, _toConsumableArray(__WEBPACK_IMPORTED_MODULE_2_shared_constants_json_regions_cities_json___default.a.map(function (item) {
    return item.children;
  }))).sort(__WEBPACK_IMPORTED_MODULE_6_shared_helpers_arrays__["b" /* compareByTitle */]);

  return hideRegions ? allLocations : [].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2_shared_constants_json_regions_cities_json___default.a), _toConsumableArray(allLocations));
};

var getDateFnsLocale = function getDateFnsLocale(locale) {
  return locale === __WEBPACK_IMPORTED_MODULE_1_shared_constants_locale__["a" /* AVAILABLE_LOCALES */][0] ? __WEBPACK_IMPORTED_MODULE_4_date_fns_locale_ru__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_3_date_fns_locale_uk__["a" /* default */];
};

var getFormattedDateFns = function getFormattedDateFns(date, formatDate, locale) {
  return __WEBPACK_IMPORTED_MODULE_5_date_fns_format__["default"](new Date(date), formatDate, {
    locale: getDateFnsLocale(locale || __WEBPACK_IMPORTED_MODULE_1_shared_constants_locale__["a" /* AVAILABLE_LOCALES */][1])
  });
};

/***/ }),

/***/ 103:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/modules/googletag/index.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TargetingCheck__ = __webpack_require__(288);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var _ref2 = _jsx('div', {}, void 0, '________________slot_________________');

var _ref3 = _jsx('div', {}, void 0, '________________targeting_________________');

var _ref4 = _jsx('div', {}, void 0, '________________end_block_________________');

var Banners = __WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */](function (_ref) {
  var globals = _ref.globals;
  return {
    targeting: globals.targeting && globals.targeting.targetingSlot
  };
}, function (dispatch) {
  return { dispatch: dispatch };
})((_temp = _class = function (_React$Component) {
  _inherits(Banners, _React$Component);

  function Banners() {
    _classCallCheck(this, Banners);

    return _possibleConstructorReturn(this, (Banners.__proto__ || Object.getPrototypeOf(Banners)).apply(this, arguments));
  }

  _createClass(Banners, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.dispatch(__WEBPACK_IMPORTED_MODULE_2_shared_actions_globals__["c" /* bannerUpdate */]({ id: this.props.id, addComponent: true }));
      __WEBPACK_IMPORTED_MODULE_4__TargetingCheck__["b" /* googletagSlotFn */]({ id: this.props.id, targetingAds: this.props.targetingAds });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      __WEBPACK_IMPORTED_MODULE_4__TargetingCheck__["b" /* googletagSlotFn */]({ id: this.props.id, targetingAds: this.props.targetingAds });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      __WEBPACK_IMPORTED_MODULE_4__TargetingCheck__["b" /* googletagSlotFn */]({ id: this.props.id, targetingAds: this.props.targetingAds });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.dispatch(__WEBPACK_IMPORTED_MODULE_2_shared_actions_globals__["c" /* bannerUpdate */]({ id: this.props.id, deleteComponent: true }));
      __WEBPACK_IMPORTED_MODULE_4__TargetingCheck__["b" /* googletagSlotFn */]({
        id: this.props.id,
        targetingAds: this.props.targetingAds,
        componentWillUnmount: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var dev = false;
      var slot = __WEBPACK_IMPORTED_MODULE_4__TargetingCheck__["b" /* googletagSlotFn */](this.props, true);
      var _props$targeting = this.props.targeting,
          targeting = _props$targeting === undefined ? {} : _props$targeting;

      if ((typeof targeting === 'undefined' ? 'undefined' : _typeof(targeting)) !== 'object') {
        return '';
      }
      return _jsx('div', {
        style: dev ? {
          width: '100%',
          minHeight: '200px',
          backgroundColor: '#ffb900',
          border: '3px solid #a73c3c'
        } : {},
        id: dev ? '' : slot.slotId
      }, void 0, dev ? _jsx(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, _ref2, _jsx(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, ' ', Object.keys(slot).map(function (a) {
        return _jsx('div', {}, a, a, ' : ', a === 'sizes' ? JSON.stringify(slot[a]) : slot[a]);
      })), _ref3, _jsx(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, ' ', Object.keys(targeting).map(function (a) {
        return _jsx('div', {}, a + 'next', a, ' : ', targeting[a]);
      })), _ref4) : '');
    }
  }]);

  return Banners;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.defaultProps = {
  targeting: {},
  id: '',
  targetingAds: null
}, _temp));
// CONCATENATED MODULE: ./src/shared/modules/translit.js


/* harmony default export */ var translit_defaultExport = (function (data, location) {
  var lang = {};
  // eslint-disable-next-line prettier/prettier
  lang.uk = ["Щ", "Я", "Ю", "Ш", "Ч", "Ц", "Х", "Ж", "ЙО", "Х", "Ф", "У", "Т", "С", "Р", "П", "О", "Н", "М", "Л", "К", "ДЖ", "І", "З", "Е", "Д", "Г", "В", "Б", "А", "І", "E", "В", "К", "Ь", "Ь"];
  // eslint-disable-next-line prettier/prettier
  lang.ru = ["Щ", "Я", "Ю", "Ш", "Ч", "Ц", "Х", "Ж", "Ё", "Х", "Ф", "У", "Т", "С", "Р", "П", "О", "Н", "М", "Л", "К", "ДЖ", "И", "З", "Е", "Д", "Г", "В", "Б", "А", "И", "E", "В", "К", "Ь", "Ь"];
  // eslint-disable-next-line prettier/prettier
  lang.en = ["SCH", "YA", "YU", "SH", "CH", "TS", "KH", "ZH", "JO", "H", "F", "U", "T", "S", "R", "P", "O", "N", "M", "L", "K", "J", "I", "Z", "E", "D", "G", "V", "B", "A", "Y", "E", "W", "Q", "'", "`"];
  if (!lang[[location]] || typeof data !== 'string') return data;
  var str = data.toUpperCase();
  for (var a = 0, b = lang.en.length; a < b; a += 1) {
    str = str.replace(new RegExp(lang.en[a], 'g'), lang[location][a]);
  }
  if (!data[1]) return str;
  if (data[1] === data[1].toUpperCase()) {
    return str;
  }
  return replaceToUpperCase(str);
});
// CONCATENATED MODULE: ./src/shared/modules/textErrField.js


/* harmony default export */ var textErrField_defaultExport = (function (val, text, obj) {
  var errText = '';
  if (!val) {
    errText = notEmptyField(val, text);
  }
  if (obj && obj.password && !errText) {
    if (!/[0-9]/.test(val)) {
      errText = 'Пароль не содержит цифр';
    }
    if (/[А-Яа-я]/.test(val)) {
      errText = 'Разрешены только буквы, цифры и общие символы пунктуации';
    }
    if (!/[A-Za-z]/.test(val)) {
      errText = 'Пароль не содержит букв';
    }
    if (val.length < 8) {
      errText = 'Пароль содержит меньше восьми символов';
    }
    if (/\s/.test(val)) {
      errText = 'Пароль не должен содержать пробелов';
    }
  }
  if (obj.bool) {
    return !errText;
  }
  if (errText) {
    return errText;
  }
  return text;
});
// CONCATENATED MODULE: ./src/shared/modules/firms.js
var firms_namespaceObject = {};
__webpack_require__.d(firms_namespaceObject, "company", function() { return company; });
__webpack_require__.d(firms_namespaceObject, "fetchedLinks", function() { return fetchedLinks; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_actions_partsForm__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_constants_api__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_query_string__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var company = function company(data) {
  var store = data.store;

  var _store$getState = store.getState(),
      companys = _store$getState.searchForm.selected.company;

  if (!companys) {
    return store.dispatch(__WEBPACK_IMPORTED_MODULE_0_shared_actions_partsForm__["c" /* partsFormAsyncSetActions */].company(data));
  }
  return false;
};

var fetchedLinks = function fetchedLinks(_ref, g, location) {
  var fetch = _ref.fetch;
  return fetch(__WEBPACK_IMPORTED_MODULE_1_shared_constants_api__["a" /* default */].FIRMS.TAGS_COUNT + '?' + __WEBPACK_IMPORTED_MODULE_2_query_string___default.a.stringify(_extends({}, location && location.id ? { location: location.id } : {}, g))).then(function (r) {
    return r.json();
  });
};
// CONCATENATED MODULE: ./src/shared/modules/targeting.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEmpty__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fromPairs__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fromPairs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fromPairs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_transportTypes_json__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_transportTypes_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shared_constants_json_transportTypes_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_actions_searchForm__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_helpers_locale__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_helpers_adsAndMetrics__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_constants_api__ = __webpack_require__(29);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var targeting__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }










/* harmony default export */ var targeting_defaultExport = ((function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2, seoRes) {
    var store = _ref2.store,
        query = _ref2.query,
        baseUrl = _ref2.baseUrl,
        path = _ref2.path,
        fetch = _ref2.fetch;

    var url, missingVocabularyFields, state, storeLocation, vocabulary, seoResponse, _seoResponse, characteristics, kind, meta, seoQuery, transportType, transportID, fetchedVocabulary, mergedVocabulary, _store$getState, categories, body, a, buf, prevSelectedTransport, storeParams, selected, queryRubric, querySparetype, currency, q, location, seo, targetingArguments;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = __WEBPACK_IMPORTED_MODULE_5_shared_helpers_locale__["e" /* removeLocaleFromHref */](('' + baseUrl + path).replace('//', '/'));
            missingVocabularyFields = [];
            // Skip this route for permalinks

            if (!url.includes('.html')) {
              _context.next = 4;
              break;
            }

            return _context.abrupt('return', null);

          case 4:
            state = store.getState();
            storeLocation = state.globals.location, vocabulary = state.searchForm.vocabulary;
            _context.t0 = seoRes;

            if (_context.t0) {
              _context.next = 11;
              break;
            }

            _context.next = 10;
            return store.dispatch(__WEBPACK_IMPORTED_MODULE_3_shared_actions_globals__["i" /* seoRequest */](url));

          case 10:
            _context.t0 = _context.sent;

          case 11:
            seoResponse = _context.t0;

            if (__WEBPACK_IMPORTED_MODULE_0_lodash_isEmpty___default.a(seoResponse)) {
              seoResponse = {
                characteristics: {},
                firms: true,
                kind: '',
                meta: {
                  description: '',
                  h1: '',
                  title: ''
                }
              };
            }
            store.dispatch(__WEBPACK_IMPORTED_MODULE_3_shared_actions_globals__["A" /* setSeoSearchUrl */](targeting__extends({}, seoResponse, { url: url })));
            _seoResponse = seoResponse, characteristics = _seoResponse.characteristics, kind = _seoResponse.kind, meta = _seoResponse.meta, seoQuery = _objectWithoutProperties(_seoResponse, ['characteristics', 'kind', 'meta']);
            transportType = seoQuery.transport || __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_transportTypes_json___default.a.find(function (i) {
              return i.slug === 'avto';
            });
            transportID = transportType.id;

            if (!vocabulary.categories) {
              missingVocabularyFields.push('categories');
            }
            _context.next = 20;
            return Promise.all(missingVocabularyFields.map(function (field) {
              return __WEBPACK_IMPORTED_MODULE_7_shared_constants_api__["a" /* default */].VOCABULARY[field] ? fetch(__WEBPACK_IMPORTED_MODULE_7_shared_constants_api__["a" /* default */].VOCABULARY[field](transportType.id)).then(function (r) {
                return r.json();
              }).then(function (response) {
                return _defineProperty({}, field, response);
              }) : Promise.resolve({});
            }));

          case 20:
            fetchedVocabulary = _context.sent;
            mergedVocabulary = fetchedVocabulary.reduce(function (results, pair) {
              return targeting__extends({}, results, pair);
            }, {});

            store.dispatch(__WEBPACK_IMPORTED_MODULE_4_shared_actions_searchForm__["o" /* setFormVocabulary */](targeting__extends({}, mergedVocabulary)));
            _store$getState = store.getState(), categories = _store$getState.searchForm.vocabulary.categories;
            body = void 0;
            a = 0;

          case 26:
            if (!(a < categories.length)) {
              _context.next = 34;
              break;
            }

            buf = categories[a] && categories[a].title && categories[a].id;

            if (!(buf && query.category && String(buf) === query.category)) {
              _context.next = 31;
              break;
            }

            body = categories[a];
            return _context.abrupt('break', 34);

          case 31:
            a += 1;
            _context.next = 26;
            break;

          case 34:
            if (!(seoQuery.location && seoQuery.location.is_country)) {
              _context.next = 36;
              break;
            }

            return _context.abrupt('return', null);

          case 36:

            if (storeLocation && storeLocation.is_country) {
              store.dispatch(__WEBPACK_IMPORTED_MODULE_3_shared_actions_globals__["r" /* setLocation */](null));
            }

            prevSelectedTransport = state.searchForm.selected && state.searchForm.selected.transport;

            if (prevSelectedTransport && prevSelectedTransport.id !== transportID) {
              store.dispatch(__WEBPACK_IMPORTED_MODULE_4_shared_actions_searchForm__["k" /* resetAll */]());
            }

            storeParams = __WEBPACK_IMPORTED_MODULE_1_lodash_fromPairs___default.a(Object.entries(store.getState().searchForm.selected).map(function (_ref4) {
              var _ref5 = _slicedToArray(_ref4, 2),
                  key = _ref5[0],
                  value = _ref5[1];

              return [key, value && value.id ? value.id : value];
            }).filter(function (_ref6) {
              var _ref7 = _slicedToArray(_ref6, 2),
                  value = _ref7[1];

              return value && (typeof value === 'string' || typeof value === 'number');
            }));
            selected = store.getState().searchForm.selected || {};
            queryRubric = query.rubric || selected.rubric && selected.rubric.id;
            querySparetype = query.sparetype || selected.sparetype && selected.sparetype.id;
            currency = selected && selected.currency;
            q = targeting__extends({}, storeParams, query, {
              transport: transportID
            }, queryRubric ? {
              rubric: queryRubric
            } : {}, querySparetype ? {
              sparetype: querySparetype
            } : {});
            location = store.getState().globals.location;


            if (seoQuery.make) {
              q.make = seoQuery.make.id;
            }
            if (seoQuery.model) {
              q.model = seoQuery.model.id;
            }
            if (seoQuery.rubric) {
              q.rubric = seoQuery.rubric.id;
            }
            if (seoQuery.part_type) {
              q.sparetype = seoQuery.part_type.id;
            }

            if (seoQuery.location) {
              location = seoQuery.location;
              store.dispatch(__WEBPACK_IMPORTED_MODULE_3_shared_actions_globals__["r" /* setLocation */](seoQuery.location));
            }

            q.location = location && location.id || undefined;
            q.currency = currency.slug;
            seo = targeting__extends({}, seoQuery, location);
            targetingArguments = __WEBPACK_IMPORTED_MODULE_6_shared_helpers_adsAndMetrics__["a" /* getAdsContext */]({
              make: seo.make,
              model: seo.model,
              isMain: seo.isMain,
              isNew: seo.isNew,
              rubric: seo.rubric,
              isCustomCleared: seo.isCustomCleared,
              location: seo.location,
              isCountry: seo.isCountry,
              transport: transportType,
              category: {
                slug: body
              },
              engine: seo.engine,
              dealer: seo.rubric,
              price: __WEBPACK_IMPORTED_MODULE_6_shared_helpers_adsAndMetrics__["b" /* getPriceValuation */]({
                from: q.priceFrom,
                to: q.priceTo
              }, q.currency),
              page: baseUrl.replace(/\//g, ''),
              id: seo.slug
            });

            store.dispatch(__WEBPACK_IMPORTED_MODULE_3_shared_actions_globals__["C" /* setTargetingArguments */](targetingArguments));
            return _context.abrupt('return', {
              targetingArguments: targetingArguments
            });

          case 57:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
})());
// CONCATENATED MODULE: ./src/shared/modules/dataLayer.js
var dataLayer_namespaceObject = {};
__webpack_require__.d(dataLayer_namespaceObject, "manipulation", function() { return manipulation; });
var dataLayer__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var manipulation = function manipulation(_ref) {
  var data = _ref.data,
      pagetype = _ref.pagetype;

  var url = (typeof window === 'undefined' ? 'undefined' : dataLayer__typeof(window)) === 'object' && window.location.href || null;
  var dataLayerObj = {
    dynx_pagetype: pagetype,
    dynx_itemid: [],
    dynx_totalvalue: [],
    url: url
  };
  if (!data) {
    return {
      dynx_pagetype: pagetype,
      url: url
    };
  }
  if (!Array.isArray(data) && data.in_promotion_feed) {
    var priceArr = data.price.filter(function (dat) {
      return dat.currency === 'usd';
    });
    var price = priceArr && priceArr[0] && priceArr[0].value || '';
    return {
      dynx_pagetype: pagetype,
      dynx_itemid: data.id,
      dynx_totalvalue: Number(price),
      url: url
    };
  }
  for (var a = 0, b = data, c = b.length; a < c; a += 1) {
    // eslint-disable-next-line no-continue
    if (!b[a].in_promotion_feed) continue;
    var _priceArr = b[a].price.filter(function (dat) {
      return dat.currency === 'usd';
    });
    var _price = _priceArr && _priceArr[0] && _priceArr[0].value || '';
    dataLayerObj.dynx_itemid.push(b[a].id);
    dataLayerObj.dynx_totalvalue.push(Number(_price));
  }
  if ('url' in dataLayerObj) {
    delete dataLayerObj.url;
  }
  return dataLayerObj;
};
// CONCATENATED MODULE: ./src/shared/modules/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Googletag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return firms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ignoreTopBanner; });
/* unused harmony export translit */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return targeting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return subjectiveText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return stateDataLayer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return notEmptyField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return textErrField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return urlReplace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return urlReplaceSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return replaceToUpperCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return replaceToLowerCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return pluralize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return replaceSpace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return normalizeLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return phoneNormalize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return cityLocale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return transformTrim; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return replaceTransport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return buildInGenitiveCityHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return buildDriveValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return camelCaseToUpperCase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_constants_regexp__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_constants_codeOperators__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__subjectiveText_allText__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__subjectiveText__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__googletag_store__ = __webpack_require__(437);
var modules__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };













var Googletag = Banners;
var firms = firms_namespaceObject;
var ignoreTopBanner = __WEBPACK_IMPORTED_MODULE_8__googletag_store__["a" /* ignoreTopBanner */];
var translit = translit_defaultExport;
var targeting = targeting_defaultExport;
var subjectiveText = __WEBPACK_IMPORTED_MODULE_6__subjectiveText__["a" /* default */];
var stateDataLayer = dataLayer_namespaceObject;
var notEmptyField = function notEmptyField(val, text) {
  return !val ? 'Обязательное поле' : text;
};
var textErrField = textErrField_defaultExport;
var urlReplace = function urlReplace(a) {
  return String(a).replace(/\(/g, '&#40').replace(/\)/g, '&#41').replace(/'/g, '');
};
var urlReplaceSlash = function urlReplaceSlash(a) {
  return String(a).replace(/\/\/|\/\/\//g, '/');
};
// eslint-disable-next-line prettier/prettier
var replaceToUpperCase = function replaceToUpperCase(a) {
  return a === '' ? '' : '' + a[0].toUpperCase() + a.substr(1).toLowerCase();
};
var replaceToLowerCase = function replaceToLowerCase(a) {
  return a === '' ? '' : a.toLowerCase();
};
var pluralize = function pluralize(text, count, endings) {
  if (typeof text !== 'string' || typeof count !== 'number' || !Array.isArray(endings)) {
    return text;
  }
  if ([11, 12, 13, 14].includes(count % 100)) {
    return '' + text + endings[0];
  } else if (count % 10 === 1) {
    return '' + text + endings[1];
  } else if ([2, 3, 4].includes(count % 10)) {
    return '' + text + endings[2];
  }

  return '' + text + endings[0];
};
var replaceSpace = function replaceSpace(a) {
  return a.replace(/\s{1,5}/g, ' ');
};
var normalizeLink = function normalizeLink(link, _ref) {
  var url = _ref.url,
      defaul = _ref.defaul;

  var strUrl = url.indexOf('/' + link);
  if (strUrl !== -1) {
    return url.slice(0, strUrl + link.length + 1);
  }
  return defaul;
};
var phoneNormalize = function phoneNormalize(data) {
  if (typeof data !== 'string') {
    return data;
  }
  var phone = data.replace(/\s/g, '');
  // eslint-disable-next-line no-useless-escape
  if (__WEBPACK_IMPORTED_MODULE_0_shared_constants_regexp__["b" /* default */].phone.test(phone)) phone = String(phone).replace(/[\(\)\s-\+-\-\,\s]{0,}/g, '');
  if (new RegExp('^(' + __WEBPACK_IMPORTED_MODULE_1_shared_constants_codeOperators__["a" /* all */] + ')[0-9]{7}$').test(phone)) phone = '+38' + phone;
  if (new RegExp('^8(' + __WEBPACK_IMPORTED_MODULE_1_shared_constants_codeOperators__["a" /* all */] + ')[0-9]{7}$').test(phone)) phone = '+3' + phone;
  if (new RegExp('^38(' + __WEBPACK_IMPORTED_MODULE_1_shared_constants_codeOperators__["a" /* all */] + ')[0-9]{7}$').test(phone)) phone = '+' + phone;
  if (new RegExp('^[0-9]{12,}$').test(phone)) phone = '+' + phone;
  return phone;
};
var cityLocale = function cityLocale(data, locale, rolle) {
  if (data && rolle && __WEBPACK_IMPORTED_MODULE_5__subjectiveText_allText__["g" /* sity */][data] && __WEBPACK_IMPORTED_MODULE_5__subjectiveText_allText__["g" /* sity */][data][locale] && __WEBPACK_IMPORTED_MODULE_5__subjectiveText_allText__["g" /* sity */][data][locale][rolle]) {
    return __WEBPACK_IMPORTED_MODULE_5__subjectiveText_allText__["g" /* sity */][data][locale][rolle];
  }
  return data;
};
var transformTrim = function transformTrim(value) {
  if (typeof value === 'string') {
    return value.trim().replace(/\s/g, '');
  }
  if ((typeof value === 'undefined' ? 'undefined' : modules__typeof(value)) === 'object') {
    var obj = {};
    Object.keys(value).forEach(function (a) {
      if (typeof value[a] === 'string') {
        obj[a] = value[a].trim();
      }
      obj[a] = value[a];
    });

    return obj;
  }
  return value;
};

var replaceTransport = function replaceTransport(transport) {
  if (transport === 'Грузовые') return 'Грузовики';else if (transport === 'Вантажні') return 'Вантажівки';else if (transport === 'Спецтехника') return 'Спецтехнику';else if (transport === 'Спецтехніка') return 'Спецтехніку';else if (transport === 'легковые') return 'Легковые авто';else if (transport === 'легкові') return 'Легкові авто';
  return transport;
};

var buildInGenitiveCityHeader = function buildInGenitiveCityHeader(genitiveCity) {
  var inSlug = 'в';

  if (genitiveCity === 'Львове') inSlug = 'во';else if (genitiveCity === 'Львові' || genitiveCity === 'Вінниці' || genitiveCity === 'Луцьку') inSlug = 'у';
  return inSlug + ' ' + genitiveCity;
};

var buildDriveValue = function buildDriveValue(driveSelected, t) {
  var drive = driveSelected ? driveSelected + ' ' + t('привод') : '';

  if (driveSelected === 'Повний що підключається') drive = 'Повний привід що підключається';
  return drive;
};

var camelCaseToUpperCase = function camelCaseToUpperCase(link) {
  return link.split('_').map(function (string, index) {
    if (index > 0) return replaceToUpperCase(string);
    return string;
  }).join('');
};

/***/ }),

/***/ 104:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return sliceArrayIntoChunks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getUniqById; });
/* unused harmony export sortByTrueKey */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return sortCollection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cleanArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return compareByTitle; });
/* unused harmony export compareByCount */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return objectToArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getSeoParamsTitles; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var getRange = function getRange() {
  var from = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var to = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var range = [];

  for (var i = parseInt(from, 10); i <= parseInt(to, 10); i += 1) {
    range.push(i);
  }

  return range;
};

var sliceArrayIntoChunks = function sliceArrayIntoChunks(array, chunkSize) {
  var result = [];
  var length = array.length;
  var normalizedChunkSize = Math.ceil(chunkSize);

  for (var i = 0; i < length; i += normalizedChunkSize) {
    result.push(array.slice(i, i + normalizedChunkSize));
  }

  return result;
};

var getUniqById = function getUniqById(items) {
  var result = [];

  items.forEach(function (item) {
    if (!result.map(function (resultItem) {
      return resultItem.id;
    }).includes(item.id)) {
      result.push(item);
    }
  });

  return result;
};

var sortByTrueKey = function sortByTrueKey(sortKey) {
  return function (x, y) {
    if (x[sortKey] === y[sortKey]) return 0;else if (x[sortKey]) return -1;
    return 1;
  };
};

var sortCollection = function sortCollection(arr, param) {
  return arr && arr.sort ? arr.sort(function (a, b) {
    if (!a || !b) {
      return 0;
    }
    if (a[param] > b[param]) {
      return 1;
    }
    if (a[param] < b[param]) {
      return -1;
    }
    return 0;
  }) : arr;
};
var cleanArray = function cleanArray(array) {
  return array.filter(function (x) {
    return !!x;
  });
};

var compareByTitle = function compareByTitle(a, b) {
  var nameA = a.title.toUpperCase();
  var nameB = b.title.toUpperCase();

  if (nameA < nameB) return -1;
  if (nameA > nameB) return 1;
  return 0;
};

var compareByCount = function compareByCount(a, b) {
  return -(parseInt(a.count, 10) - parseInt(b.count, 10));
};

var objectToArray = function objectToArray(object) {
  return Object.entries(object).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    if (typeof value === 'boolean') {
      return value ? key : null;
    }

    return value;
  }).filter(function (element) {
    return element !== null;
  });
};

var getSeoParamsTitles = function getSeoParamsTitles(_ref3, t) {
  var make = _ref3.make,
      model = _ref3.model,
      generation = _ref3.generation,
      gearbox = _ref3.gearbox,
      engine = _ref3.engine,
      body = _ref3.body,
      drive = _ref3.drive,
      isNew = _ref3.isNew,
      location = _ref3.location,
      rubric = _ref3.rubric,
      partType = _ref3.part_type,
      transport = _ref3.transport,
      year = _ref3.year,
      country = _ref3.country;
  return _extends({}, location && location.title ? { location: location.title } : {}, country && country.is_country ? { country: country } : {}, location && location.is_city ? { city: location } : {}, make && make.title ? { make: make.title } : {}, make && make[t('locale') + '_title'] ? { makeTranslate: make[t('locale') + '_title'] } : {}, model && model.title ? { model: model.title } : {}, model && model[t('locale') + '_title'] ? { modelTranslate: model[t('locale') + '_title'] } : {}, generation && generation.title ? { generation: generation.title } : {}, gearbox && gearbox.title ? { gearbox: t(gearbox.title) } : {}, engine && engine.title ? { engine: t(engine.title) } : {}, body && body.title ? { body: t(body.title) } : {}, drive && drive.title ? { drive: t(drive.title) } : {}, isNew ? { isNew: isNew } : {}, rubric && rubric.title ? { rubric: rubric.title } : {}, partType && partType.title ? { partType: partType.title } : {}, partType && partType[t('locale') + '_title'] ? { partTypeUk: partType[t('locale') + '_title'] } : {}, transport && transport.title ? { transport: t(transport.title) } : {}, year ? { year: year } : {});
};

/***/ }),

/***/ 1051:
/***/ (function(module, exports) {

module.exports = {"Винницкая область":{"ru":{"genitive":"Винницкой области","accusative":"Винницкой области"},"uk":{"genitive":"Вінницькій області","accusative":"Вінницької області"}},"Волынская область":{"ru":{"genitive":"Волынской области","accusative":"Волынской области"},"uk":{"genitive":"Волинській області","accusative":"Волинської області"}},"Днепропетровская область":{"ru":{"genitive":"Днепропетровской области","accusative":"Днепропетровской области"},"uk":{"genitive":"Дніпропетровській області","accusative":"Дніпропетровської області"}},"Донецкая область":{"ru":{"genitive":"Донецкой области","accusative":"Донецкой области"},"uk":{"genitive":"Донецькій області","accusative":"Донецької області"}},"Житомирская область":{"ru":{"genitive":"Житомирской области","accusative":"Житомирской области"},"uk":{"genitive":"Житомирській області","accusative":"Житомирської області"}},"Закарпатская область":{"ru":{"genitive":"Закарпатской области","accusative":"Закарпатской области"},"uk":{"genitive":"Закарпатській області","accusative":"Закарпатської області"}},"Запорожская область":{"ru":{"genitive":"Запорожской области","accusative":"Запорожской области"},"uk":{"genitive":"Запорізькій області","accusative":"Запорізької області"}},"Ивано-Франковская область":{"ru":{"genitive":"Ивано-Франковской области","accusative":"Ивано-Франковской области"},"uk":{"genitive":"Івано-Франківській області","accusative":"Івано-Франківської області"}},"Киевская область":{"ru":{"genitive":"Киевской области","accusative":"Киевской области"},"uk":{"genitive":"Київській області","accusative":"Київській області"}},"Кировоградская область":{"ru":{"genitive":"Кировоградской области","accusative":"Кировоградской области"},"uk":{"genitive":"Кіровоградській області","accusative":"Кіровоградської області"}},"Луганская область":{"ru":{"genitive":"Луганской области","accusative":"Луганской области"},"uk":{"genitive":"Луганській області","accusative":"Луганської області"}},"Львовская область":{"ru":{"genitive":"Львовской области","accusative":"Львовской области"},"uk":{"genitive":"Львівській області","accusative":"Львівської області"}},"Николаевская область":{"ru":{"genitive":"Николаевской области","accusative":"Николаевской области"},"uk":{"genitive":"Миколаївській області","accusative":"Миколаївської області"}},"Одесская область":{"ru":{"genitive":"Одесской области","accusative":"Одесской области"},"uk":{"genitive":"Одеській області","accusative":"Одеської області"}},"Полтавская область":{"ru":{"genitive":"Полтавской области","accusative":"Полтавской области"},"uk":{"genitive":"Полтавській області","accusative":"Полтавської області"}},"Ровенская область":{"ru":{"genitive":"Ровенской области","accusative":"Ровенской области"},"uk":{"genitive":"Рівненській області","accusative":"Рівненської області"}},"Сумская область":{"ru":{"genitive":"Сумской области","accusative":"Сумской области"},"uk":{"genitive":"Сумській області","accusative":"Сумської області"}},"Тернопольская область":{"ru":{"genitive":"Тернопольской области","accusative":"Тернопольской области"},"uk":{"genitive":"Тернопільській області","accusative":"Тернопільської області"}},"Харьковская область":{"ru":{"genitive":"Харьковской области","accusative":"Харьковской области"},"uk":{"genitive":"Харківській області","accusative":"Харківської області"}},"Херсонская область":{"ru":{"genitive":"Херсонской области","accusative":"Херсонской области"},"uk":{"genitive":"Херсонській області","accusative":"Херсонської області"}},"Хмельницкая область":{"ru":{"genitive":"Хмельницкой области","accusative":"Хмельницкой области"},"uk":{"genitive":"Хмельницької області","accusative":"Хмельницької області"}},"Черкасская область":{"ru":{"genitive":"Черкасской области","accusative":"Черкасской области"},"uk":{"genitive":"Черкаській області","accusative":"Черкаської області"}},"Черновицкая область":{"ru":{"genitive":"Черновицкой области","accusative":"Черновицкой области"},"uk":{"genitive":"Чернівецькій області","accusative":"Чернівецької області"}},"Черниговская область":{"ru":{"genitive":"Черниговской области","accusative":"Черниговской области"},"uk":{"genitive":"Чернігівській області","accusative":"Чернігівської області"}},"Авдеевка":{"ru":{"genitive":"Авдеевкк","accusative":"Авдеевки"},"uk":{"genitive":"Авдіївці","accusative":"Авдіївки"}},"Александрия":{"ru":{"genitive":"Александрии","accusative":"Александрии"},"uk":{"genitive":"Олександрії","accusative":"Олександрії"}},"Алешки":{"ru":{"genitive":"Алешках","accusative":"Алешки"},"uk":{"genitive":"Олешках","accusative":"Олешкова"}},"Алупка":{"ru":{"genitive":"Алупке","accusative":"Алупки"},"uk":{"genitive":"Алупці","accusative":"Алупки"}},"Алушта":{"ru":{"genitive":"Алуште","accusative":"Алушты"},"uk":{"genitive":"Алушті","accusative":"Алушти"}},"Алчевск":{"ru":{"genitive":"Алчевске","accusative":"Алчевска"},"uk":{"genitive":"Алчевську","accusative":"Алчевська"}},"Ананьев":{"ru":{"genitive":"Ананьеве","accusative":"Ананьева"},"uk":{"genitive":"Ананьїві","accusative":"Ананьєва"}},"Андрушевка":{"ru":{"genitive":"Андрушевке","accusative":"Андрушевки"},"uk":{"genitive":"Андрушівці","accusative":"Андрушівки"}},"Антрацит":{"ru":{"genitive":"Антраците","accusative":"Антрацита"},"uk":{"genitive":"Антрациті","accusative":"Антрациту"}},"Апостолово":{"ru":{"genitive":"Апостолово","accusative":"Апостолова"},"uk":{"genitive":"Апостоловму","accusative":"Апостолова"}},"Армянск":{"ru":{"genitive":"Армянске","accusative":"Армянска"},"uk":{"genitive":"Армянську","accusative":"Армянська"}},"Арциз":{"ru":{"genitive":"Арцизе","accusative":"Арциза"},"uk":{"genitive":"Арцизі","accusative":"Арциза"}},"Ахтырка":{"ru":{"genitive":"Ахтырке","accusative":"Ахтырки"},"uk":{"genitive":"Охтирці","accusative":"Охтирки"}},"Балаклея":{"ru":{"genitive":"Балаклек","accusative":"Балаклеева"},"uk":{"genitive":"Балаклії","accusative":"Балаклієва"}},"Балта":{"ru":{"genitive":"Балте","accusative":"Балты"},"uk":{"genitive":"Балті","accusative":"Балтаы"}},"Бар":{"ru":{"genitive":"Баре","accusative":"Бара"},"uk":{"genitive":"Барі","accusative":"Бара"}},"Барановка":{"ru":{"genitive":"Барановке","accusative":"Барановки"},"uk":{"genitive":"Баранівці","accusative":"Баранівки"}},"Барвенково":{"ru":{"genitive":"Барвенкове","accusative":"Барвенкового"},"uk":{"genitive":"Барвінковому","accusative":"Барвінкового"}},"Батурин":{"ru":{"genitive":"Батурине","accusative":"Батурина"},"uk":{"genitive":"Батурині","accusative":"Батурина"}},"Бахмач":{"ru":{"genitive":"Бахмаче","accusative":"Бахмача"},"uk":{"genitive":"Бахмачі","accusative":"Бахмача"}},"Бахмут":{"ru":{"genitive":"Бахмуте","accusative":"Бахмута"},"uk":{"genitive":"Бахмуті","accusative":"Бахмута"}},"Бахчисарай":{"ru":{"genitive":"Бахчисарае","accusative":"Бахчисарая"},"uk":{"genitive":"Бахчисараї","accusative":"Бахчисарая"}},"Баштанка":{"ru":{"genitive":"Баштанке","accusative":"Баштанки"},"uk":{"genitive":"Баштанці","accusative":"Баштанки"}},"Белая Церковь":{"ru":{"genitive":"Белой Церкове","accusative":"Белой Церкови"},"uk":{"genitive":"Білій Церкві","accusative":"Білої Церкви"}},"Белгород-Днестровский":{"ru":{"genitive":"Белгород-Днестровске","accusative":"Белгород-Днестровска"},"uk":{"genitive":"Білгород-Дністровську","accusative":"Білгород-Дністровського"}},"Белз":{"ru":{"genitive":"Белзе","accusative":"Белза"},"uk":{"genitive":"Белзі","accusative":"Белза"}},"Белицкое":{"ru":{"genitive":"Белицком","accusative":"Белицкого"},"uk":{"genitive":"Білицькому","accusative":"Білицького"}},"Белогорск":{"ru":{"genitive":"Белогорске","accusative":"Белогорска"},"uk":{"genitive":"Білогірську","accusative":"Білогірського"}},"Белозерское":{"ru":{"genitive":"Белозерском","accusative":"Белозерского"},"uk":{"genitive":"Білозерському","accusative":"Білозерського"}},"Белополье":{"ru":{"genitive":"Белополье","accusative":"Белополья"},"uk":{"genitive":"Білопіллі","accusative":"Білопілля"}},"Беляевка":{"ru":{"genitive":"Беляевке","accusative":"Беляевки"},"uk":{"genitive":"Біляївці","accusative":"Біляївки"}},"Бердичев":{"ru":{"genitive":"Бердичеве","accusative":"Бердичева"},"uk":{"genitive":"Бердичеві","accusative":"Бердичева"}},"Бердянск":{"ru":{"genitive":"Бердянске","accusative":"Бердянска"},"uk":{"genitive":"Бердянську","accusative":"Бердянська"}},"Берегово":{"ru":{"genitive":"Берегово","accusative":"Берегова"},"uk":{"genitive":"Береговому","accusative":"Берегова"}},"Бережаны":{"ru":{"genitive":"Бережанах","accusative":"Бережанов"},"uk":{"genitive":"Бережанах","accusative":"Бережанів"}},"Березань":{"ru":{"genitive":"Березани","accusative":"Березаня"},"uk":{"genitive":"Березані","accusative":"Березаня"}},"Березно":{"ru":{"genitive":"Березном","accusative":"Березного"},"uk":{"genitive":"Березному","accusative":"Березного"}},"Березовка":{"ru":{"genitive":"Березовке","accusative":"Березовки"},"uk":{"genitive":"Березівці","accusative":"Березівки"}},"Берестечко":{"ru":{"genitive":"Берестечке","accusative":"Берестечка"},"uk":{"genitive":"Берестечку","accusative":"Берестечка"}},"Берислав":{"ru":{"genitive":"Бериславе","accusative":"Берислава"},"uk":{"genitive":"Бериславі","accusative":"Берислава"}},"Бершадь":{"ru":{"genitive":"Бершаде","accusative":"Бершадь"},"uk":{"genitive":"Бершаді","accusative":"Бершадь"}},"Благовещенское":{"ru":{"genitive":"Благовещенском","accusative":"Благовещенского"},"uk":{"genitive":"Благовіщенському","accusative":"Благовіщенського"}},"Бобринец":{"ru":{"genitive":"Бобринце","accusative":"Бобринца"},"uk":{"genitive":"Бобринці","accusative":"Бобринеця"}},"Бобрка":{"ru":{"genitive":"Бобрке","accusative":"Бобрки"},"uk":{"genitive":"Бібрці","accusative":"Бібрки"}},"Бобровица":{"ru":{"genitive":"Бобровице","accusative":"Бобровицы"},"uk":{"genitive":"Бобровиці","accusative":"Бобровиці"}},"Богодухов":{"ru":{"genitive":"Богодухове","accusative":"Богодухова"},"uk":{"genitive":"Богодухові","accusative":"Богодухіва"}},"Богуслав":{"ru":{"genitive":"Богуславе","accusative":"Богуслава"},"uk":{"genitive":"Богуславі","accusative":"Богуслава"}},"Болград":{"ru":{"genitive":"Болграде","accusative":"Болграда"},"uk":{"genitive":"Болграді","accusative":"Болграда"}},"Болехов":{"ru":{"genitive":"Болехове","accusative":"Болехова"},"uk":{"genitive":"Болехові","accusative":"Болехова"}},"Борзна":{"ru":{"genitive":"Борзной","accusative":"Борзны"},"uk":{"genitive":"Борзні","accusative":"Борзни"}},"Борислав":{"ru":{"genitive":"Бориславе","accusative":"Борислава"},"uk":{"genitive":"Бориславі","accusative":"Борислава"}},"Борисполь":{"ru":{"genitive":"Борисполе","accusative":"Борисполя"},"uk":{"genitive":"Борисполі","accusative":"Борисполя"}},"Борщев":{"ru":{"genitive":"Борщеве","accusative":"Борщева"},"uk":{"genitive":"Борщеві","accusative":"Борщева"}},"Боярка":{"ru":{"genitive":"Боярке","accusative":"Боярки"},"uk":{"genitive":"Боярці","accusative":"Боярки"}},"Бровары":{"ru":{"genitive":"Броварах","accusative":"Броваров"},"uk":{"genitive":"Броварах","accusative":"Броварів"}},"Броды":{"ru":{"genitive":"Бродах","accusative":"Бродов"},"uk":{"genitive":"Бродах","accusative":"Бродів"}},"Брянка":{"ru":{"genitive":"Брянке","accusative":"Брянки"},"uk":{"genitive":"Брянці","accusative":"Брянки"}},"Бурштын":{"ru":{"genitive":"Бурштыне","accusative":"Бурштына"},"uk":{"genitive":"Бурштині","accusative":"Бурштина"}},"Бурынь":{"ru":{"genitive":"Бурыне","accusative":"Бурынь"},"uk":{"genitive":"Бурині","accusative":"Буринь"}},"Буск":{"ru":{"genitive":"Буске","accusative":"Буска"},"uk":{"genitive":"Буську","accusative":"Буська"}},"Буча":{"ru":{"genitive":"Буче","accusative":"Бучы"},"uk":{"genitive":"Бучі","accusative":"Бучі"}},"Бучач":{"ru":{"genitive":"Бучаче","accusative":"Бучача"},"uk":{"genitive":"Бучачі","accusative":"Бучача"}},"Валки":{"ru":{"genitive":"Валках","accusative":"Валкова"},"uk":{"genitive":"Валках","accusative":"Валкова"}},"Вараш":{"ru":{"genitive":"Вараше","accusative":"Вараша"},"uk":{"genitive":"Вараші","accusative":"Вараша"}},"Васильевка":{"ru":{"genitive":"Васильевке","accusative":"Васильевки"},"uk":{"genitive":"Василівці","accusative":"Василівки"}},"Васильков":{"ru":{"genitive":"Василькове","accusative":"Василькова"},"uk":{"genitive":"Василькові","accusative":"Василькова"}},"Ватутине":{"ru":{"genitive":"Ватутином","accusative":"Ватутиного"},"uk":{"genitive":"Ватутіному","accusative":"Ватутіного"}},"Ватутино":{"ru":{"genitive":"Ватутином","accusative":"Ватутиного"},"uk":{"genitive":"Ватутіному","accusative":"Ватутіного"}},"Вашковцы":{"ru":{"genitive":"Вашковцах","accusative":"Вашковцов"},"uk":{"genitive":"Вашківцях","accusative":"Вашківців"}},"Великие Мосты":{"ru":{"genitive":"Великих Мостах","accusative":"Великих Мостов"},"uk":{"genitive":"Великих Мостах","accusative":"Великих Мостів"}},"Верхнеднепровск":{"ru":{"genitive":"Верхнеднепровске","accusative":"Верхнеднепровска"},"uk":{"genitive":"Верхньодніпровську","accusative":"Верхньодніпровська"}},"Верховцево":{"ru":{"genitive":"Верховцевом","accusative":"Верховцевого"},"uk":{"genitive":"Верхівцевому","accusative":"Верхівцевого"}},"Вижница":{"ru":{"genitive":"Вижнице","accusative":"Вижницы"},"uk":{"genitive":"Вижниці","accusative":"Вижниці"}},"Вилково":{"ru":{"genitive":"Вилковом","accusative":"Вилкового"},"uk":{"genitive":"Вилковому","accusative":"Вилкового"}},"Винники":{"ru":{"genitive":"Винниких","accusative":"Винников"},"uk":{"genitive":"Винниках","accusative":"Винників"}},"Виноградов":{"ru":{"genitive":"Виноградове","accusative":"Виноградова"},"uk":{"genitive":"Виноградові","accusative":"Виноградова"}},"Вишневое":{"ru":{"genitive":"Вишневом","accusative":"Вишневого"},"uk":{"genitive":"Вишневому","accusative":"Вишневого"}},"Владимир-Волынский":{"ru":{"genitive":"Владимир-Волынском","accusative":"Владимир-Волынского"},"uk":{"genitive":"Володимир-Волинську","accusative":"Володимир-Волинського"}},"Вознесенск":{"ru":{"genitive":"Вознесенске","accusative":"Вознесенска"},"uk":{"genitive":"Вознесенську","accusative":"Вознесенська"}},"Волноваха":{"ru":{"genitive":"Волновахе","accusative":"Волновахи"},"uk":{"genitive":"Волновасі","accusative":"Волновахи"}},"Волочиск":{"ru":{"genitive":"Волочиске","accusative":"Волочиска"},"uk":{"genitive":"Волочиську","accusative":"Волочиська"}},"Волчанск":{"ru":{"genitive":"Волчанске","accusative":"Волчанска"},"uk":{"genitive":"Вовчанську","accusative":"Вовчанська"}},"Вольногорск":{"ru":{"genitive":"Вольногорске","accusative":"Вольногорска"},"uk":{"genitive":"Вільногірську","accusative":"Вільногірська"}},"Вольнянск":{"ru":{"genitive":"Вольнянске","accusative":"Вольнянска"},"uk":{"genitive":"Вільнянську","accusative":"Вільнянська"}},"Ворожба":{"ru":{"genitive":"Ворожбе","accusative":"Ворожбы"},"uk":{"genitive":"Ворожбі","accusative":"Ворожби"}},"Врадиевка":{"ru":{"genitive":"Врадиевке","accusative":"Врадиевки"},"uk":{"genitive":"Врадіївці","accusative":"Врадіївки"}},"Вышгород":{"ru":{"genitive":"Вышгороде","accusative":"Вышгорода"},"uk":{"genitive":"Вишгороді","accusative":"Вишгорода"}},"Гадяч":{"ru":{"genitive":"Гадяче","accusative":"Гадяча"},"uk":{"genitive":"Гадячі","accusative":"Гадяча"}},"Гайворон":{"ru":{"genitive":"Гайвороне","accusative":"Гайворона"},"uk":{"genitive":"Гайвороні","accusative":"Гайворона"}},"Гайсин":{"ru":{"genitive":"Гайсине","accusative":"Гайсина"},"uk":{"genitive":"Гайсині","accusative":"Гайсина"}},"Галич":{"ru":{"genitive":"Галиче","accusative":"Галича"},"uk":{"genitive":"Галичі","accusative":"Галича"}},"Геническ":{"ru":{"genitive":"Геническе","accusative":"Геническа"},"uk":{"genitive":"Генічеську","accusative":"Генічеська"}},"Герца":{"ru":{"genitive":"Герце","accusative":"Герца"},"uk":{"genitive":"Герці","accusative":"Герца"}},"Глиняны":{"ru":{"genitive":"Глинянах","accusative":"Глинянов"},"uk":{"genitive":"Глинянах","accusative":"Глинянів"}},"Глобино":{"ru":{"genitive":"Глобино","accusative":"Глобиного"},"uk":{"genitive":"Глобиному","accusative":"Глобиного"}},"Глухов":{"ru":{"genitive":"Глухове","accusative":"Глухова"},"uk":{"genitive":"Глухові","accusative":"Глухова"}},"Глыбокая":{"ru":{"genitive":"Глыбокой","accusative":"Глыбокой"},"uk":{"genitive":"Глибокій","accusative":"Глибокої"}},"Гнивань":{"ru":{"genitive":"Гнивани","accusative":"Гнивани"},"uk":{"genitive":"Гнівані","accusative":"Гнівані"}},"Голая Пристань":{"ru":{"genitive":"Голой Пристани","accusative":"Голой Пристани"},"uk":{"genitive":"Голій Пристані","accusative":"Голої Пристані"}},"Горишние Плавни":{"ru":{"genitive":"Горишних Плавнях","accusative":"Горишние Плавни"},"uk":{"genitive":"Горішніх Плавнях","accusative":"Горішні Плавні"}},"Горловка":{"ru":{"genitive":"Горловке","accusative":"Горловки"},"uk":{"genitive":"Горлівці","accusative":"Горлівки"}},"Горняк":{"ru":{"genitive":"Горняке","accusative":"Горняка"},"uk":{"genitive":"Гірнику","accusative":"Гірника"}},"Городенка":{"ru":{"genitive":"Городенке","accusative":"Городенки"},"uk":{"genitive":"Городенці","accusative":"Городенки"}},"Городище":{"ru":{"genitive":"Городищеве","accusative":"Городища"},"uk":{"genitive":"Городищеві","accusative":"Городища"}},"Городня":{"ru":{"genitive":"Городня","accusative":"Городной"},"uk":{"genitive":"Городня","accusative":"Городної"}},"Городок":{"ru":{"genitive":"Городке","accusative":"Городка"},"uk":{"genitive":"Городку","accusative":"Городка"}},"Городок (Хмельницкая обл)":{"ru":{"genitive":"Городке (Хмельницкая обл)","accusative":"Городока (Хмельницкая обл)"},"uk":{"genitive":"Городку (Хмельницька обл)","accusative":"Городока (Хмельницька обл)"}},"Городок (Львовская обл)":{"ru":{"genitive":"Городке (Львовская обл)","accusative":"Городока(Львовская обл)"},"uk":{"genitive":"Городку (Львівська обл)","accusative":"Городока (Львівська обл)"}},"Горохов":{"ru":{"genitive":"Горохове","accusative":"Горохова"},"uk":{"genitive":"Горохові","accusative":"Горохова"}},"Горское":{"ru":{"genitive":"Горском","accusative":"Горского"},"uk":{"genitive":"Гірському","accusative":"Гірського"}},"Гребенка":{"ru":{"genitive":"Гребенке","accusative":"Гребенки"},"uk":{"genitive":"Гребінці","accusative":"Гребінки"}},"Гуляйполе":{"ru":{"genitive":"Гуляйполе","accusative":"Гуляйполя"},"uk":{"genitive":"Гуляйполі","accusative":"Гуляйполя"}},"Дебальцево":{"ru":{"genitive":"Дебальцевом","accusative":"Дебальцевого"},"uk":{"genitive":"Дебальцевому","accusative":"Дебальцевого"}},"Деражня":{"ru":{"genitive":"Деражне","accusative":"Деражни"},"uk":{"genitive":"Деражні","accusative":"Деражні"}},"Дергачи":{"ru":{"genitive":"Дергаче","accusative":"Дергачей"},"uk":{"genitive":"Дергачі","accusative":"Дергачів"}},"Джанкой":{"ru":{"genitive":"Джанком","accusative":"Джанкой"},"uk":{"genitive":"Джанковому","accusative":"Джанкой"}},"Днепр":{"ru":{"genitive":"Днепре","accusative":"Днепра"},"uk":{"genitive":"Дніпрі","accusative":"Дніпроа"}},"Днепрорудное":{"ru":{"genitive":"Днепрорудном","accusative":"Днепрорудного"},"uk":{"genitive":"Дніпрорудному","accusative":"Дніпрорудного"}},"Добромиль":{"ru":{"genitive":"Добромиле","accusative":"Добромиля"},"uk":{"genitive":"Добромилі","accusative":"Добромиля"}},"Доброполье":{"ru":{"genitive":"Добропольном","accusative":"Доброполья"},"uk":{"genitive":"Добропіллі","accusative":"Добропілля"}},"Довжанск":{"ru":{"genitive":"Довжанске","accusative":"Довжанска"},"uk":{"genitive":"Довжанську","accusative":"Довжанська"}},"Докучаевск":{"ru":{"genitive":"Докучаевске","accusative":"Докучаевска"},"uk":{"genitive":"Докучаєвську","accusative":"Докучаєвська"}},"Долина":{"ru":{"genitive":"Долине","accusative":"Долины"},"uk":{"genitive":"Долині","accusative":"Долини"}},"Долинская":{"ru":{"genitive":"Долинской","accusative":"Долинской"},"uk":{"genitive":"Долинській","accusative":"Долинської"}},"Дрогобыч":{"ru":{"genitive":"Дрогобыче","accusative":"Дрогобыча"},"uk":{"genitive":"Дрогобичі","accusative":"Дрогобича"}},"Дружба":{"ru":{"genitive":"Дружбе","accusative":"Дружбы"},"uk":{"genitive":"Дружбі","accusative":"Дружби"}},"Дружковка":{"ru":{"genitive":"Дружковке","accusative":"Дружковки"},"uk":{"genitive":"Дружківці","accusative":"Дружківки"}},"Дубляны":{"ru":{"genitive":"Дублянах","accusative":"Дублянов"},"uk":{"genitive":"Дублянах","accusative":"Дублянів"}},"Дубно":{"ru":{"genitive":"Дубном","accusative":"Дубного"},"uk":{"genitive":"Дубному","accusative":"Дубного"}},"Дубровица":{"ru":{"genitive":"Дубровице","accusative":"Дубровицы"},"uk":{"genitive":"Дубровиці","accusative":"Дубровиці"}},"Дунаевцы":{"ru":{"genitive":"Дунаевцах","accusative":"Дунаевцев"},"uk":{"genitive":"Дунаївцях","accusative":"Дунаївців"}},"Евпатория":{"ru":{"genitive":"Евпатории","accusative":"Евпатории"},"uk":{"genitive":"Євпаторії","accusative":"Євпаторії"}},"Енакиево":{"ru":{"genitive":"Енакиевом","accusative":"Енакиева"},"uk":{"genitive":"Єнакієвому","accusative":"Єнакієва"}},"Жашков":{"ru":{"genitive":"Жашкове","accusative":"Жашкова"},"uk":{"genitive":"Жашкові","accusative":"Жашкова"}},"Ждановка":{"ru":{"genitive":"Ждановке","accusative":"Ждановки"},"uk":{"genitive":"Жданівці","accusative":"Жданівки"}},"Железное":{"ru":{"genitive":"Железном","accusative":"Железного"},"uk":{"genitive":"Залізному","accusative":"Залізного"}},"Желтые Воды":{"ru":{"genitive":"Желтых Водах","accusative":"Желтых Вод"},"uk":{"genitive":"Жовтих Водах","accusative":"Жовтих Вод"}},"Жидачов":{"ru":{"genitive":"Жидачеве","accusative":"Жидачова"},"uk":{"genitive":"Жидачеві","accusative":"Жидачева"}},"Жмеринка":{"ru":{"genitive":"Жмеринке","accusative":"Жмеринки"},"uk":{"genitive":"Жмеринці","accusative":"Жмеринки"}},"Жолква":{"ru":{"genitive":"Жолкве","accusative":"Жолквы"},"uk":{"genitive":"Жовкві","accusative":"Жовкви"}},"Заводское":{"ru":{"genitive":"Заводском","accusative":"Заводского"},"uk":{"genitive":"Заводському","accusative":"Заводського"}},"Залещики":{"ru":{"genitive":"Залещиках","accusative":"Залещиков"},"uk":{"genitive":"Заліщиках","accusative":"Заліщиків"}},"Заставна":{"ru":{"genitive":"Заставной","accusative":"Заставной"},"uk":{"genitive":"Заставній","accusative":"Заставної"}},"Збараж":{"ru":{"genitive":"Збараже","accusative":"Збаража"},"uk":{"genitive":"Збаражі","accusative":"Збаража"}},"Зборов":{"ru":{"genitive":"Зборове","accusative":"Зборова"},"uk":{"genitive":"Зборові","accusative":"Зборова"}},"Звенигородка":{"ru":{"genitive":"Звенигородке","accusative":"Звенигородки"},"uk":{"genitive":"Звенигородці","accusative":"Звенигородки"}},"Здолбунов":{"ru":{"genitive":"Здолбунове","accusative":"Здолбунова"},"uk":{"genitive":"Здолбунові","accusative":"Здолбунова"}},"Зеленодольск":{"ru":{"genitive":"Зеленодольске","accusative":"Зеленодольска"},"uk":{"genitive":"Зеленодольську","accusative":"Зеленодольська"}},"Зеньков":{"ru":{"genitive":"Зенькове","accusative":"Зенькова"},"uk":{"genitive":"Зінькові","accusative":"Зінькова"}},"Змиев":{"ru":{"genitive":"Змиеве","accusative":"Змиева"},"uk":{"genitive":"Змієві","accusative":"Зміїва"}},"Знаменка":{"ru":{"genitive":"Знаменке","accusative":"Знаменки"},"uk":{"genitive":"Знам'янці","accusative":"Знам'янки"}},"Золотое":{"ru":{"genitive":"Золотом","accusative":"Золотого"},"uk":{"genitive":"Золотому","accusative":"Золотого"}},"Золотоноша":{"ru":{"genitive":"Золотоноше","accusative":"Золотоношы"},"uk":{"genitive":"Золотоноші","accusative":"Золотоноші"}},"Золочев":{"ru":{"genitive":"Золочеве","accusative":"Золочева"},"uk":{"genitive":"Золочеві","accusative":"Золочева"}},"Зугрэс":{"ru":{"genitive":"Зугрэсе","accusative":"Зугрэса"},"uk":{"genitive":"Зугресі","accusative":"Зугреса"}},"Измаил":{"ru":{"genitive":"Измаиле","accusative":"Измаила"},"uk":{"genitive":"Ізмаїлі","accusative":"Ізмаїла"}},"Изюм":{"ru":{"genitive":"Изюме","accusative":"Изюма"},"uk":{"genitive":"Ізюмі","accusative":"Ізюма"}},"Изяслав":{"ru":{"genitive":"Изяславе","accusative":"Изяслава"},"uk":{"genitive":"Ізяславі","accusative":"Ізяслава"}},"Иловайск":{"ru":{"genitive":"Иловайске","accusative":"Иловайска"},"uk":{"genitive":"Іловайську","accusative":"Іловайська"}},"Ильинцы":{"ru":{"genitive":"Ильинцах","accusative":"Ильинцов"},"uk":{"genitive":"Іллінцях","accusative":"Іллінців"}},"Ирпень":{"ru":{"genitive":"Ирпене","accusative":"Ирпеня"},"uk":{"genitive":"Ірпені","accusative":"Ірпіня"}},"Иршава":{"ru":{"genitive":"Иршаве","accusative":"Иршавы"},"uk":{"genitive":"Іршаві","accusative":"Іршави"}},"Ичня":{"ru":{"genitive":"Ичне","accusative":"Ични"},"uk":{"genitive":"Ічні","accusative":"Ічні"}},"Кагарлык":{"ru":{"genitive":"Кагарлыке","accusative":"Кагарлыка"},"uk":{"genitive":"Кагарлику","accusative":"Кагарлика"}},"Кадеевка":{"ru":{"genitive":"Кадеевке","accusative":"Кадеевки"},"uk":{"genitive":"Кадіївці","accusative":"Кадіївки"}},"Казатин":{"ru":{"genitive":"Казатине","accusative":"Казатина"},"uk":{"genitive":"Козятині","accusative":"Козятина"}},"Калиновка":{"ru":{"genitive":"Калиновке","accusative":"Калиновки"},"uk":{"genitive":"Калинівці","accusative":"Калинівки"}},"Калуш":{"ru":{"genitive":"Калуше","accusative":"Калуша"},"uk":{"genitive":"Калуші","accusative":"Калуша"}},"Каменец-Подольский":{"ru":{"genitive":"Каменец-Подольском","accusative":"Каменец-Подольска"},"uk":{"genitive":"Кам'янець-Подільському","accusative":"Кам'янець-Подільська"}},"Каменка":{"ru":{"genitive":"Каменке","accusative":"Каменки"},"uk":{"genitive":"Кам'янці","accusative":"Кам'янки"}},"Каменка-Бугская":{"ru":{"genitive":"Каменке-Бугске","accusative":"Каменки-Бугской"},"uk":{"genitive":"Кам'янці-Бузькі","accusative":"Кам'янки-Бузької"}},"Каменка-Днепровская":{"ru":{"genitive":"Каменке-Днепровске","accusative":"Каменки-Днепровской"},"uk":{"genitive":"Кам'янці-Дніпровську","accusative":"Кам'янки-Дніпровської"}},"Каменское":{"ru":{"genitive":"Каменском","accusative":"Каменского"},"uk":{"genitive":"Кам'янському","accusative":"Кам'янського"}},"Камень-Каширский":{"ru":{"genitive":"Камень-Каширске","accusative":"Камень-Каширского"},"uk":{"genitive":"Камінь-Каширську","accusative":"Камінь-Каширського"}},"Канев":{"ru":{"genitive":"Каневе","accusative":"Канева"},"uk":{"genitive":"Каневі","accusative":"Канова"}},"Карловка":{"ru":{"genitive":"Карловке","accusative":"Карловки"},"uk":{"genitive":"Карлівці","accusative":"Карлівки"}},"Каховка":{"ru":{"genitive":"Каховке","accusative":"Каховки"},"uk":{"genitive":"Каховці","accusative":"Каховки"}},"Керчь":{"ru":{"genitive":"Керче","accusative":"Керчи"},"uk":{"genitive":"Керчі","accusative":"Керчі"}},"Киверцы":{"ru":{"genitive":"Киверцах","accusative":"Киверцов"},"uk":{"genitive":"Ківерцях","accusative":"Ківерців"}},"Килия":{"ru":{"genitive":"Килии","accusative":"Килии"},"uk":{"genitive":"Кілії","accusative":"Кілії"}},"Кировское":{"ru":{"genitive":"Кировском","accusative":"Кировского"},"uk":{"genitive":"Кіровському","accusative":"Кіровського"}},"Кицмань":{"ru":{"genitive":"Кицмане","accusative":"Кицмани"},"uk":{"genitive":"Кіцмані","accusative":"Кіцмані"}},"Кобеляки":{"ru":{"genitive":"Кобеляках","accusative":"Кобеляков"},"uk":{"genitive":"Кобеляках","accusative":"Кобеляків"}},"Ковель":{"ru":{"genitive":"Ковеле","accusative":"Ковеля"},"uk":{"genitive":"Ковелі","accusative":"Ковеля"}},"Кодыма":{"ru":{"genitive":"Кодыме","accusative":"Кодыма"},"uk":{"genitive":"Кодимі","accusative":"Кодима"}},"Коломыя":{"ru":{"genitive":"Коломые","accusative":"Коломыи"},"uk":{"genitive":"Коломиї","accusative":"Коломиї"}},"Комарно":{"ru":{"genitive":"Комарном","accusative":"Комарного"},"uk":{"genitive":"Комарному","accusative":"Комарного"}},"Комсомольское":{"ru":{"genitive":"Комсомольском","accusative":"Комсомольского"},"uk":{"genitive":"Кальміуському","accusative":"Кальміуськго"}},"Конотоп":{"ru":{"genitive":"Конотопе","accusative":"Конотопа"},"uk":{"genitive":"Конотопі","accusative":"Конотопа"}},"Константиновка":{"ru":{"genitive":"Константиновке","accusative":"Константиновки"},"uk":{"genitive":"Костянтинівці","accusative":"Костянтинівкаи"}},"Копычинцы":{"ru":{"genitive":"Копычинцах","accusative":"Копычинцов"},"uk":{"genitive":"Копичинцях","accusative":"Копичинців"}},"Корец":{"ru":{"genitive":"Корце","accusative":"Корца"},"uk":{"genitive":"Корці","accusative":"Кірця"}},"Коростень":{"ru":{"genitive":"Коростене","accusative":"Коростеня"},"uk":{"genitive":"Коростені","accusative":"Коростеня"}},"Коростышев":{"ru":{"genitive":"Коростышее","accusative":"Коростышева"},"uk":{"genitive":"Коростишеві","accusative":"Коростишева"}},"Корсунь-Шевченковский":{"ru":{"genitive":"Корсунь-Шевченковском","accusative":"Корсунь-Шевченковского"},"uk":{"genitive":"Корсунь-Шевченківському","accusative":"Корсунь-Шевченківського"}},"Корюковка":{"ru":{"genitive":"Корюковке","accusative":"Корюковка"},"uk":{"genitive":"Корюківці","accusative":"Корюківка"}},"Косов":{"ru":{"genitive":"Косовом","accusative":"Косов"},"uk":{"genitive":"Косовому","accusative":"Косів"}},"Костополь":{"ru":{"genitive":"Костополе","accusative":"Костополь"},"uk":{"genitive":"Костополі","accusative":"Костопіль"}},"Краматорск":{"ru":{"genitive":"Краматорске","accusative":"Краматорск"},"uk":{"genitive":"Краматорську","accusative":"Краматорськ"}},"Красилов":{"ru":{"genitive":"Красилове","accusative":"Красилов"},"uk":{"genitive":"Красилові","accusative":"Красилів"}},"Красногоровка":{"ru":{"genitive":"Красногоровке","accusative":"Красногоровка"},"uk":{"genitive":"Красногорівці","accusative":"Красногорівка"}},"Красноград":{"ru":{"genitive":"Краснограде","accusative":"Краснограда"},"uk":{"genitive":"Краснограді","accusative":"Краснограда"}},"Красноильск":{"ru":{"genitive":"Красноильске","accusative":"Красноильска"},"uk":{"genitive":"Красноїльську","accusative":"Красноїльська"}},"Красноперекопск":{"ru":{"genitive":"Красноперекопске","accusative":"Красноперекопска"},"uk":{"genitive":"Красноперекопську","accusative":"Красноперекопська"}},"Кременец":{"ru":{"genitive":"Кременеце","accusative":"Кременеца"},"uk":{"genitive":"Кременеці","accusative":"Кременеця"}},"Кременная":{"ru":{"genitive":"Кременной","accusative":"Кременной"},"uk":{"genitive":"Кремінній","accusative":"Кремінної"}},"Кременчуг":{"ru":{"genitive":"Кременчуге","accusative":"Кременчуга"},"uk":{"genitive":"Кременчуці","accusative":"Кременчука"}},"Кривое Озеро":{"ru":{"genitive":"Кривом Озере","accusative":"Кривого Озера"},"uk":{"genitive":"Кривому Озері","accusative":"Кривого Озера"}},"Кролевец":{"ru":{"genitive":"Кролевеце","accusative":"Кролевца"},"uk":{"genitive":"Кролевеці","accusative":"Кролевця"}},"Кропивницкий":{"ru":{"genitive":"Кропивницком","accusative":"Кропивницкого"},"uk":{"genitive":"Кропивницькому","accusative":"Кропивницького"}},"Купянск":{"ru":{"genitive":"Купянске","accusative":"Купянска"},"uk":{"genitive":"Куп'янську","accusative":"Куп'янська"}},"Ладыжин":{"ru":{"genitive":"Ладыжином","accusative":"Ладыжного"},"uk":{"genitive":"Ладижиному","accusative":"Ладижного"}},"Лановцы":{"ru":{"genitive":"Лановцах","accusative":"Лановцов"},"uk":{"genitive":"Ланівцях","accusative":"Ланівців"}},"Лебедин":{"ru":{"genitive":"Лебедином","accusative":"Лебединого"},"uk":{"genitive":"Лебединому","accusative":"Лебединого"}},"Липовец":{"ru":{"genitive":"Липовеце","accusative":"Липовца"},"uk":{"genitive":"Липовеці","accusative":"Липовеця"}},"Лисичанск":{"ru":{"genitive":"Лисичанске","accusative":"Лисичанска"},"uk":{"genitive":"Лисичанську","accusative":"Лисичанська"}},"Лозова":{"ru":{"genitive":"Лозовой","accusative":"Лозовой"},"uk":{"genitive":"Лозовій","accusative":"Лозової"}},"Лозовая":{"ru":{"genitive":"Лозовой","accusative":"Лозовой"},"uk":{"genitive":"Лозовій","accusative":"Лозоої"}},"Лохвица":{"ru":{"genitive":"Лохвице","accusative":"Лохвицы"},"uk":{"genitive":"Лохвиці","accusative":"Лохвиці"}},"Лубны":{"ru":{"genitive":"Лубном","accusative":"Лубнов"},"uk":{"genitive":"Лубному","accusative":"Лубнів"}},"Любомль":{"ru":{"genitive":"Любомле","accusative":"Любомля"},"uk":{"genitive":"Любомлі","accusative":"Любомля"}},"Люботин":{"ru":{"genitive":"Люботине","accusative":"Люботина"},"uk":{"genitive":"Люботині","accusative":"Люботина"}},"Макеевка":{"ru":{"genitive":"Макеевке","accusative":"Макеевки"},"uk":{"genitive":"Макіївці","accusative":"Макіївки"}},"Малая Виска":{"ru":{"genitive":"Малой Виски","accusative":"Малой Виски"},"uk":{"genitive":"Малій Висці","accusative":"Малої Виски"}},"Малин":{"ru":{"genitive":"Малине","accusative":"Малина"},"uk":{"genitive":"Малині","accusative":"Малина"}},"Марганец":{"ru":{"genitive":"Марганце","accusative":"Марганца"},"uk":{"genitive":"Марганці","accusative":"Марганця"}},"Мариуполь":{"ru":{"genitive":"Мариуполе","accusative":"Мариуполя"},"uk":{"genitive":"Маріуполі","accusative":"Маріуполя"}},"Марьинка":{"ru":{"genitive":"Марьинке","accusative":"Марьинки"},"uk":{"genitive":"Мар'їнці","accusative":"Мар'їнки"}},"Мелитополь":{"ru":{"genitive":"Мелитополе","accusative":"Мелитополя"},"uk":{"genitive":"Мелітополі","accusative":"Мелітополя"}},"Мена":{"ru":{"genitive":"Мене","accusative":"Мены"},"uk":{"genitive":"Мені","accusative":"Мени"}},"Мерефа":{"ru":{"genitive":"Мерефе","accusative":"Мерефы"},"uk":{"genitive":"Мерефі","accusative":"Мерефи"}},"Миргород":{"ru":{"genitive":"Миргороде","accusative":"Миргорода"},"uk":{"genitive":"Миргороді","accusative":"Миргорода"}},"Мирноград":{"ru":{"genitive":"Мирнограде","accusative":"Мирнограда"},"uk":{"genitive":"Мирнограді","accusative":"Мирнограда"}},"Мироновка":{"ru":{"genitive":"Мироновке","accusative":"Мироновки"},"uk":{"genitive":"Миронівці","accusative":"Миронівки"}},"Могилев-Подольский":{"ru":{"genitive":"Могилев-Подольском","accusative":"Могилев-Подольского"},"uk":{"genitive":"Могилів-Подільському","accusative":"Могилів-Подільського"}},"Молочанск":{"ru":{"genitive":"Молочанске","accusative":"Молочанса"},"uk":{"genitive":"Молочанську","accusative":"Молочанська"}},"Монастыриска":{"ru":{"genitive":"Монастыриске","accusative":"Монастыриской"},"uk":{"genitive":"Монастириську","accusative":"Монастириської"}},"Монастырище":{"ru":{"genitive":"Монастырище","accusative":"Монастырища"},"uk":{"genitive":"Монастирищі","accusative":"Монастирища"}},"Моршин":{"ru":{"genitive":"Моршине","accusative":"Моршина"},"uk":{"genitive":"Моршині","accusative":"Моршина"}},"Мостиска":{"ru":{"genitive":"Мостиской","accusative":"Мостиской"},"uk":{"genitive":"Мостиській","accusative":"Мостиської"}},"Мукачево":{"ru":{"genitive":"Мукачевом","accusative":"Мукачева"},"uk":{"genitive":"Мукачевому","accusative":"Мукачева"}},"Надворная":{"ru":{"genitive":"Надворной","accusative":"Надворной"},"uk":{"genitive":"Надвірній","accusative":"Надвірної"}},"Нежин":{"ru":{"genitive":"Нежине","accusative":"Нежина"},"uk":{"genitive":"Ніжині","accusative":"Ніжина"}},"Немиров":{"ru":{"genitive":"Немирове","accusative":"Немирова"},"uk":{"genitive":"Немиреві","accusative":"Немирова"}},"Нетешин":{"ru":{"genitive":"Нетешине","accusative":"Нетешина"},"uk":{"genitive":"Нетішині","accusative":"Нетішина"}},"Николаев, (Львовская обл)":{"ru":{"genitive":"Николаеве, (Львовская обл)","accusative":"Николаева, (Львовская обл)"},"uk":{"genitive":"Миколаєві, (Львівська обл)","accusative":"Миколаєва, (Львівська обл)"}},"Николаев":{"ru":{"genitive":"Николаеве","accusative":"Николаева"},"uk":{"genitive":"Миколаєві","accusative":"Миколаєва"}},"Николаевка":{"ru":{"genitive":"Николаевке","accusative":"Николаевки"},"uk":{"genitive":"Миколаївці","accusative":"Миколаївки"}},"Никополь":{"ru":{"genitive":"Никополе","accusative":"Никополя"},"uk":{"genitive":"Нікополі","accusative":"Нікополя"}},"Новая Каховка":{"ru":{"genitive":"Новой Каховке","accusative":"Новой Каховки"},"uk":{"genitive":"Новій Каховці","accusative":"Нової Каховки"}},"Новая Одесса":{"ru":{"genitive":"Новой Одессе","accusative":"Новой Одессы"},"uk":{"genitive":"Новій Одесі","accusative":"Нової Одеси"}},"Новгород-Северский":{"ru":{"genitive":"Новгород-Северском","accusative":"Новгород-Северска"},"uk":{"genitive":"Новгород-Сіверську","accusative":"Новгород-Сіверська"}},"Новоград-Волынский":{"ru":{"genitive":"Новоград-Волынском","accusative":"Новоград-Волынска"},"uk":{"genitive":"Новоград-Волинську","accusative":"Новоград-Волинська"}},"Новогродовка":{"ru":{"genitive":"Новогродовке","accusative":"Новогродовки"},"uk":{"genitive":"Новогродівці","accusative":"Новогродівки"}},"Новоднестровск":{"ru":{"genitive":"Новоднестровске","accusative":"Новоднестровска"},"uk":{"genitive":"Новодністровську","accusative":"Новодністровська"}},"Новодружеск":{"ru":{"genitive":"Новодружеске","accusative":"Новодружеска"},"uk":{"genitive":"Новодружеську","accusative":"Новодружеська"}},"Новомиргород":{"ru":{"genitive":"Новомиргороде","accusative":"Новомиргорода"},"uk":{"genitive":"Новомиргороді","accusative":"Новомиргорода"}},"Новомосковск":{"ru":{"genitive":"Новомосковске","accusative":"Новомосковска"},"uk":{"genitive":"Новомосковську","accusative":"Новомосковська"}},"Новоселица":{"ru":{"genitive":"Новоселице","accusative":"Новоселицы"},"uk":{"genitive":"Новоселиці","accusative":"Новоселиці"}},"Новоукраинка":{"ru":{"genitive":"Новоукраинке","accusative":"Новоукраинки"},"uk":{"genitive":"Новоукраїнку","accusative":"Новоукраїнки"}},"Новояворовск":{"ru":{"genitive":"Новояворовске","accusative":"Новояворовска"},"uk":{"genitive":"Новояворівську","accusative":"Новояворівська"}},"Новый Буг":{"ru":{"genitive":"Новом Буге","accusative":"Нового Буга"},"uk":{"genitive":"Новому Бузі","accusative":"Нового Буга"}},"Новый Калинов":{"ru":{"genitive":"Новом Калинове","accusative":"Нового Калинова"},"uk":{"genitive":"Новому Калиневі","accusative":"Нового Калиннова"}},"Новый Роздол":{"ru":{"genitive":"Новом Роздоле","accusative":"Нового Роздола"},"uk":{"genitive":"Новому Роздолі","accusative":"Нового Роздолу"}},"Носовка":{"ru":{"genitive":"Носовке","accusative":"Носовки"},"uk":{"genitive":"Носівці","accusative":"Носівки"}},"Обухов":{"ru":{"genitive":"Обухове","accusative":"Обухова"},"uk":{"genitive":"Обухові","accusative":"Обухіва"}},"Овруч":{"ru":{"genitive":"Овруче","accusative":"Овруча"},"uk":{"genitive":"Овручі","accusative":"Овруча"}},"Олевск":{"ru":{"genitive":"Олевске","accusative":"Олевска"},"uk":{"genitive":"Олевську","accusative":"Олевська"}},"Орехов":{"ru":{"genitive":"Орехове","accusative":"Орехова"},"uk":{"genitive":"Оріхові","accusative":"Оріхова"}},"Остер":{"ru":{"genitive":"Остре","accusative":"Остра"},"uk":{"genitive":"Острі","accusative":"Остра"}},"Острог":{"ru":{"genitive":"Остроге","accusative":"Острога"},"uk":{"genitive":"Острозі","accusative":"Острога"}},"Очаков":{"ru":{"genitive":"Очакове","accusative":"Очакова"},"uk":{"genitive":"Очакові","accusative":"Очакова"}},"Павлоград":{"ru":{"genitive":"Павлограде","accusative":"Павлограда"},"uk":{"genitive":"Павлограді","accusative":"Павлограда"}},"Первомайск":{"ru":{"genitive":"Первомайске","accusative":"Первомайска"},"uk":{"genitive":"Первомайську","accusative":"Первомайська"}},"Первомайский":{"ru":{"genitive":"Первомайском","accusative":"Первомайского"},"uk":{"genitive":"Первомайському","accusative":"Первомайського"}},"Перемышляны":{"ru":{"genitive":"Перемышлянах","accusative":"Перемышлян"},"uk":{"genitive":"Перемишлянах","accusative":"Перемишлян"}},"Перечин":{"ru":{"genitive":"Перечине","accusative":"Перечина"},"uk":{"genitive":"Перечині","accusative":"Перечина"}},"Перещепино":{"ru":{"genitive":"Перещепином","accusative":"Перещепина"},"uk":{"genitive":"Перещепиному","accusative":"Перещепина"}},"Переяслав":{"ru":{"genitive":"Переяславе","accusative":"Переяслава"},"uk":{"genitive":"Переяславі","accusative":"Переяслава"}},"Переяслав-Хмельницкий":{"ru":{"genitive":"Переяслав-Хмельницком","accusative":"Переяслав-Хмельницка"},"uk":{"genitive":"Переяслав-Хмельницкому","accusative":"Переяслав-Хмельницка"}},"Першотравенск":{"ru":{"genitive":"Першотравенском","accusative":"Першотравенска"},"uk":{"genitive":"Першотравенську","accusative":"Першотравенська"}},"Песочин":{"ru":{"genitive":"Песочном","accusative":"Песочина"},"uk":{"genitive":"Пісочному","accusative":"Пісочина"}},"Пивденное (Южное)":{"ru":{"genitive":"Пивденном (Южном)","accusative":"Пивденного (Южного)"},"uk":{"genitive":"Південному","accusative":"Південного"}},"Пирятин":{"ru":{"genitive":"Пирятине","accusative":"Пирятина"},"uk":{"genitive":"Пирятині","accusative":"Пирятина"}},"Погребище":{"ru":{"genitive":"Погребище","accusative":"Погребища"},"uk":{"genitive":"Погребищі","accusative":"Погребища"}},"Подгайцы":{"ru":{"genitive":"Подгайцах","accusative":"Подгайцев"},"uk":{"genitive":"Підгайцях","accusative":"Підгайців"}},"Подгородное":{"ru":{"genitive":"Подгородном","accusative":"Подгородного"},"uk":{"genitive":"Підгороднму","accusative":"Підгородного"}},"Подольск":{"ru":{"genitive":"Подольске","accusative":"Подольска"},"uk":{"genitive":"Подільську","accusative":"Подільська"}},"Покров":{"ru":{"genitive":"Покрове","accusative":"Покрова"},"uk":{"genitive":"Покрові","accusative":"Покрова"}},"Покровск":{"ru":{"genitive":"Покровске","accusative":"Покровского"},"uk":{"genitive":"Покровську","accusative":"Покровського"}},"Пологи":{"ru":{"genitive":"Пологиах","accusative":"Пологов"},"uk":{"genitive":"Пологах","accusative":"Пологів"}},"Полонное":{"ru":{"genitive":"Полонном","accusative":"Полонного"},"uk":{"genitive":"Полонному","accusative":"Полонного"}},"Помошная":{"ru":{"genitive":"Помошной","accusative":"Помошной"},"uk":{"genitive":"Помічній","accusative":"Помічної"}},"Попасная":{"ru":{"genitive":"Попаснтй","accusative":"Попасной"},"uk":{"genitive":"Попасній","accusative":"Попасної"}},"Почаев":{"ru":{"genitive":"Почаеве","accusative":"Почаева"},"uk":{"genitive":"Почаєві","accusative":"Почаєва"}},"Приволье":{"ru":{"genitive":"Приволье","accusative":"Привольного"},"uk":{"genitive":"Привіллі","accusative":"Привілля"}},"Прилуки":{"ru":{"genitive":"Прилуках","accusative":"Прилук"},"uk":{"genitive":"Прилуках","accusative":"Прилук"}},"Приморск":{"ru":{"genitive":"Приморском","accusative":"Приморска"},"uk":{"genitive":"Приморську","accusative":"Приморська"}},"Припять":{"ru":{"genitive":"Припяте","accusative":"Припяти"},"uk":{"genitive":"Прип'яті","accusative":"Прип'яті"}},"Пустомыты":{"ru":{"genitive":"Пустомытах","accusative":"Пустомыт"},"uk":{"genitive":"Пустомитах","accusative":"Пустомит"}},"Путивль":{"ru":{"genitive":"Путивле","accusative":"Путивли"},"uk":{"genitive":"Путивлі","accusative":"Путивлі"}},"Пятихатки":{"ru":{"genitive":"Пятихатках","accusative":"Пятихатков"},"uk":{"genitive":"П'ятихатках","accusative":"П'ятихатків"}},"Рава-Русская":{"ru":{"genitive":"Рава-Русской","accusative":"Равы-Русской"},"uk":{"genitive":"Рава-Руській","accusative":"Рави-Руськаої"}},"Радехов":{"ru":{"genitive":"Радехове","accusative":"Радехова"},"uk":{"genitive":"Радехові","accusative":"Радехова"}},"Радивилов":{"ru":{"genitive":"Радивилове","accusative":"Радивилова"},"uk":{"genitive":"Радивилові","accusative":"Радивилова"}},"Радомышль":{"ru":{"genitive":"Радомышле","accusative":"Радомышля"},"uk":{"genitive":"Радомишлі","accusative":"Радомишля"}},"Раздельная":{"ru":{"genitive":"Раздельной","accusative":"Раздельной"},"uk":{"genitive":"Роздільній","accusative":"Роздільної"}},"Рахов":{"ru":{"genitive":"Рахове","accusative":"Рахова"},"uk":{"genitive":"Рахові","accusative":"Рахова"}},"Рени":{"ru":{"genitive":"Ренм","accusative":"Рени"},"uk":{"genitive":"Ренях","accusative":"Рені"}},"Ржищев":{"ru":{"genitive":"Ржищеве","accusative":"Ржищева"},"uk":{"genitive":"Ржищеві","accusative":"Ржищева"}},"Ровеньки":{"ru":{"genitive":"Ровеньках","accusative":"Ровеньки"},"uk":{"genitive":"Ровеньках","accusative":"Ровеньки"}},"Рогатин":{"ru":{"genitive":"Рогатине","accusative":"Рогатина"},"uk":{"genitive":"Рогатині","accusative":"Рогатина"}},"Родинское":{"ru":{"genitive":"Родинском","accusative":"Родинского"},"uk":{"genitive":"Родинському","accusative":"Родинського"}},"Рожище":{"ru":{"genitive":"Рожище","accusative":"Рожища"},"uk":{"genitive":"Рожищі","accusative":"Рожища"}},"Ромны":{"ru":{"genitive":"Ромнах","accusative":"Ромнов"},"uk":{"genitive":"Ромнах","accusative":"Ромнів"}},"Рубежное":{"ru":{"genitive":"Рубежном","accusative":"Рубежного"},"uk":{"genitive":"Рубіжному","accusative":"Рубіжного"}},"Рудки":{"ru":{"genitive":"Рудках","accusative":"Рудков"},"uk":{"genitive":"Рудках","accusative":"Рудків"}},"Саки":{"ru":{"genitive":"Саках","accusative":"Саков"},"uk":{"genitive":"Саках","accusative":"Саків"}},"Самбор":{"ru":{"genitive":"Самборе","accusative":"Самбора"},"uk":{"genitive":"Самборі","accusative":"Самбора"}},"Сарны":{"ru":{"genitive":"Сарнах","accusative":"Сарнов"},"uk":{"genitive":"Сарнах","accusative":"Сарнів"}},"Свалява":{"ru":{"genitive":"Сваляве","accusative":"Свалявы"},"uk":{"genitive":"Сваляві","accusative":"Сваляви"}},"Сватово":{"ru":{"genitive":"Сватовом","accusative":"Сватового"},"uk":{"genitive":"Сватовому","accusative":"Сватового"}},"Светловодск":{"ru":{"genitive":"Светловодске","accusative":"Светловодска"},"uk":{"genitive":"Світловодську","accusative":"Світловодська"}},"Светлодарск":{"ru":{"genitive":"Светлодарске","accusative":"Светлодарска"},"uk":{"genitive":"Світлодарську","accusative":"Світлодарська"}},"Святогорск":{"ru":{"genitive":"Святогорске","accusative":"Святогорска"},"uk":{"genitive":"Святогірську","accusative":"Святогірська"}},"Севастополь":{"ru":{"genitive":"Севастополье","accusative":"Севастополя"},"uk":{"genitive":"Севастополі","accusative":"Севастопіля"}},"Северодонецк":{"ru":{"genitive":"Северодонецке","accusative":"Северодонецка"},"uk":{"genitive":"Сєвєродонецьку","accusative":"Сєвєродонецька"}},"Северск":{"ru":{"genitive":"Северске","accusative":"Северска"},"uk":{"genitive":"Сіверську","accusative":"Сіверська"}},"Селидово":{"ru":{"genitive":"Селидовом","accusative":"Селидова"},"uk":{"genitive":"Селидовому","accusative":"Селидова"}},"Семеновка":{"ru":{"genitive":"Семеновке","accusative":"Семеновки"},"uk":{"genitive":"Семенівці","accusative":"Семенівки"}},"Середина-Буда":{"ru":{"genitive":"Середине-Буда","accusative":"Середины-Буда"},"uk":{"genitive":"Середині-Буда","accusative":"Середини-Буда"}},"Симферополь":{"ru":{"genitive":"Симферополе","accusative":"Симферополя"},"uk":{"genitive":"Сімферополі","accusative":"Сімферополя"}},"Синельниково":{"ru":{"genitive":"Синельниковом","accusative":"Синельникова"},"uk":{"genitive":"Синельниковому","accusative":"Синельникова"}},"Скадовск":{"ru":{"genitive":"Скадовске","accusative":"Скадовска"},"uk":{"genitive":"Скадовську","accusative":"Скадовська"}},"Скалат":{"ru":{"genitive":"Скалате","accusative":"Скалата"},"uk":{"genitive":"Скалаті","accusative":"Скалата"}},"Сквира":{"ru":{"genitive":"Сквире","accusative":"Сквиры"},"uk":{"genitive":"Сквирі","accusative":"Сквири"}},"Сколе":{"ru":{"genitive":"Сколом","accusative":"Сколого"},"uk":{"genitive":"Сколому","accusative":"Сколого"}},"Славута":{"ru":{"genitive":"Славуте","accusative":"Славуты"},"uk":{"genitive":"Славуті","accusative":"Славути"}},"Славутич":{"ru":{"genitive":"Славутиче","accusative":"Славутича"},"uk":{"genitive":"Славутичі","accusative":"Славутича"}},"Славянск":{"ru":{"genitive":"Славянске","accusative":"Славянска"},"uk":{"genitive":"Слов'янську","accusative":"Слов'янська"}},"Смела":{"ru":{"genitive":"Смеле","accusative":"Смелы"},"uk":{"genitive":"Смілі","accusative":"Сміли"}},"Снежное":{"ru":{"genitive":"Снежном","accusative":"Снежного"},"uk":{"genitive":"Сніжному","accusative":"Сніжного"}},"Снигиревка":{"ru":{"genitive":"Снигиревке","accusative":"Снигиревки"},"uk":{"genitive":"Снігурівці","accusative":"Снігурівки"}},"Сновск":{"ru":{"genitive":"Сновске","accusative":"Сновска"},"uk":{"genitive":"Сновську","accusative":"Сновська"}},"Снятын":{"ru":{"genitive":"Снятыне","accusative":"Снятына"},"uk":{"genitive":"Снятині","accusative":"Снятина"}},"Сокаль":{"ru":{"genitive":"Сокале","accusative":"Сокаля"},"uk":{"genitive":"Сокалі","accusative":"Сокаля"}},"Сокиряны":{"ru":{"genitive":"Сокирянах","accusative":"Сокирян"},"uk":{"genitive":"Сокирянах","accusative":"Сокирян"}},"Соледар":{"ru":{"genitive":"Соледаре","accusative":"Соледара"},"uk":{"genitive":"Соледарі","accusative":"Соледара"}},"Сорокино":{"ru":{"genitive":"Сорокином","accusative":"Сорокина"},"uk":{"genitive":"Сорокиному","accusative":"Сорокина"}},"Сосновка":{"ru":{"genitive":"Сосновке","accusative":"Сосновки"},"uk":{"genitive":"Соснівці","accusative":"Соснівки"}},"Старобельск":{"ru":{"genitive":"Старобельске","accusative":"Старобельска"},"uk":{"genitive":"Старобільську","accusative":"Старобільська"}},"Староконстантинов":{"ru":{"genitive":"Староконстантинове","accusative":"Староконстантинова"},"uk":{"genitive":"Старокостянтинові","accusative":"Старокостянтинова"}},"Старый Крым":{"ru":{"genitive":"Старом Крыму","accusative":"Старого Крыма"},"uk":{"genitive":"Старому Кримі","accusative":"Старого Крима"}},"Старый Самбор":{"ru":{"genitive":"Старом Самборе","accusative":"Старого Самбора"},"uk":{"genitive":"Старому Самборі","accusative":"Старого Самбора"}},"Стебник":{"ru":{"genitive":"Стебнике","accusative":"Стебника"},"uk":{"genitive":"Стебнику","accusative":"Стебника"}},"Сторожинец":{"ru":{"genitive":"Сторожинеце","accusative":"Сторожинца"},"uk":{"genitive":"Сторожинеці","accusative":"Сторожинця"}},"Стрый":{"ru":{"genitive":"Стрые","accusative":"Стрыя"},"uk":{"genitive":"Стрию","accusative":"Стрия"}},"Судак":{"ru":{"genitive":"Судаке","accusative":"Судака"},"uk":{"genitive":"Судаку","accusative":"Судака"}},"Судовая Вишня":{"ru":{"genitive":"Судовой Вишне","accusative":"Судовой Вишни"},"uk":{"genitive":"Судовій Вишні","accusative":"Судової Вишні"}},"Счастье":{"ru":{"genitive":"Счастье","accusative":"Счастья"},"uk":{"genitive":"Щасті","accusative":"Щастя"}},"Таврийск":{"ru":{"genitive":"Таврийске","accusative":"Таврийскв"},"uk":{"genitive":"Таврійську","accusative":"Таврійськв"}},"Тальное":{"ru":{"genitive":"Тальном","accusative":"Тального"},"uk":{"genitive":"Тальному","accusative":"Тального"}},"Тараща":{"ru":{"genitive":"Тараще","accusative":"Таращы"},"uk":{"genitive":"Таращі","accusative":"Таращі"}},"Татарбунары":{"ru":{"genitive":"Татарбунарах","accusative":"Татарбунар"},"uk":{"genitive":"Татарбунарах","accusative":"Татарбунар"}},"Теплодар":{"ru":{"genitive":"Теплодаре","accusative":"Теплодарв"},"uk":{"genitive":"Теплодарі","accusative":"Теплодарв"}},"Теребовля":{"ru":{"genitive":"Теребовле","accusative":"Теребовли"},"uk":{"genitive":"Теребовлі","accusative":"Теребовлі"}},"Терновка":{"ru":{"genitive":"Терновке","accusative":"Терновки"},"uk":{"genitive":"Тернівці","accusative":"Тернівки"}},"Тетиев":{"ru":{"genitive":"Тетиеве","accusative":"Тетиева"},"uk":{"genitive":"Тетієві","accusative":"Тетієва"}},"Тлумач":{"ru":{"genitive":"Тлумаче","accusative":"Тлумача"},"uk":{"genitive":"Тлумачі","accusative":"Тлумача"}},"Токмак":{"ru":{"genitive":"Токмаке","accusative":"Токмака"},"uk":{"genitive":"Токмаці","accusative":"Токмака"}},"Торецк":{"ru":{"genitive":"Торецке","accusative":"Торецка"},"uk":{"genitive":"Торецьку","accusative":"Торецька"}},"Тростянец":{"ru":{"genitive":"Тростянеце","accusative":"Тростянца"},"uk":{"genitive":"Тростянеці","accusative":"Тростянця"}},"Трускавец":{"ru":{"genitive":"Трускавеце","accusative":"Трускавца"},"uk":{"genitive":"Трускавці","accusative":"Трускавця"}},"Тульчин":{"ru":{"genitive":"Тульчине","accusative":"Тульчина"},"uk":{"genitive":"Тульчині","accusative":"Тульчина"}},"Турка":{"ru":{"genitive":"Турке","accusative":"Турки"},"uk":{"genitive":"Турці","accusative":"Турки"}},"Тысменица":{"ru":{"genitive":"Тысменице","accusative":"Тысменицы"},"uk":{"genitive":"Тисмениці","accusative":"Тисмениці"}},"Тячев":{"ru":{"genitive":"Тячеве","accusative":"Тячева"},"uk":{"genitive":"Тячеві","accusative":"Тячева"}},"Угледар":{"ru":{"genitive":"Угледаре","accusative":"Угледара"},"uk":{"genitive":"Вугледарі","accusative":"Вугледара"}},"Угнев":{"ru":{"genitive":"Угневе","accusative":"Угнева"},"uk":{"genitive":"Угневі","accusative":"Угнева"}},"Узин":{"ru":{"genitive":"Узине","accusative":"Узина"},"uk":{"genitive":"Узині","accusative":"Узина"}},"Украинка":{"ru":{"genitive":"Украинке","accusative":"Украинки"},"uk":{"genitive":"Украиїці","accusative":"Украиїки"}},"Украинск":{"ru":{"genitive":"Украинске","accusative":"Украинска"},"uk":{"genitive":"Українську","accusative":"Українська"}},"Умань":{"ru":{"genitive":"Умане","accusative":"Умани"},"uk":{"genitive":"Умані","accusative":"Умани"}},"Устилуг":{"ru":{"genitive":"Устилуге","accusative":"Устилуга"},"uk":{"genitive":"Устилузі","accusative":"Устилуга"}},"Фастов":{"ru":{"genitive":"Фастове","accusative":"Фастова"},"uk":{"genitive":"Фастові","accusative":"Фастова"}},"Феодосия":{"ru":{"genitive":"Феодосии","accusative":"Феодосии"},"uk":{"genitive":"Феодосії","accusative":"Феодосії"}},"Харцызск":{"ru":{"genitive":"Харцызске","accusative":"Харцызска"},"uk":{"genitive":"Харцизьку","accusative":"Харцизька"}},"Хмельник":{"ru":{"genitive":"Хмельнике","accusative":"Хмельника"},"uk":{"genitive":"Хмільнику","accusative":"Хмільника"}},"Ходоров":{"ru":{"genitive":"Ходорове","accusative":"Ходорова"},"uk":{"genitive":"Ходорові","accusative":"Ходорова"}},"Хорол":{"ru":{"genitive":"Хороле","accusative":"Хорола"},"uk":{"genitive":"Хоролі","accusative":"Хорола"}},"Хоростков":{"ru":{"genitive":"Хоросткове","accusative":"Хоросткова"},"uk":{"genitive":"Хоросткові","accusative":"Хоросткова"}},"Хотин":{"ru":{"genitive":"Хотине","accusative":"Хотина"},"uk":{"genitive":"Хотині","accusative":"Хотина"}},"Христиновка":{"ru":{"genitive":"Христиновке","accusative":"Христиновки"},"uk":{"genitive":"Христинівці","accusative":"Христинівки"}},"Хрустальный":{"ru":{"genitive":"Хрустальном","accusative":"Хрустального"},"uk":{"genitive":"Хрустальному","accusative":"Хрустального"}},"Хуст":{"ru":{"genitive":"Хусте","accusative":"Хуста"},"uk":{"genitive":"Хусті","accusative":"Хуста"}},"Хыров":{"ru":{"genitive":"Хырове","accusative":"Хырова"},"uk":{"genitive":"Хирові","accusative":"Хирова"}},"Часов Яр":{"ru":{"genitive":"Часов Яре","accusative":"Часов Яра"},"uk":{"genitive":"Часів Ярі","accusative":"Часів Яра"}},"Червоноград":{"ru":{"genitive":"Червонограде","accusative":"Червонограда"},"uk":{"genitive":"Червонограді","accusative":"Червонограда"}},"Чернобыль":{"ru":{"genitive":"Чернобыле","accusative":"Чернобыля"},"uk":{"genitive":"Чорнобилі","accusative":"Чорнобиля"}},"Черноморск":{"ru":{"genitive":"Черноморске","accusative":"Черноморска"},"uk":{"genitive":"Чорноморську","accusative":"Чорноморська"}},"Чигирин":{"ru":{"genitive":"Чигирине","accusative":"Чигирина"},"uk":{"genitive":"Чигирині","accusative":"Чигирина"}},"Чистяково":{"ru":{"genitive":"Чистякове","accusative":"Чистякова"},"uk":{"genitive":"Чистякові","accusative":"Чистякова"}},"Чоп":{"ru":{"genitive":"Чопе","accusative":"Чопа"},"uk":{"genitive":"Чопі","accusative":"Чопа"}},"Чортков":{"ru":{"genitive":"Чорткове","accusative":"Чорткова"},"uk":{"genitive":"Чорткові","accusative":"Чорткова"}},"Чугуев":{"ru":{"genitive":"Чугуеве","accusative":"Чугуева"},"uk":{"genitive":"Чугуєві","accusative":"Чугуєва"}},"Чуднов":{"ru":{"genitive":"Чуднове","accusative":"Чуднова"},"uk":{"genitive":"Чуднові","accusative":"Чуднова"}},"Шаргород":{"ru":{"genitive":"Шаргороде","accusative":"Шаргорода"},"uk":{"genitive":"Шаргороді","accusative":"Шаргорода"}},"Шахтерск":{"ru":{"genitive":"Шахтерске","accusative":"Шахтерска"},"uk":{"genitive":"Шахтарську","accusative":"Шахтарська"}},"Шепетовка":{"ru":{"genitive":"Шепетовке","accusative":"Шепетовки"},"uk":{"genitive":"Шепетівці","accusative":"Шепетівки"}},"Шостка":{"ru":{"genitive":"Шостке","accusative":"Шостки"},"uk":{"genitive":"Шостці","accusative":"Шостки"}},"Шпола":{"ru":{"genitive":"Шполе","accusative":"Шполы"},"uk":{"genitive":"Шполі","accusative":"Шполи"}},"Шумск":{"ru":{"genitive":"Шумске","accusative":"Шумска"},"uk":{"genitive":"Шумську","accusative":"Шумська"}},"Щелкино":{"ru":{"genitive":"Щелкином","accusative":"Щелкина"},"uk":{"genitive":"Щолкіному","accusative":"Щолкіна"}},"Энергодар":{"ru":{"genitive":"Энергодаре","accusative":"Энергодара"},"uk":{"genitive":"Енергодарі","accusative":"Енергодара"}},"Южное":{"ru":{"genitive":"Южном","accusative":"Южного"},"uk":{"genitive":"Южному","accusative":"Южного"}},"Южноукраинск":{"ru":{"genitive":"Южноукраинске","accusative":"Южноукраинска"},"uk":{"genitive":"Южноукраїнську","accusative":"Южноукраїнська"}},"Яворов":{"ru":{"genitive":"Яворове","accusative":"Яворова"},"uk":{"genitive":"Яворові","accusative":"Яворова"}},"Яготин":{"ru":{"genitive":"Яготине","accusative":"Яготина"},"uk":{"genitive":"Яготині","accusative":"Яготина"}},"Ялта":{"ru":{"genitive":"Ялте","accusative":"Ялты"},"uk":{"genitive":"Ялті","accusative":"Ялти"}},"Ямполь":{"ru":{"genitive":"Ямполе","accusative":"Ямполя"},"uk":{"genitive":"Ямполі","accusative":"Ямполя"}},"Яремче":{"ru":{"genitive":"Яремче","accusative":"Яремча"},"uk":{"genitive":"Яремче","accusative":"Яремча"}},"Ясиноватая":{"ru":{"genitive":"Ясиноватой","accusative":"Ясиноватой"},"uk":{"genitive":"Ясинуватій","accusative":"Ясинуватої"}},"Ивано-Франковск":{"ru":{"genitive":"Ивано-Франковске","accusative":"Ивано-Франковска"},"uk":{"genitive":"Івано-Франківську","accusative":"Івано-Франківська"}}}

/***/ }),

/***/ 106:
/***/ (function(module, exports) {

module.exports = [{"id":1,"slug":"avto","title":"Легковые","isAdvertType":true,"isMobileSearch":true,"isMobileDealersSearch":true,"isInAdvertFormNavigation":true,"parents":[]},{"id":131,"slug":"mototsikl","title":"Мотоциклы","isAdvertType":true,"isMobileSearch":true,"isMobileDealersSearch":true,"parents":[124]},{"id":124,"slug":"moto","title":"Мототранспорт","isInAdvertFormNavigation":true,"parents":[]},{"id":196,"slug":"avtobus","title":"Автобусы","isMobileSearch":true,"isMobileDealersSearch":true,"isInAdvertFormNavigation":true,"parents":[]},{"id":200,"slug":"gruzovye","title":"Грузовые","isAdvertType":true,"isMobileSearch":true,"isMobileDealersSearch":true,"isInAdvertFormNavigation":true,"parents":[]},{"id":145,"slug":"pritsepy","title":"Прицепы","isInAdvertFormNavigation":true,"isMobileDealersSearch":true,"isMobileSearch":true,"parents":[]},{"id":267,"slug":"vodnyi-transport","title":"Водный транспорт","isInAdvertFormNavigation":true,"isMobileDealersSearch":true,"isMobileSearch":true,"parents":[]},{"id":23,"slug":"spetstehnika","title":"Спецтехника","isInAdvertFormNavigation":true,"isMobileDealersSearch":true,"isMobileSearch":true,"parents":[]},{"id":146,"slug":"konteyner","title":"Контейнер","isAdvertType":true,"parents":[145]},{"id":147,"slug":"budka","title":"Будка","isAdvertType":true,"parents":[145]},{"id":154,"slug":"polupritsep","title":"Полуприцеп","isAdvertType":true,"parents":[145]},{"id":168,"slug":"pritsep","title":"Прицеп","isAdvertType":true,"parents":[145]},{"id":189,"slug":"dacha","title":"Дача","isAdvertType":true,"parents":[145]},{"id":125,"slug":"karting","title":"Картинг","isAdvertType":true,"parents":[124]},{"id":126,"slug":"vezdehod-amfibiya","title":"Вездеход-амфибия","parents":[124]},{"id":127,"slug":"baggi","title":"Багги","isAdvertType":true,"parents":[124]},{"id":128,"slug":"detskiy-transport","title":"Детский транспорт","parents":[124]},{"id":130,"slug":"moped","title":"Мопеды","isAdvertType":true,"parents":[124]},{"id":138,"slug":"tritsikl","title":"Трицикл","isAdvertType":true,"parents":[124]},{"id":139,"slug":"kvadrotsikl","title":"Квадроциклы","isAdvertType":true,"parents":[124]},{"id":142,"slug":"velosiped","title":"Велосипед","parents":[124]},{"id":143,"slug":"vezdehod","title":"Вездеход","isAdvertType":true,"parents":[124]},{"id":144,"slug":"skuter","title":"Скутеры","isAdvertType":true,"parents":[124]},{"id":129,"slug":"snegohod","title":"Снегоходы","isAdvertType":true,"parents":[124]},{"id":201,"slug":"avtotsisterna","title":"Автоцистерна","parents":[200]},{"id":202,"slug":"avtovoz","title":"Автовоз","parents":[200]},{"id":203,"slug":"bortovoy","title":"Бортовой","parents":[200]},{"id":204,"slug":"zernovoz","title":"Зерновоз","parents":[200]},{"id":205,"slug":"izotermo","title":"Изотермо","parents":[200]},{"id":206,"slug":"konteynerovoz","title":"Контейнеровоз","parents":[200]},{"id":207,"slug":"razvozchik-napitkov","title":"Развозчик напитков","parents":[200]},{"id":208,"slug":"mebelniy-furgon","title":"Мебельный фургон","parents":[200]},{"id":209,"slug":"pochtoviy-furgon","title":"Почтовый фургон","parents":[200]},{"id":210,"slug":"refrizherator","title":"Рефрижератор","parents":[200]},{"id":211,"slug":"promtovarniy-furgon","title":"Промтоварный фургон","parents":[200]},{"id":212,"slug":"samosval","title":"Самосвал","parents":[200]},{"id":213,"slug":"tent","title":"Тент","parents":[200]},{"id":214,"slug":"tyagach","title":"Тягач","parents":[200]},{"id":215,"slug":"hlebniy-furgon","title":"Хлебный фургон","parents":[200]},{"id":216,"slug":"shassi","title":"Шасси","parents":[200]},{"id":217,"slug":"evakuator","title":"Эвакуатор","parents":[200]},{"id":197,"slug":"gruzo-pass","title":"Грузо-пасс.","isAdvertType":true,"parents":[196]},{"id":198,"slug":"gruzovoy","title":"Грузовой","isAdvertType":true,"parents":[196]},{"id":199,"slug":"passazhirskiy","title":"Пассажирский","isAdvertType":true,"parents":[196]},{"id":24,"slug":"stroitelnaya","title":"Строительная","isAdvertType":true,"parents":[23]},{"id":25,"slug":"avtovyshka","title":"Автовышка","isAdvertType":true,"parents":[23]},{"id":29,"slug":"betonosmesitel","title":"Бетоносмеситель","isAdvertType":true,"parents":[23]},{"id":32,"slug":"benzovoz","title":"Бензовоз","isAdvertType":true,"parents":[23]},{"id":36,"slug":"buldozer","title":"Бульдозер","isAdvertType":true,"parents":[23]},{"id":39,"slug":"betononasos","title":"Бетононасос","isAdvertType":true,"parents":[23]},{"id":42,"slug":"burovye-ustanovki","title":"Буровые установки","isAdvertType":true,"parents":[23]},{"id":45,"slug":"dorozhnaya-tehnika","title":"Дорожная техника","isAdvertType":true,"parents":[23]},{"id":51,"slug":"ekskavator","title":"Экскаватор","isAdvertType":true,"parents":[23]},{"id":57,"slug":"ekskavator-pogruzchik","title":"Екскаватор погрузчик","isAdvertType":true,"parents":[23]},{"id":58,"slug":"kommunalnaya-tehnika","title":"Коммунальная техника","isAdvertType":true,"parents":[23]},{"id":66,"slug":"kran","title":"Кран","isAdvertType":true,"parents":[23]},{"id":73,"slug":"minitraktor","title":"Минитрактор","isAdvertType":true,"parents":[23]},{"id":74,"slug":"motoblok","title":"Мотоблок","isAdvertType":true,"parents":[23]},{"id":75,"slug":"pogruzchik","title":"Погрузчик","isAdvertType":true,"parents":[23]},{"id":80,"slug":"spetsavtomobili","title":"Спецавтомобили","isAdvertType":true,"parents":[23]},{"id":94,"slug":"traktor","title":"Трактор","isAdvertType":true,"parents":[23]},{"id":97,"slug":"podemnik","title":"Подъемник","isAdvertType":true,"parents":[23]},{"id":98,"slug":"selhoztehnika","title":"Сельхозтехника","isAdvertType":true,"parents":[23]},{"id":225,"slug":"elektrostanciya-generator","title":"Электростанция / Генератор","isAdvertType":true,"parents":[23]},{"id":268,"slug":"hidrotsykl","title":"Гидроцикл","isAdvertType":true,"parents":[267]},{"id":269,"slug":"kater","title":"Катер","isAdvertType":true,"parents":[267]},{"id":270,"slug":"choven","title":"Лодка","isAdvertType":true,"parents":[267]},{"id":271,"slug":"yakhta","title":"Яхта","isAdvertType":true,"parents":[267]},{"id":272,"slug":"debarkader","title":"Дебаркадер","isAdvertType":true,"parents":[267]},{"id":273,"slug":"katamaran","title":"Катамаран","isAdvertType":true,"parents":[267]},{"id":274,"slug":"plav-dacha","title":"Плав-дача","isAdvertType":true,"parents":[267]},{"id":275,"slug":"teplokhid","title":"Теплоход","isAdvertType":true,"parents":[267]},{"id":276,"slug":"khauz-bot","title":"Хауз-бот","isAdvertType":true,"parents":[267]},{"id":302,"slug":"chovnovyi-motor","title":"Лодочный двигатель","isAdvertType":true,"parents":[267]},{"id":303,"slug":"ponton","title":"Понтон","isAdvertType":true,"parents":[267]},{"id":304,"slug":"prychip-vodnoho-transportu","title":"Прицеп для водного транспорта","isAdvertType":true,"parents":[267]},{"id":305,"slug":"rozvahy-na-vodi","title":"Развлечения на воде","isAdvertType":true,"parents":[267]}]

/***/ }),

/***/ 1149:
/***/ (function(module, exports) {

module.exports = [{"id":64482,"slug":"body-with-docs","title":"кузов с документами"},{"id":64481,"slug":"entirely-spare-parts","title":"целиком по запчастям"}]

/***/ }),

/***/ 1151:
/***/ (function(module, exports) {

module.exports = [{"id":"all","title":"Любой"},{"id":"yes","title":"Частник"},{"id":"no","title":"Компания"}]

/***/ }),

/***/ 1152:
/***/ (function(module, exports) {

module.exports = [{"id":"left","title":"Левый руль"},{"id":"rigth","title":"Правый"}]

/***/ }),

/***/ 1153:
/***/ (function(module, exports) {

module.exports = [{"id":0,"title":"Кроме битых","value":0},{"id":1,"title":"После ДТП","value":1},{"id":null,"title":"Неважно","value":null}]

/***/ }),

/***/ 1154:
/***/ (function(module, exports) {

module.exports = [{"id":197,"slug":"gruzo-pass","title":"Грузо-пасс."},{"id":198,"slug":"gruzovoy","title":"Грузовой"},{"id":218,"slug":"refrizherator","title":"Рефрижератор","parent":198},{"id":199,"slug":"passazhirskiy","title":"Пассажирский"},{"id":219,"slug":"avtodom","title":"Автодом","parent":199},{"id":220,"slug":"gorodskoy","title":"Городской","parent":199},{"id":221,"slug":"mezhdugorodnyy","title":"Междугородный","parent":199},{"id":222,"slug":"prigorodnyy","title":"Пригородный","parent":199},{"id":223,"slug":"turisticheskiy","title":"Туристический","parent":199},{"id":224,"slug":"shkolnyy","title":"Школьный","parent":199}]

/***/ }),

/***/ 1155:
/***/ (function(module, exports) {

module.exports = [{"id":201,"slug":"avtotsisterna","title":"Автоцистерна"},{"id":202,"slug":"avtovoz","title":"Автовоз"},{"id":203,"slug":"bortovoy","title":"Бортовой"},{"id":204,"slug":"zernovoz","title":"Зерновоз"},{"id":205,"slug":"izotermo","title":"Изотермо"},{"id":206,"slug":"konteynerovoz","title":"Контейнеровоз"},{"id":207,"slug":"razvozchik-napitkov","title":"Развозчик напитков"},{"id":208,"slug":"mebelniy-furgon","title":"Мебельный фургон"},{"id":209,"slug":"pochtoviy-furgon","title":"Почтовый фургон"},{"id":210,"slug":"refrizherator","title":"Рефрижератор"},{"id":211,"slug":"promtovarniy-furgon","title":"Промтоварный фургон"},{"id":212,"slug":"samosval","title":"Самосвал"},{"id":213,"slug":"tent","title":"Тент"},{"id":214,"slug":"tyagach","title":"Тягач"},{"id":215,"slug":"hlebniy-furgon","title":"Хлебный фургон"},{"id":216,"slug":"shassi","title":"Шасси"},{"id":217,"slug":"evakuator","title":"Эвакуатор"}]

/***/ }),

/***/ 1156:
/***/ (function(module, exports) {

module.exports = [{"id":146,"slug":"konteyner","title":"Контейнер"},{"id":147,"slug":"budka","title":"Будка"},{"id":154,"slug":"polupritsep","title":"Полуприцеп"},{"id":168,"slug":"pritsep","title":"Прицеп"},{"id":189,"slug":"dacha","title":"Дача","parent":147},{"id":148,"slug":"razvozchik","title":"Развозчик","parent":147},{"id":149,"slug":"izotermo","title":"Изотермо","parent":147},{"id":150,"slug":"refrizherator","title":"Рефрижератор","parent":147},{"id":151,"slug":"tent","title":"Тент","parent":147},{"id":152,"slug":"mebelniy","title":"Мебельный","parent":147},{"id":153,"slug":"kuzov-bortovoy","title":"Кузов бортовой","parent":147},{"id":156,"slug":"izotermo","title":"Изотермо","parent":154},{"id":157,"slug":"lafet","title":"Лафет","parent":154},{"id":158,"slug":"tent","title":"Тент","parent":154},{"id":159,"slug":"tral","title":"Трал","parent":154},{"id":160,"slug":"tsementovoz","title":"Цементовоз","parent":154},{"id":161,"slug":"konteynerovoz","title":"Контейнеровоз","parent":154},{"id":162,"slug":"tsisterna","title":"Цистерна","parent":154},{"id":163,"slug":"zernovoz","title":"Зерновоз","parent":154},{"id":164,"slug":"avtovoz","title":"Автовоз","parent":154},{"id":165,"slug":"platforma","title":"Платформа","parent":154},{"id":166,"slug":"bortovoy","title":"Бортовой","parent":154},{"id":167,"slug":"refrizherator","title":"Рефрижератор","parent":154},{"id":169,"slug":"dlya-perevozki-zhivotnyh","title":"Для перевозки животных","parent":168},{"id":170,"slug":"avtovoz","title":"Автовоз","parent":168},{"id":171,"slug":"bortovoy","title":"Бортовой","parent":168},{"id":172,"slug":"k-legkovomu-avto","title":"К легковому авто","parent":168},{"id":173,"slug":"refrizherator","title":"Рефрижератор","parent":168},{"id":174,"slug":"tsisterna","title":"Цистерна","parent":168},{"id":176,"slug":"izotermo","title":"Изотермо","parent":168},{"id":177,"slug":"konteynerovoz","title":"Контейнеровоз","parent":168},{"id":178,"slug":"rospusk","title":"Роспуск","parent":168},{"id":179,"slug":"tent","title":"Тент","parent":168},{"id":180,"slug":"torgoviy","title":"Торговый","parent":168},{"id":181,"slug":"tselnometallicheskiy","title":"Цельнометаллический","parent":168},{"id":182,"slug":"zernovoz","title":"Зерновоз","parent":168},{"id":183,"slug":"lafet","title":"Лафет","parent":168},{"id":184,"slug":"tsementovoz","title":"Цементовоз","parent":168},{"id":185,"slug":"platforma","title":"Платформа","parent":168},{"id":186,"slug":"dlya-mototehniki","title":"для мототехники","parent":168},{"id":187,"slug":"dlya-lodok-i-skuterov","title":"для лодок и скутеров","parent":168},{"id":188,"slug":"dlya-aviatehniki","title":"для авиатехники","parent":168},{"id":190,"slug":"avtodacha","title":"Автодача","parent":189},{"id":191,"slug":"avtodom","title":"Автодом","parent":189},{"id":192,"slug":"avtokemper","title":"Автокемпер","parent":189},{"id":193,"slug":"karavan","title":"Караван","parent":189},{"id":194,"slug":"zhiloy-furgon","title":"Жилой фургон","parent":189},{"id":195,"slug":"dom-na-kolesah","title":"Дом на колёсах","parent":189}]

/***/ }),

/***/ 1157:
/***/ (function(module, exports) {

module.exports = [{"id":24,"slug":"stroitelnaya","title":"Строительная"},{"id":25,"slug":"avtovyshka","title":"Автовышка"},{"id":29,"slug":"betonosmesitel","title":"Бетоносмеситель"},{"id":32,"slug":"benzovoz","title":"Бензовоз"},{"id":36,"slug":"buldozer","title":"Бульдозер"},{"id":39,"slug":"betononasos","title":"Бетононасос"},{"id":42,"slug":"burovye-ustanovki","title":"Буровые установки"},{"id":45,"slug":"dorozhnaya-tehnika","title":"Дорожная техника"},{"id":51,"slug":"ekskavator","title":"Экскаватор"},{"id":57,"slug":"ekskavator-pogruzchik","title":"Екскаватор погрузчик"},{"id":58,"slug":"kommunalnaya-tehnika","title":"Коммунальная техника"},{"id":66,"slug":"kran","title":"Кран"},{"id":73,"slug":"minitraktor","title":"Минитрактор"},{"id":74,"slug":"motoblok","title":"Мотоблок"},{"id":75,"slug":"pogruzchik","title":"Погрузчик"},{"id":80,"slug":"spetsavtomobili","title":"Спецавтомобили"},{"id":94,"slug":"traktor","title":"Трактор"},{"id":97,"slug":"podemnik","title":"Подъемник"},{"id":98,"slug":"selhoztehnika","title":"Сельхозтехника"},{"id":225,"slug":"elektrostanciya-generator","title":"Электростанция / Генератор"},{"id":76,"slug":"vilochniy","title":"Вилочный","parent":75},{"id":77,"slug":"frontalniy","title":"Фронтальный","parent":75},{"id":78,"slug":"teleskopicheskiy","title":"Телескопический","parent":75},{"id":79,"slug":"konteynerniy","title":"Контейнерный","parent":75},{"id":26,"slug":"kolenchato-teleskopicheskaya","title":"коленчато-телескопическая","parent":25},{"id":27,"slug":"loktevaya-kolenchataya","title":"локтевая (коленчатая)","parent":25},{"id":28,"slug":"teleskopicheskaya","title":"телескопическая","parent":25},{"id":30,"slug":"avtomobilniy","title":"автомобильный","parent":29},{"id":31,"slug":"ustanovka","title":"установка","parent":29},{"id":33,"slug":"polupritsep-tsisterna","title":"полуприцеп-цистерна","parent":32},{"id":34,"slug":"pritsep-tsisterna","title":"прицеп-цистерна","parent":32},{"id":35,"slug":"avtotsisterna","title":"автоцистерна","parent":32},{"id":37,"slug":"pnevmokolesniy","title":"пневмоколесный","parent":36},{"id":38,"slug":"gusenichniy","title":"гусеничный","parent":36},{"id":40,"slug":"ustanovka","title":"установка","parent":39},{"id":41,"slug":"avtomobilniy","title":"автомобильный","parent":39},{"id":43,"slug":"na-gusenichnom-hodu","title":"На гусеничном ходу","parent":42},{"id":44,"slug":"na-avtohodu","title":"На автоходу","parent":42},{"id":46,"slug":"freza-dorozhnaya","title":"Фреза дорожная","parent":45},{"id":47,"slug":"asfaltoukladchik","title":"Асфальтоукладчик","parent":45},{"id":48,"slug":"greyder","title":"Грейдер","parent":45},{"id":49,"slug":"skreper","title":"Скрепер","parent":45},{"id":50,"slug":"katok","title":"Каток","parent":45},{"id":52,"slug":"strug","title":"Струг","parent":51},{"id":53,"slug":"draglayn","title":"Драглайн","parent":51},{"id":54,"slug":"greyfer","title":"Грейфер","parent":51},{"id":55,"slug":"obratnaya-lopata","title":"Обратная лопата","parent":51},{"id":56,"slug":"pryamaya-lopata","title":"Прямая лопата","parent":51},{"id":59,"slug":"podmetalno-uborochnaya-mashina","title":"Подметально-уборочная машина","parent":58},{"id":60,"slug":"peskorazbrasyvatel","title":"Пескоразбрасыватель","parent":58},{"id":61,"slug":"kombinirovannaya-mashina","title":"Комбинированная машина","parent":58},{"id":62,"slug":"snegoochistitel","title":"Снегоочиститель","parent":58},{"id":63,"slug":"musorovoz","title":"Мусоровоз","parent":58},{"id":64,"slug":"polivomoechnaya-mashina","title":"Поливомоечная машина","parent":58},{"id":65,"slug":"kanalopromyvochnaya-mashina","title":"Каналопромывочная машина","parent":58},{"id":67,"slug":"avtokran","title":"Автокран","parent":66},{"id":68,"slug":"bashenniy","title":"Башенный","parent":66},{"id":69,"slug":"gusenichniy","title":"Гусеничный","parent":66},{"id":70,"slug":"manipulyator","title":"Манипулятор","parent":66},{"id":71,"slug":"kozlovoy","title":"Козловой","parent":66},{"id":72,"slug":"mostovoy","title":"Мостовой","parent":66},{"id":81,"slug":"skoraya-pomoshch","title":"Скорая помощь","parent":80},{"id":82,"slug":"vakuumniy-avtomobil","title":"Вакуумный автомобиль","parent":80},{"id":83,"slug":"broneavtomobil","title":"Бронеавтомобиль","parent":80},{"id":84,"slug":"evakuator","title":"Эвакуатор","parent":80},{"id":85,"slug":"avtovoz","title":"Автовоз","parent":80},{"id":86,"slug":"assenizator","title":"Ассенизатор","parent":80},{"id":87,"slug":"gazovoz","title":"Газовоз","parent":80},{"id":88,"slug":"lesovoz","title":"Лесовоз","parent":80},{"id":89,"slug":"molokovoz","title":"Молоковоз","parent":80},{"id":90,"slug":"tsementirovochniy-agregat","title":"Цементировочный агрегат","parent":80},{"id":91,"slug":"pozharnaya-mashina","title":"Пожарная машина","parent":80},{"id":92,"slug":"kompressor","title":"Компрессор","parent":80},{"id":93,"slug":"tsementovoz","title":"Цементовоз","parent":80},{"id":95,"slug":"gusenichniy","title":"гусеничный","parent":94},{"id":96,"slug":"kolesniy","title":"колесный","parent":94},{"id":99,"slug":"kultivator","title":"Культиватор","parent":98},{"id":100,"slug":"glubokoryhlitel","title":"Глубокорыхлитель","parent":98},{"id":101,"slug":"mulchirovatel","title":"Мульчирователь","parent":98},{"id":102,"slug":"kartofelekopalka","title":"Картофелекопалка","parent":98},{"id":103,"slug":"kosilka-plyushchilka","title":"Косилка-плющилка","parent":98},{"id":104,"slug":"grabli","title":"Грабли","parent":98},{"id":105,"slug":"kartofelesazhalka","title":"Картофелесажалка","parent":98},{"id":106,"slug":"razbrasyvatel-udobreniy","title":"Разбрасыватель удобрений","parent":98},{"id":107,"slug":"shnekoviy-transporter","title":"Шнековый транспортер","parent":98},{"id":108,"slug":"rassadoposadochnaya-mashina","title":"Рассадопосадочная машина","parent":98},{"id":109,"slug":"kombayn-gorohouborochniy","title":"Комбайн горохоуборочный","parent":98},{"id":110,"slug":"kosilka","title":"Косилка","parent":98},{"id":111,"slug":"borona","title":"Борона","parent":98},{"id":112,"slug":"kombayn-kartofeleuborochniy","title":"Комбайн картофелеуборочный","parent":98},{"id":113,"slug":"kombayn-kukuruzouborochniy","title":"Комбайн кукурузоуборочный","parent":98},{"id":114,"slug":"kombayn-podsolnuhouborochniy","title":"Комбайн подсолнухоуборочный","parent":98},{"id":115,"slug":"kombayn-zernouborochniy","title":"Комбайн зерноуборочный","parent":98},{"id":116,"slug":"opryskivatel","title":"Опрыскиватель","parent":98},{"id":117,"slug":"plug","title":"Плуг","parent":98},{"id":118,"slug":"press-podborshchik","title":"Пресс-подборщик","parent":98},{"id":119,"slug":"seyalka","title":"Сеялка","parent":98},{"id":120,"slug":"zhatka","title":"Жатка","parent":98},{"id":121,"slug":"kombayn-kormouborochniy","title":"Комбайн кормоуборочный","parent":98},{"id":122,"slug":"kombayn-sveklouborochniy","title":"Комбайн свеклоуборочный","parent":98}]

/***/ }),

/***/ 1158:
/***/ (function(module, exports) {

module.exports = [{"id":277,"slug":"stoiachyi","title":"Стоячий","parent":268},{"id":278,"slug":"sydiachyi","title":"Сидячий","parent":268},{"id":280,"slug":"shvydkisnyi-predstavnytskyi","title":"Скоростной представительский","parent":269},{"id":281,"slug":"khodova-rubka","title":"Ходовая рубка (Pilot House)","parent":269},{"id":282,"slug":"sportyvnyi","title":"Спортивный","parent":269},{"id":283,"slug":"sportyvnyi-buksyrovshchyk","title":"Спортивный буксировщик","parent":269},{"id":284,"slug":"kruyzer","title":"Круизер","parent":269},{"id":285,"slug":"prohuliankovyi","title":"Прогулочный","parent":269},{"id":286,"slug":"rybalskyi","title":"Рыболовный","parent":269},{"id":287,"slug":"pontonnyi","title":"Понтонный","parent":269},{"id":288,"slug":"metaleva","title":"Металлическая","parent":270},{"id":289,"slug":"naduvnyi-choven-rib","title":"Надувная лодка с жестким дном RIB","parent":270},{"id":290,"slug":"naduvnyi-choven","title":"Надувная лодка","parent":270},{"id":291,"slug":"Pidvodnyi","title":"Подводная","parent":270},{"id":292,"slug":"skloplastykovyi","title":"Стеклопластиковая","parent":270},{"id":293,"slug":"sportyvna","title":"Спортивная","parent":271},{"id":294,"slug":"khodova-rubka","title":"Ходовая рубка (Pilot House)","parent":271},{"id":295,"slug":"kruizna","title":"Круизная","parent":271},{"id":296,"slug":"meha-super","title":"Мега (Супер)","parent":271},{"id":297,"slug":"motorna","title":"Моторная","parent":271},{"id":298,"slug":"vitrylna","title":"Парусная","parent":271},{"id":299,"slug":"vitrylno-motornaia","title":"Парусно-моторная","parent":271},{"id":300,"slug":"shvertbot","title":"Швертбот","parent":271},{"id":301,"slug":"trauler","title":"Траулер","parent":271},{"id":306,"slug":"chotyrytaktnyi","title":"Четырехтактный","parent":302},{"id":307,"slug":"dvotaktnyi","title":"Двухтактный","parent":302},{"id":308,"slug":"e-tec","title":"E-Tec","parent":302},{"id":309,"slug":"e-tec-g2","title":"E-Tec G2","parent":302},{"id":310,"slug":"elektrychnyi","title":"Электрический","parent":302},{"id":311,"slug":"hidrotsykl-prychip","title":"Гидроцикл","parent":304},{"id":312,"slug":"kater-prychip","title":"Катер","parent":304},{"id":313,"slug":"choven-prychip","title":"Лодка","parent":304},{"id":314,"slug":"yakhta-prychip","title":"Яхта","parent":304},{"id":315,"slug":"dzhetbord","title":"Джетборд","parent":305},{"id":316,"slug":"flaibord","title":"Флайборд","parent":305},{"id":317,"slug":"pidvodnyi-skuter","title":"Подводный скутер","parent":305},{"id":268,"slug":"hidrotsykl","title":"Гидроцикл"},{"id":269,"slug":"kater","title":"Катер"},{"id":270,"slug":"choven","title":"Лодка"},{"id":271,"slug":"yakhta","title":"Яхта"},{"id":272,"slug":"debarkader","title":"Дебаркадер"},{"id":273,"slug":"katamaran","title":"Катамаран"},{"id":274,"slug":"plav-dacha","title":"Плав-дача"},{"id":275,"slug":"teplokhid","title":"Теплоход"},{"id":276,"slug":"khauz-bot","title":"Хауз-бот"},{"id":302,"slug":"chovnovyi-motor","title":"Лодочный двигатель"},{"id":303,"slug":"ponton","title":"Понтон"},{"id":304,"slug":"prychip-vodnoho-transportu","title":"Прицеп для водного транспорта"},{"id":305,"slug":"rozvahy-na-vodi","title":"Развлечения на воде"}]

/***/ }),

/***/ 1159:
/***/ (function(module, exports) {

module.exports = [{"id":1938,"slug":"euro-i","title":"Euro I"},{"id":2018,"slug":"euro-ii","title":"Euro II"},{"id":2019,"slug":"euro-iii","title":"Euro III"},{"id":2020,"slug":"euro-iv","title":"Euro IV"},{"id":2021,"slug":"euro-v","title":"Euro V"},{"id":74153,"slug":"euro-vi","title":"Euro VI"}]

/***/ }),

/***/ 1160:
/***/ (function(module, exports) {

module.exports = [{"id":null,"title":"Продажа и аренда","value":null},{"id":1,"title":"Только аренда","value":1},{"id":0,"title":"Только продажа","value":0}]

/***/ }),

/***/ 1161:
/***/ (function(module, exports) {

module.exports = [{"id":null,"title":"C кредитными","value":null},{"id":1,"title":"Только кредит","value":1},{"id":0,"title":"Без кредита","value":0}]

/***/ }),

/***/ 1162:
/***/ (function(module, exports) {

module.exports = [{"title":"За все время"},{"id":"hours","title":"за 3 часа"},{"id":"day","title":"за день"},{"id":"week","title":"за неделю"},{"id":"month","title":"за месяц"}]

/***/ }),

/***/ 1163:
/***/ (function(module, exports) {

module.exports = [{"value":0.2,"title":"0.2 л"},{"value":0.4,"title":"0.4 л"},{"value":0.6,"title":"0.6 л"},{"value":0.8,"title":"0.8 л"},{"value":1,"title":"1.0 л"},{"value":1.2,"title":"1.2 л"},{"value":1.4,"title":"1.4 л"},{"value":1.6,"title":"1.6 л"},{"value":1.8,"title":"1.8 л"},{"value":2,"title":"2.0 л"},{"value":2.2,"title":"2.2 л"},{"value":2.4,"title":"2.4 л"},{"value":2.6,"title":"2.6 л"},{"value":2.8,"title":"2.8 л"},{"value":3,"title":"3.0 л"},{"value":3.5,"title":"3.5 л"},{"value":4,"title":"4.0 л"},{"value":4.5,"title":"4.5 л"},{"value":5,"title":"5.0 л"},{"value":5.5,"title":"5.5 л"},{"value":6,"title":"6.0 л"},{"value":7,"title":"7.0 л"},{"value":8,"title":"8.0 л"},{"value":9,"title":"9.0 л"},{"value":10,"title":"10.0 л"}]

/***/ }),

/***/ 1164:
/***/ (function(module, exports) {

module.exports = [{"id":1,"title":"Авто не в Украине","value":1},{"id":0,"title":"Авто в Украине","value":0},{"id":null,"title":"Неважно","value":null}]

/***/ }),

/***/ 1232:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./about": [
		209,
		12
	],
	"./about/": [
		209,
		12
	],
	"./about/index": [
		209,
		12
	],
	"./about/index.js": [
		209,
		12
	],
	"./advertising": [
		210,
		7
	],
	"./advertising-conditions": [
		211,
		11
	],
	"./advertising-conditions/": [
		211,
		11
	],
	"./advertising-conditions/index": [
		211,
		11
	],
	"./advertising-conditions/index.js": [
		211,
		11
	],
	"./advertising/": [
		210,
		7
	],
	"./advertising/index": [
		210,
		7
	],
	"./advertising/index.js": [
		210,
		7
	],
	"./biznes-paket": [
		212,
		3
	],
	"./biznes-paket/": [
		212,
		3
	],
	"./biznes-paket/index": [
		212,
		3
	],
	"./biznes-paket/index.js": [
		212,
		3
	],
	"./for-dealers": [
		213,
		5
	],
	"./for-dealers/": [
		213,
		5
	],
	"./for-dealers/index": [
		213,
		5
	],
	"./for-dealers/index.js": [
		213,
		5
	],
	"./for-privates": [
		214,
		6
	],
	"./for-privates/": [
		214,
		6
	],
	"./for-privates/index": [
		214,
		6
	],
	"./for-privates/index.js": [
		214,
		6
	],
	"./for-services": [
		215,
		8
	],
	"./for-services/": [
		215,
		8
	],
	"./for-services/index": [
		215,
		8
	],
	"./for-services/index.js": [
		215,
		8
	],
	"./help": [
		216,
		9
	],
	"./help/": [
		216,
		9
	],
	"./help/index": [
		216,
		9
	],
	"./help/index.js": [
		216,
		9
	],
	"./info-zapchasti": [
		217,
		4
	],
	"./info-zapchasti/": [
		217,
		4
	],
	"./info-zapchasti/index": [
		217,
		4
	],
	"./info-zapchasti/index.js": [
		217,
		4
	],
	"./law": [
		218,
		13
	],
	"./law/": [
		218,
		13
	],
	"./law/index": [
		218,
		13
	],
	"./law/index.js": [
		218,
		13
	],
	"./public-contract": [
		219,
		10
	],
	"./public-contract/": [
		219,
		10
	],
	"./public-contract/index": [
		219,
		10
	],
	"./public-contract/index.js": [
		219,
		10
	],
	"./terms": [
		220,
		14
	],
	"./terms/": [
		220,
		14
	],
	"./terms/index": [
		220,
		14
	],
	"./terms/index.js": [
		220,
		14
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 1232;

/***/ }),

/***/ 1233:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./metaTegs/ru.json": [
		572,
		27
	],
	"./metaTegs/uk.json": [
		573,
		26
	],
	"./ru.json": [
		1235,
		48
	],
	"./uk.json": [
		1236,
		47
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 1233;

/***/ }),

/***/ 1234:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./ru.json": [
		572,
		27
	],
	"./uk.json": [
		573,
		26
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 1234;

/***/ }),

/***/ 132:
/***/ (function(module, exports) {

module.exports = [{"title":"грн","symbol":"₴","translit":"uah","slug":"uah","id":1917},{"title":"$","symbol":"$","translit":"usd","slug":"usd","currency":"usd","id":1915},{"title":"€","symbol":"€","translit":"eur","slug":"eur","currency":"eur","id":1916}]

/***/ }),

/***/ 134:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getSelectedThunksBySlug; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return detectTransportType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return postPhotos; });
/* unused harmony export fetchVocabulary */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fillUserData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fillVocabulary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return normalizePlainOptionIDsToSelected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return parseDecimal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchAdvertAverage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchAveragePrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchAdvertItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return postAdvert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return updateAdvert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return prepareAdverObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getSortedPakages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return isDisabledPackage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_snakecase_keys__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_snakecase_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_snakecase_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_helpers_common__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_helpers_transportTypes__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_actions_advertForm__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_constants_advertForm__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_constants_json_priceStatuses_json__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_constants_json_priceStatuses_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_shared_constants_json_priceStatuses_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_helpers_locale__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_constants_json_countries_json__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_constants_json_countries_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_shared_constants_json_countries_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__arrays__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants_api__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_constants_payment__ = __webpack_require__(308);
var _this = this;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









// import CITIES from 'shared/constants/json/cities.json';





var getSelectedThunksBySlug = function getSelectedThunksBySlug(transportSlug) {
  switch (transportSlug) {
    case 'avto':
      {
        return __WEBPACK_IMPORTED_MODULE_3_shared_actions_advertForm__["a" /* carSetThunks */];
      }
    default:
      return __WEBPACK_IMPORTED_MODULE_3_shared_actions_advertForm__["d" /* otherTransportSetThunks */];
  }
};

var detectTransportType = function detectTransportType(transportSlug) {
  var rootSlug = (__WEBPACK_IMPORTED_MODULE_2_shared_helpers_transportTypes__["c" /* getRootTransportBySlug */](transportSlug) || {}).slug;

  return {
    isAvto: rootSlug === 'avto',
    isMoto: rootSlug === 'moto',
    isTruck: rootSlug === 'gruzovye',
    isBus: rootSlug === 'avtobus',
    isTechnics: rootSlug === 'spetstehnika',
    isTrailer: rootSlug === 'pritsepy',
    isWater: rootSlug === 'vodnyi-transport'
  };
};

var postPhotos = function postPhotos(fetch, id, token) {
  return Promise.all(
  /* photos */[].map(function () {
    return fetch(__WEBPACK_IMPORTED_MODULE_10__constants_api__["a" /* default */].ADVERT.photos(id), {
      method: 'POST',
      headers: { Authorization: 'JWT ' + token },
      body: ''
    });
  }));
};

var fetchVocabulary = function fetchVocabulary(fetch, vocabularyState, transportType, parentTransportType) {
  var missingVocabularyFields = Object.keys(vocabularyState).filter(function (key) {
    return !vocabularyState[key];
  });
  var vocabularyAPI = __WEBPACK_IMPORTED_MODULE_5_shared_constants_advertForm__["e" /* VOCABULARY */][transportType.slug];

  return Promise.all(missingVocabularyFields.map(function (field) {
    return vocabularyAPI[field] ? fetch(vocabularyAPI[field](parentTransportType.slug === 'moto' || field === 'categories' ? transportType.id : parentTransportType.id)).then(function (r) {
      return r.ok ? r.json() : [];
    }).then(function (response) {
      return _defineProperty({}, field, response);
    }) : Promise.resolve({});
  })).then(function (data) {
    return data.reduce(function (result, pair) {
      return _extends({}, result, pair);
    }, {});
  });
};

var fetchLocation = function fetchLocation(fetch, id) {
  return id ? fetch(__WEBPACK_IMPORTED_MODULE_10__constants_api__["a" /* default */].VOCABULARY.location(id)).then(function (r) {
    return r.json();
  }) : Promise.resolve();
};

var fillUserData = function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(fetch, store) {
    var shouldFetchLocation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var state, email, phones, location;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            state = store.getState();
            email = state.user.user.email || null;
            phones = (state.user.user.phones || []).filter(function (phone) {
              return phone.is_verified;
            }).map(function (phone) {
              return phone.number;
            });


            store.dispatch(__WEBPACK_IMPORTED_MODULE_3_shared_actions_advertForm__["g" /* selectedActions */].set.email(email));
            store.dispatch(__WEBPACK_IMPORTED_MODULE_3_shared_actions_advertForm__["g" /* selectedActions */].set.phones(phones));
            if (state.user.user.name) {
              store.dispatch(__WEBPACK_IMPORTED_MODULE_3_shared_actions_advertForm__["g" /* selectedActions */].set.contactName(state.user.user.name));
            }

            if (!shouldFetchLocation) {
              _context.next = 11;
              break;
            }

            _context.next = 9;
            return state.advertForm.selected.location || fetchLocation(fetch, state.user.user.location);

          case 9:
            location = _context.sent;


            if (location) {
              store.dispatch(__WEBPACK_IMPORTED_MODULE_3_shared_actions_advertForm__["g" /* selectedActions */].set.location(location));
            }

          case 11:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function fillUserData(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();

var fillVocabulary = function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(fetch, store, transportType, parentTransport) {
    var state, vocabularyTmp, locations, vocabulary, _ref4, makes, fetchedVocabulary;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            state = store.getState();
            vocabularyTmp = state.advertForm.vocabulary;
            locations = vocabularyTmp.locations, vocabulary = _objectWithoutProperties(vocabularyTmp, ['locations']);

            // Do not fetch locations data from API

            _context2.next = 5;
            return fetchVocabulary(fetch, vocabulary, transportType, parentTransport);

          case 5:
            _ref4 = _context2.sent;
            makes = _ref4.makes;
            fetchedVocabulary = _objectWithoutProperties(_ref4, ['makes']);


            store.dispatch(__WEBPACK_IMPORTED_MODULE_3_shared_actions_advertForm__["j" /* setFormVocabulary */](_extends({}, fetchedVocabulary, {
              locations: __WEBPACK_IMPORTED_MODULE_7_shared_helpers_locale__["b" /* getAllLocations */](true),
              // locations: CITIES,
              // todo: refactor this logic. We need countries from may be driven cars, but not "europeanCountries".
              europeanCountries: __WEBPACK_IMPORTED_MODULE_8_shared_constants_json_countries_json___default.a.filter(function (country) {
                return country.isEuropean || country.isUsa || country.includeInDrivenFrom;
              }),
              priceStatuses: __WEBPACK_IMPORTED_MODULE_6_shared_constants_json_priceStatuses_json___default.a,
              makes: [].concat(_toConsumableArray(parentTransport.slug !== 'avto' ? [__WEBPACK_IMPORTED_MODULE_5_shared_constants_advertForm__["d" /* OTHER_ITEM */]] : []), _toConsumableArray(vocabulary.makes || makes.sort(__WEBPACK_IMPORTED_MODULE_9__arrays__["b" /* compareByTitle */])))
            })));

          case 9:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function fillVocabulary(_x4, _x5, _x6, _x7) {
    return _ref3.apply(this, arguments);
  };
}();


var normalizePlainOptionIDsToSelected = function normalizePlainOptionIDsToSelected(options, optionsTree) {
  var firstLevelOptions = optionsTree.map(function (category) {
    return category.options;
  }).reduce(function (result, pack) {
    return [].concat(_toConsumableArray(result), _toConsumableArray(pack));
  }, []);

  var normalizedOptions = options.map(function (option) {
    var firstLevelParent = firstLevelOptions.find(function (firstLevelOption) {
      return firstLevelOption.children && firstLevelOption.children.find(function (child) {
        return child.id === option;
      });
    });

    return firstLevelParent ? _defineProperty({}, firstLevelParent.id, option) : _defineProperty({}, option, true);
  });

  return normalizedOptions.reduce(function (result, pack) {
    return _extends({}, result, pack);
  }, {});
};

var parseDecimal = function parseDecimal(value, intLength, decimalLength) {
  var newValue = value;

  if (value) {
    var strValue = '' + value;
    var indexOfDot = strValue.indexOf('.');
    var dotPosition = indexOfDot >= 0 ? indexOfDot : strValue.length;
    var intPart = strValue.substring(0, Math.min(dotPosition, intLength));
    var decPart = strValue.substring(dotPosition + 1, dotPosition + 1 + decimalLength);

    newValue = '' + intPart + (decPart ? '.' + decPart : '');
  }

  return newValue;
};

var fetchAdvertAverage = function fetchAdvertAverage(fetch, _ref7) {
  var make = _ref7.make,
      model = _ref7.model,
      year = _ref7.year;
  return fetch(__WEBPACK_IMPORTED_MODULE_10__constants_api__["a" /* default */].ADVERT.ALL('?' + __WEBPACK_IMPORTED_MODULE_4_query_string___default.a.stringify({
    make: make && make.id,
    model: model && model.id,
    year_from: year || undefined,
    year_to: year || undefined,
    per_page: 6
  }))).then(function (r) {
    return r.ok ? r.json() : null;
  }).then(function (adverts) {
    return adverts && adverts.results;
  });
};

var fetchAveragePrice = function fetchAveragePrice(fetch, _ref8) {
  var make = _ref8.make,
      model = _ref8.model,
      year = _ref8.year,
      currency = _ref8.currency,
      mileage = _ref8.mileage,
      _ref8$modification = _ref8.modification,
      modification = _ref8$modification === undefined ? null : _ref8$modification;
  return fetch(__WEBPACK_IMPORTED_MODULE_10__constants_api__["a" /* default */].CMM.averagePrice({
    make: make && make.id,
    model: model && model.id,
    year: year,
    currency: currency && currency.id ? currency.id : undefined,
    modification: modification && modification.id ? modification.id : undefined,
    mileage: mileage * 1000
  })).then(function (r) {
    return r.ok ? r.json() : null;
  }).then(function (averagePrice) {
    return !averagePrice && modification && modification.id ? fetchAveragePrice(fetch, { make: make, model: model, year: year, currency: currency, mileage: mileage * 1000 }) : averagePrice;
  });
};

var fetchAdvertItem = function fetchAdvertItem(id) {
  return fetch(__WEBPACK_IMPORTED_MODULE_10__constants_api__["a" /* default */].ADVERT.ITEM(id)).then(function (r) {
    return r.json();
  });
};

var postAdvert = function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(fetch, _ref10, token) {
    var _ref10$photos = _ref10.photos,
        photos = _ref10$photos === undefined ? [] : _ref10$photos,
        advert = _objectWithoutProperties(_ref10, ['photos']);

    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt('return', fetch(__WEBPACK_IMPORTED_MODULE_10__constants_api__["a" /* default */].ADVERT.ALL(), {
              method: 'POST',
              headers: { Authorization: 'JWT ' + token },
              body: JSON.stringify(_extends({}, advert, {
                photos: photos
              }))
            }).then(function (response) {
              if (!response.ok) {
                throw new Error('Не удалось отправить форму. Попробуйте позже.');
              }

              return response;
            }).then(function (r) {
              return r.json();
            }));

          case 1:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this);
  }));

  return function postAdvert(_x8, _x9, _x10) {
    return _ref9.apply(this, arguments);
  };
}();


var updateAdvert = function updateAdvert(fetch, token, id, payload) {
  var isSpare = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  return fetch(isSpare ? __WEBPACK_IMPORTED_MODULE_10__constants_api__["a" /* default */].SPARE_PARTS.ITEM(id) : __WEBPACK_IMPORTED_MODULE_10__constants_api__["a" /* default */].ADVERT.ITEM(id), {
    method: 'PATCH',
    body: JSON.stringify(payload),
    headers: { Authorization: 'JWT ' + token }
  });
};

var prepareAdverObject = function prepareAdverObject(data, formData, user) {
  var options = data.options,
      advertFields = data.advertFields,
      colorFeatures = data.colorFeatures,
      transport = data.transport,
      category = data.category,
      regNumber = data.regNumber,
      drivenFrom = data.drivenFrom,
      usedWarranty = data.usedWarranty,
      formState = _objectWithoutProperties(data, ['options', 'advertFields', 'colorFeatures', 'transport', 'category', 'regNumber', 'drivenFrom', 'usedWarranty']);

  var rootTransport = __WEBPACK_IMPORTED_MODULE_2_shared_helpers_transportTypes__["b" /* getRootTransport */](transport);
  var isMoto = rootTransport.slug === 'moto';

  var photos = formData.newExistingPhotos;
  if (!(formState.phones && formState.phones[0]) && user.phones) {
    formState.phones = user.phones.map(function (dat) {
      return dat.number;
    });
  }

  return _extends({}, __WEBPACK_IMPORTED_MODULE_0_snakecase_keys___default.a(_extends({}, __WEBPACK_IMPORTED_MODULE_1_shared_helpers_common__["l" /* objectsToIDs */](_extends({}, formState, {
    transport: isMoto ? transport : rootTransport,
    category: category || transport,
    reg_number: regNumber,
    driven_from: Number(drivenFrom),
    used_warranty: usedWarranty
  })), advertFields, {
    options: __WEBPACK_IMPORTED_MODULE_9__arrays__["f" /* objectToArray */](options).map(function (item) {
      return parseInt(item, 10);
    }),
    colorFeatures: __WEBPACK_IMPORTED_MODULE_9__arrays__["f" /* objectToArray */](colorFeatures).map(function (item) {
      return parseInt(item, 10);
    })
  })), {
    photos: photos,
    'transport-group': rootTransport.slug
    // [!!promoteInSocial && 'promote_in_social']: promoteInSocial,
  });
};


var getSortedPakages = function getSortedPakages(packages) {
  return packages.sort(function (a, b) {
    if (!__WEBPACK_IMPORTED_MODULE_11_shared_constants_payment__["f" /* PACKAGES_SORT */][a.slug] || !__WEBPACK_IMPORTED_MODULE_11_shared_constants_payment__["f" /* PACKAGES_SORT */][b.slug]) return 0;
    return __WEBPACK_IMPORTED_MODULE_11_shared_constants_payment__["f" /* PACKAGES_SORT */][a.slug] - __WEBPACK_IMPORTED_MODULE_11_shared_constants_payment__["f" /* PACKAGES_SORT */][b.slug];
  });
};

/**
 * Is package should be disabled
 * @param {Object} user 
 * @param {Object} pkg 
 * @param {Object} advert 
 * @returns 
 */
var isDisabledPackage = function isDisabledPackage(user, pkg, advert) {
  if (pkg.slug === user.tariff.slug) return true;
  if (pkg.slug === 'v2-maxi' && user.tariff.slug === 'v2') return true;
  if (pkg.slug === 'v2-maxi' && advert.active === 1) return true;
  return false;
};

/***/ }),

/***/ 135:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return partsFormActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setVocabularyField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hrefSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return partsFormAsyncSetActions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_constants_api__ = __webpack_require__(29);
var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




// Setters

var DEFAULT_TRANSPORT_ID = 1;

var partsFormActions = __WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* createActions */]({
  partsForm: {
    selected: {
      set: {
        transport: undefined,
        make: undefined,
        model: undefined,
        rubric: undefined,
        subRubric: undefined,
        yearFrom: undefined,
        yearTo: undefined,
        price: undefined,
        currency: undefined,
        contactName: undefined,
        email: undefined,
        location: undefined,
        sellingType: undefined,
        description: undefined,
        phones: undefined
      },
      add: {
        photos: undefined,
        phones: undefined
      },
      remove: {
        photos: undefined,
        phones: undefined
      },
      toggle: {
        advertFields: undefined
      }
    },
    vocabulary: {
      transports: undefined,
      makes: undefined,
      models: undefined,
      rubrics: undefined,
      subRubrics: undefined,
      currency: undefined,
      locations: undefined,
      company: undefined,
      typeWork: undefined,
      count: undefined,
      url: undefined,
      query: undefined,
      queryobj: undefined
    },
    isEdit: undefined,
    clear: undefined
  }
});

var set = partsFormActions.partsForm.selected.set;

var setVocabularyField = partsFormActions.partsForm.vocabulary;

// Async actions
var hrefSet = function hrefSet(_ref) {
  var query = _ref.query,
      url = _ref.url;
  return function (dispatch) {
    var queryobj = Object.assign({}, query);
    if (query) {
      delete queryobj.fields;
      delete queryobj.per_page;

      dispatch(setVocabularyField.query(__WEBPACK_IMPORTED_MODULE_1_query_string___default.a.stringify(queryobj)));
      dispatch(setVocabularyField.queryobj(queryobj));
    }
    if (url) {
      dispatch(setVocabularyField.url(url.replace(/\/\//g, '/')));
    }
  };
};
var partsFormAsyncSetActions = {
  transport: function transport(_transport) {
    return function (dispatch, getState, _ref2) {
      var fetch = _ref2.fetch;

      dispatch(set.transport(_transport));
      dispatch(partsFormAsyncSetActions.make(null));
      dispatch(partsFormAsyncSetActions.rubric(null));
      // dispatch(partsFormAsyncSetActions.company(null));
      dispatch(setVocabularyField.makes(null));
      dispatch(setVocabularyField.rubrics(null));
      // dispatch(setVocabularyField.company(null));

      if (_transport) {
        return Promise.all([fetch(__WEBPACK_IMPORTED_MODULE_2_shared_constants_api__["a" /* default */].VOCABULARY.makes(_transport.id)).then(function (r) {
          return r.json();
        }).then(function (makes) {
          return dispatch(setVocabularyField.makes(makes));
        }), fetch(__WEBPACK_IMPORTED_MODULE_2_shared_constants_api__["a" /* default */].VOCABULARY.rubrics(_transport.id)).then(function (r) {
          return r.json();
        }).then(function (rubrics) {
          return dispatch(setVocabularyField.rubrics(rubrics));
        })]);
      }

      return Promise.resolve();
    };
  },
  rubric: function rubric(_rubric) {
    return function (dispatch, getState, _ref3) {
      var fetch = _ref3.fetch;

      dispatch(set.rubric(_rubric));
      dispatch(set.subRubric(null));
      dispatch(setVocabularyField.subRubrics(null));

      if (_rubric) {
        return fetch(__WEBPACK_IMPORTED_MODULE_2_shared_constants_api__["a" /* default */].VOCABULARY.rubrics(getState().partsForm.selected.transport.id, _rubric.id)).then(function (r) {
          return r.json();
        }).then(function (subRubrics) {
          return dispatch(setVocabularyField.subRubrics(subRubrics));
        });
      }

      return Promise.resolve();
    };
  },
  make: function make(_make) {
    return function (dispatch, getState, _ref4) {
      var fetch = _ref4.fetch;

      dispatch(set.make(_make));
      dispatch(set.model(null));
      dispatch(setVocabularyField.models(null));
      var transport = getState().partsForm.selected.transport;
      var transportId = transport && transport.id || DEFAULT_TRANSPORT_ID;

      if (_make && _make.id >= 0) {
        return fetch(__WEBPACK_IMPORTED_MODULE_2_shared_constants_api__["a" /* default */].CMM.modelsByMake(_make.id, transportId) + '&all').then(function (r) {
          return r.json();
        }).then(function (models) {
          return dispatch(setVocabularyField.models(models));
        });
      }

      return Promise.resolve();
    };
  },
  company: function company(data) {
    return function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState, _ref6) {
        var fetch = _ref6.fetch;

        var _getState, _getState$partsForm, _getState$partsForm$v, queryobj, typeWorkPartsForm, _getState$searchForm$, company, makes, typeWork, transport, isOfficial, location, buf, bufNext;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _getState = getState(), _getState$partsForm = _getState.partsForm;
                _getState$partsForm = _getState$partsForm === undefined ? {} : _getState$partsForm;
                _getState$partsForm$v = _getState$partsForm.vocabulary;
                _getState$partsForm$v = _getState$partsForm$v === undefined ? {} : _getState$partsForm$v;
                queryobj = _getState$partsForm$v.queryobj, typeWorkPartsForm = _getState$partsForm$v.typeWork, _getState$searchForm$ = _getState.searchForm.selected, company = _getState$searchForm$.company, makes = _getState$searchForm$.makes, typeWork = _getState$searchForm$.typeWork, transport = _getState$searchForm$.transport, isOfficial = _getState$searchForm$.isOfficial, location = _getState.globals.location;
                buf = {
                  per_page: 20,
                  fields: 'id,title'
                };
                bufNext = {
                  fields: 'id,per_page'
                };

                if (queryobj && queryobj.tags) {
                  buf.tags = queryobj.tags;
                  bufNext.tags = queryobj.tags;
                }
                if (location) {
                  buf.location = location.id;
                  bufNext.location = location.id;
                }
                if (transport) {
                  buf.transport = transport.id;
                }

                if (!(data && data.count)) {
                  _context2.next = 19;
                  break;
                }

                if (company) {
                  bufNext.title = company.title;
                } else if (bufNext.title) {
                  delete bufNext.title;
                }
                if (makes) {
                  bufNext.makes = Number(makes.id);
                } else if (bufNext.makes) {
                  delete bufNext.makes;
                }
                if (transport) {
                  bufNext.transport = Number(transport.id);
                } else if (bufNext.transport) {
                  delete bufNext.transport;
                }
                if (isOfficial) bufNext.is_official = isOfficial;else delete bufNext.is_official;

                if (typeWork) {
                  bufNext.services = typeWork.id;
                } else if (bufNext.services) {
                  delete bufNext.services;
                }
                hrefSet({ query: bufNext })(dispatch, null, {});

                _context2.next = 19;
                return fetch(__WEBPACK_IMPORTED_MODULE_2_shared_constants_api__["a" /* default */].FIRMS.NEW_COUNT('?' + __WEBPACK_IMPORTED_MODULE_1_query_string___default.a.stringify(bufNext))).then(function (r) {
                  return r.json();
                }).then(function (dat) {
                  dispatch(setVocabularyField.count(dat.count));
                });

              case 19:
                if (!(!data || data && data.str)) {
                  _context2.next = 23;
                  break;
                }

                if (data && data.str && typeof data.str === 'string' && data.str.length > 0 && data.str.length < 1000) {
                  buf.title = data.str;
                }
                _context2.next = 23;
                return fetch(__WEBPACK_IMPORTED_MODULE_2_shared_constants_api__["a" /* default */].FIRMS.ALL('?' + __WEBPACK_IMPORTED_MODULE_1_query_string___default.a.stringify(buf))).then(function () {
                  var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
                    var res;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return response.json();

                          case 2:
                            res = _context.sent;

                            if (response.ok && res.results) {
                              dispatch(setVocabularyField.company(res.results));
                            } else {
                              dispatch(setVocabularyField.company([]));
                            }

                          case 4:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this);
                  }));

                  return function (_x4) {
                    return _ref7.apply(this, arguments);
                  };
                }()).catch(function () {
                  return dispatch(setVocabularyField.company([]));
                });

              case 23:
                if (!(!data || !typeWorkPartsForm)) {
                  _context2.next = 26;
                  break;
                }

                _context2.next = 26;
                return Promise.all([fetch(__WEBPACK_IMPORTED_MODULE_2_shared_constants_api__["a" /* default */].VOCABULARY.makes(1)).then(function (r) {
                  return r.json();
                }).then(function (dat) {
                  return dispatch(setVocabularyField.makes(dat));
                }), fetch(__WEBPACK_IMPORTED_MODULE_2_shared_constants_api__["a" /* default */].FIRMS.TYPE_WORK()).then(function (r) {
                  return r.json();
                }).then(function (dat) {
                  return dispatch(setVocabularyField.typeWork(dat));
                })]);

              case 26:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }));

      return function (_x, _x2, _x3) {
        return _ref5.apply(this, arguments);
      };
    }();
  }
};


/***/ }),

/***/ 17:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return HISTORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return NOTIFICATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FAVORITES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return HOME_SPECIAL_CARS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return HOME_NEWS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return HOME_COUNTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADVERT_TOP_CARS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return MOTO_SET_ADVERTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADVERT_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SEARCH_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GLOBALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return JOURNAL; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LOADING = {
  START: 'LOADING_STARTED',
  DONE: 'LOADING_DONE',
  SET_INITIAL: 'LOADING_SET_INITIAL'
};

var USER = {
  SET_SESSION: 'SET_SESSION',
  SET_USER: 'SET_USER',
  SET_PHONE: 'SET_PHONE',
  SET_BALANCE: 'SET_BALANCE',
  SET_BALANCE_IS_FETCHING: 'SET_BALANCE_IS_FETCHING',
  REMOVE_PHONE: 'REMOVE_PHONE',
  LOGOUT: 'LOGOUT',
  REGISTRATION: 'REGISTRATION',
  BEFORE_REGISTRATION: 'BEFORE_REGISTRATION',
  ERROR: 'ERROR',
  SET_SAVED_SEARCHES: 'SET_SAVED_SEARCHES',
  SET_SHOW_SAVE_SEARCH_BTN: 'SET_SHOW_SAVE_SEARCH_BTN'
};
var HISTORY = {
  CURRENT_PATH_SET: 'HISTORY_CURRENT_PATH_SET',
  CURRENT_ROUTE_NAME_SET: 'HISTORY_CURRENT_ROUTE_NAME_SET',
  PREVIOUS_ROUTE_NAME_SET: 'HISTORY_PREVIOUS_ROUTE_NAME_SET',
  PREVIOUS_PATH_SET: 'HISTORY_PREVIOUS_PATH_SET',
  NEXT_SEARCH_ITEM_INDEX: 'HISTORY_NEXT_SEARCH_ITEM_INDEX'
};

var NOTIFICATIONS = {
  ENQUEUE: 'NOTIFICATIONS_ENQUEUE',
  SHIFT: 'NOTIFICATIONS_SHIFT'
};

var FAVORITES = {
  SET: 'FAVORITES_SET',
  ADD: 'FAVORITES_ADD',
  REMOVE: 'FAVORITES_REMOVE',
  TOGGLE: 'FAVORITES_TOGGLE'
};

var HOME_SPECIAL_CARS = {
  SET: 'HOME_SPECIAL_CARS_SET'
};

var HOME_NEWS = {
  SET: 'HOME_NEWS'
};

var HOME_COUNTERS = {
  SET: 'HOME_COUNTERS'
};

var ADVERT_TOP_CARS = {
  SET: 'ADVERT_TOP_CARS'
};

var MOTO_SET_ADVERTS = {
  SET: 'MOTO_SET_ADVERTS'
};

/* ADVERT FORM */

var ADVERT_FORM = {
  SELECTED: {
    SET__ID: 'SET__ID',
    SET__ACTIVE: 'SET__ACTIVE',
    SET__TRANSPORT: 'SET__TRANSPORT',
    SET__MAKE: 'SET__MAKE',
    SET__MODEL: 'SET__MODEL',
    SET__GENERATION: 'SET__GENERATION',
    SET__YEAR: 'SET__YEAR',
    SET__CURRENCY: 'SET__CURRENCY',
    SET__ENGINE: 'SET__ENGINE',
    SET__DRIVE: 'SET__DRIVE',
    SET__GEARBOX: 'SET__GEARBOX',
    SET__MODIFICATION: 'SET__MODIFICATION',
    SET__EQUIPMENT: 'SET__EQUIPMENT',
    SET__PHOTOS: 'SET__PHOTOS',
    SET__VIDEO: 'SET__VIDEO',
    SET__COLOR: 'SET__COLOR',
    SET__MILEAGE: 'SET__MILEAGE',
    SET__MILEAGE_UNIT: 'SET__MILEAGE_UNIT',
    SET__VIN: 'SET__VIN',
    SET__PRICE: 'SET__PRICE',
    SET__DESCRIPTION: 'SET__DESCRIPTION',
    SET__SERIES: 'SET__SERIES',
    SET__BODY: 'SET__BODY',
    SET__OPTIONS: 'SET__OPTIONS',
    SET__LOCATION: 'SET__LOCATION',
    SET__CONTACT_NAME: 'SET__CONTACT_NAME',
    SET__EMAIL: 'SET__EMAIL',
    SET__PHONES: 'SET__PHONES',
    SET__ABROAD: 'SET__ABROAD',
    SET__DRIVEN_FROM: 'SET__DRIVEN_FROM',
    ADD__PHONE: 'ADD__PHONE',
    REMOVE__PHONE: 'REMOVE__PHONE',
    ADD__PHOTOS: 'ADD__PHOTOS',
    REMOVE__PHOTOS: 'REMOVE__PHOTOS',
    TOGGLE__COLOR_FEATURES: 'TOGGLE__COLOR_FEATURES',
    TOGGLE__STATUSES: 'TOGGLE__STATUSES',
    TOGGLE__ADVERT_FIELDS: 'TOGGLE__ADVERT_FIELDS',
    CLEAR__OPTIONS: 'CLEAR__OPTIONS',
    TOGGLE__CLARIFY_PRICE: 'TOGGLE__CLARIFY_PRICE',
    SET__CLARIFY_PRICE: 'SET__CLARIFY_PRICE',
    SET__CLARIFY_PRICE_LINK: 'SET__CLARIFY_PRICE_LINK',
    SET__CATEGORY: 'SET__CATEGORY',
    SET__ENGINE_ORDER: 'SET__ENGINE_ORDER',
    SET__TACTS: 'SET__TACTS',
    SET__CAPACITY: 'SET__CAPACITY',
    SET__CAPACITY_UNIT: 'SET__CAPACITY_UNIT',
    SET__POWER: 'SET__POWER',
    SET__POWER_UNIT: 'SET__POWER_UNIT',
    SET__CABIN: 'SET__CABIN',
    SET__UNLOADING: 'SET__UNLOADING',
    SET__ECOTYPE: 'SET__ECOTYPE',
    SET__CABIN_SUSPENSION: 'SET__CABIN_SUSPENSION',
    SET__CHASSIS_SUSPENSION: 'SET__CHASSIS_SUSPENSION',
    SET__SEATS: 'SET__SEATS',
    SET__TONNAGE: 'SET__TONNAGE',
    SET__CAPACITY_BODY: 'SET__CAPACITY_BODY',
    SET__AXISES: 'SET__AXISES',
    SET__DIMENSION_WIDTH: 'SET__DIMENSION_WIDTH',
    SET__DIMENSION_HEIGHT: 'SET__DIMENSION_HEIGHT',
    SET__DIMENSION_LENGTH: 'SET__DIMENSION_LENGTH',
    SET__DIMENSION_WEIGHT: 'SET__DIMENSION_WEIGHT',
    SET__CAPACITY_BUCKET: 'SET__CAPACITY_BUCKET',
    SET__LAYING_WIDTH: 'SET__LAYING_WIDTH',
    SET__LIFT_HEIGHT: 'SET__LIFT_HEIGHT',
    SET__ADMISSION_HEIGHT: 'SET__ADMISSION_HEIGHT',
    SET__ARM_BOOM: 'SET__ARM_BOOM',
    SET__DEP_BIG: 'SET__DEP_BIG',
    SET__PRODUCTIVITY: 'SET__PRODUCTIVITY',
    SET__CAPACITY_BODY_TYPE: 'SET__CAPACITY_BODY_TYPE',
    SET__SUSPENSION: 'SET__SUSPENSION',
    SET__BRAKES: 'SET__BRAKES',
    SET__MODEL_TITLE: 'SET__MODEL_TITLE',
    SET__MAKE_TITLE: 'SET__MAKE_TITLE',
    SET__OVERALL_LENGTH: 'SET__OVERALL_LENGTH',
    SET__DRY_WEIGHT: 'SET__DRY_WEIGHT',
    SET__DRAFT: 'SET__DRAFT',
    SET__DISPLACEMENT: 'SET__DISPLACEMENT',
    SET__FUEL_TANK: 'SET__FUEL_TANK',
    SET__WATER_TANK: 'SET__WATER_TANK',
    SET__SEAWORTHINESS_CLASS: 'SET__SEAWORTHINESS_CLASS',
    SET__REG_NUMBER: 'SET__REG_NUMBER',
    SET__USED_WARRANTY: 'SET__USED_WARRANTY'
  },
  // Data
  DATA_MODELS_SET: 'ADVERT_FORM_DATA_MODELS_SET',
  DATA_MODIFICATIONS_SET: 'ADVERT_FORM_DATA_MODIFICATIONS_SET',
  DATA_EQUIPMENTS_SET: 'ADVERT_FORM_DATA_EQUIPMENTS_SET',
  DATA_PRICES_SET: 'ADVERT_FORM_DATA_PRICES_SET',
  DATA_EXISTING_PHOTOS_SET: 'ADVERT_FORM_DATA_EXISTING_PHOTOS_SET',
  DATA_EXISTING_PHOTOS_SET_NEW: 'DATA_EXISTING_PHOTOS_SET_NEW',
  DATA_EXISTING_ADVERTS_SET_NEW: 'DATA_EXISTING_ADVERTS_SET_NEW',
  DATA_NEW_ADVERT: 'DATA_NEW_ADVERT',
  DATA_CURRENT_FORM_STEP: 'DATA_CURRENT_FORM_STEP',
  DATA_YEARS_SET: 'ADVERT_FORM_DATA_YEARS_SET',
  DATA_GENERATIONS_SET: 'ADVERT_FORM_DATA_GENERATIONS_SET',
  DATA_SERIES_SET: 'ADVERT_FORM_DATA_SERIES_SET',
  DATA_DRIVES_SET: 'ADVERT_FORM_DATA_DRIVES_SET',
  DATA_GEARBOXES_SET: 'ADVERT_FORM_DATA_GEARBOXES_SET',
  DATA_AVERAGE_PRICE_SET: 'ADVERT_FORM_DATA_AVERAGE_PRICE_SET',
  DATA_ADVERTS_AVERAGE_PRICE_SET: 'ADVERT_FORM_DATA_ADVERTS_AVERAGE_PRICE_SET',
  DATA_AVERAGE_PRICE_PARAMS_SET: 'ADVERT_FORM_DATA_AVERAGE_PRICE_PARAMS_SET',
  DATA_WARRANTY_SET: 'ADVERT_FORM_DATA_WARRANTY_SET',
  DATA_SHOW_AVERAGE_PRICE_SET: 'ADVERT_FORM_DATA_SHOW_AVERAGE_PRICE_SET',
  // Vocabulary
  VOCABULARY_SET: 'ADVERT_FORM_VOCABULARY_SET',
  VOCABULARY_CLEAR: 'ADVERT_FORM_VOCABULARY_CLEAR',
  // Clear
  CLEAR: 'ADVERT_FORM_CLEAR',
  //
  SET_IS_EDIT: 'ADVERT_FORM_SET_IS_EDIT',
  //
  SET_IS_CLEAR_BTN: 'ADVERT_FORM_SET_IS_CLEAR_BTN'
};

/* SEARCH FORM */

var searchFormSelectedFields = ['SET__MAKE', 'SET__MAKES', 'SET__MODEL', 'SET__GENERATION', 'SET__YEAR_FROM', 'SET__YEAR_TO', 'SET__MILEAGE_FROM', 'SET__COMPANY', 'SET__TYPE_WORK', 'SET__MILEAGE_TO', 'SET__PRICE_FROM', 'SET__PRICE_TO', 'SET__MONTHLY', 'SET__PREPAID', 'SET__POWER_FROM', 'SET__POWER_TO', 'SET__POWER_UNIT', 'SET__CAPACITY_FROM', 'SET__CAPACITY_TO', 'SET__CAPACITY_UNIT', 'SET__CURRENCY', 'SET__ENGINE', 'SET__DRIVE', 'SET__GEARBOX', 'SET__MILEAGE_UNIT', 'SET__CATEGORY', 'SET__ENGINE_ORDER', 'SET__TACTS', 'SET__TRANSPORT_CHILD', 'SET__SERIES', 'SET__BODY', 'SET__OPTIONS', 'SET__LOCATION', 'SET__DEALER', 'SET__FIRM', 'SET__TRANSPORT', 'SET__ORDERING', 'SET__PERIOD', 'SET__IS_RENT', 'SET__IS_NEW', 'SET__HAS_NEW', 'SET__IS_USED', 'SET__TAGS', 'SET__IS_ORIGINAL', 'SET__IS_ANALOGUE', 'SET__ABROAD', 'SET__FROM_DEALER',
// Avto
'SET__DRIVEN_FROM', 'SET__USED_WARRANTY',
// Truck
'SET__ECOTYPE', 'SET__UNLOADING', 'SET__TONNAGE_FROM', 'SET__TONNAGE_TO',
// Bus
'SET__SEATS',
// Technics
'SET__CAPACITY_BODY_FROM', 'SET__CAPACITY_BODY_TO', 'SET__CAPACITY_BUCKET_FROM', 'SET__CAPACITY_BUCKET_TO', 'SET__LAYING_WIDTH_FROM', 'SET__LAYING_WIDTH_TO', 'SET__LIFT_HEIGHT_FROM', 'SET__LIFT_HEIGHT_TO', 'SET__ADMISSION_HEIGHT_FROM', 'SET__ADMISSION_HEIGHT_TO', 'SET__ARM_BOOM_FROM', 'SET__ARM_BOOM_TO', 'SET__DEP_BIG_FROM', 'SET__DEP_BIG_TO', 'SET__PRODUCTIVITY_FROM', 'SET__PRODUCTIVITY_TO',
//
'SET__IN_STOCK', 'SET__IS_UNDER_THE_ORDER', 'SET__IS_CRASHED', 'SET__IS_NOT_CLEARED', 'SET__IS_SWAP', 'SET__IS_UNDER_LOAN', 'SET__IS_SALE_ON_CREDIT', 'SET__COLORS', 'SET__PHOTOS', 'SET__FROM_AUCTION', 'SET__IS_OFFICIAL', 'SET__Q', 'SET__QUERY', 'SET__TEST_DRIVE', 'SET__TRADE_IN', 'SET__CREDIT', 'SET__INSURANCE', 'SET__ACCESSORIES', 'SET__RUBRIC', 'SET__SPARETYPE',
// 'SET__STATE',
// 'SET__PRICE',
// 'SET__DESCRIPTION',
// 'SET__WHEEL',
// 'SET__CREDIT',
// 'SET__CUSTOMS',
'TOGGLE__COLORS', 'TOGGLE__COLOR_FEATURES', 'TOGGLE__STATUSES', 'TOGGLE__PRICE_STATUSES', 'CLEAR__OPTIONS'];

var SEARCH_FORM = {
  // { SET__MAKE: 'SET__MAKE', ... }
  SELECTED: searchFormSelectedFields.reduce(function (object, field) {
    return _extends({}, object, _defineProperty({}, field, field));
  }, {}),
  // Results
  RESULTS_SET: 'SEARCH_FORM_RESULTS_SET',
  COUNTS_SET: 'SEARCH_FORM_COUNTS_SET',
  // Data
  DATA_COUNT_SET: 'SEARCH_FORM_DATA_COUNT_SET',
  DATA_MAKES_COUNTER_SET: 'SEARCH_FORM_DATA_COUNTER_SET',
  DATA_BRAND_TO_CHOSE_SET: 'SEARCH_FORM_DATA_BRAND_TO_CHOSE_SET',
  DATA_MODELS_SET: 'SEARCH_FORM_DATA_MODELS_SET',
  DATA_GENERATIONS_SET: 'SEARCH_FORM_DATA_GENERATIONS_SET',
  DATA_SPARETYPES_SET: 'DATA_SPARETYPES_SET',

  // to remove
  DATA_MODIFICATIONS_SET: 'SEARCH_FORM_DATA_MODIFICATIONS_SET',
  DATA_EQUIPMENTS_SET: 'SEARCH_FORM_DATA_EQUIPMENTS_SET',
  DATA_PRICES_SET: 'SEARCH_FORM_DATA_PRICES_SET',
  DATA_YEARS_SET: 'SEARCH_FORM_DATA_YEARS_SET',
  DATA_SERIES_SET: 'SEARCH_FORM_DATA_SERIES_SET',

  // Vocabulary
  VOCABULARY_SET: 'SEARCH_FORM_VOCABULARY_SET',

  // Clear
  CLEAR: 'SEARCH_FORM_CLEAR',
  RESET_ALL: 'SEARCH_FORM_RESET_ALL'
};

var GLOBALS = {
  PROMOTE_IN_SOCIAL_SET: 'GLOBALS_PROMOTE_IN_SOCIAL_SET',
  LOCATION_SET: 'GLOBALS_LOCATION_SET',
  FINGERPRINT_SET: 'GLOBALS_FINGERPRINT_SET',
  SET_REDIRECT_URL: 'GLOBALS_SET_REDIRECT_URL',
  RATIO_SET: 'GLOBALS_RATIO_SET',
  TARGETING_ARGUMENTS_SET: 'TARGETING_ARGUMENTS_SET',
  SEO_SEARCH_URLS: 'SEO_SEARCH_URLS',
  PAYMENT_SET_MODAL: 'PAYMENT_SET_MODAL',
  DATA_LAYER_SET: 'DATA_LAYER_SET',
  BANNER_SHOW: 'BANNER_SHOW',
  BANNER_UPDATE: 'BANNER_UPDATE',
  BANNER_HIDE: 'BANNER_HIDE',
  SEO_TEXT_SET: 'GLOBALS_SEO_TEXT_SET',
  DEALER_SLUG_SET: 'GLOBALS_DEALER_SLUG_SET',
  // insurance start
  SET_INSURANCE_ORDERS: 'SET_INSURANCE_ORDERS',
  SET_INSURANCE_REGIONS: 'SET_INSURANCE_REGIONS',
  SET_INSURANCE_FILTERS: 'SET_INSURANCE_FILTERS',
  SET_INSURANCE_MAKES: 'SET_INSURANCE_MAKES',
  SET_SELECTED_VALUES: 'SET_SELECTED_VALUES',
  SET_SELECTED_OFFER: 'SET_SELECTED_OFFER',
  SET_ORDER_WITH_HASH: 'SET_ORDER_WITH_HASH',
  SET_FILL_DATA: 'SET_FILL_DATA',
  SET_OFFERS_DATA: 'SET_OFFERS_DATA',
  SET_IS_NUMBER_BLOCK: 'SET_IS_NUMBER_BLOCK',
  SET_ORDER_FOR_EDIT: 'SET_ORDER_FOR_EDIT',
  SET_SHOW_CONFIRM_MODAL: 'SET_SHOW_CONFIRM_MODAL',
  // insurance end
  SET_IS_APPROVE_PUB: 'SET_IS_APPROVE_PUB'
};

var JOURNAL = {
  SET_NEWS: 'SET_NEWS',
  SET_VIDEO_TOPICS: 'SET_VIDEO_TOPICS',
  SET_VIDEO_FILTERS: 'SET_VIDEO_FILTERS',
  SET_SELECTED_VIDEO_PARAMS: 'SET_SELECTED_VIDEO_PARAMS',
  SET_SELECTED_VIDEO_DATA: 'SET_SELECTED_VIDEO_DATA',
  SET_VIDEO_HEAD_FILTER: 'SET_VIDEO_HEAD_FILTER'
};

/***/ }),

/***/ 184:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IS_MOBILE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return numberWithSpaces; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getTitleOrEmpty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getFondyCheckoutUrl; });
/* unused harmony export postWithRedirect */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return objectsToIDs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return chainPromises; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return disableReactIntlLocaleErrors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getResultFromStoreByKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return imageBgStyle; });
/* unused harmony export parseEvent */
/* unused harmony export setDataToDebug */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return doRedirectToCheckout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return iniRedirectToCheckout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return adjustLinksTitle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_modules__ = __webpack_require__(103);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



var IS_MOBILE = "desktop" === 'mobile';

var numberWithSpaces = function numberWithSpaces(number) {
  var _$split = ('' + number).split('.'),
      _$split2 = _slicedToArray(_$split, 1),
      intPart = _$split2[0];

  return intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};

var getTitleOrEmpty = function getTitleOrEmpty(object) {
  return object && object.title || '';
};

var getFondyCheckoutUrl = function getFondyCheckoutUrl(data) {
  var p24 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var receipt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var redirectUrl = data.checkout_url;
  if (p24) {
    redirectUrl = redirectUrl + '&autoredirect=p24';
  }
  if (receipt) {
    redirectUrl = redirectUrl + '&autoinit=receipt';
  }
  return redirectUrl;
};

var postWithRedirect = function postWithRedirect(url) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var form = document.createElement('form');
  form.method = 'POST';
  form.action = url;

  Object.entries(data).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    var input = document.createElement('input');

    input.type = 'hidden';
    input.name = key;
    input.value = value;

    form.appendChild(input);
  });

  form.style.display = 'none';
  document.body.appendChild(form);
  form.submit();
};

var getDisplayName = function getDisplayName(WrappedComponent) {
  if (!WrappedComponent) {
    return 'no_component_provided';
  }

  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

var objectsToIDs = function objectsToIDs(state) {
  var newState = {};

  Object.entries(state).forEach(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        value = _ref4[1];

    if (value != null) {
      if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && !Array.isArray(value)) {
        if (value.id || value.id === 0) {
          newState[key] = value.id;
        }
      } else {
        newState[key] = value;
      }
    }
  });

  return newState;
};

var chainPromises = function chainPromises(promises) {
  return promises.reduce(function (prev, cur) {
    return prev.then(cur);
  }, Promise.resolve());
};

var disableReactIntlLocaleErrors = function disableReactIntlLocaleErrors(console) {
  if (true) {
    var error = console.error;

    // eslint-disable-next-line no-param-reassign
    console.error = function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (!(('' + args).includes('for locale: "ru"') || '' + args.includes('using message id as fallback'))) {
        error.apply(undefined, args);
      }
    };
  }
};

/* Discouraged */

var getResultFromStoreByKey = function getResultFromStoreByKey(store, key) {
  return store.getState().searchForm && store.getState().searchForm.results ? store.getState().searchForm.results[key] : null;
};

var imageBgStyle = function imageBgStyle(img) {
  var fill = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'cover';
  return {
    background: 'url(' + __WEBPACK_IMPORTED_MODULE_0_shared_modules__["u" /* urlReplace */](img && img.replace('http:', 'https:')) + ') no-repeat 50%/' + fill
  };
};

var parseEvent = function parseEvent(e) {
  return parseInt(e.target.value, 10);
};

var setDataToDebug = function setDataToDebug(url, data, toDebugJson) {
  if (String(url).includes('opel/zafira-2/gruziya/')) {
    return _extends({}, toDebugJson, data);
  }
  return null;
};

var doRedirectToCheckout = function doRedirectToCheckout(url) {
  if (typeof window.customOpenWindow === 'undefined' || !window.customOpenWindow || window.customOpenWindow.closed || typeof window.customOpenWindow.closed === 'undefined') {
    // if pop-up is blocked
    return window.location.replace(url);
  }
  window.customOpenWindow.location = url;
  return window.customOpenWindow.location;
};

var iniRedirectToCheckout = function iniRedirectToCheckout() {
  window.customOpenWindow = window.open('', '_blank');
};

var adjustLinksTitle = function adjustLinksTitle(canonicalLinks, prefix) {
  var postfix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  var canonicalListData = [];
  if (canonicalLinks && canonicalLinks.length) {
    if (canonicalLinks[0].title.indexOf(prefix) === -1) {
      canonicalListData = canonicalLinks.map(function (item) {
        return _extends({}, item, {
          title: (prefix + ' ' + item.title + ' ' + postfix).trim()
        });
      });
    } else {
      canonicalListData = [].concat(_toConsumableArray(canonicalLinks));
    }
  }
  return canonicalListData;
};

/***/ }),

/***/ 185:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory__ = __webpack_require__(1066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory__);




// Navigation manager, e.g. history.push('/home')
// https://github.com/mjackson/history
/* harmony default export */ __webpack_exports__["a"] = (true && __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory___default.a());

/***/ }),

/***/ 192:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/helpers/api.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createVocabularyForTypes = function createVocabularyForTypes(types, value) {
  return types.map(function (key) {
    return _defineProperty({}, key, value);
  }).reduce(function (result, current) {
    return _extends({}, result, current);
  });
};
// CONCATENATED MODULE: ./src/shared/constants/advertForm.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MAX_UPLOADED_PHOTOS_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return OTHER_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FORM_STEPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FORM_STEPS_TITLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return VOCABULARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return submenuItems; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_constants_api__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_helpers_transportTypes__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_transportTypes_json__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_transportTypes_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shared_constants_json_transportTypes_json__);
var advertForm__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }






/* General constants */

var MAX_UPLOADED_PHOTOS_COUNT = 20;
var OTHER_ITEM = {
  id: null,
  title: 'Другая'
};

var FORM_STEPS = {
  MAIN: 'MAIN',
  PUBLISH_AND_PAY: 'PUBLISH_AND_PAY',
  QUALITY: 'QUALITY'
};

var FORM_STEPS_TITLE = {
  MAIN: 'Основная информация',
  PUBLISH_AND_PAY: 'Публикация и оплата',
  QUALITY: 'Качество объявления'
};

/* Vocabulary */

// Types
var motoTypes = ['moto'].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2_shared_helpers_transportTypes__["a" /* getChildTransportsBySlug */]('moto').map(function (type) {
  return type.slug;
})));
var busTypes = ['avtobus'].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2_shared_helpers_transportTypes__["a" /* getChildTransportsBySlug */]('avtobus').map(function (type) {
  return type.slug;
})));
var technicsTypes = ['spetstehnika'].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2_shared_helpers_transportTypes__["a" /* getChildTransportsBySlug */]('spetstehnika').map(function (type) {
  return type.slug;
})));
var waterTypes = ['vodnyi-transport'].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2_shared_helpers_transportTypes__["a" /* getChildTransportsBySlug */]('vodnyi-transport').map(function (type) {
  return type.slug;
})));
var trailerTypes = ['pritsepy'].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2_shared_helpers_transportTypes__["a" /* getChildTransportsBySlug */]('pritsepy').map(function (type) {
  return type.slug;
})));
var truckTypes = ['gruzovye'].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2_shared_helpers_transportTypes__["a" /* getChildTransportsBySlug */]('gruzovye').map(function (type) {
  return type.slug;
})));

// Classifiers
var _API$VOCABULARY = __WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].VOCABULARY,
    categories = _API$VOCABULARY.subtypes,
    services = _API$VOCABULARY.services,
    makes = _API$VOCABULARY.makes,
    drives = _API$VOCABULARY.drives,
    options = _API$VOCABULARY.options,
    engines = _API$VOCABULARY.engines,
    gearboxes = _API$VOCABULARY.gearboxes,
    locations = _API$VOCABULARY.locations,
    colors = _API$VOCABULARY.colors,
    colorFeatures = _API$VOCABULARY.colorFeatures,
    currencies = _API$VOCABULARY.currencies,
    tacts = _API$VOCABULARY.tacts,
    engineOrders = _API$VOCABULARY.engineOrders,
    ecotypes = _API$VOCABULARY.ecotypes,
    unloadings = _API$VOCABULARY.unloadings,
    suspensions = _API$VOCABULARY.suspensions,
    brakes = _API$VOCABULARY.brakes,
    cabins = _API$VOCABULARY.cabins,
    cabinSuspensions = _API$VOCABULARY.cabinSuspensions,
    chassisSuspensions = _API$VOCABULARY.chassisSuspensions,
    seaworthinessClasses = _API$VOCABULARY.seaworthinessClasses;


var sharedPart = {
  services: services,
  makes: makes,
  drives: drives,
  options: options,
  engines: engines,
  gearboxes: gearboxes,
  locations: locations,
  colors: colors,
  colorFeatures: colorFeatures,
  currencies: currencies
};

var VOCABULARY = advertForm__extends({
  // Avto
  avto: advertForm__extends({}, sharedPart)
}, createVocabularyForTypes(motoTypes, advertForm__extends({}, sharedPart, {
  categories: categories,
  tacts: tacts,
  engineOrders: engineOrders
})), createVocabularyForTypes(truckTypes, advertForm__extends({}, sharedPart, {
  categories: categories,
  ecotypes: ecotypes,
  unloadings: unloadings,
  cabins: cabins,
  cabinSuspensions: cabinSuspensions,
  chassisSuspensions: chassisSuspensions
})), createVocabularyForTypes(busTypes, advertForm__extends({}, sharedPart, {
  categories: categories,
  ecotypes: ecotypes
})), createVocabularyForTypes(technicsTypes, advertForm__extends({}, sharedPart, {
  categories: categories,
  ecotypes: ecotypes,
  unloadings: unloadings
})), createVocabularyForTypes(waterTypes, advertForm__extends({}, sharedPart, {
  categories: categories,
  ecotypes: ecotypes,
  unloadings: unloadings,
  seaworthinessClasses: seaworthinessClasses
})), createVocabularyForTypes(trailerTypes, advertForm__extends({}, sharedPart, {
  categories: categories,
  unloadings: unloadings,
  suspensions: suspensions,
  brakes: brakes
})));

var submenuItems = [].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_3_shared_constants_json_transportTypes_json___default.a.filter(function (type) {
  return type.isInAdvertFormNavigation;
}).map(function (item) {
  return { route: '/add/' + item.slug + '/', title: item.title };
})), [{ route: '/add/zapchasti/', title: 'Запчасти' }]);

/***/ }),

/***/ 194:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getChildTransportsBySlug; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getRootTransport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getRootTransportBySlug; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getRootTransportType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_constants_json_transportTypes_json__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_constants_json_transportTypes_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_shared_constants_json_transportTypes_json__);


var getChildTransportsBySlug = function getChildTransportsBySlug(slug) {
  var id = __WEBPACK_IMPORTED_MODULE_0_shared_constants_json_transportTypes_json___default.a.find(function (type) {
    return type.slug === slug;
  }).id;
  return __WEBPACK_IMPORTED_MODULE_0_shared_constants_json_transportTypes_json___default.a.filter(function (type) {
    return type.parents.includes(id);
  });
};

var getRootTransport = function getRootTransport(transport) {
  if (!transport) {
    return transport;
  }

  // TODO: recurse
  return transport.parents.length === 0 ? transport : __WEBPACK_IMPORTED_MODULE_0_shared_constants_json_transportTypes_json___default.a.find(function (t) {
    return t.id === transport.parents[0];
  });
};

var getRootTransportBySlug = function getRootTransportBySlug(transportSlug) {
  return getRootTransport(__WEBPACK_IMPORTED_MODULE_0_shared_constants_json_transportTypes_json___default.a.find(function (type) {
    return type.slug === transportSlug;
  }));
};

var getRootTransportType = function getRootTransportType(transport) {
  if (!transport) {
    return null;
  } else if (transport.parents && transport.parents.length > 0) {
    return getRootTransportType(transport.parents[0]);
  } else if (transport.slug) {
    return transport;
  }

  return null;
};

/***/ }),

/***/ 288:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defineOutOfPageSlot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return problemSlot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return problemSlotFunc; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return scrollFun; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return targetingCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return time; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return googletagSlotFn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__googletag__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(437);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };





var scrollSetTimeout = null;
var blockDisplay = false;
// let blockDisplayAfterScroll = false;
// const heightScrollToShow = 330;

var defineOutOfPageSlot = {
  ab_mobile_web_catfish: 'div-gpt-ad-1510224093566-0'
};
var problemSlot = {
  mobile_web_top: 'mobile_web_top',
  ab_branding_top: 'branding_top',
  style: {
    ab_mobile_web_catfish: { id: 'banner' },
    ab_mobile_web_catfish_button: { id: 'close_ab_mobile_web_catfish' }
  }
};
var problemSlotFunc = function problemSlotFunc() {
  window.App.dispatch(__WEBPACK_IMPORTED_MODULE_0_shared_actions_globals__["a" /* bannerHide */]());
  var bannerOne = window.document.getElementById(problemSlot.style.ab_mobile_web_catfish.id);
  if (bannerOne) {
    bannerOne.parentNode.removeChild(bannerOne);
    window.AbStor.blockAbInstallNext = false;
    blockDisplay = false;
    window.AbStor.blockAbInstall = false;
  }
};
var scrollFun = function scrollFun() {
  // if (window.scrollY >= heightScrollToShow && blockDisplayAfterScroll === false) {
  //   blockDisplayAfterScroll = true;
  //   // eslint-disable-next-line no-use-before-define
  //   time(0, 1000);
  // }

  var bannerShowWidth = window.innerWidth < window.innerHeight;
  var changeObserver = function changeObserver() {
    if (!window.AbStor.blockAbInstall && window.document.getElementById('close')) {
      document.querySelector('#close').click(function () {
        problemSlotFunc();
      });
      window.document.getElementById('close').onclick = function () {
        problemSlotFunc();
      };
      window.AbStor.blockAbInstall = true;
    }
    if (!window.AbStor.blockAbInstallNext && window.document.getElementById(problemSlot.style.ab_mobile_web_catfish_button.id)) {
      document.querySelector('#' + problemSlot.style.ab_mobile_web_catfish_button.id).click(function () {
        problemSlotFunc();
      });
      window.document.getElementById(problemSlot.style.ab_mobile_web_catfish_button.id).onclick = function () {
        problemSlotFunc();
      };
      window.AbStor.blockAbInstallNext = true;
    }
  };
  if (!bannerShowWidth) {
    blockDisplay = false;
    clearTimeout(scrollSetTimeout);
    scrollSetTimeout = setTimeout(function () {
      if (document.getElementById(problemSlot.style.ab_mobile_web_catfish.id)) {
        document.getElementById(problemSlot.style.ab_mobile_web_catfish.id).style.display = 'none';
      }
    }, 700);
  } else if (bannerShowWidth && !blockDisplay) {
    clearTimeout(scrollSetTimeout);
    scrollSetTimeout = setTimeout(function () {
      var state = window.App.getState && window.App.getState();
      var _state$globals = state.globals;
      _state$globals = _state$globals === undefined ? {} : _state$globals;
      var _state$globals$banner = _state$globals.banner,
          banner = _state$globals$banner === undefined ? {} : _state$globals$banner;

      if (banner.slot_1) {
        var abMobileWebCatfish = window.document.getElementById(problemSlot.style.ab_mobile_web_catfish.id);
        var abMobileBodyABIdBlock = window.document.getElementById('bodyABIdBlock');
        var scrollY = window.scrollY;
        var windowHeight = 0; // window.innerHeight;

        if (abMobileWebCatfish && scrollY >= windowHeight) {
          blockDisplay = true;
          abMobileWebCatfish.style.display = 'block';

          var observer = new MutationObserver(changeObserver);
          if (abMobileBodyABIdBlock) {
            observer.observe(abMobileBodyABIdBlock, { attributes: true, childList: true });
          }

          changeObserver();
        }
      }
    }, 700);
  }
};
var targetingCheck = function targetingCheck(targeting) {
  var state = void 0;

  if (typeof targeting === 'function' && targeting() && targeting().targetingAds) {
    window.App.dispatch(__WEBPACK_IMPORTED_MODULE_0_shared_actions_globals__["C" /* setTargetingArguments */](targeting().targetingAds));
    state = { getState: window.App.getState };
  } else {
    state = { getState: window.App.getState };
  }

  if (state && state.getState && typeof state.getState === 'function') {
    var _state$getState = state.getState(),
        _state$getState$globa = _state$getState.globals;

    _state$getState$globa = _state$getState$globa === undefined ? {} : _state$getState$globa;
    var _state$getState$globa2 = _state$getState$globa.targeting;
    _state$getState$globa2 = _state$getState$globa2 === undefined ? {} : _state$getState$globa2;
    var targetingSlot = _state$getState$globa2.targetingSlot;


    if (targetingSlot) {
      var obj = targetingSlot && Object.keys(targetingSlot)[0] in targetingSlot && targetingSlot || false;
      return obj;
    }
    return false;
  }

  return false;
};
var time = function time(iter) {
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;

  if (!(typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' || !((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window.googletag)) return;
  var displayArr = Object.keys(window.AbStor.DefineSlot);
  if (window.googletag && window.googletag.apiReady && window.AbStor.DefineSlot && window.googletag.pubadsReady && displayArr[0] in window.AbStor.DefineSlot) {
    clearTimeout(window.AbStor.SetTimeoutrefresh);
    window.AbStor.SetTimeoutrefresh = setTimeout(function () {
      var refresh = [];
      Object.keys(window.AbStor.DefineSlot).map(function (a) {
        if (defineOutOfPageSlot.ab_mobile_web_catfish === window.AbStor.adUnitNameId[a] && window.document.getElementById(defineOutOfPageSlot.ab_mobile_web_catfish)) {
          problemSlotFunc();
          window.App.dispatch(__WEBPACK_IMPORTED_MODULE_0_shared_actions_globals__["b" /* bannerShow */]());
        }
        if (window.document.getElementById(window.AbStor.adUnitNameId[a])) {
          refresh.push(window.AbStor.DefineSlot[a]);
        }
        return '';
      });

      window.googletag.pubads().refresh(refresh);
      displayArr.map(function (a) {
        if (window.document.getElementById(window.AbStor.adUnitNameId[a])) {
          if (!defineOutOfPageSlot[a]) {
            window.googletag.display(window.AbStor.adUnitNameId[a]);
          }
        }
        return '';
      });
      scrollFun();
    }, timeout);
  } else if (iter < 10 /* 00 */) {
      var buf = iter;
      setTimeout(time, 100 + iter * 1.1, buf += 1);
    }
};
var googletagSlotFn = function googletagSlotFn(_ref, render) {
  var targetingAds = _ref.targetingAds,
      _ref$id = _ref.id,
      id = _ref$id === undefined ? '' : _ref$id,
      componentWillUnmount = _ref.componentWillUnmount;

  if (!id) return { slotId: '' };
  for (var a = 0, b = __WEBPACK_IMPORTED_MODULE_2__store__["b" /* slots */], c = b.length; a < c; a += 1) {
    if (b[a].slotId === id) {
      return render ? b[a] : __WEBPACK_IMPORTED_MODULE_1__googletag__["a" /* default */]({
        componentWillUnmount: componentWillUnmount ? [_extends({}, b[a], {
          targetingArguments: targetingAds ? function () {
            return { targetingAds: targetingAds };
          } : null
        })] : false,
        slots: [_extends({}, b[a], {
          targetingArguments: targetingAds ? function () {
            return { targetingAds: targetingAds };
          } : null
        })]
      });
    }
  }
  return { slotId: '' };
};

/***/ }),

/***/ 29:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TRANSPORTS_PATH */
/* unused harmony export CLASSIFIERS_PATH */
/* unused harmony export originalAdverts */
/* unused harmony export safeAdverts */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__json_transportTypes_json__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__json_transportTypes_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__json_transportTypes_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__payment__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stats__ = __webpack_require__(497);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/* eslint-disable max-len, prettier/prettier */
/* global __DEV__ */






var basePath = '/api';
var TRANSPORTS_PATH = basePath + '/transports';
var CLASSIFIERS_PATH = basePath + '/classifiers';
var SEO_URLS = basePath + '/seo-urls';
var API_EXPRESS = '/api-urls';
var POLIS_PATH = basePath + '/polis';
var SHOW_IN_AB_PARAMS = 'show_in_ab=1';
// const FIN_UP = 'https://api.finup.lv/v1';
//
var DEFAULT_TYPE = __WEBPACK_IMPORTED_MODULE_1__json_transportTypes_json___default.a.find(function (item) {
  return item.slug === 'avto';
}).id;

/**
 * The word '_posts' is used in paths instead of 'adverts' to be replaced later (in the proxy).
 * This is because requests containing that word are being cancelled by AdBlock.
 * */
var originalAdverts = 'adverts';
var safeAdverts = '_posts';

var API = {
  // LEASING_PARAM: {
  //   GET_TEMPERATURE: `${FIN_UP}/temperature/`,
  //   GET_VERIFICATION: `${FIN_UP}/verification/`,
  // },
  ADVERT: {
    ALL: function ALL() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return basePath + '/' + safeAdverts + '/' + params;
    },
    ITEM: function ITEM(id) {
      return basePath + '/' + safeAdverts + '/' + id + '/';
    },
    SIMILAR: function SIMILAR(id, similarities) {
      return basePath + '/' + safeAdverts + '/' + id + '/similar/?similarities=' + similarities;
    },
    LIST: basePath + '/' + safeAdverts + '/',
    MY: function MY(_ref) {
      var query = _objectWithoutProperties(_ref, []);

      return basePath + '/' + safeAdverts + '/my/?' + __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify(query);
    },
    COUNT: basePath + '/' + safeAdverts + '/_count/',
    MAKES_COUNT: basePath + '/makes/' + safeAdverts + '/_count/',
    MODELS_COUNT: basePath + '/models/' + safeAdverts + '/_count/',
    photos: function photos(id) {
      return basePath + '/' + safeAdverts + '/' + id + '/photos/';
    },
    photosNew: function photosNew() {
      return basePath + '/upload/';
    },
    photosItem: function photosItem(photoId) {
      return basePath + '/' + safeAdverts + '/photos/' + photoId + '/';
    },
    STATUS: function STATUS(advertsIds) {
      return basePath + '/accounts/' + safeAdverts + '/?id=' + advertsIds.join(',');
    },
    FAVORITES: basePath + '/favorites/',
    FAVORITES_ADVERTS: function FAVORITES_ADVERTS(_ref2) {
      var transportId = _ref2.transportId;
      return basePath + '/favorites-adverts/?' + __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify({ transport: transportId });
    },
    PHONES: function PHONES(advertID) {
      return basePath + '/' + safeAdverts + '/' + advertID + '/phones/';
    },
    PARAMS_BY_ID: {
      make: function make(id) {
        return TRANSPORTS_PATH + '/makes/' + id;
      },
      model: function model(id) {
        return TRANSPORTS_PATH + '/models/' + id;
      },
      engine: function engine(id) {
        return TRANSPORTS_PATH + '/engines/?id=' + id;
      },
      body: function body(id) {
        return TRANSPORTS_PATH + '/categories/?id=' + id;
      }
    },
    PARAMS_BY_REG_NUMBER: function PARAMS_BY_REG_NUMBER(regNumber) {
      return basePath + '/vehreg/vehicles/current/' + regNumber + '/';
    },
    warranty: function warranty(userId) {
      return basePath + '/dealers/?user=' + userId;
    },
    APPROVE_PUB: function APPROVE_PUB(userId, key) {
      return basePath + '/_posts/' + userId + '/approve-pub/?key=' + key;
    },
    SEARCH_SUB: basePath + '/' + safeAdverts + '/search-sub/',
    SEARCH_SUB_BY_ID: function SEARCH_SUB_BY_ID(id) {
      return basePath + '/' + safeAdverts + '/search-sub/' + id + '/';
    },
    //
    LEASING: {
      GET_PARAMS: API_EXPRESS + '/leasing/verification/',
      ADD_BITRIX_LEAD: 'https://avtobazar.bitrix24.ua/rest/1/hb181kj300s9yv0n/crm.lead.add/',

      ADD_FINUP_LEAD: API_EXPRESS + '/leasing/application/',
      ADD_AFINANCE_LEAD: API_EXPRESS + '/leasing/afinance/',
      ADD_AUTOMONEY_LEAD: API_EXPRESS + '/leasing/automoney/',
      GET_RATE: API_EXPRESS + '/leasing/rate/',
      GET_TEMPERATURE: API_EXPRESS + '/leasing/temperature/',

      REQUEST_ID: basePath + '/fin_up/otp/',
      SCORING: basePath + '/fin_up/scoring/'
    },
    //
    MICRO_CREDITS: {
      ADD: API_EXPRESS + '/microcredit/'
    },
    //
    CREDIT_MARKET: {
      ADD: API_EXPRESS + '/creditmarket/'
    },
    //
    LEASING_ULF24: {
      ADD_LEAD: API_EXPRESS + '/leasing/ulf24/addlead/',
      CALCULATE: API_EXPRESS + '/leasing/ulf24/calculate/'
    },
    LEASING_ULF: {
      ADD_LEAD: API_EXPRESS + '/leasing/ulf/addlead/'
    },
    SUGGESTION: {
      ADD_SUGGESTION: API_EXPRESS + '/suggestion/add/'
    }

  },
  ARTICLES: function ARTICLES(url) {
    return SEO_URLS + '/leasing/?url=' + url;
  },

  AUTHORIZE: basePath + '/authorize/',
  PROFILE: basePath + '/users/profile/',
  USER_PROFILE: basePath + '/users/profile/',
  REGISTER: basePath + '/users/register/',
  SEND_MAIL: basePath + '/send_email/',
  SUPPORT_SET_MAIL: API_EXPRESS + '/support-mail/',
  SEND_CREDIT_MAIL: API_EXPRESS + '/credit-mail/',
  LEASING: API_EXPRESS + '/leasing/',
  SET_VIN: basePath + '/_posts/vin-check-claim/',
  GET_PHONE: function GET_PHONE(params) {
    return basePath + '/_posts/' + params + '/phones/';
  },
  USERS_AUTHORIZE: basePath + '/users/authorize/',
  USERS_AUTHORIZE_TOKEN: basePath + '/users/authorize/token/',
  USERS_RECOVERY: basePath + '/users/recovery/',
  USERS_VERIFY_RESEND: basePath + '/users/verify/resend/',
  USERS_VERIFY_GET: basePath + '/users/verify/',
  USERS_LOGISTICS: basePath + '/stats/',
  KATALOG_KOMPANIY_STO: '/katalog-kompaniy/sto/',
  KATALOG_KOMPANIY: function KATALOG_KOMPANIY(params) {
    return '/katalog-kompaniy/' + params + '/';
  },
  USERS_USER_CHECK_CODE: basePath + '/users/check/',
  CHANGE_USER_PASSWORD: basePath + '/users/profile/set-password/',
  SOCIAL_LOGIN: {
    FB: basePath + '/users/authorize/facebook/'
  },
  CMM: {
    allSeries: function allSeries() {
      return TRANSPORTS_PATH + '/categories';
    },
    allDrives: function allDrives() {
      return TRANSPORTS_PATH + '/drives';
    },
    allGearboxes: function allGearboxes() {
      return TRANSPORTS_PATH + '/gearboxes';
    },
    modelsByMake: function modelsByMake(makeID, transportID) {
      return TRANSPORTS_PATH + '/models/?' + __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify({ make: makeID, transport: transportID });
    },
    modelById: function modelById(modelID) {
      return TRANSPORTS_PATH + '/models/' + modelID + '/';
    },
    generationsByModel: function generationsByModel(modelID) {
      return TRANSPORTS_PATH + '/generations/?model=' + modelID;
    },
    generationById: function generationById(generationID) {
      return TRANSPORTS_PATH + '/generations/' + generationID + '/';
    },
    seriesByGeneration: function seriesByGeneration(generationID) {
      return TRANSPORTS_PATH + '/series/?generation=' + generationID;
    },
    seriesByModel: function seriesByModel(modelID) {
      return TRANSPORTS_PATH + '/series/?model=' + modelID;
    },
    modificationsBySeries: function modificationsBySeries(seriesID) {
      return TRANSPORTS_PATH + '/modifications/?series=' + seriesID;
    },
    equipmentsByModification: function equipmentsByModification(modificationID) {
      var typeID = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_TYPE;
      return TRANSPORTS_PATH + '/equipments/?modification=' + modificationID + '&transport=' + typeID;
    },
    //
    averagePrice: function averagePrice(params) {
      return CLASSIFIERS_PATH + '/average-price/?' + __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify(params);
    },
    //
    sparetypesBySection: function sparetypesBySection(sectionId) {
      return CLASSIFIERS_PATH + '/sparepart-sections/?parent=' + sectionId;
    },
    sparetypesById: function sparetypesById(subsectionId) {
      return CLASSIFIERS_PATH + '/sparepart-sections/?id=' + subsectionId;
    }
  },
  DEALER: {
    MAKES_COUNT: function MAKES_COUNT(id) {
      return basePath + '/makes/_posts/_count/?dealer=' + id;
    }
  },
  DEALERS: {
    ALL: function ALL() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return basePath + '/dealers/' + params;
    },
    COUNT: basePath + '/dealers/_count/',
    ITEM: function ITEM(slug) {
      return basePath + '/dealers/' + slug + '/';
    },
    MAKES_COUNT: basePath + '/makes/dealers/_count/',
    REQUEST_SERVICE: API_EXPRESS + '/dealer-services/'
  },
  FIRMS: {
    ALL: function ALL() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return basePath + '/firms/' + params;
    },
    ITEM: function ITEM(slug) {
      return basePath + '/firms/' + slug + '/';
    },
    TYPE_WORK: function TYPE_WORK() {
      return basePath + '/firms/services-for-filter/';
    },
    COUNT: basePath + '/firms/_count/',
    NEW_COUNT: function NEW_COUNT(params) {
      return basePath + '/firms/' + params;
    },
    TAGS_COUNT: basePath + '/firms/tags/_count/'
  },
  PHONES: {
    ADD: basePath + '/users/phones/',
    DELETE: function DELETE(id) {
      return basePath + '/users/phones/' + id + '/';
    },
    RESEND_CODE: basePath + '/users/phones/verify/resend/',
    VERIFY_PHONE: basePath + '/users/phones/verify/'
  },
  VOCABULARY: {
    authormakes: function authormakes() {
      var typeID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_TYPE;
      var authorId = arguments[1];
      return basePath + '/spareparts/author-makes/?author=' + authorId + '&transport=' + typeID;
    },
    authormodels: function authormodels(makeID, authorId) {
      return basePath + '/spareparts/author-models/?author=' + authorId + '&make=' + makeID;
    },
    subtypes: function subtypes(typeID) {
      return TRANSPORTS_PATH + '/types/?parent=' + typeID;
    },
    makes: function makes() {
      var typeID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_TYPE;
      return TRANSPORTS_PATH + '/makes/?transport=' + typeID;
    },
    drives: function drives() {
      var typeID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_TYPE;
      return TRANSPORTS_PATH + '/drives/?transport=' + typeID;
    },
    options: function options() {
      var typeID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_TYPE;
      return TRANSPORTS_PATH + '/options-tree/?transport=' + typeID;
    },
    engineFeatures: function engineFeatures() {
      var typeID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_TYPE;
      return TRANSPORTS_PATH + '/engine-features/?transport=' + typeID;
    },
    categories: function categories() {
      var typeID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_TYPE;
      return TRANSPORTS_PATH + '/categories/?transport=' + typeID;
    },
    types: function types() {
      var typeID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_TYPE;
      return TRANSPORTS_PATH + '/types/?parent=' + typeID;
    },
    engines: function engines() {
      var typeID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_TYPE;
      return TRANSPORTS_PATH + '/engines/?transport=' + typeID;
    },
    gearboxes: function gearboxes() {
      var typeID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_TYPE;
      return TRANSPORTS_PATH + '/gearboxes/?transport=' + typeID;
    },
    seaworthinessClasses: function seaworthinessClasses() {
      return API_EXPRESS + '/transports/seaworthiness-classes/';
    },
    locations: function locations() {
      return CLASSIFIERS_PATH + '/locations/all/?parent_id=1911';
    },
    locationsAll: function locationsAll(id) {
      return CLASSIFIERS_PATH + '/locations/all/' + (id && '?parent_id=' + id);
    },
    location: function location(id) {
      return CLASSIFIERS_PATH + '/locations/' + id + '/';
    },
    countries: CLASSIFIERS_PATH + '/locations/',
    colors: function colors() {
      return CLASSIFIERS_PATH + '/colors/';
    },
    colorFeatures: function colorFeatures() {
      return CLASSIFIERS_PATH + '/color-features/';
    },
    currencies: CLASSIFIERS_PATH + '/currencies/',
    services: function services() {
      return basePath + '/accounts/services/';
    },
    rubrics: function rubrics() {
      var typeID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_TYPE;
      var parentID = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return CLASSIFIERS_PATH + '/sparepart-sections/?transport=' + typeID + (parentID ? '&parent=' + parentID : '');
    },
    engineOrders: function engineOrders() {
      var typeID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_TYPE;
      return TRANSPORTS_PATH + '/engine-orders/?transport=' + typeID;
    },
    ecotypes: function ecotypes() {
      return TRANSPORTS_PATH + '/ecotypes/';
    },
    tacts: function tacts() {
      var typeID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_TYPE;
      return TRANSPORTS_PATH + '/tacts/?transport=' + typeID;
    },
    unloadings: function unloadings() {
      var typeID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_TYPE;
      return TRANSPORTS_PATH + '/unloadings/?transport=' + typeID;
    },
    suspensions: function suspensions(typeID) {
      return TRANSPORTS_PATH + '/suspensions/?transport=' + typeID;
    },
    brakes: function brakes(typeID) {
      return TRANSPORTS_PATH + '/brakes/?transport=' + typeID;
    },
    cabins: function cabins(typeID) {
      return TRANSPORTS_PATH + '/cabins/?transport=' + typeID;
    },
    cabinSuspensions: function cabinSuspensions(typeID) {
      return TRANSPORTS_PATH + '/cabin-suspensions/?transport=' + typeID;
    },
    chassisSuspensions: function chassisSuspensions(typeID) {
      return TRANSPORTS_PATH + '/chassis-suspensions/?transport=' + typeID;
    }
  },
  SEO: {
    SEARCH_URLS: function SEARCH_URLS(url) {
      var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return SEO_URLS + '/?' + __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify(_extends({ url: url }, query));
    },
    SEARCH_TRENDS: function SEARCH_TRENDS() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return SEO_URLS + '/trends/?' + __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify(query);
    },
    VIDEO_URLS: function VIDEO_URLS(url) {
      var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return SEO_URLS + '/?' + __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify(_extends({ url: url }, query));
    },
    SEARCH_TEXT: function SEARCH_TEXT() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return API_EXPRESS + '/seo-text?' + __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify(query);
    },
    SEARCH_MODEL: function SEARCH_MODEL() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return basePath + '/transports/models/' + query + '/';
    },
    SEARCH_GENERATIONS: function SEARCH_GENERATIONS() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return basePath + '/transports/generations/' + query + '/';
    }
  },
  ACCOUNTS: {
    BALANCE: basePath + '/accounts/info/',
    ORDERS: function ORDERS(userId) {
      return basePath + '/accounts/user/' + userId + '/orders/';
    },
    FREE_SLOTS_COUNT: function FREE_SLOTS_COUNT(transportID) {
      return basePath + '/accounts/free-slots-count/?transport=' + transportID;
    },
    FREE_SLOTS_COUNT_SPAREPARTS: basePath + '/accounts/spareparts-slots-count/'
  },
  PAYMENT: {
    // PORTMONE_GATEWAY: 'https://www.portmone.com.ua/gateway/',
    FONDY_GATEWAY: 'https://api.fondy.eu/api/checkout/redirect/',
    FONDY_ORDER_DATA: basePath + '/accounts/order-fondy-data/',
    FONDY_ORDER_CHECKOUT: basePath + '/accounts/order-fondy-checkout/',
    MONO_ORDER_DATA: basePath + '/accounts/order-mono-data/',
    MONO_ORDER_CHECKOUT: basePath + '/accounts/order-mono-checkout/',
    // LIQPAY_GATEWAY: 'https://www.liqpay.ua/api/3/checkout/',
    // LIQPAY_ORDER_DATA: `${basePath}/accounts/order-liqpay-data/`,
    ORDER_STATUS: '/accounts/order-status/',
    packages: function packages() {
      var kind = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_2__payment__["g" /* PACKAGES_TYPES */].C2C;
      return basePath + '/accounts/tariff-plans/?kind=' + kind;
    },
    orders: function orders() {
      return basePath + '/accounts/orders/';
    }
  },
  LOGOS: function LOGOS(slug) {
    return basePath + '/logos/' + slug + '/';
  },
  SPARE_PARTS: {
    ALL: function ALL(params) {
      return basePath + '/spareparts/' + (params || '');
    },
    COUNT: basePath + '/spareparts/_count/',
    ITEM: function ITEM(id) {
      return basePath + '/spareparts/' + id + '/';
    },
    ITEM_PHOTOS: function ITEM_PHOTOS(id) {
      return basePath + '/spareparts/' + id + '/photos/';
    },
    PHOTOS_ITEM: function PHOTOS_ITEM(photoId) {
      return basePath + '/spareparts/photos/' + photoId + '/';
    },
    PHONES: function PHONES(id) {
      return basePath + '/spareparts/' + id + '/phones/';
    },
    MY: function MY(params) {
      return basePath + '/spareparts/my/' + (params || '');
    },
    RUBRIC_COUNT: basePath + '/spareparts/rubrics/_count/',
    MAKES_COUNT: basePath + '/spareparts/makes/_count/'
  },
  STATS: {
    BASE: basePath + '/stats/',
    AGGS: function AGGS() {
      var identifiers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var dateFrom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      var objects = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [__WEBPACK_IMPORTED_MODULE_3__stats__["d" /* OBJECT_TYPES */].ADVERT];
      var field = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : __WEBPACK_IMPORTED_MODULE_3__stats__["a" /* AGGREGATION_FIELDS */].OBJECT;
      var interval = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : __WEBPACK_IMPORTED_MODULE_3__stats__["c" /* INTERVALS */].DAY;
      var events = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [__WEBPACK_IMPORTED_MODULE_3__stats__["b" /* EVENT_TYPES */].VIEW, __WEBPACK_IMPORTED_MODULE_3__stats__["b" /* EVENT_TYPES */].PHONE_CLICK, __WEBPACK_IMPORTED_MODULE_3__stats__["b" /* EVENT_TYPES */].REDIRECT];
      return basePath + '/stats/aggs/' + field + '/?' + __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify({
        id: identifiers.join(','),
        events: events.join(','),
        interval: interval,
        objects: objects,
        date_from: dateFrom
      }, { encode: false });
    },
    COUNT: function COUNT(ids) {
      var events = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [__WEBPACK_IMPORTED_MODULE_3__stats__["b" /* EVENT_TYPES */].VIEW];
      var objects = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [__WEBPACK_IMPORTED_MODULE_3__stats__["d" /* OBJECT_TYPES */].ADVERT];
      return basePath + '/stats/_count/?' + __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify({
        object: ids.join(','),
        events: events.join(','),
        objects: objects.join(',')
      }, { encode: false });
    }
  },
  JOURNAL: {
    ITEM: function ITEM(slug) {
      return basePath + '/posts/?slug=' + slug;
    },
    LIST: function LIST(_ref3) {
      var page = _ref3.page,
          tag = _ref3.tag,
          perPage = _ref3.perPage,
          agency = _ref3.agency,
          mainPage = _ref3.mainPage,
          _ref3$rubric = _ref3.rubric,
          rubric = _ref3$rubric === undefined ? ['news', 'promo', 'test-drive'].join(',') : _ref3$rubric,
          make = _ref3.make,
          model = _ref3.model,
          generation = _ref3.generation,
          showInAdvert = _ref3.showInAdvert,
          showInVideo = _ref3.showInVideo,
          ordering = _ref3.ordering,
          topic = _ref3.topic,
          language = _ref3.language;
      return basePath + '/posts/?' + SHOW_IN_AB_PARAMS + '&' + __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify({
        tag_slug: tag,
        rubric: rubric,
        per_page: perPage,
        main_page: mainPage,
        page: page,
        agency: agency,
        make: make,
        model: model,
        generation: generation,
        topic: topic,
        show_in_advert: showInAdvert,
        show_in_video: showInVideo,
        ordering: ordering,
        language: language
      }, { encode: false });
    },
    TEST_DRIVES: function TEST_DRIVES(_ref4) {
      var make = _ref4.make,
          model = _ref4.model,
          year = _ref4.year,
          generation = _ref4.generation,
          page = _ref4.page,
          language = _ref4.language;
      return basePath + '/posts/?' + SHOW_IN_AB_PARAMS + '&' + __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify({
        rubric: 'test-drive',
        make: make,
        model: model,
        year: year,
        generation: generation,
        page: page,
        language: language
      });
    },
    RUBRICS: function RUBRICS() {
      return basePath + '/posts/rubrics/';
    },
    TAGS: function TAGS(data) {
      return basePath + '/posts/tags/_count/?' + __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify(data) + '&' + SHOW_IN_AB_PARAMS;
    },
    SET_STATS: function SET_STATS() {
      return basePath + '/stats/';
    },
    VIDEO_TOPICS: function VIDEO_TOPICS(language) {
      return basePath + '/posts/topics/?' + __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify(language);
    }
  },
  CONTACT: basePath + '/contact/',
  RATINGS: {
    competitors: function competitors(_ref5) {
      var active = _ref5.active,
          packages = _ref5.packages;
      return basePath + '/ratings/competitors/?' + __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify({
        active: active,
        packages: packages
      }, { encode: false });
    }
  },
  NEW_CARS: basePath + '/vehicles/newcars/',
  CAR_DRIVE: {
    LIST: function LIST(params) {
      return basePath + '/firms/?' + __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify(params);
    },
    SEND_FORM: basePath + '/firms/car-drive-claim/'
  },
  CALCULATOR: function CALCULATOR(params) {
    return API_EXPRESS + '/calculate-customs-clearance?' + __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify(params);
  },
  POLIS: {
    OSAGO_FILTERS: function OSAGO_FILTERS(lang) {
      return POLIS_PATH + '/osago/filters/?langSign=' + lang;
    },
    REGIONS: function REGIONS(name, lang) {
      return POLIS_PATH + '/cities/?name=' + name + '&langSign=' + lang;
    },
    OFFERS: POLIS_PATH + '/osago/offers/',
    ORDERS_CREATE: function ORDERS_CREATE() {
      return POLIS_PATH + '/osago/orders/';
    },
    ORDERS_FILL: function ORDERS_FILL(orderHash) {
      return POLIS_PATH + '/osago/orders/fill/' + orderHash + '/';
    },
    MY_ORDERS: function MY_ORDERS(lang) {
      return POLIS_PATH + '/osago/orders/my/?langSign=' + lang;
    },
    MAKES: function MAKES() {
      return POLIS_PATH + '/makes/?name=';
    },
    MODELS: function MODELS(makeId) {
      return POLIS_PATH + '/models/?mark_id=' + makeId + '&name=';
    },
    CONFIRM_ORDER: function CONFIRM_ORDER(hash) {
      return POLIS_PATH + '/osago/orders/confirm/' + hash + '/';
    }
  },
  GET_ALL_DIALOGS: basePath + '/users/dialogs/',
  GET_DIALOG_MESSAGES: function GET_DIALOG_MESSAGES(dialogId) {
    return basePath + '/users/dialogs/' + dialogId + '/';
  },
  SEND_MESSAGES: function SEND_MESSAGES(advertId) {
    return basePath + '/_posts/' + advertId + '/send-message/';
  },
  SEND_MESSAGES_REPLY: function SEND_MESSAGES_REPLY(dialogId) {
    return basePath + '/users/dialogs/' + dialogId + '/reply/';
  }
};

/* harmony default export */ __webpack_exports__["a"] = (API);

/***/ }),

/***/ 296:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AVAILABLE_LOCALES; });
var AVAILABLE_LOCALES = ['ru', 'uk'];

/***/ }),

/***/ 308:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return URLS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PAYMENT_METHODS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ERRORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ORDER_STATUSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PACKAGES_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PACKAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PACKAGES_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PACKAGES_SORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return TARIFFS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return KINDS; });
var _PACKAGES_SORT;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable import/prefer-default-export */

var _ref = typeof window === 'undefined' ? {} : window.location,
    protocol = _ref.protocol,
    hostname = _ref.hostname,
    port = _ref.port;
// const HANDLER_URL = `/portmone/handle/`;


var HANDLER_URL = '/mono/handle/';

var URLS = {
  HANDLER_URL: HANDLER_URL,
  HANDLER_URL_FULL: protocol + '//' + hostname + (port ? ':' + port : '') + HANDLER_URL
};

var PAYMENT_METHODS = {
  // LIQPAY: 'liqpay',
  // PORTMONE: 'portmone',
  // FONDY_P24: 'fondy_p24',
  // FONDY: 'fondy',
  BALANCE: 'balance',
  INVOICE: 'invoice',
  MONO: 'mono'
};

var ERRORS = {
  PAYMENT_REQUIRED: 'Payment required.'
};

var ORDER_STATUSES = {
  PAID: 'paid'
};

// Packages

var PACKAGES_TYPES = {
  B2C: 'b2c',
  C2C: 'c2c',
  V2C2C: 'v2-'
};

var PACKAGES = {
  B2C: 'b2c-subscription',
  B2C_PLUS: 'b2c-plus-subscription',
  C2C_SLOT: 'c2c-slot',
  C2C_FREE: 'c2c-free',
  C2C_TURBO: 'c2c-turbo',
  C2C_FAST: 'c2c-fast',
  C2C_SINGLE: 'c2c-single-update',

  C2C_V2_TURBO: 'v2-turbo',
  C2C_V2_VIP: 'v2-vip',
  C2C_V2_MAXI: 'v2-maxi'
};

var PACKAGES_DETAILS = _defineProperty({}, PACKAGES.C2C_V2_MAXI, {
  months_count: 1,
  tariff: 'v2'
});

var PACKAGES_SORT = (_PACKAGES_SORT = {}, _defineProperty(_PACKAGES_SORT, PACKAGES.C2C_V2_TURBO, 1), _defineProperty(_PACKAGES_SORT, PACKAGES.C2C_V2_VIP, 2), _defineProperty(_PACKAGES_SORT, PACKAGES.C2C_V2_MAXI, 3), _PACKAGES_SORT);

var TARIFFS = {
  B2C: 'b2c'
};

var KINDS = {
  BALANCE_REFILL: 'balance-refill',
  SUBSCRIPTION: 'subscription',
  VIN_PAY: 'vin-check'
};

/***/ }),

/***/ 309:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return sity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return plural; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return pluralCrutch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return crutch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return rubrics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return gearboxes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return engines; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_constants_json_citiesGenAccusative_json__ = __webpack_require__(1051);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_constants_json_citiesGenAccusative_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_shared_constants_json_citiesGenAccusative_json__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


// noinspection NonAsciiCharacters
var sity = _extends({}, __WEBPACK_IMPORTED_MODULE_0_shared_constants_json_citiesGenAccusative_json___default.a, {
  'АР Крым': {
    ru: { genitive: 'Крыму', accusative: 'Крыма' },
    uk: { genitive: 'Криму', accusative: 'Крима' }
  },
  Винница: {
    ru: { genitive: 'Виннице', accusative: 'Винницы' },
    uk: { genitive: 'Вінниці', accusative: 'Вінниці' }
  },
  'Днепр (Днепропетровск)': {
    ru: { genitive: 'Днепропетровске', accusative: 'Днепропетровска' },
    uk: { genitive: 'Дніпропетровську', accusative: 'Дніпропетровська' }
  },
  Донецк: {
    ru: { genitive: 'Донецке', accusative: 'Донецка' },
    uk: { genitive: 'Донецьку', accusative: 'Донецька' }
  },
  Житомир: {
    ru: { genitive: 'Житомире', accusative: 'Житомира' },
    uk: { genitive: 'Житомирі', accusative: 'Житомира' }
  },
  Запорожье: {
    ru: { genitive: 'Запорожье', accusative: 'Запорожья' },
    uk: { genitive: 'Запоріжжі', accusative: 'Запоріжжя' }
  },
  'Ивано-Франковск': {
    ru: { genitive: 'Ивано-Франковске', accusative: 'Ивано-Франковска' },
    uk: { genitive: 'Івано-Франківську', accusative: 'Івано-Франківська' }
  },
  Киев: {
    ru: { genitive: 'Киеве', accusative: 'Киева' },
    uk: { genitive: 'Києві', accusative: 'Києва' }
  },
  'Киевская обл.': {
    ru: { genitive: 'Киевской области', accusative: 'Киевской области' },
    uk: { genitive: 'Київській області', accusative: 'Київської облласті' }
  },
  'Кривой Рог': {
    ru: { genitive: 'Кривом Рогу', accusative: 'Кривого Рога' },
    uk: { genitive: 'Кривому Розі', accusative: 'Кривого Рогу' }
  },
  'Кропивницкий (Кировоград)': {
    ru: { genitive: 'Кропивницком', accusative: 'Кропивницкого' },
    uk: { genitive: 'Кропивницькому', accusative: 'Кропивницького' }
  },
  Луганск: {
    ru: { genitive: 'Луганске', accusative: 'Луганска' },
    uk: { genitive: 'Луганську', accusative: 'Луганська' }
  },
  Луцк: {
    ru: { genitive: 'Луцке', accusative: 'Луцка' },
    uk: { genitive: 'Луцьку', accusative: 'Луцька' }
  },
  Львов: {
    ru: { genitive: 'Львове', accusative: 'Львова' },
    uk: { genitive: 'Львові', accusative: 'Львова' }
  },
  Николаев: {
    ru: { genitive: 'Николаеве', accusative: 'Николаева' },
    uk: { genitive: 'Миколаєві', accusative: 'Миколаїва' }
  },
  Нововолынск: {
    ru: { genitive: 'Нововолынске', accusative: 'Нововолынска' },
    uk: { genitive: 'Нововолинську', accusative: 'Нововолинська' }
  },
  Одесса: {
    ru: { genitive: 'Одессе', accusative: 'Одессы' },
    uk: { genitive: 'Одесі', accusative: 'Одеси' }
  },
  Полтава: {
    ru: { genitive: 'Полтаве', accusative: 'Полтавы' },
    uk: { genitive: 'Полтаві', accusative: 'Полтави' }
  },
  Ровно: {
    ru: { genitive: 'Ровно', accusative: 'Ровно' },
    uk: { genitive: 'Рівному', accusative: 'Рівного' }
  },
  Сумы: {
    ru: { genitive: 'Сумах', accusative: 'Сум' },
    uk: { genitive: 'Сумах', accusative: 'Сум' }
  },
  Тернополь: {
    ru: { genitive: 'Тернополе', accusative: 'Тернополя' },
    uk: { genitive: 'Тернополі', accusative: 'Тернополя' }
  },
  Ужгород: {
    ru: { genitive: 'Ужгороде', accusative: 'Ужгорода' },
    uk: { genitive: 'Ужгороді', accusative: 'Ужгорода' }
  },
  Харьков: {
    ru: { genitive: 'Харькове', accusative: 'Харькова' },
    uk: { genitive: 'Харкові', accusative: 'Харкова' }
  },
  Херсон: {
    ru: { genitive: 'Херсоне', accusative: 'Херсона' },
    uk: { genitive: 'Херсоні', accusative: 'Херсона' }
  },
  Хмельницкий: {
    ru: { genitive: 'Хмельницком', accusative: 'Хмельницкого' },
    uk: { genitive: 'Хмельницькому', accusative: 'Хмельницького' }
  },
  Черкассы: {
    ru: { genitive: 'Черкассах', accusative: 'Черкасс' },
    uk: { genitive: 'Черкасах', accusative: 'Черкас' }
  },
  Чернигов: {
    ru: { genitive: 'Чернигове', accusative: 'Чернигова' },
    uk: { genitive: 'Чернігові', accusative: 'Чернігова' }
  },
  Черновцы: {
    ru: { genitive: 'Черновцах', accusative: 'Черновцов' },
    uk: { genitive: 'Чернівцях', accusative: 'Чернівців' }
  },
  Украина: {
    ru: { genitive: 'Украине', accusative: 'Украины' },
    uk: { genitive: 'Україні', accusative: 'України' }
  },
  Германия: {
    ru: { genitive: 'Германии', accusative: 'Германии' },
    uk: { genitive: 'Німеччині', accusative: 'Німеччини' }
  },
  Польша: {
    ru: { genitive: 'Польше', accusative: 'Польши' },
    uk: { genitive: 'Польщі', accusative: 'Польщі' }
  },
  Чехия: {
    ru: { genitive: 'Чехии', accusative: 'Чехии' },
    uk: { genitive: 'Чехії', accusative: 'Чехії' }
  },
  Литва: {
    ru: { genitive: 'Литве', accusative: 'Литвы' },
    uk: { genitive: 'Литві', accusative: 'Литви' }
  },
  Латвия: {
    ru: { genitive: 'Латвии', accusative: 'Латвии' },
    uk: { genitive: 'Латвії', accusative: 'Латвії' }
  },
  США: {
    ru: { genitive: 'США', accusative: 'США' },
    uk: { genitive: 'США', accusative: 'США' }
  }
});
// noinspection NonAsciiCharacters
var plural = {
  Мотоцикл: {
    ru: 'Мотоциклы',
    uk: 'Мотоцикли'
  }
};
// noinspection NonAsciiCharacters
var pluralCrutch = {
  спецтехника: {
    ru: 'Cпецтехнику',
    uk: 'Cпецтехніку'
  }
};
// noinspection NonAsciiCharacters
var crutch = function crutch(newCar) {
  return {
    Грузовые: {
      ru: {
        transportTitle: newCar && 'грузовик' || 'грузовик',
        transportNextTitle: newCar && 'грузовые' || 'грузовые',

        transportDescriptions: newCar && 'грузовики' || 'грузовик',
        transportNextDescriptions: newCar && 'грузовик' || 'грузовики',

        transportHeader: newCar && 'новый грузовик' || 'грузовик',
        plural: newCar && 'новые грузовики' || 'грузовики',
        pluralGenitive: newCar && 'новых грузовиков' || 'грузовиков'
      },
      uk: {
        transportTitle: newCar && 'вантажівку' || 'вантажівку',
        transportNextTitle: newCar && 'вантажні' || 'вантажні',

        transportDescriptions: newCar && 'вантажівки' || 'вантажівок',
        transportNextDescriptions: newCar && 'вантажівку' || 'вантажівку',

        transportHeader: newCar && 'нову вантажівку' || 'вантажівку',
        plural: newCar && 'нові вантажівки' || 'вантажівки',
        pluralGenitive: newCar && 'нових вантажівок' || 'вантажівок'
      }
    },
    Автобусы: {
      ru: {
        transportTitle: newCar && 'автобус' || 'автобус',
        transportNextTitle: newCar && '' || '',

        transportDescriptions: newCar && 'автобусы' || 'автобус',
        transportNextDescriptions: newCar && '' || '',

        transportHeader: newCar && 'новый автобус' || 'автобус'
      },
      uk: {
        transportTitle: newCar && 'автобус' || 'автобус',
        transportNextTitle: newCar && '' || '',

        transportDescriptions: newCar && 'автобусів' || 'автобусів',
        transportNextDescriptions: newCar && '' || '',

        transportHeader: newCar && 'новий автобус' || 'автобус'
      }
    },
    Прицепы: {
      ru: {
        transportTitle: newCar && 'автоприцеп' || 'автоприцеп',
        transportNextTitle: newCar && 'автоприцепы' || 'автоприцепы',

        transportDescriptions: newCar && 'автоприцепов' || 'автоприцепов',
        transportNextDescriptions: newCar && 'автоприцеп' || 'автоприцеп',

        transportHeader: newCar && 'новый автоприцеп' || 'автоприцеп'
      },
      uk: {
        transportTitle: newCar && 'автопричепи' || 'автопричепи',
        transportNextTitle: newCar && 'автопричепи' || 'автопричепи',

        transportDescriptions: newCar && 'причепів' || 'причепів',
        transportNextDescriptions: newCar && 'причіп' || 'причіп',

        transportHeader: newCar && 'новий причіп' || 'причіп'
      }
    },
    Спецтехника: {
      ru: {
        transportTitle: newCar && 'спецтехнику' || 'спецтехнику',
        transportNextTitle: newCar && 'специальная техника' || 'специальная техника',

        transportDescriptions: newCar && 'спецтехнику' || 'спецтехнику',
        transportNextDescriptions: newCar && 'Строительная, сельскохозяйственная, дорожная техника' || 'Строительная, сельскохозяйственная, дорожная техника',

        transportHeader: newCar && 'новую спецтехнику' || 'спецтехнику'
      },
      uk: {
        transportTitle: newCar && 'спецтехніку' || 'спецтехніку',
        transportNextTitle: newCar && 'спеціальна техніка' || 'спеціальна техніка',

        transportDescriptions: newCar && 'спецтехніки' || 'спецтехніки',
        transportNextDescriptions: newCar && 'Будівельна, сільськогосподарська, дорожня техніка' || 'Будівельна, сільськогосподарська, дорожня техніка',

        transportHeader: newCar && 'нову спецтехніку' || 'спецтехніку'
      }
    },
    'Водный транспорт': {
      ru: {
        transportTitle: newCar && 'водный транспорт' || 'водный транспорт',
        transportNextTitle: newCar && 'водный транспорт' || 'водный транспорт',

        transportDescriptions: newCar && 'водный транспорт' || 'водный транспорт',
        transportNextDescriptions: '',

        transportHeader: newCar && 'новый водный транспорт' || 'водный транспорт'
      },
      uk: {
        transportTitle: newCar && 'водний транспорт' || 'водний транспорт',
        transportNextTitle: '',

        transportDescriptions: newCar && 'водних транспортів' || 'водного транспорту',
        transportNextDescriptions: '',

        transportHeader: newCar && 'новий водний транспорт' || 'водний транспорт'
      }
    },

    /* START TYPES OF GRUZOVYE */

    Автоцистерна: {
      ru: {
        transportHeader: newCar && 'новую автоцистерну' || 'автоцистерну',
        pluralTransport: newCar && 'новые автоцистерны' || 'автоцистерны',
        pluralGenericTransport: newCar && 'новых автоцистерн' || 'автоцистерн'
      },
      uk: {
        transportHeader: newCar && 'нову автоцистерну' || 'автоцистерну',
        pluralTransport: newCar && 'нові автоцистерни' || 'автоцистерни',
        pluralGenericTransport: newCar && 'нових автоцистерн' || 'автоцистерн'
      }
    },
    Автовоз: {
      ru: {
        transportHeader: newCar && 'новый автовоз' || 'автовоз',
        pluralTransport: newCar && 'новые автовозы' || 'автоцистерны',
        pluralGenericTransport: newCar && 'новых автовозов' || 'автовозов'
      },
      uk: {
        transportHeader: newCar && 'новий автовоз' || 'автовоз',
        pluralTransport: newCar && 'нові автовози' || 'автовози',
        pluralGenericTransport: newCar && 'нових автовозів' || 'автовозів'
      }
    },
    Зерновоз: {
      ru: {
        transportHeader: newCar && 'новый зерновоз' || 'зерновоз',
        pluralTransport: newCar && 'новые зерновозы' || 'зерновозы',
        pluralGenitiveTransport: newCar && 'новых зерновозов' || 'зерновозов'
      },
      uk: {
        transportHeader: newCar && 'новий зерновоз' || 'зерновоз',
        pluralTransport: newCar && 'нові зерновози' || 'зерновози',
        pluralGenitiveTransport: newCar && 'нових зерновозів' || 'зерновозів'
      }
    },
    Бортовой: {
      ru: {
        transportHeader: newCar && 'новый бортовой грузовик' || 'бортовой грузовик',
        pluralTransport: newCar && 'новые бортовые грузовики' || 'бортовые грузовики',
        pluralGenitiveTransport: newCar && 'новых бортовых грузовиков' || 'бортовых грузовиков'
      },
      uk: {
        transportHeader: newCar && 'нову бортову вантажівку' || 'бортову вантажівку',
        pluralTransport: newCar && 'нові бортові вантажівки' || 'бортові вантажівки',
        pluralGenitiveTransport: newCar && 'нових бортових вантажівок' || 'бортових вантажівок'
      }
    },
    Изотермо: {
      ru: {
        transportHeader: newCar && 'новый изотерм грузовик' || 'изотерм грузовик',
        pluralTransport: newCar && 'новые изотерм грузовики' || 'изотерм грузовики',
        pluralGenitiveTransport: newCar && 'новых изотерм грузовиков' || 'изотерм грузовиков'
      },
      uk: {
        transportHeader: newCar && 'нову ізотерм вантажівку' || 'ізотерм вантажівку',
        pluralTransport: newCar && 'нові ізотерм вантажівки' || 'ізотерм вантажівки',
        pluralGenitiveTransport: newCar && 'нових ізотерм вантажівок' || 'ізотерм вантажівок'
      }
    },
    Контейнеровоз: {
      ru: {
        transportHeader: newCar && 'новый контейнеровоз' || 'контейнеровоз',
        pluralTransport: newCar && 'новые контейнеровозы' || 'контейнеровозы',
        pluralGenitiveTransport: newCar && 'новых контейнеровозов' || 'контейнеровозов'
      },
      uk: {
        transportHeader: newCar && 'новий контейнеровоз' || 'контейнеровоз',
        pluralTransport: newCar && 'нові контейнеровози' || 'контейнеровози',
        pluralGenitiveTransport: newCar && 'нових контейнеровозів' || 'контейнеровозів'
      }
    },
    'Развозчик напитков': {
      ru: {
        transportHeader: newCar && 'новый развозчик напитков' || 'развозчик напитков',
        pluralTransport: newCar && 'новые развозчики напитков' || 'развозчики напитков',
        pluralGenitiveTransport: newCar && 'новых развозчиков напитков' || 'развозчиков напитков'
      },
      uk: {
        transportHeader: newCar && 'новий розвізник напоїв' || 'розвізник напоїв',
        pluralTransport: newCar && 'нові розвізники напоїв' || 'розвізники напоїв',
        pluralGenitiveTransport: newCar && 'нових розвізників напоїв' || 'розвізників напоїв'
      }
    },
    'Мебельный фургон': {
      ru: {
        transportHeader: newCar && 'новый мебельный фургон' || 'мебельный фургон',
        pluralTransport: newCar && 'новые мебельные фургоны' || 'мебельные фургоны',
        pluralGenitiveTransport: newCar && 'новых мебельных фургонов' || 'мебельных фургонов'
      },
      uk: {
        transportHeader: newCar && 'новий меблевий фургон' || 'меблевий фургон',
        pluralTransport: newCar && 'нові меблеві фургони' || 'меблеві фургони',
        pluralGenitiveTransport: newCar && 'нових меблевих фургонів' || 'меблевих фургонів'
      }
    },
    'Почтовый фургон': {
      ru: {
        transportHeader: newCar && 'новый почтовый фургон' || 'почтовый фургон',
        pluralTransport: newCar && 'новые почтовые фургоны' || 'почтовые фургоны',
        pluralGenitiveTransport: newCar && 'новых почтовых фургонов' || 'почтовых фургонов'
      },
      uk: {
        transportHeader: newCar && 'новий поштовий фургон' || 'поштовий фургон',
        pluralTransport: newCar && 'нові поштові фургони' || 'поштові фургони',
        pluralGenitiveTransport: newCar && 'нових поштових фургонів' || 'поштових фургонів'
      }
    },
    Рефрижератор: {
      ru: {
        transportHeader: newCar && 'новый грузовик рефрижератор' || 'грузовик рефрижератор',
        pluralTransport: newCar && 'новые грузовики рефрижераторы' || 'грузовики рефрижераторы',
        pluralGenitiveTransport: newCar && 'новых грузовиков рефрижераторов' || 'грузовиков рефрижераторов'
      },
      uk: {
        transportHeader: newCar && 'новий вантажівку рефрижератор' || 'вантажівку рефрижератор',
        pluralTransport: newCar && 'нові вантажівки рефрижератори' || 'вантажівки рефрижератори',
        pluralGenitiveTransport: newCar && 'нових вантажівок рефрижераторів' || 'вантажівок рефрижераторів'
      }
    },
    'Промтоварный фургон': {
      ru: {
        transportHeader: newCar && 'новый промтоварный фургон' || 'промтоварный фургон',
        pluralTransport: newCar && 'новые промтоварные фургоны' || 'промтоварные фургоны',
        pluralGenitiveTransport: newCar && 'новых промтоварных фургонов' || 'промтоварных фургонов'
      },
      uk: {
        transportHeader: newCar && 'новий промтоварний фургон' || 'промтоварний фургон',
        pluralTransport: newCar && 'нові промтоварні фургони' || 'промтоварні фургони',
        pluralGenitiveTransport: newCar && 'нових промтоварних фургонів' || 'промтоварних фургонів'
      }
    },
    Самосвал: {
      ru: {
        transportHeader: newCar && 'новый самосвал' || 'самосвал',
        pluralTransport: newCar && 'новые самосвалы' || 'самосвалы',
        pluralGenitiveTransport: newCar && 'новых самосвалов' || 'самосвалов'
      },
      uk: {
        transportHeader: newCar && 'новий самоскид' || 'самоскид',
        pluralTransport: newCar && 'нові самоскиди' || 'самоскиди',
        pluralGenitiveTransport: newCar && 'нових самоскидів' || 'самоскидів'
      }
    },
    Тент: {
      ru: {
        transportHeader: newCar && 'новый тент' || 'тент',
        pluralTransport: newCar && 'новые тенты' || 'тенты',
        pluralGenitiveTransport: newCar && 'новых тентов' || 'тентов'
      },
      uk: {
        transportHeader: newCar && 'новий тент' || 'тент',
        pluralTransport: newCar && 'нові тенти' || 'тенти',
        pluralGenitiveTransport: newCar && 'нових тентів' || 'тентів'
      }
    },
    Тягач: {
      ru: {
        transportHeader: newCar && 'новый тягач' || 'тягач',
        pluralTransport: newCar && 'новые тягачи' || 'тягачи',
        pluralGenitiveTransport: newCar && 'новых тягачей' || 'тягачей'
      },
      uk: {
        transportHeader: newCar && 'новий тягач' || 'тягач',
        pluralTransport: newCar && 'нові тягачі' || 'тягачі',
        pluralGenitiveTransport: newCar && 'нових тягачів' || 'тягачів'
      }
    },
    'Хлебный фургон': {
      ru: {
        transportHeader: newCar && 'новый хлебный фургон' || 'хлебный фургон',
        pluralTransport: newCar && 'новые хлебные фургоны' || 'хлебные фургоны',
        pluralGenitiveTransport: newCar && 'новых хлебных фургонов' || 'хлебных фургонов'
      },
      uk: {
        transportHeader: newCar && 'новий хлібний фургон' || 'хлібний фургон',
        pluralTransport: newCar && 'нові хлібні фургони' || 'хлібні фургони',
        pluralGenitiveTransport: newCar && 'нових хлібних фургонів' || 'хлібних фургонів'
      }
    },
    Шасси: {
      ru: {
        transportHeader: newCar && 'новое шасси' || 'шасси',
        pluralTransport: newCar && 'новые шасси' || 'шасси',
        pluralGenitiveTransport: newCar && 'новых шасси' || 'шасси'
      },
      uk: {
        transportHeader: newCar && 'нове шасі' || 'шасі',
        pluralTransport: newCar && 'нові шасі' || 'шасі',
        pluralGenitiveTransport: newCar && 'нових шасі' || 'шасі'
      }
    },
    Эвакуатор: {
      ru: {
        transportHeader: newCar && 'новый эвакуатор' || 'эвакуатор',
        pluralTransport: newCar && 'новые эвакуаторы' || 'эвакуаторы',
        pluralGenitiveTransport: newCar && 'новых эвакуаторов' || 'эвакуаторов'
      },
      uk: {
        transportHeader: newCar && 'новий евакуатор' || 'евакуатор',
        pluralTransport: newCar && 'нові евакуатори' || 'евакуатори',
        pluralGenitiveTransport: newCar && 'нових евакуаторів' || 'евакуаторів'
      }
    },

    /* END TYPES OF GRUZOVYE */

    /* START TYPES OF AVTOBUS */

    'Грузо-пасс.': {
      ru: {
        transportHeader: newCar && 'новый грузопассажирский автобус' || 'грузопассажирский автобус',
        pluralTransport: 'грузо-пассажирские'
      },
      uk: {
        transportHeader: newCar && 'новий вантажопасажирський автобус' || 'вантажопасажирський автобус',
        pluralTransport: 'вантажо-пасажирські'
      }
    },
    Грузовой: {
      ru: {
        transportHeader: newCar && 'новый грузовой автобус' || 'грузовой автобус',
        pluralTransport: 'грузовые'
      },
      uk: {
        transportHeader: newCar && 'новий вантажний автобус' || 'вантажний автобус',
        pluralTransport: 'вантажні'
      }
    },
    Пассажирский: {
      ru: {
        transportHeader: newCar && 'новый пассажирский автобус' || 'пассажирский автобус',
        pluralTransport: 'пассажирские'
      },
      uk: {
        transportHeader: newCar && 'новий пасажирський автобус' || 'пасажирський автобус',
        pluralTransport: 'пасажирські'
      }
    },

    /* END TYPES OF AVTOBUS */

    /* START TYPES OF PRITSEPY */

    Контейнер: {
      ru: {
        transportHeader: newCar && 'новый контейнер' || 'контейнер',
        transportCategoryTitle: 'Прицеп контейнер'
      },
      uk: {
        transportHeader: newCar && 'новий контейнер' || 'контейнер',
        transportCategoryTitle: 'Причіп контейнер'
      }
    },
    Будка: {
      ru: {
        transportHeader: newCar && 'новый будка' || 'будка',
        transportCategoryTitle: 'Прицеп будка'
      },
      uk: {
        transportHeader: newCar && 'нову будку' || 'будку',
        transportCategoryTitle: 'Причіп будка'
      }
    },
    Полуприцеп: {
      ru: {
        transportHeader: newCar && 'новый полуприцеп' || 'полуприцеп'
      },
      uk: {
        transportHeader: newCar && 'новий напівпричіп' || 'напівпричіп'
      }
    },
    Прицеп: {
      ru: {
        transportHeader: newCar && 'новый прицеп' || 'прицеп'
      },
      uk: {
        transportHeader: newCar && 'новий причіп' || 'причіп'
      }
    },
    Дача: {
      ru: {
        transportHeader: newCar && 'новый дача' || 'дача'
      },
      uk: {
        transportHeader: newCar && 'нову дачу' || 'дачу'
      }
    },

    /* END TYPES OF PRITSEPY */

    /* START TYPES OF VODNYI-TRANSPORT */

    Гидроцикл: {
      ru: {
        transportHeader: newCar && 'новый гидроцикл' || 'гидроцикл',
        transportCategoryTitle: 'Гидроцикл'
      },
      uk: {
        transportHeader: newCar && 'новий гідроцикл' || 'гідроцикл',
        transportCategoryTitle: 'Гідроцикл'
      }
    },
    Катер: {
      ru: {
        transportHeader: newCar && 'новый катер' || 'катер',
        transportCategoryTitle: 'Катер'
      },
      uk: {
        transportHeader: newCar && 'новий катер' || 'катер',
        transportCategoryTitle: 'Катер'
      }
    },
    Лодка: {
      ru: {
        transportHeader: newCar && 'новую лодку' || 'лодку',
        transportCategoryTitle: 'Лодка'
      },
      uk: {
        transportHeader: newCar && 'новий човен' || 'човен',
        transportCategoryTitle: 'Човен'
      }
    },
    Яхта: {
      ru: {
        transportHeader: newCar && 'новую яхту' || 'яхту',
        transportCategoryTitle: 'Яхта'
      },
      uk: {
        transportHeader: newCar && 'нову яхту' || 'яхту',
        transportCategoryTitle: 'Яхта'
      }
    },
    Дебаркадер: {
      ru: {
        transportHeader: newCar && 'новый дебаркадер' || 'дебаркадер',
        transportCategoryTitle: 'Дебаркадер'
      },
      uk: {
        transportHeader: newCar && 'новий дебаркадер' || 'дебаркадер',
        transportCategoryTitle: 'Дебаркадер'
      }
    },
    Катамаран: {
      ru: {
        transportHeader: newCar && 'новый катамаран' || 'катамаран',
        transportCategoryTitle: 'Катамаран'
      },
      uk: {
        transportHeader: newCar && 'новий катамаран' || 'катамаран',
        transportCategoryTitle: 'Катамаран'
      }
    },
    'Плав-дача': {
      ru: {
        transportHeader: newCar && 'новую плав-дачу' || 'плав-дачу',
        transportCategoryTitle: 'Плав-дача'
      },
      uk: {
        transportHeader: newCar && 'нову плав-дачу' || 'плав-дачу',
        transportCategoryTitle: 'Плав-дача'
      }
    },
    Теплоход: {
      ru: {
        transportHeader: newCar && 'новый теплоход' || 'теплоход',
        transportCategoryTitle: 'Теплоход'
      },
      uk: {
        transportHeader: newCar && 'новий теплохід' || 'теплохід',
        transportCategoryTitle: 'Теплохід'
      }
    },
    'Хауз-бот': {
      ru: {
        transportHeader: newCar && 'новый хауз-бот' || 'хауз-бот',
        transportCategoryTitle: 'Хауз-бот'
      },
      uk: {
        transportHeader: newCar && 'новий хауз-бот' || 'хауз-бот',
        transportCategoryTitle: 'Хауз-бот'
      }
    },
    'Лодочный двигатель': {
      ru: {
        transportHeader: newCar && 'новый лодочный двигатель' || 'лодочный двигатель',
        transportCategoryTitle: 'Лодочный двигатель'
      },
      uk: {
        transportHeader: newCar && 'новий човновий двигун' || 'човновий двигун',
        transportCategoryTitle: 'Човновий двигун'
      }
    },
    'Прицеп для водного транспорта': {
      ru: {
        transportHeader: newCar && 'новый прицеп для водного транспорта' || 'прицеп для водного транспорта',
        transportCategoryTitle: 'Прицеп для водного транспорта'
      },
      uk: {
        transportHeader: newCar && 'новий причіп для водного транспорту' || 'причіп для водного транспорту',
        transportCategoryTitle: 'Причіп для водного транспорту'
      }
    },
    'Развлечения на воде': {
      ru: {
        transportHeader: newCar && 'новые развлечения на воде' || 'развлечения на воде',
        transportCategoryTitle: 'Развлечения на воде'
      },
      uk: {
        transportHeader: newCar && 'нові розваги на воді' || 'розваги на воді',
        transportCategoryTitle: 'Розваги на воді'
      }
    },

    /* END TYPES OF VODNYI-TRANSPORT */

    /* START TYPES OF SPETSTEHNIKA */

    'Электростанция / Генератор': {
      ru: {
        transportHeader: newCar && 'новую электростанцию / генератор' || 'электростанцию / генератор',
        transportCategoryTitle: 'Электростанции / Генераторы'
      },
      uk: {
        transportHeader: newCar && 'нову електростанцію / генератор' || 'електростанція / генератор',
        transportCategoryTitle: 'Електростанції / Генератои'
      }
    },
    Строительная: {
      ru: {
        transportHeader: newCar && 'новую строительную технику' || 'строительную технику',
        transportCategoryTitle: 'Строительная техника'
      },
      uk: {
        transportHeader: newCar && 'нову будівельну техніку' || 'будівельну техніку',
        transportCategoryTitle: 'Будівельна техніка'
      }
    },
    Автовышка: {
      ru: {
        transportHeader: newCar && 'новую автовышку' || 'автовышку',
        transportCategoryTitle: 'Автовышки'
      },
      uk: {
        transportHeader: newCar && 'нову автовишку' || 'автовишку',
        transportCategoryTitle: 'Автовишки'
      }
    },
    Бетоносмеситель: {
      ru: {
        transportHeader: newCar && 'новый бетоносмеситель' || 'бетоносмеситель',
        transportCategoryTitle: 'Бетоносмесители'
      },
      uk: {
        transportHeader: newCar && 'новий бетонозмішувач' || 'бетонозмішувач',
        transportCategoryTitle: 'Бетонозмішувачі'
      }
    },
    Бензовоз: {
      ru: {
        transportHeader: newCar && 'новый бензовоз' || 'бензовоз',
        transportCategoryTitle: 'Бензовозы'
      },
      uk: {
        transportHeader: newCar && 'новий бензовоз' || 'бензовоз',
        transportCategoryTitle: 'Бензовози'
      }
    },
    Бульдозер: {
      ru: {
        transportHeader: newCar && 'новый бульдозер' || 'бульдозер',
        transportCategoryTitle: 'Бульдозеры'
      },
      uk: {
        transportHeader: newCar && 'новий бульдозер' || 'бульдозер',
        transportCategoryTitle: 'Бульдозери'
      }
    },
    Бетононасос: {
      ru: {
        transportHeader: newCar && 'новый бетононасос' || 'бетононасос',
        transportCategoryTitle: 'Бетононасосы'
      },
      uk: {
        transportHeader: newCar && 'новий бетононасос' || 'бетононасос',
        transportCategoryTitle: 'Бетононасоси'
      }
    },
    'Буровые установки': {
      ru: {
        transportHeader: newCar && 'новые буровые установки' || 'буровые установки',
        transportCategoryTitle: 'Буровые установки'
      },
      uk: {
        transportHeader: newCar && 'нові бурові установки' || 'бурові установки',
        transportCategoryTitle: 'Бурові установки'
      }
    },
    'Дорожная техника': {
      ru: {
        transportHeader: newCar && 'новую дорожную технику' || 'дорожную технику',
        transportCategoryTitle: 'Дорожная техника'
      },
      uk: {
        transportHeader: newCar && 'нову дорожню техніку' || 'дорожню техніку',
        transportCategoryTitle: 'Дорожня техніка'
      }
    },
    Экскаватор: {
      ru: {
        transportHeader: newCar && 'новый экскаватор' || 'экскаватор',
        transportCategoryTitle: 'Экскаваторы'
      },
      uk: {
        transportHeader: newCar && 'новий екскаватор' || 'екскаватор',
        transportCategoryTitle: 'Екскаватори'
      }
    },
    'Екскаватор погрузчик': {
      ru: {
        transportHeader: newCar && 'новый экскаватор погрузчик' || 'экскаватор погрузчик',
        transportCategoryTitle: 'Екскаваторы погрузчикы'
      },
      uk: {
        transportHeader: newCar && 'новий екскаватор навантажувач' || 'екскаватор навантажувач',
        transportCategoryTitle: 'Екскаватори навантажувачі'
      }
    },
    'Коммунальная техника': {
      ru: {
        transportHeader: newCar && 'новую коммунальную технику' || 'коммунальную технику',
        transportCategoryTitle: 'Коммунальные техники'
      },
      uk: {
        transportHeader: newCar && 'нову комунальну техніку' || 'комунальну техніку',
        transportCategoryTitle: 'Комунальна техніка'
      }
    },
    Кран: {
      ru: {
        transportHeader: newCar && 'новый кран' || 'кран',
        transportCategoryTitle: 'Краны'
      },
      uk: {
        transportHeader: newCar && 'новий кран' || 'кран',
        transportCategoryTitle: 'Крани'
      }
    },
    'Машина для разбрасывания': {
      ru: {
        transportHeader: newCar && 'новую машину для разбрасывания' || 'машину для разбрасывания',
        transportCategoryTitle: 'Машины для разбрасывания'
      },
      uk: {
        transportHeader: newCar && 'нову машину для розкидання' || 'машину для розкидання',
        transportCategoryTitle: 'Машини для розкидання'
      }
    },
    Минитрактор: {
      ru: {
        transportHeader: newCar && 'новый минитрактор' || 'минитрактор',
        transportCategoryTitle: 'Минитракторы'
      },
      uk: {
        transportHeader: newCar && 'новий мінітрактор' || 'мінітрактор',
        transportCategoryTitle: 'Мінітрактори'
      }
    },
    Мотоблок: {
      ru: {
        transportHeader: newCar && 'новый мотоблок' || 'мотоблок',
        transportCategoryTitle: 'Мотоблоки'
      },
      uk: {
        transportHeader: newCar && 'новий мотоблок' || 'мотоблок',
        transportCategoryTitle: 'Мотоблоки'
      }
    },
    Погрузчик: {
      ru: {
        transportHeader: newCar && 'новый погрузчик' || 'погрузчик',
        transportCategoryTitle: 'Погрузчики'
      },
      uk: {
        transportHeader: newCar && 'новий навантажувач' || 'навантажувач',
        transportCategoryTitle: 'Навантажувачі'
      }
    },
    Спецавтомобили: {
      ru: {
        transportHeader: newCar && 'новые спецавтомобили' || 'спецавтомобили',
        transportCategoryTitle: 'Спецавтомобили'
      },
      uk: {
        transportHeader: newCar && 'нові спецавтомобілі' || 'спецавтомобілі',
        transportCategoryTitle: 'Спецавтомобілі'
      }
    },
    Трактор: {
      ru: {
        transportHeader: newCar && 'новый трактор' || 'трактор',
        transportCategoryTitle: 'Тракторы'
      },
      uk: {
        transportHeader: newCar && 'новий трактор' || 'трактор',
        transportCategoryTitle: 'Трактори'
      }
    },
    Подъемник: {
      ru: {
        transportHeader: newCar && 'новый подъемник' || 'подъемник',
        transportCategoryTitle: 'Подъемники'
      },
      uk: {
        transportHeader: newCar && 'новий підйомник' || 'підйомник',
        transportCategoryTitle: 'Підйомники'
      }
    },
    Сельхозтехника: {
      ru: {
        transportHeader: newCar && 'новую сельхозтехнику' || 'сельхозтехнику',
        transportCategoryTitle: 'Сельхозтехника'
      },
      uk: {
        transportHeader: newCar && 'нову сільгосптехніку' || 'сільгосптехніку',
        transportCategoryTitle: 'Сільгосптехніка'
      }
    },
    /* END TYPES OF SPETSTEHNIKA */

    /* END TYPES OF MOTO-TRANSPORT */
    Мотоциклы: {
      ru: {
        motoHeader: newCar && 'новый мотоцикл' || 'мотоцикл',
        motoTitle: newCar && 'новый мотоцикл' || 'мотоцикл'
      },
      uk: {
        motoHeader: newCar && 'новий мотоцикл' || 'мотоцикл',
        motoTitle: newCar && 'новий мотоцикл' || 'мотоцикл'
      }
    },
    Классик: {
      ru: {
        motoHeader: newCar && 'новый мотоцикл классик' || 'мотоцикл классик',
        motoTitle: newCar && 'новый мотоцикл классик' || 'мотоцикл классик'
      },
      uk: {
        motoHeader: newCar && 'новий мотоцикл классік' || 'мотоцикл классік',
        motoTitle: newCar && 'новий мотоцикл классік' || 'мотоцикл классік'
      }
    },
    'Круизер / Чоппер': {
      ru: {
        motoHeader: newCar && 'новый круизер / чоппер' || 'круизер / чоппер',
        motoTitle: newCar && 'новый круизер / чопер' || 'круизер / чопер'
      },
      uk: {
        motoHeader: newCar && 'новий круїзер / чоппер' || 'круїзер / чоппер',
        motoTitle: newCar && 'новий круїзер / чоппер' || 'круїзер / чоппер'
      }
    },
    'Эндуро / Кросс': {
      ru: {
        motoHeader: newCar && 'новый мотоцикл эндуро / кросс' || 'мотоцикл эндуро / кросс',
        motoTitle: newCar && 'новый мотоцикл эндуро / кросс' || 'мотоцикл эндуро / кросс'
      },
      uk: {
        motoHeader: newCar && 'новий мотоцикл ендуро / крос' || 'мотоцикл ендуро / крос',
        motoTitle: newCar && 'новий мотоцикл ендуро / крос' || 'мотоцикл ендуро / крос'
      }
    },
    Спорт: {
      ru: {
        motoHeader: newCar && 'новый спортивный мотоцикл' || 'спортивный мотоцикл',
        motoTitle: newCar && 'новый спортивный мотоцикл' || 'спортивный мотоцикл'
      },
      uk: {
        motoHeader: newCar && 'новий спортивний мотоцикл' || 'спортивний мотоцикл',
        motoTitle: newCar && 'новий спортивний мотоцикл' || 'спортивний мотоцикл'
      }
    },
    Трайк: {
      ru: {
        motoHeader: newCar && 'новый трайк' || 'трайк',
        motoTitle: newCar && 'новый трайк' || 'трайк'
      },
      uk: {
        motoHeader: newCar && 'новий трайк' || 'трайк',
        motoTitle: newCar && 'новий трайк' || 'трайк'
      }
    },
    Турист: {
      ru: {
        motoHeader: newCar && 'новый мотоцикл турист' || 'мотоцикл турист',
        motoTitle: newCar && 'новый мотоцикл турист' || 'мотоцикл турист'
      },
      uk: {
        motoHeader: newCar && 'новий мотоцикл турист' || 'мотоцикл турист',
        motoTitle: newCar && 'новий мотоцикл турист' || 'мотоцикл турист'
      }
    },
    Спортивный: {
      ru: {
        motoHeader: newCar && 'новый спортивный квадроцикл' || 'спортивный квадроцикл',
        motoTitle: newCar && 'новый спортивный квадроцикл' || 'спортивный квадроцикл'
      },
      uk: {
        motoHeader: newCar && 'новий спортивний квадроцикл' || 'спортивний квадроцикл',
        motoTitle: newCar && 'новий спортивний квадроцикл' || 'спортивний квадроцикл'
      }
    },
    Утилитарный: {
      ru: {
        motoHeader: newCar && 'новый утилитарный квадроцикл' || 'утилитарный квадроцикл',
        motoTitle: newCar && 'новый утилитарный квадроцикл' || 'утилитарный квадроцикл'
      },
      uk: {
        motoHeader: newCar && 'новий утилітарний квадроцикл' || 'утилітарний квадроцикл',
        motoTitle: newCar && 'новий утилітарний квадроцикл' || 'утилітарний квадроцикл'
      }
    }
    /* START TYPES OF MOTO-TRANSPORT  */
  };
};
// noinspection NonAsciiCharacters
var rubrics = {
  Двигатель: {
    ru: { nominative: 'Двигатель', accusative: 'Двигателя' },
    uk: { nominative: 'Двигун', accusative: 'Двигуна' }
  },
  'Дополнительное оборудование': {
    ru: { nominative: 'Дополнительное оборудование', accusative: 'Дополнительного оборудования' },
    uk: { nominative: 'Додаткове обладнання', accusative: 'Додаткового обладнання' }
  },
  Кузов: {
    ru: { nominative: 'Кузов', accusative: 'Кузова' },
    uk: { nominative: 'Кузов', accusative: 'Кузова' }
  },
  'Оптика, стекло, зеркала': {
    ru: { nominative: 'Оптика, стекло, зеркала', accusative: 'Оптики, стекла, зеркал' },
    uk: { nominative: 'Оптика, скло, дзеркала', accusative: 'Оптики, скла, дзеркал' }
  },
  'Отопление и кондиционирование': {
    ru: {
      nominative: 'Отопление и кондиционирование',
      accusative: 'Отопления и кондиционирования'
    },
    uk: { nominative: 'Опалення та кондиціонування', accusative: 'Опалення та кондиціонування' }
  },
  'Очистители стекла и фар': {
    ru: { nominative: 'Очистители стекла и фар', accusative: 'Очистителей стекла и фар' },
    uk: { nominative: 'Очищувачі скла і фар', accusative: 'Очищувачів скла і фар' }
  },
  'Прицепное оборудование': {
    ru: { nominative: 'Прицепное оборудование', accusative: 'Прицепного оборудования' },
    uk: { nominative: 'Причіпне обладнання', accusative: 'Причіпного обладнання' }
  },
  Разборка: {
    ru: { nominative: 'Разборка', accusative: 'Разборки' },
    uk: { nominative: 'Розбірка', accusative: 'Розбірки' }
  },
  'Рулевое управление': {
    ru: { nominative: 'Рулевое управление', accusative: 'Рулевого управления' },
    uk: { nominative: 'Рульове управління', accusative: 'Рульового управління' }
  },
  Салон: {
    ru: { nominative: 'Салон', accusative: 'Салона' },
    uk: { nominative: 'Салон', accusative: 'Салону' }
  },
  'Система безопасности': {
    ru: { nominative: 'Система безопасности', accusative: 'Системы безопасности' },
    uk: { nominative: 'Система безпеки', accusative: 'Системи безпеки' }
  },
  'Система охлаждения': {
    ru: { nominative: 'Система охлаждения', accusative: 'Системы охлаждения' },
    uk: { nominative: 'Система охолодження', accusative: 'Системи охолодження' }
  },
  'Топливная система': {
    ru: { nominative: 'Топливная система', accusative: 'Топливной системы' },
    uk: { nominative: 'Паливна система', accusative: 'Паливної системи' }
  },
  'Тормозная система': {
    ru: { nominative: 'Тормозная система', accusative: 'Тормозной системы' },
    uk: { nominative: 'Гальмівна система', accusative: 'Гальмівної системи' }
  },
  Трансмиссия: {
    ru: { nominative: 'Трансмиссия', accusative: 'Трансмиссии' },
    uk: { nominative: 'Трансмісія', accusative: 'Трансмісії' }
  },
  Фильтры: {
    ru: { nominative: 'Фильтры', accusative: 'Фильтров' },
    uk: { nominative: 'Фільтри', accusative: 'Фільтрів' }
  },
  Ходовая: {
    ru: { nominative: 'Ходовая', accusative: 'Ходовой' },
    uk: { nominative: 'Ходова', accusative: 'Ходової' }
  },
  'Шины, диски': {
    ru: { nominative: 'Шины, диски', accusative: 'Шин, дисков' },
    uk: { nominative: 'Шини, диски', accusative: 'Шин, дисків' }
  },
  'Электрика и электроника': {
    ru: { nominative: 'Электрика и электроника', accusative: 'Электрики и электроники' },
    uk: { nominative: 'Електрика та електроніка', accusative: 'Електрики та електроніки' }
  }
};
// noinspection NonAsciiCharacters
var gearboxes = {
  Автомат: {
    ru: {
      title: 'Автомат',
      altTitle: 'Автоматическая коробка'
    },
    uk: {
      title: 'Автомат',
      altTitle: 'Автоматична коробка'
    }
  },
  Механика: {
    ru: {
      title: 'Механика',
      altTitle: 'Механическая коробка'
    },
    uk: {
      title: 'Механіка',
      altTitle: 'Механічна коробка'
    }
  },
  Механіка: {
    uk: {
      title: 'Механіка',
      altTitle: 'Механічна коробка'
    }
  },
  Вариатор: {
    ru: {
      title: 'Вариатор',
      altTitle: 'Вариаторная коробка'
    },
    uk: {
      title: 'Варіатор',
      altTitle: 'Варіаторна коробка'
    }
  },
  Варіатор: {
    uk: {
      title: 'Варіатор',
      altTitle: 'Варіаторна коробка'
    }
  },
  Робот: {
    ru: {
      title: 'Робот',
      altTitle: 'Роботизированная коробка'
    },
    uk: {
      title: 'Робот',
      altTitle: 'Роботизована коробка'
    }
  }
};

// noinspection NonAsciiCharacters
var engines = {
  Дизельный: {
    ru: {
      short: 'дизель',
      title: 'Автомобиль дизель',
      altTitle: 'Дизельные авто'
    },
    uk: {
      short: 'дизель',
      title: 'Авто дизель',
      altTitle: 'Дизельні авто'
    }
  },
  Дизельний: {
    uk: {
      short: 'дизель',
      title: 'Авто дизель',
      altTitle: 'Дизельні авто'
    }
  },
  Электрический: {
    ru: {
      short: 'электро',
      title: 'Электромобиль',
      altTitle: 'Электромобили'
    },
    uk: {
      short: 'электро',
      title: 'Электромобіль',
      altTitle: 'Электромобілі'
    }
  },
  Електричний: {
    uk: {
      short: 'электро',
      title: 'Электромобіль',
      altTitle: 'Электромобілі'
    }
  },
  Бензиновый: {
    ru: {
      short: 'бензин',
      title: 'Автомобиль бензин',
      altTitle: 'Бензиновые авто'
    },
    uk: {
      short: 'бензин',
      title: 'Авто бензин',
      altTitle: 'Бензиновые авто'
    }
  },
  Бензиновий: {
    uk: {
      short: 'бензин',
      title: 'Авто бензин',
      altTitle: 'Бензиновые авто'
    }
  },
  Гибридный: {
    ru: {
      short: 'гибрид',
      title: 'Гибрид',
      altTitle: 'Гибридные авто'
    },
    uk: {
      short: 'гібрид',
      title: 'Гібрид',
      altTitle: 'Гибридні авто'
    }
  },
  Гібридний: {
    uk: {
      short: 'гібрид',
      title: 'Гібрид',
      altTitle: 'Гибридні авто'
    }
  },
  Газ: {
    ru: {
      short: 'газ/бензин',
      title: 'Автомобиль газ/бензин',
      altTitle: 'Авто газ/бензин'
    },
    uk: {
      short: 'газ/бензин',
      title: 'Автомобиль газ/бензин',
      altTitle: 'Авто газ/бензин'
    }
  }
};

/***/ }),

/***/ 310:
/***/ (function(module, exports) {

module.exports = [{"id":1911,"showInFooter":true,"title":"Украина","where":{"ru":"в Украине","uk":"в Україні"},"from":{"ru":"из Украины","uk":"з України"},"slug":"ukraina","is_country":true},{"id":1940,"showInFooter":true,"title":"Беларусь","where":{"ru":"в Беларуси","uk":"в Білорусі"},"from":{"ru":"из Беларуси","uk":"з Білорусі"},"slug":"belarusiya","is_country":true},{"id":4482,"showInFooter":true,"title":"Литва","isEuropean":true,"where":{"ru":"в Литве","uk":"в Литві"},"from":{"ru":"из Литвы","uk":"з Литви"},"slug":"litva","is_country":true},{"id":4483,"showInFooter":true,"includeInDrivenFrom":true,"title":"Молдова","where":{"ru":"в Молдове","uk":"в Молдові"},"from":{"ru":"из Молдовы","uk":"з Молдови"},"slug":"moldova","is_country":true},{"id":4484,"showInFooter":true,"title":"Польша","isEuropean":true,"where":{"ru":"в Польше","uk":"в Польщі"},"from":{"ru":"из Польши","uk":"з Польщі"},"slug":"polsha","is_country":true},{"id":1939,"showInFooter":true,"title":"Россия","where":{"ru":"в России","uk":"в Росії"},"from":{"ru":"из России","uk":"з Росії"},"slug":"rossiya","is_country":true},{"id":4495,"showInFooter":false,"title":"США","where":{"ru":"в США","uk":"в США"},"from":{"ru":"из США","uk":"з США"},"slug":"ssha","is_country":true,"isUsa":true},{"id":4488,"showInFooter":false,"title":"Австрия","isEuropean":true,"where":{"ru":"в Австрии","uk":"в Австрії"},"from":{"ru":"из Австрии","uk":"з Австрії"},"slug":"avstriya","is_country":true},{"id":4489,"showInFooter":false,"title":"Бельгия","isEuropean":true,"where":{"ru":"из Бельгии","uk":"в Бельгії"},"from":{"ru":"из Бельгии","uk":"з Бельгії"},"slug":"belgiya","is_country":true},{"id":4490,"showInFooter":false,"title":"Болгария","isEuropean":true,"where":{"ru":"в Болгарии","uk":"в Болгарії"},"from":{"ru":"из Болгарии","uk":"з Болгарії"},"slug":"bolgariya","is_country":true},{"id":4486,"showInFooter":true,"title":"Чехия","isEuropean":true,"where":{"ru":"в Чехии","uk":"в Чехії"},"from":{"ru":"из Чехии","uk":"з Чехії"},"slug":"chehiya","is_country":true},{"id":4492,"showInFooter":false,"title":"Черногория","where":{"ru":"в Черногории","uk":"в Чорногорії"},"from":{"ru":"из Черногории","uk":"з Чорногорії"},"slug":"chernogoriya","is_country":true},{"id":4496,"showInFooter":false,"title":"Дания","isEuropean":true,"where":{"ru":"в Дании","uk":"в Данії"},"from":{"ru":"из Дании","uk":"з Данії"},"slug":"daniya","is_country":true},{"id":4497,"showInFooter":true,"title":"Эстония","isEuropean":true,"where":{"ru":"в Эстонии","uk":"в Естонії"},"from":{"ru":"из Эстонии","uk":"з Естонії"},"slug":"estoniya","is_country":true},{"id":4498,"showInFooter":false,"title":"Финляндия","isEuropean":true,"where":{"ru":"в Финляндии","uk":"у Фінляндії"},"from":{"ru":"из Финляндии","uk":"з Фінляндії"},"slug":"finlyandiya","is_country":true},{"id":4499,"showInFooter":true,"title":"Франция","isEuropean":true,"where":{"ru":"во Франции","uk":"в Франції"},"from":{"ru":"из Франции","uk":"з Франції"},"slug":"frantsiya","is_country":true},{"id":4487,"showInFooter":true,"title":"Германия","isEuropean":true,"where":{"ru":"в Германии","uk":"в Німеччині"},"from":{"ru":"из Германии","uk":"з Німеччини"},"slug":"germaniya","is_country":true},{"id":4500,"showInFooter":false,"title":"Греция","where":{"ru":"в Греции","uk":"у Греції"},"from":{"ru":"из Греции","uk":"з Греції"},"slug":"gretsiya","is_country":true},{"id":4501,"showInFooter":true,"title":"Грузия","where":{"ru":"в Грузии","uk":"у Грузії"},"from":{"ru":"из Грузии","uk":"з Грузії"},"slug":"gruziya","is_country":true},{"id":37202,"showInFooter":false,"title":"Индия","where":{"ru":"в Индии","uk":"в Індії"},"from":{"ru":"из Индии","uk":"з Індії"},"slug":"indiya","is_country":true},{"id":17013,"showInFooter":false,"title":"Индонезия","where":{"ru":"в Индонезии","uk":"в Індонезії"},"from":{"ru":"из Индонезии","uk":"з Індонезії"},"slug":"indoneziya","is_country":true},{"id":4503,"showInFooter":false,"title":"Ирландия","where":{"ru":"в Ирландии","uk":"в Ірландії"},"from":{"ru":"из Ирландии","uk":"з Ірландії"},"slug":"irlandiya","is_country":true},{"id":4502,"showInFooter":false,"title":"Испания","isEuropean":true,"where":{"ru":"в Испании","uk":"в Іспанії"},"from":{"ru":"из Испании","uk":"з Іспанії"},"slug":"ispaniya","is_country":true},{"id":4504,"showInFooter":false,"title":"Италия","isEuropean":true,"where":{"ru":"в Италии","uk":"в Італії"},"from":{"ru":"из Италии","uk":"з Італії"},"slug":"italiya","is_country":true},{"id":4505,"showInFooter":false,"title":"Израиль","where":{"ru":"в Израиле","uk":"в Ізраїлі"},"from":{"ru":"из Израиля","uk":"з Ізраїлю"},"slug":"izrail","is_country":true},{"id":4506,"showInFooter":false,"title":"Канада","where":{"ru":"в Канаде","uk":"в Канаді"},"from":{"ru":"из Канады","uk":"з Канади"},"slug":"kanada","is_country":true},{"id":4507,"showInFooter":false,"title":"Казахстан","where":{"ru":"в Казахстане","uk":"в Казахстані"},"from":{"ru":"из Казахстана","uk":"з Казахстана"},"slug":"kazahstan","is_country":true},{"id":4508,"showInFooter":false,"title":"Хорватия","isEuropean":true,"where":{"ru":"в Хорватии","uk":"у Хорватії"},"from":{"ru":"из Хорватии","uk":"з Хорватії"},"slug":"horvatiya","is_country":true},{"id":7845,"showInFooter":false,"title":"Китай","where":{"ru":"в Китае","uk":"в Китаї"},"from":{"ru":"из Китая","uk":"з Китаю"},"slug":"kitay","is_country":true},{"id":9710,"showInFooter":false,"includeInDrivenFrom":true,"title":"Корея","where":{"ru":"в Корее","uk":"в Кореї"},"from":{"ru":"из Кореи","uk":"з Кореї"},"slug":"koreya","is_country":true},{"id":4509,"showInFooter":true,"title":"Латвия","where":{"ru":"в Латвии","uk":"у Латвії"},"from":{"ru":"из Латвии","uk":"з Латвії"},"slug":"latviya","is_country":true},{"id":101364,"showInFooter":false,"title":"Лихтенштейн","where":{"ru":"в Лихтенштейне","uk":"в Ліхтенштейні"},"from":{"ru":"из Лихтенштейна","uk":"з Ліхтенштейну"},"slug":"lihtenshteyn","is_country":true},{"id":4510,"showInFooter":false,"title":"Македония","where":{"ru":"в Македонии","uk":"у Македонії"},"from":{"ru":"из Македонии","uk":"з Македонії"},"slug":"makedoniya","is_country":true},{"id":4511,"showInFooter":false,"title":"Нидерланды","isEuropean":true,"where":{"ru":"в Нидерландах","uk":"в Нідерландах"},"from":{"ru":"из Нидерланд","uk":"з Нідерланд"},"slug":"niderlandy","is_country":true},{"id":4512,"showInFooter":false,"title":"Норвегия","where":{"ru":"в Норвегии","uk":"у Норвегії"},"from":{"ru":"из Норвегии","uk":"з Норвегії"},"slug":"norvegiya","is_country":true},{"id":4513,"showInFooter":false,"title":"Португалия","isEuropean":true,"where":{"ru":"в Португалии","uk":"у Португалії"},"from":{"ru":"из Португалии","uk":"з Португалії"},"slug":"portugaliya","is_country":true},{"id":4514,"showInFooter":false,"title":"Румыния","isEuropean":true,"where":{"ru":"в Румынии","uk":"в Румунії"},"from":{"ru":"из Румынии","uk":"з Румунії"},"slug":"rumyniya","is_country":true},{"id":4491,"showInFooter":false,"title":"Сербия","where":{"ru":"в Сербии","uk":"у Сербії"},"from":{"ru":"из Сербии","uk":"з Сербії"},"slug":"serbiya","is_country":true},{"id":4515,"showInFooter":false,"title":"Швеция","isEuropean":true,"where":{"ru":"в Швеции","uk":"у Швеції"},"from":{"ru":"из Швеции","uk":"зі Швеції"},"slug":"shvetsiya","is_country":true},{"id":4516,"showInFooter":false,"includeInDrivenFrom":true,"title":"Швейцария","where":{"ru":"в Швейцарии","uk":"у Швейцарії"},"from":{"ru":"из Швейцарии","uk":"зі Швейцарії"},"slug":"shveytsariya","is_country":true},{"id":4493,"showInFooter":true,"title":"Словакия","isEuropean":true,"where":{"ru":"в Словакии","uk":"у Словаччині"},"from":{"ru":"из Словакии","uk":"зі Словаччини"},"slug":"slovakiya","is_country":true},{"id":4494,"showInFooter":false,"title":"Словения","isEuropean":true,"where":{"ru":"в Словении","uk":"в Словенії"},"from":{"ru":"из Словении","uk":"зі Словенії"},"slug":"sloveniya","is_country":true},{"id":4495,"showInFooter":true,"title":"США","where":{"ru":"в США","uk":"в США"},"from":{"ru":"из США","uk":"з США"},"slug":"ssha","is_country":true},{"id":17879,"showInFooter":false,"title":"Таиланд","where":{"ru":"в Таиланде","uk":"в Таїланді"},"from":{"ru":"из Таиланда","uk":"з Таїланду"},"slug":"tailand","is_country":true},{"id":10585,"showInFooter":false,"title":"Тайвань","where":{"ru":"в Тайване","uk":"в Тайвані"},"from":{"ru":"из Тайваня","uk":"з Тайваню"},"slug":"tayvan","is_country":true},{"id":4517,"showInFooter":false,"title":"Турция","where":{"ru":"в Турции","uk":"у Туреччині"},"from":{"ru":"из Турции","uk":"з Туреччини"},"slug":"turtsiya","is_country":true},{"id":4518,"showInFooter":false,"title":"Великобритания","isEuropean":true,"where":{"ru":"в Великобритании","uk":"у Великобританії"},"from":{"ru":"из Великобритании","uk":"з Великобританії"},"slug":"velikobritaniya","is_country":true},{"id":4485,"showInFooter":false,"title":"Венгрия","isEuropean":true,"where":{"ru":"в Венгрии","uk":"в Угорщині"},"from":{"ru":"с Венгрии","uk":"з Угорщини"},"slug":"vengriya","is_country":true},{"id":7844,"showInFooter":false,"title":"Япония","where":{"ru":"в Японии","uk":"в Японії"},"from":{"ru":"из Японии","uk":"з Японії"},"slug":"yaponiya","is_country":true},{"id":116098,"showInFooter":false,"isEuropean":false,"where":{"ru":"в ОАЭ","uk":"в ОАE"},"from":{"ru":"с ОАЭ","uk":"з ОАE"},"slug":"uae","is_country":true,"title":"ОАЭ","includeInDrivenFrom":true},{"id":1942,"showInFooter":false,"title":"Дальнее зарубежье","where":{"ru":"в Дальнем зарубежье","uk":"в Далекому зарубіжжі"},"from":{"ru":"с Дальнего зарубежья","uk":"з Далекого зарубіжжя"},"slug":"dalnee-zarubezhe","is_country":true},{"id":1941,"showInFooter":true,"title":"Европа","where":{"ru":"в Европе","uk":"в Європі"},"from":{"ru":"с Европы","uk":"з Європи"},"slug":"evropa","is_country":true},{"id":116156,"showInFooter":true,"title":"Азия","where":{"ru":"в Азии","uk":"в Азії"},"from":{"ru":"с Азии","uk":"з Азії"},"slug":"asia","is_country":true}]

/***/ }),

/***/ 312:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* unused harmony export getMake */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return generateUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return generateSearchQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return generateSearchUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return generateDealersSearchUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return generateFirmsSearchUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return generateSparesSearchUrl; });
/* unused harmony export generateFirmSparesSearchUrl */
/* unused harmony export transformQuery */
/* unused harmony export changeQuery */
/* unused harmony export shouldDisplayCountries */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getIdFromSpareUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return generateJournalhUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getDealerLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return translateSeoLinks; });
/* unused harmony export getBaseURL */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__history__ = __webpack_require__(185);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }




var isClient = true;
var HOST = process.env.HOST || process.env.WEBSITE_HOSTNAME;

function getMake(make) {
  return make && (typeof make === 'string' ? make : make.slug) || '';
}

var generateUrl = function generateUrl(car) {
  if (!car.permalink) {
    return (car.make && getMake(car.make)) + '-' + (car.model && car.model.slug) + '-' + car.year + '-' + (car.location && car.location.slug) + '-1-' + car.id + '-1.html';
  }
  return car.permalink;
};

var getRangeNumber = function getRangeNumber(number) {
  var rangePercent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;

  var precentValue = number / 100 * rangePercent;
  var from = Math.round(number - precentValue);
  var to = Math.round(number + precentValue);
  return { from: from, to: to };
};

var generateSearchQuery = function generateSearchQuery(select) {
  var query = {};

  Object.keys(select).forEach(function (key) {
    if (select[key] === null || select[key] === undefined) {
      return null;
    } else if (key === 'colors') {
      query[key] = select[key];
    } else if (key === 'currency') {
      query[key] = select[key].slug || select[key];
    } else if (Object.keys(select[key]).length > 0 && _typeof(select[key]) === 'object') {
      query[key] = select[key].id || select[key].value;
    } else if (key === 'options') {
      query[key] = Object.keys(select[key]);
    } else if (key === 'prepaid') {
      var range = getRangeNumber(select[key]);
      query.prepaid_sum__gte = range.from;
      query.prepaid_sum__lte = range.to;
      query[key] = select[key];
    } else if (key === 'monthly') {
      var _range = getRangeNumber(select[key]);
      query.monthly_payment__gte = _range.from;
      query.monthly_payment__lte = _range.to;
      query[key] = select[key];
    } else {
      query[key] = select[key];
    }
    return query;
  });
  return query;
};

var generateSearchUrl = function generateSearchUrl(_ref) {
  var transport = _ref.transport,
      isNew = _ref.isNew,
      make = _ref.make,
      model = _ref.model,
      year = _ref.year,
      location = _ref.location,
      transportChild = _ref.transportChild;
  var isCountry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var result = [transport && transport.slug, isNew && transport && 'novye', make && getMake(make), model && model.slug, year && 'god-' + year, transportChild && transportChild.slug, location && (!isNew && transport && transport.slug === 'avto' ? true : !isCountry) && '' + location.slug, '/'].filter(function (i) {
    return !!i;
  }).join('/').replace(/\/\//g, '/');
  return result;
};

var generateDealersSearchUrl = function generateDealersSearchUrl(_ref2) {
  var transport = _ref2.transport,
      make = _ref2.make,
      model = _ref2.model,
      location = _ref2.location;
  return ['avtosalony', transport && transport.slug !== 'avto' && transport.slug, make && getMake(make), model && model.slug, location && '' + location.slug, '/'].filter(function (i) {
    return !!i;
  }).join('/').replace(/\/\//g, '/');
};

var generateFirmsSearchUrl = function generateFirmsSearchUrl(_ref3) {
  var tag = _ref3.tag,
      location = _ref3.location;
  return ['katalog-kompaniy', tag && tag.slug, location && location.slug + '/'].filter(function (i) {
    return !!i;
  }).join('/').replace(/\/\//g, '/');
};

var generateSparesSearchUrl = function generateSparesSearchUrl(_ref4) {
  var transport = _ref4.transport,
      rubric = _ref4.rubric,
      sparetype = _ref4.sparetype,
      make = _ref4.make,
      model = _ref4.model,
      location = _ref4.location;
  return ['zapchasti', transport && transport.slug !== 'avto' && transport.slug, rubric && rubric.slug, sparetype && sparetype.slug, make && getMake(make), model && model.slug, location && location.slug, '/'].filter(function (i) {
    return !!i;
  }).join('/').replace(/\/\//g, '/');
};

var generateFirmSparesSearchUrl = function generateFirmSparesSearchUrl(_ref5) {
  var transport = _ref5.transport,
      rubric = _ref5.rubric,
      sparetype = _ref5.sparetype,
      make = _ref5.make,
      model = _ref5.model,
      location = _ref5.location;
  return [location && location.pathname, transport && transport.slug !== 'avto' && transport.slug].concat(_toConsumableArray(transport && transport.slug === 'avto' ? [rubric && rubric.slug, sparetype && sparetype.slug] : []), [make && getMake(make), model && model.slug, '/']).filter(function (i) {
    return !!i;
  }).join('/').replace(/\/\//g, '/');
};

var transformQuery = function transformQuery(propQuery, data, param) {
  var query = _extends({}, propQuery);
  if (data === '' || data === null) {
    delete query[param];
  } else {
    query[param] = data;
  }
  query.page = 1;

  return query;
};

var changeQuery = function changeQuery(url, query) {
  __WEBPACK_IMPORTED_MODULE_1__history__["a" /* default */].push(url + '?' + __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify(query));
};

var shouldDisplayCountries = function shouldDisplayCountries(path, routeName, formState) {
  return !path.includes('/novye') && (formState && formState.transport ? formState.transport.slug === 'avto' : true) && routeName !== 'dealers' && routeName !== 'moto' && routeName !== 'firms' && routeName !== 'dealer' && routeName !== 'auto-parts';
};

var getIdFromSpareUrl = function getIdFromSpareUrl(url) {
  if (url.match(/([0-9]-)([0-9])+(-[0-9].html)/g)) {
    return url.match(/([0-9]-)([0-9])+(-[0-9].html)/g)[0].split('-')[1];
  } else if (url.match(/[0-9]+.html/g)) {
    return url.match(/[0-9]+.html/g)[0].replace('.html', '');
  } else if (url.match(/[0-9]+$/g)) {
    return url.match(/[0-9]+$/g);
  }

  return null;
};

var generateJournalhUrl = function generateJournalhUrl(_ref6) {
  var topic = _ref6.topic,
      make = _ref6.make,
      model = _ref6.model;
  return ['/zhurnal/video/', topic && topic.seo_slug, make && getMake(make), model && model.slug].filter(function (i) {
    return !!i;
  }).join('/').replace(/\/\//g, '/');
};

var getDealerLink = function getDealerLink(dealer) {
  var url = dealer.is_dealer ? 'avtosalony' : 'katalog-kompaniy';
  return '/' + url + '/' + dealer.slug + '/';
};

var translateSeoLinks = function translateSeoLinks(links, t) {
  var availableKeys = { categories: 1, engines: 1, gearboxes: 1, rubrics: 1 };
  if (t('locale') === 'ru') return links || {};

  Object.keys(links || {}).forEach(function (key) {
    if (!availableKeys[key]) return;
    (links[key] || []).forEach(function (item) {
      item.locale_title = item.uk_title || t(item.title);
    });
  });
  return links || {};
};

function getBaseURL() {
  var host = isClient && location && location.host || HOST || 'avtobazar.ua';
  var protocol = isClient && location && location.protocol || 'https:';
  return protocol + '//' + host;
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(250)))

/***/ }),

/***/ 317:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VINRegexp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return numberWithSpacesRegexp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__codeOperators__ = __webpack_require__(435);
/* eslint-disable no-useless-escape */
/* eslint-disable import/prefer-default-export */


var VINRegexp = '^[0-9ABCDEFGHJKLMNPRSTUVWXYZabcdefghjklmnprstuvwxyz]{0,17}$';

var numberWithSpacesRegexp = '^[0-9 ]{0,15}$';

/* harmony default export */ __webpack_exports__["b"] = ({
  phoneOperators: new RegExp('^(\\+[0-9]{2}\\((' + __WEBPACK_IMPORTED_MODULE_0__codeOperators__["a" /* all */] + ')\\)[0-9]{3}-[0-9]{2}-[0-9]{2}|(\\+38|38|8)?(' + __WEBPACK_IMPORTED_MODULE_0__codeOperators__["a" /* all */] + ')[0-9]{7})$'),
  password: /.{0,}/,
  number: /^[0-9]{0,50}$/,
  phone: new RegExp('^(\\+[0-9]{2}\\(([0-9]{3})\\)[0-9]{3}-[0-9]{2}-[0-9]{2}|(\\+38|38|8)?([0-9]{3})[0-9]{7})$'),
  phoneNormalize: /^(\+38|38|8)?[0-9]{10}$/,
  name: /^[0-9a-zабвгґдеєжзиіїйклмнопрстуфхцчшщьюяёъыэя\ʼ\'\`\-\s]{1,100}$/i
});

/***/ }),

/***/ 320:
/***/ (function(module, exports) {

module.exports = [{"id":0,"title":"тыс. км."},{"id":1,"title":"тыс. миль"}]

/***/ }),

/***/ 322:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIVE_STATUSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ANY_TYPE_OMITTED_FIELDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return OMMITED_FIELDS_BY_TRANSPORT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ENGINES_CONVERTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GEARBOX_CONVERTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return WHELL_DRIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FEATURES; });
var ACTIVE_STATUSES = {
  ACTIVE: 1,
  NOT_ACTIVE: 0,
  REMOVED: -2
};

var ANY_TYPE_OMITTED_FIELDS = ['options', 'description', 'vin', 'cooling', 'categories_width', 'categories_height', 'brake_rear', 'brake_front', 'range_type', 'contact_name', 'fueltank_capacity', 'flowrate', 'dimension_width', 'dimension_length', 'dimension_weight', 'bucket_count', 'condition', 'cabin', 'brakes', 'suspension', 'chassis_suspension', 'cabin_suspension', 'date_overhaul', 'gears', 'migrated', 'features', 'engine_features', 'color_features', 'gas_equipment', 'views_count', 'caterpillars_width', 'gearbox_with_dividers', 'is_bdf', 'crane_arm', 'palets'];

var OMMITED_FIELDS_BY_TRANSPORT_ID = {
  1: ['tacts', 'engine_order', 'unloading', 'tonnage', 'accessibility', 'productivity', 'dimension_height', 'capacity_body', 'capacity_bucket', 'laying_width', 'lift_height', 'admission_height', 'arm_boom', 'dep_big', 'axises', 'fueltanks_count', 'fueltanks_capacity', 'couchettes']
};

var ENGINES_CONVERTER = {
  dizelniy: 'D',
  elektricheskiy: 'E',
  benzinoviy: 'P',
  gibridniy: 'E',
  gazoviy: 'G'
};

var GEARBOX_CONVERTER = {
  avtomat: 'A',
  mehanika: 'M',
  variator: 'A',
  robot: 'A'
};

var WHELL_DRIVE = {
  peredniy: 'FRONT',
  polniy: 'FOUR',
  zadniy: 'REAR'
};

var FEATURES = {
  'Обогрев руля': 'STEERING_WHEEL_HEATING',
  'Климат-Климат-контроль': 'CLIMATE_CONTROL',
  'Электростеклоподъемники-Передние': 'FRONT_GLASS_LIFT',
  'Мультимедиа-Сенсорный экран': 'MEDIA_SCREEN',
  'Электростеклоподъемники-Все': 'REAR_GLASS_LIFT',
  'AUTONOMOUS_HEATER': 'AUTONOMOUS_HEATER', // -- 
  'Панорамная крыша': 'PANORAMIC_ROOF',
  'Bluetooth': 'BLUETOOTH',
  'Датчик дождя': 'RAIN_DETECTOR',
  '"Обогрев зеркал': 'MIRROR_HEATING',
  'Круиз-контроль': 'CRUISE_CONTROL',
  'Электрорегулировка сидений': 'ELECTRO_SEAT_ADJUSTMENT',
  'HITCH': 'HITCH', // -- 
  'Фары-Ксеноновые': 'XENON_LIGHTS',
  'Противотуманные фары': 'FOG_LIGHTS',
  'Подушки безопасности боковые': 'SIDE_SAFEBAGS',
  'ESP': 'ESP',
  'Рейлинги на крыше': 'RAILINGS',
  'USB': 'USB',
  'Система контроля слепых зон': 'MIRROR_DEAD_ZONE_CONTROL',
  'Система “старт-стоп”': 'DRIVE_AUTO_START',
  'Климат-Кондиционер': 'CONDITIONER',
  'Мультимедиа-CD': 'CD_MP3_PLAYER',
  'Мультимедиа-MP3': 'CD_MP3_PLAYER',
  'STEERING_WHEEL_MEDIA_CONTROL': 'STEERING_WHEEL_MEDIA_CONTROL', // ---
  'Охранные системы': 'ALARM',
  'Подушка безопасности пассажира': 'REAR_SAFEBAGS',
  'Мультимедиа-Навигация': 'NAVIGATOR',
  'Обогрев лобового стекла': 'FRONT_GLASS_HEATING',
  'Охранные системы-Иммобилайзер': 'IMMOBILIZER',
  'Диски-Легкосплавные': 'ALLOY_WHEELS',
  'ABS': 'ABS',
  'Обогрев сидений': 'SEAT_HEATING',
  'Люк': 'HATCH',
  'Камера заднего вида': 'REAR_VIEW_CAMERA',
  'Подушка безопасности водител': 'FRONT_SAFEBAGS',
  'Антипробуксовочная система': 'ANTI_SLIP_SYSTEM', // ---
  'AUX': 'AUX_IPOD',
  'Фары-Светодиодные': 'LED_LIGHTS',
  'Задний парктроник': 'PARKTRONICS',
  'Передний парктроник': 'PARKTRONICS'
};

/***/ }),

/***/ 329:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  registration: function registration() {
    return '/registration';
  },
  login: function login() {
    return '/login';
  },
  recovery: function recovery() {
    return '/recovery';
  },
  my: function my() {
    return '/my';
  },
  law: function law() {
    return '/law';
  },
  verify: function verify() {
    return '/verify';
  }
});

/***/ }),

/***/ 435:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return all; });
var codeOperaturs = {
  mts: ['050', '066', '095', '099'],
  kyivstar: ['067', '096', '097', '098', '039'],
  beeline: ['068'],
  life: ['063', '093', '073'],
  utel: ['091'],
  peopleNet: ['092'],
  intertelecom: ['094']
};
var str = '';
var arr = Object.keys(codeOperaturs);
arr.map(function (a, b) {
  if (arr.length > b + 1 || codeOperaturs[a].length < 1) {
    str += codeOperaturs[a].join('|') + '|';
  } else {
    str += codeOperaturs[a].join('|');
  }
  return '';
});
var all = str;

/***/ }),

/***/ 436:
/***/ (function(module, exports) {

module.exports = {"id":-1,"title":"Любая марка","title_uk":"Будь-яка марка"}

/***/ }),

/***/ 437:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slots; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ignoreTopBanner; });
var slotsValid = [{}, {}];
var slots = [{
  dfpNetworkId: '78780000',
  adUnit: 'branding_top',
  sizes: [[1, 1], [728, 90], [1100, 120], [980, 90], 'fluid'],
  slotId: 'div-gpt-ad-1514298874616-0'
}, {
  dfpNetworkId: '78780000',
  adUnit: 'desktop_premium',
  sizes: [[300, 400], [300, 600], [300, 250]],
  slotId: 'div-gpt-ad-1510239331518-1'
}, {
  dfpNetworkId: '78780000',
  adUnit: 'desktop_right_sidebar',
  sizes: [[300, 250]],
  slotId: 'div-gpt-ad-1510224251147-0'
}, {
  dfpNetworkId: '78780000',
  adUnit: 'desktop_context',
  sizes: [[728, 90], 'fluid'],
  slotId: 'div-gpt-ad-1510239331518-2'
}, {
  dfpNetworkId: '78780000',
  adUnit: 'ab_desktop_content-roll',
  sizes: [[670, 200], [670, 380]],
  slotId: 'div-gpt-ad-1573820960067-0'
}, {
  dfpNetworkId: '78780000',
  adUnit: 'mobile_web_premium',
  sizes: ['fluid', [300, 250], [300, 600], [300, 400]],
  slotId: 'div-gpt-ad-1510224093566-3'
}, {
  dfpNetworkId: '78780000',
  adUnit: 'mobile_web_bottom',
  sizes: [[320, 100], [320, 50], [300, 250], 'fluid'],
  slotId: 'div-gpt-ad-1548957160695-0'
}, {
  dfpNetworkId: '78780000',
  adUnit: 'ab_mobile_content-roll',
  sizes: [[345, 200]],
  slotId: 'div-gpt-ad-1573834860031-0'
}, {
  dfpNetworkId: '78780000',
  adUnit: 'ab_mobile_web_catfish',
  sizes: [],
  slotId: 'div-gpt-ad-1510224093566-0'
}, {
  dfpNetworkId: '78780000',
  adUnit: 'mobile_web_top',
  sizes: [[320, 50], [320, 100], 'fluid'],
  slotId: 'div-gpt-ad-1575022787355-0'
}].map(function (a) {
  if (!slotsValid[0][a.adUnit] && !slotsValid[1][a.slotId]) {
    slotsValid[0][a.adUnit] = true;
    slotsValid[1][a.slotId] = true;
    return a;
  }
  throw void 0;
});
var ignoreTopBanner = ['/registration/', '/registration', '/login/', '/login', '/my/', '/my', '/recovery', '/recovery/', '/my/zapchasti', '/my/zapchasti/', '/messages', '/messages/', '/favorites', '/favorites/', '/billing', '/billing/', '/profile', '/profile/', '/my/moto', '/my/moto/', '/my/avtobus', '/my/avtobus/', '/my/gruzovye', '/my/gruzovye/', '/my/spetstehnika', '/my/spetstehnika/', '/my/pritsepy', '/my/pritsepy/', '/my/zapchasti', '/my/zapchasti/', '/add/avto', '/add/avto/', '/add/moto/', '/add/moto', '/add/avtobus', '/add/avtobus/', '/add/gruzovye', '/add/gruzovye/', '/add/spetstehnika', '/add/spetstehnika/', '/add/pritsepy', '/add/pritsepy/', '/add/zapchasti', '/add/zapchasti/', '/insurance/orders', '/insurance/orders/', '/dialogs', '/dialogs/', '/service/search-subscriptions', '/service/search-subscriptions/'];

/***/ }),

/***/ 443:
/***/ (function(module, exports) {

module.exports = [{"id":0,"title":"Растаможенные","value":0},{"id":1,"title":"Нерастаможенные","value":1},{"id":null,"title":"Неважно","value":null}]

/***/ }),

/***/ 463:
/***/ (function(module, exports) {

module.exports = [{"id":1901,"slug":"000000","title":"черный"},{"id":1963,"slug":"cc0000","title":"красный"},{"id":1969,"slug":"990000","title":"вишневый"},{"id":1964,"slug":"ff9900","title":"оранжевый"},{"id":1965,"slug":"ffff00","title":"желтый"},{"id":1966,"slug":"99ff66","title":"салатовый"},{"id":1971,"slug":"339900","title":"зеленый"},{"id":1967,"slug":"3399ff","title":"голубой"},{"id":1972,"slug":"003399","title":"синий"},{"id":1973,"slug":"660099","title":"фиолетовый"},{"id":1968,"slug":"cc3399","title":"пурпурный"},{"id":4481,"slug":"f5f5dc","title":"бежевый"},{"id":1970,"slug":"996600","title":"коричневый"},{"id":1900,"slug":"969293","title":"серый"},{"id":1960,"slug":"dddcda","title":"серебристый"},{"id":1961,"slug":"eedd80","title":"золотистый"},{"id":1962,"slug":"c28944","title":"бронзовый"},{"id":1899,"slug":"ffffff","title":"белый"},{"id":47716,"slug":"xxxxxx","title":"другой"}]

/***/ }),

/***/ 464:
/***/ (function(module, exports) {

module.exports = [{"title":"новая","id":"is_new"},{"title":"б/у","id":"is_used"},{"title":"оригинал","id":"is_original"},{"title":"аналог","id":"is_analogue"},{"title":"под заказ","id":"is_under_the_order"},{"title":"в наличии","id":"in_stock"},{"title":"доставка по Украине","id":"delivery_in_ukraine"}]

/***/ }),

/***/ 47:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return journal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return directSetLocation; });
/* unused harmony export directSetFingerprint */
/* unused harmony export directSetPromoteInSocial */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return setTargetingArguments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return setSeoSearchUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return setPaymentModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return setDataLayer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bannerShow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return bannerUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bannerHide; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return directSetSeoText; });
/* unused harmony export directSetDealerSlug */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return setIsApprovePub; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return setRedirectUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return setInsuranceOrders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return setInsuranceRegions; });
/* unused harmony export setInsuranceFilters */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return setInsuranceMakes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return setSelectedValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return setSelectedOffer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return setOrderWithHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return setFillData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return setOffersData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return setIsNumberBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return setShowConfirmModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return setOrderForEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return setFingerprint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return clearEditOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return clearRedirectUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return setPromoteInSocial; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return setLocation; });
/* unused harmony export setRatio */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return seoRequest; });
/* unused harmony export sendCreditEmail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fingerprintjs2__ = __webpack_require__(1050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fingerprintjs2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fingerprintjs2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_constants_api__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_constants_json_anyMake_json__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_constants_json_anyMake_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_shared_constants_json_anyMake_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_actionTypes__ = __webpack_require__(17);
var _this = this;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/* eslint-disable import/prefer-default-export */









var journal = __WEBPACK_IMPORTED_MODULE_2_redux_actions__["b" /* createActions */]({
  journal: {
    setRubrics: undefined
  }
}).journal;

var directSetRatio = __WEBPACK_IMPORTED_MODULE_2_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_5__constants_actionTypes__["d" /* GLOBALS */].RATIO_SET);
var directSetLocation = __WEBPACK_IMPORTED_MODULE_2_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_5__constants_actionTypes__["d" /* GLOBALS */].LOCATION_SET);
var directSetFingerprint = __WEBPACK_IMPORTED_MODULE_2_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_5__constants_actionTypes__["d" /* GLOBALS */].FINGERPRINT_SET);
var directSetPromoteInSocial = __WEBPACK_IMPORTED_MODULE_2_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_5__constants_actionTypes__["d" /* GLOBALS */].PROMOTE_IN_SOCIAL_SET);
var setTargetingArguments = __WEBPACK_IMPORTED_MODULE_2_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_5__constants_actionTypes__["d" /* GLOBALS */].TARGETING_ARGUMENTS_SET);
var setSeoSearchUrl = __WEBPACK_IMPORTED_MODULE_2_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_5__constants_actionTypes__["d" /* GLOBALS */].SEO_SEARCH_URLS);
var setPaymentModal = __WEBPACK_IMPORTED_MODULE_2_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_5__constants_actionTypes__["d" /* GLOBALS */].PAYMENT_SET_MODAL);
var setDataLayer = __WEBPACK_IMPORTED_MODULE_2_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_5__constants_actionTypes__["d" /* GLOBALS */].DATA_LAYER_SET);
var bannerShow = __WEBPACK_IMPORTED_MODULE_2_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_5__constants_actionTypes__["d" /* GLOBALS */].BANNER_SHOW);
var bannerUpdate = __WEBPACK_IMPORTED_MODULE_2_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_5__constants_actionTypes__["d" /* GLOBALS */].BANNER_UPDATE);
var bannerHide = __WEBPACK_IMPORTED_MODULE_2_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_5__constants_actionTypes__["d" /* GLOBALS */].BANNER_HIDE);
var directSetSeoText = __WEBPACK_IMPORTED_MODULE_2_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_5__constants_actionTypes__["d" /* GLOBALS */].SEO_TEXT_SET);
var directSetDealerSlug = __WEBPACK_IMPORTED_MODULE_2_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_5__constants_actionTypes__["d" /* GLOBALS */].DEALER_SLUG_SET);
var setIsApprovePub = __WEBPACK_IMPORTED_MODULE_2_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_5__constants_actionTypes__["d" /* GLOBALS */].SET_IS_APPROVE_PUB);
var setRedirectUrl = __WEBPACK_IMPORTED_MODULE_2_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_5__constants_actionTypes__["d" /* GLOBALS */].SET_REDIRECT_URL);

// start Insurance
var setInsuranceOrders = __WEBPACK_IMPORTED_MODULE_2_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_5__constants_actionTypes__["d" /* GLOBALS */].SET_INSURANCE_ORDERS);
var setInsuranceRegions = __WEBPACK_IMPORTED_MODULE_2_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_5__constants_actionTypes__["d" /* GLOBALS */].SET_INSURANCE_REGIONS);
var setInsuranceFilters = __WEBPACK_IMPORTED_MODULE_2_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_5__constants_actionTypes__["d" /* GLOBALS */].SET_INSURANCE_FILTERS);
var setInsuranceMakes = __WEBPACK_IMPORTED_MODULE_2_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_5__constants_actionTypes__["d" /* GLOBALS */].SET_INSURANCE_MAKES);
var setSelectedValues = __WEBPACK_IMPORTED_MODULE_2_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_5__constants_actionTypes__["d" /* GLOBALS */].SET_SELECTED_VALUES);
var setSelectedOffer = __WEBPACK_IMPORTED_MODULE_2_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_5__constants_actionTypes__["d" /* GLOBALS */].SET_SELECTED_OFFER);
var setOrderWithHash = __WEBPACK_IMPORTED_MODULE_2_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_5__constants_actionTypes__["d" /* GLOBALS */].SET_ORDER_WITH_HASH);
var setFillData = __WEBPACK_IMPORTED_MODULE_2_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_5__constants_actionTypes__["d" /* GLOBALS */].SET_FILL_DATA);
var setOffersData = __WEBPACK_IMPORTED_MODULE_2_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_5__constants_actionTypes__["d" /* GLOBALS */].SET_OFFERS_DATA);
var setIsNumberBlock = __WEBPACK_IMPORTED_MODULE_2_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_5__constants_actionTypes__["d" /* GLOBALS */].SET_IS_NUMBER_BLOCK);
var setShowConfirmModal = __WEBPACK_IMPORTED_MODULE_2_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_5__constants_actionTypes__["d" /* GLOBALS */].SET_SHOW_CONFIRM_MODAL);
var setOrderForEdit = __WEBPACK_IMPORTED_MODULE_2_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_5__constants_actionTypes__["d" /* GLOBALS */].SET_ORDER_FOR_EDIT);
// end Insurance

var setFingerprint = function setFingerprint() {
  return function (dispatch) {
    try {
      new __WEBPACK_IMPORTED_MODULE_1_fingerprintjs2___default.a().get(function (result) {
        dispatch(directSetFingerprint(result)); // a hash, representing your device fingerprint
      });
    } catch (e) {
      // It's ok if the fingerprint can't be calculated
    }
  };
};

var clearEditOrder = function clearEditOrder() {
  return function (dispatch) {
    dispatch(setOrderForEdit(null));
  };
};

var clearRedirectUrl = function clearRedirectUrl() {
  return function (dispatch) {
    dispatch(setRedirectUrl(''));
  };
};

var setPromoteInSocial = function setPromoteInSocial(value) {
  return function (dispatch) {
    dispatch(directSetPromoteInSocial(value));
  };
};

var setLocation = function setLocation(location) {
  return function (dispatch) {
    dispatch(directSetLocation(location));
  };
};

var setRatio = function setRatio() {
  return function (dispatch, getState) {
    if (!getState().globals.ratio) {
      var ratio = 1;
      var mediaQuery = '(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5),(-o-min-device-pixel-ratio: 3/2),(min-resolution: 1.5dppx)';
      if (true && window.devicePixelRatio) {
        ratio = window.devicePixelRatio;
      } else if (true && window.matchMedia && window.matchMedia(mediaQuery).matches) {
        ratio = 1.5;
      }

      __WEBPACK_IMPORTED_MODULE_0_js_cookie__["set"]('ratio', parseFloat(ratio));

      dispatch(directSetRatio(ratio));
    }

    return Promise.resolve(null);
  };
};

var seoRequest = function seoRequest(url, query) {
  var obj = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState, _ref2) {
      var fetch = _ref2.fetch;
      var resSeo, trendsStorage, trends;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!url) {
                _context.next = 6;
                break;
              }

              _context.next = 3;
              return fetch(__WEBPACK_IMPORTED_MODULE_3_shared_constants_api__["a" /* default */].SEO.SEARCH_URLS(url, query)).then(function (r) {
                return r.ok ? r.json() : null;
              });

            case 3:
              _context.t0 = _context.sent;
              _context.next = 7;
              break;

            case 6:
              _context.t0 = null;

            case 7:
              resSeo = _context.t0;


              if (query && query.make === '-1' && resSeo) resSeo.make = __WEBPACK_IMPORTED_MODULE_4_shared_constants_json_anyMake_json___default.a;

              // Currently trends for all pages the same, this is should be changed if trends will be different.
              trendsStorage = getState().globals.seoSearchUrlResponse.trends;
              _context.t1 = trendsStorage;

              if (_context.t1) {
                _context.next = 15;
                break;
              }

              _context.next = 14;
              return fetch(__WEBPACK_IMPORTED_MODULE_3_shared_constants_api__["a" /* default */].SEO.SEARCH_TRENDS({})).then(function (r) {
                return r.ok ? r.json() : null;
              });

            case 14:
              _context.t1 = _context.sent;

            case 15:
              trends = _context.t1;

              if (resSeo) {
                resSeo.trends = trends;
              } else {
                dispatch(setSeoSearchUrl(_extends({}, resSeo, obj, { trends: trends })));
              }

              return _context.abrupt('return', resSeo);

            case 18:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x2, _x3, _x4) {
      return _ref.apply(this, arguments);
    };
  }();
};

var sendCreditEmail = function sendCreditEmail(data) {
  return function (dispatch, getState, _ref3) {
    var fetch = _ref3.fetch;
    return fetch(__WEBPACK_IMPORTED_MODULE_3_shared_constants_api__["a" /* default */].SEND_CREDIT_MAIL, {
      method: 'POST',
      body: JSON.stringify(data)
    }).then(function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(res) {
        var status, dat;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                status = res.status;
                _context2.next = 3;
                return res.json();

              case 3:
                _context2.t0 = _context2.sent;

                if (_context2.t0) {
                  _context2.next = 6;
                  break;
                }

                _context2.t0 = {};

              case 6:
                dat = _context2.t0;

                if (!(status === 200)) {
                  _context2.next = 9;
                  break;
                }

                return _context2.abrupt('return', dat.message || 'Ваше письмо отправлено');

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }));

      return function (_x5) {
        return _ref4.apply(this, arguments);
      };
    }()).catch(function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(err) {
        var dat;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return err.json();

              case 2:
                _context3.t0 = _context3.sent;

                if (_context3.t0) {
                  _context3.next = 5;
                  break;
                }

                _context3.t0 = {};

              case 5:
                dat = _context3.t0;
                return _context3.abrupt('return', dat.message || 'Извините, произошла ошибка на сервере, попробуйте повторить операцию позже');

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this);
      }));

      return function (_x6) {
        return _ref5.apply(this, arguments);
      };
    }());
  };
};

/***/ }),

/***/ 475:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return shiftNotification; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return enqueueNotification; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__ = __webpack_require__(17);



var shiftNotification = __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["l" /* NOTIFICATIONS */].SHIFT);
var enqueueNotification = __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["l" /* NOTIFICATIONS */].ENQUEUE, function (message) {
  return typeof message === 'string' ? {
    text: message
  } : message;
});

/***/ }),

/***/ 476:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/constants/cookies.js
var TOKEN_KEY = 'jwtt';

var LEASING_PARTNER = 'leasing_partner';
var STO_TOKEN_KEY = 'sto_vote_token';
var STO_COOKIE_MAX_AGE_DAYS = 60;
var COOKIES_LOCATION = 'current_location';
// CONCATENATED MODULE: ./src/shared/actions/user.js
/* unused harmony export setSession */
/* unused harmony export setUser */
/* unused harmony export setPhone */
/* unused harmony export removePhone */
/* unused harmony export userRegistration */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return beforeRegistration; });
/* unused harmony export userError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return setSavedSearches; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return setShowSaveSearchBtn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return user_userLogout; });
/* unused harmony export userLogin */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return updateUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addPhone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return deletePhone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return authWithPhone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return authorize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return resendVerifyCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return loginWithFacebookToken; });
/* unused harmony export setBalance */
/* unused harmony export setBalanceIsFetching */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return fetchBalance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return reloadUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return registration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return userAuthorize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return userRecovery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return userVerifyMail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return userVerifyCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return userCheckCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return changePassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return logistics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getSingleAuthToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return renderRecaptchaV2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_helpers_partsForm__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_helpers_advertForm__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_helpers_google__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_actions_notifications__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_cookie__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_helpers_locale__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_constants_regexp__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_validator__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_validator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_object_to_formdata__ = __webpack_require__(1231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_object_to_formdata___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_object_to_formdata__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_constants_api__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_history_js__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_constants_url__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_modules__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants_actionTypes__ = __webpack_require__(17);
var _this = this;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




















var SECONDARY_COOKIE_DOMAIN =  true ? '.' + window.location.hostname : undefined;

var L = {
  DEFAULT_ERROR_MESSAGE: {
    ru: 'Извините, произошла ошибка на сервере, попробуйте повторить операцию позже',
    uk: 'Вибачте, сталася помилка на сервері, спробуйте повторити операцію пізніше'
  },
  USER_ALREADY_EXIST_MESSAGE: {
    ru: 'Такой пользователь уже зарегистрирован',
    uk: 'Такий користувач вже зареєстрований'
  },
  CODE_NOT_VALID_MESSAGE: {
    ru: 'Вы ввели неверный код',
    uk: 'Ви ввели невірний код'
  },
  PASSWORD_NOT_VALID_MESSAGE: {
    ru: 'Вы ввели неверный пароль',
    uk: 'Ви ввели невірний пароль'
  },
  INPUT_VALID_USER_MESSAGE: {
    ru: 'Введите мобильный телефон',
    uk: 'Введіть мобільний телефон'
  },
  IMAGE_SIZE_MESSAGE: {
    ru: 'Вес изображения должен быть не больше 1 мб',
    uk: 'Вага зображення повинна бути не більше 1 мб'
  },
  USER_RECOVERY_MESSAGE: function USER_RECOVERY_MESSAGE(data) {
    return {
      ru: '\u041D\u0430 ' + data + ' \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D \u043D\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C',
      uk: '\u041D\u0430 ' + data + ' \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E \u043D\u043E\u0432\u0438\u0439 \u043F\u0430\u0440\u043E\u043B\u044C'
    };
  },
  USER_RECOVERY_VERIFY: function USER_RECOVERY_VERIFY(data) {
    return {
      ru: '\u041D\u0430 ' + data + ' \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u0434\u043B\u044F \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u043F\u043E\u0447\u0442\u044B',
      uk: '\u041D\u0430 ' + data + ' \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F \u0434\u043B\u044F \u043F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F \u043F\u043E\u0448\u0442\u0438'
    };
  },
  'User with this phone already registered': 'Пользователь с таким телефоном уже зарегистрирован',
  'User with this email already registered': 'Пользователь с таким адресом электронной почты уже зарегистрирован',
  'Invalid password for this login': 'Не верная электронная почта или пароль',
  'User with such login does not exist': 'Указанный телефон или почта не зарегистрирована в системе'
};

var setSession = __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_14__constants_actionTypes__["n" /* USER */].SET_SESSION);
var setUser = __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_14__constants_actionTypes__["n" /* USER */].SET_USER);
var setPhone = __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_14__constants_actionTypes__["n" /* USER */].SET_PHONE);
var removePhone = __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_14__constants_actionTypes__["n" /* USER */].REMOVE_PHONE);
var userRegistration = __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_14__constants_actionTypes__["n" /* USER */].REGISTRATION);
var beforeRegistration = __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_14__constants_actionTypes__["n" /* USER */].BEFORE_REGISTRATION);
var userError = __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_14__constants_actionTypes__["n" /* USER */].ERROR);
var setSavedSearches = __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_14__constants_actionTypes__["n" /* USER */].SET_SAVED_SEARCHES);
var setShowSaveSearchBtn = __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_14__constants_actionTypes__["n" /* USER */].SET_SHOW_SAVE_SEARCH_BTN);
var user_userLogout = function userLogout() {
  __WEBPACK_IMPORTED_MODULE_5_js_cookie__["remove"](TOKEN_KEY);
  __WEBPACK_IMPORTED_MODULE_5_js_cookie__["remove"](STO_TOKEN_KEY, { domain: SECONDARY_COOKIE_DOMAIN });

  return {
    type: __WEBPACK_IMPORTED_MODULE_14__constants_actionTypes__["n" /* USER */].LOGOUT
  };
};

var user_userLogin = function userLogin(token) {
  var customHeaders = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var modal = arguments[2];
  var enqueueNotification = arguments[3];
  return function (dispatch, getState, _ref) {
    var fetch = _ref.fetch;

    var _getState = getState(),
        locale = _getState.globals.locale,
        currentPath = _getState.history.currentPath;

    return fetch(__WEBPACK_IMPORTED_MODULE_10_shared_constants_api__["a" /* default */].USER_PROFILE, {
      method: 'GET',
      headers: _extends({
        Authorization: 'JWT ' + token
      }, customHeaders)
    }).then(function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
        var json, currentUrl, queryArr, result, vars;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!response.ok) {
                  _context.next = 20;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_5_js_cookie__["set"](TOKEN_KEY, token);
                __WEBPACK_IMPORTED_MODULE_5_js_cookie__["set"](STO_TOKEN_KEY, token, {
                  domain: SECONDARY_COOKIE_DOMAIN,
                  expires: STO_COOKIE_MAX_AGE_DAYS
                });

                _context.next = 5;
                return response.json();

              case 5:
                json = _context.sent;

                dispatch(setUser(json));
                dispatch(setSession(token));
                // start getting redirect url
                currentUrl = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' ? window.location.href : '';
                queryArr = currentUrl.split('?');
                result = { redirectUrl: '' };

                if (!(queryArr.length > 1)) {
                  _context.next = 17;
                  break;
                }

                vars = queryArr[1].split('&');

                vars.map(function (item) {
                  var pair = item.split('=');
                  if (pair[0] === 'redirectUrl') {
                    result.redirectUrl = pair[1];
                  }
                  return false;
                });

                if (!result.redirectUrl) {
                  _context.next = 17;
                  break;
                }

                window.location.href = result.redirectUrl;
                return _context.abrupt('return', false);

              case 17:
                // end getting redirect url
                if (!modal && __WEBPACK_IMPORTED_MODULE_11_history_js__["a" /* default */]) {
                  __WEBPACK_IMPORTED_MODULE_11_history_js__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_6_shared_helpers_locale__["h" /* toLocalized */](__WEBPACK_IMPORTED_MODULE_12_shared_constants_url__["a" /* default */].my(), locale));
                }

                if (true && typeof currentPath === 'string' && /\/add/.test(currentPath)) {
                  if (/\/add\/zapchasti/.test(currentPath)) {
                    __WEBPACK_IMPORTED_MODULE_1_shared_helpers_partsForm__["a" /* fillUserData */](fetch, { dispatch: dispatch, getState: getState });
                  } else {
                    __WEBPACK_IMPORTED_MODULE_2_shared_helpers_advertForm__["e" /* fillUserData */](fetch, { dispatch: dispatch, getState: getState });
                  }
                }
                return _context.abrupt('return', Promise.resolve(json));

              case 20:

                if (enqueueNotification) {
                  enqueueNotification(L.DEFAULT_ERROR_MESSAGE[locale]);
                }

                throw new Error(L.DEFAULT_ERROR_MESSAGE[locale]);

              case 22:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }()).catch(function (err) {
      if (enqueueNotification) {
        enqueueNotification(L.DEFAULT_ERROR_MESSAGE[locale]);
      }
    });
  };
};

var updateUser = function updateUser(data, _ref3) {
  var intl = _ref3.intl,
      ContactInformation = _ref3.ContactInformation;
  return function (dispatch, getState, _ref4) {
    var fetch = _ref4.fetch;

    var _getState2 = getState(),
        user = _getState2.user.user,
        locale = _getState2.globals.locale;

    var token = getState().user.token;
    return fetch(__WEBPACK_IMPORTED_MODULE_10_shared_constants_api__["a" /* default */].PROFILE, {
      method: 'PATCH',
      headers: {
        Authorization: 'JWT ' + token
      },
      body: __WEBPACK_IMPORTED_MODULE_9_object_to_formdata___default.a(data)
    }).then(function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(response) {
        var json, email, isEmailVerified;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!response.ok) {
                  _context2.next = 8;
                  break;
                }

                _context2.next = 3;
                return response.json();

              case 3:
                json = _context2.sent;
                email = json.email, isEmailVerified = json.is_email_verified;


                if (email && user.email !== email && isEmailVerified === false && ContactInformation) {
                  dispatch(__WEBPACK_IMPORTED_MODULE_4_shared_actions_notifications__["a" /* enqueueNotification */](intl.formatMessage({ id: 'На {email} отправлено сообщение для подтверждения почты' }, { email: email })));
                }

                dispatch(setUser(json));

                return _context2.abrupt('return', Promise.resolve());

              case 8:
                throw new Error(response.status === 413 ? L.IMAGE_SIZE_MESSAGE[locale] : L.DEFAULT_ERROR_MESSAGE[locale]);

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }));

      return function (_x3) {
        return _ref5.apply(this, arguments);
      };
    }()).catch(function () {
      throw new Error(L.DEFAULT_ERROR_MESSAGE[locale]);
    });
  };
};

var addPhone = function addPhone(_ref6) {
  var phone = _ref6.phone,
      advert = _ref6.advert;
  return function (dispatch, getState, _ref7) {
    var fetch = _ref7.fetch;

    var _getState3 = getState(),
        _getState3$user$user$ = _getState3.user.user.phones,
        phones = _getState3$user$user$ === undefined ? [] : _getState3$user$user$;

    var url = __WEBPACK_IMPORTED_MODULE_10_shared_constants_api__["a" /* default */].PHONES.ADD;
    for (var i = 0; i < phones.length; i += 1) {
      if (__WEBPACK_IMPORTED_MODULE_13_shared_modules__["j" /* phoneNormalize */](phones[i].number) === __WEBPACK_IMPORTED_MODULE_13_shared_modules__["j" /* phoneNormalize */](phone) && phones[i].is_verified) {
        return new Promise(function (resolve, reject) {
          reject({ message: 'Телефон уже подтвержден' });
        });
      }
      if (__WEBPACK_IMPORTED_MODULE_13_shared_modules__["j" /* phoneNormalize */](phones[i].number) === __WEBPACK_IMPORTED_MODULE_13_shared_modules__["j" /* phoneNormalize */](phone)) {
        url = __WEBPACK_IMPORTED_MODULE_10_shared_constants_api__["a" /* default */].PHONES.RESEND_CODE;
      }
    }
    return fetch(url, {
      method: 'POST',
      body: JSON.stringify({ phone: __WEBPACK_IMPORTED_MODULE_13_shared_modules__["j" /* phoneNormalize */](phone) }),
      headers: {
        Authorization: 'JWT ' + getState().user.token
      }
    }).then(function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(response) {
        var locale;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!response.ok) {
                  _context3.next = 3;
                  break;
                }

                if (!advert) {
                  dispatch(setPhone({
                    number: phone,
                    is_verified: false
                  }));
                }

                return _context3.abrupt('return', Promise.resolve());

              case 3:
                locale = getState().globals.locale;
                throw new Error(response.status === 400 ? L.USER_ALREADY_EXIST_MESSAGE[locale] : L.DEFAULT_ERROR_MESSAGE[locale]);

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this);
      }));

      return function (_x4) {
        return _ref8.apply(this, arguments);
      };
    }());
  };
};
var deletePhone = function deletePhone(id) {
  return function (dispatch, getState, _ref9) {
    var fetch = _ref9.fetch;

    if ((typeof id === 'undefined' ? 'undefined' : _typeof(id)) === 'object') {
      return dispatch(removePhone(id));
    }
    return fetch(__WEBPACK_IMPORTED_MODULE_10_shared_constants_api__["a" /* default */].PHONES.DELETE(id), {
      method: 'DELETE',
      headers: {
        Authorization: 'JWT ' + getState().user.token
      }
    }).then(function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(response) {
        var locale;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!response.ok) {
                  _context4.next = 4;
                  break;
                }

                dispatch(removePhone(id));
                // TODO: remove
                dispatch(updateUser({}, {}));

                return _context4.abrupt('return', Promise.resolve());

              case 4:
                locale = getState().globals.locale;
                throw new Error(L.DEFAULT_ERROR_MESSAGE[locale]);

              case 6:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this);
      }));

      return function (_x5) {
        return _ref10.apply(this, arguments);
      };
    }());
  };
};

var authWithPhone = function authWithPhone(_ref11) {
  var phone = _ref11.phone,
      code = _ref11.code;
  return function (dispatch, getState, _ref12) {
    var fetch = _ref12.fetch;
    var locale = getState().globals.locale;

    return fetch(__WEBPACK_IMPORTED_MODULE_10_shared_constants_api__["a" /* default */].PHONES.VERIFY_PHONE, {
      method: 'POST',
      body: JSON.stringify({ phone: __WEBPACK_IMPORTED_MODULE_13_shared_modules__["j" /* phoneNormalize */](phone), code: code }),
      headers: {
        Authorization: 'JWT ' + getState().user.token
      }
    }).then(function () {
      var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(response) {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(response.status === 200)) {
                  _context5.next = 3;
                  break;
                }

                // TODO: remove
                dispatch(updateUser({}, {}));
                return _context5.abrupt('return', Promise.resolve());

              case 3:
                throw new Error(response.status === 400 ? L.CODE_NOT_VALID_MESSAGE[locale] : L.DEFAULT_ERROR_MESSAGE[locale]);

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this);
      }));

      return function (_x6) {
        return _ref13.apply(this, arguments);
      };
    }()).catch(function () {
      throw new Error(L.DEFAULT_ERROR_MESSAGE[locale]);
    });
  };
};

var authorize = function authorize(_ref14) {
  var thing = _ref14.thing,
      code = _ref14.code,
      _ref14$isPassword = _ref14.isPassword,
      isPassword = _ref14$isPassword === undefined ? false : _ref14$isPassword;
  return function (dispatch, getState, _ref15) {
    var fetch = _ref15.fetch;
    return __WEBPACK_IMPORTED_MODULE_3_shared_helpers_google__["a" /* getGoogleCaptchaToken */]('authorize').then(function (gtoken) {
      return fetch(__WEBPACK_IMPORTED_MODULE_10_shared_constants_api__["a" /* default */].AUTHORIZE, {
        method: 'POST',
        headers: { gtoken: gtoken },
        body: JSON.stringify(_extends({ thing: thing }, code ? { code: code } : {}))
      }).then(function () {
        var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(response) {
          var json, token, message, locale, error;
          return regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  _context6.next = 2;
                  return response.json();

                case 2:
                  json = _context6.sent;

                  if (!response.ok) {
                    _context6.next = 9;
                    break;
                  }

                  if (!code) {
                    _context6.next = 8;
                    break;
                  }

                  token = json.token;

                  if (!token) {
                    _context6.next = 8;
                    break;
                  }

                  return _context6.abrupt('return', dispatch(user_userLogin(token)));

                case 8:
                  return _context6.abrupt('return', Promise.resolve(json));

                case 9:
                  message = void 0;

                  if (json && Object.keys(json).length > 0) {
                    message = json[Object.keys(json)[0]][0];
                  }

                  locale = getState().globals.locale;
                  error = L.DEFAULT_ERROR_MESSAGE[locale];

                  if (isPassword) {
                    error = L.PASSWORD_NOT_VALID_MESSAGE[locale];
                  } else if (message === 'invalid') {
                    error = code ? L.CODE_NOT_VALID_MESSAGE[locale] : L.INPUT_VALID_USER_MESSAGE[locale];
                  }

                  throw new Error(error);

                case 15:
                case 'end':
                  return _context6.stop();
              }
            }
          }, _callee6, _this);
        }));

        return function (_x7) {
          return _ref16.apply(this, arguments);
        };
      }());
    });
  };
};

var resendVerifyCode = function resendVerifyCode(_ref17) {
  var phone = _ref17.phone;
  return function (dispatch, getState, _ref18) {
    var fetch = _ref18.fetch;
    return fetch(__WEBPACK_IMPORTED_MODULE_10_shared_constants_api__["a" /* default */].PHONES.RESEND_CODE, {
      method: 'POST',
      body: JSON.stringify({ phone: __WEBPACK_IMPORTED_MODULE_13_shared_modules__["j" /* phoneNormalize */](phone) }),
      headers: {
        Authorization: 'JWT ' + getState().user.token
      }
    }).then(function (response) {
      var locale = getState().globals.locale;


      return response.ok ? Promise.resolve() : Promise.reject(new Error(L.DEFAULT_ERROR_MESSAGE[locale]));
    });
  };
};

var loginWithFacebookToken = function loginWithFacebookToken(fbToken, _ref19) {
  var modal = _ref19.modal,
      enqueueNotification = _ref19.enqueueNotification;
  return function (dispatch, getState, _ref20) {
    var fetch = _ref20.fetch;

    if (!fbToken) return;
    fetch(__WEBPACK_IMPORTED_MODULE_10_shared_constants_api__["a" /* default */].SOCIAL_LOGIN.FB, {
      method: 'POST',
      body: JSON.stringify({
        token: fbToken
      })
    }).then(function (r) {
      if (!r.ok) {
        throw new Error('Не удалось осуществить вход');
      }

      return r.json();
    }).then(function (_ref21) {
      var token = _ref21.token;

      if (token && typeof token === 'string') {
        dispatch(user_userLogin(token, null, modal, enqueueNotification));
      }
    }).catch(function (e) {
      return enqueueNotification(e.message ? e.message : e);
    });
  };
};
// Balance

// eslint-disable-next-line no-underscore-dangle
var _fetchBalance = function _fetchBalance(fetch, token) {
  return fetch(__WEBPACK_IMPORTED_MODULE_10_shared_constants_api__["a" /* default */].ACCOUNTS.BALANCE, {
    headers: {
      Authorization: 'JWT ' + token
    }
  }).then(function (response) {
    if (!response.ok) {
      throw new Error('Не удалось получить баланс пользователя');
    }

    return response;
  }).then(function (r) {
    return r.json();
  }).then(function (_ref22) {
    var balance = _ref22.balance;
    return balance;
  });
};

var setBalance = __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_14__constants_actionTypes__["n" /* USER */].SET_BALANCE);
var setBalanceIsFetching = __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_14__constants_actionTypes__["n" /* USER */].SET_BALANCE_IS_FETCHING);

var fetchBalance = function fetchBalance() {
  return function (dispatch, getState, _ref23) {
    var fetch = _ref23.fetch;

    var _getState4 = getState(),
        _getState4$user = _getState4.user;

    _getState4$user = _getState4$user === undefined ? {} : _getState4$user;
    var token = _getState4$user.token;


    if (token) {
      dispatch(setBalanceIsFetching(true));

      _fetchBalance(fetch, token).then(function (balance) {
        dispatch(setBalance(balance));
        dispatch(setBalanceIsFetching(false));
      });
    }
  };
};

var reloadUser = function reloadUser() {
  return function (dispatch, getState) {
    var token = getState().user.token;


    return token ? dispatch(user_userLogin(token, null, true)).then(function () {
      return dispatch(fetchBalance());
    }) : Promise.resolve;
  };
};
var registration = function registration(data, _ref24) {
  var setFields = _ref24.setFields,
      enqueueNotification = _ref24.enqueueNotification,
      intl = _ref24.intl;
  return function (dispatch, getState, _ref25) {
    var fetch = _ref25.fetch;

    var _getState5 = getState(),
        locale = _getState5.globals.locale,
        user = _getState5.user;

    var gr = user.beforeRegistration.gr;

    var gtokenv2 = gr && gr.getResponse() || '';
    dispatch(beforeRegistration({}));
    __WEBPACK_IMPORTED_MODULE_3_shared_helpers_google__["a" /* getGoogleCaptchaToken */]('registration').then(function (tokenv3) {
      fetch(__WEBPACK_IMPORTED_MODULE_10_shared_constants_api__["a" /* default */].REGISTER, {
        method: 'POST',
        headers: {
          gtoken: tokenv3,
          gtokenv2: gtokenv2
        },
        body: JSON.stringify({
          email: data.email,
          phone: __WEBPACK_IMPORTED_MODULE_13_shared_modules__["j" /* phoneNormalize */](data.phone),
          name: data.name
        })
      }).then(function () {
        var _ref26 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(res) {
          var err, buf;
          return regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  if (!(res.status === 201)) {
                    _context7.next = 10;
                    break;
                  }

                  _context7.t0 = dispatch;
                  _context7.t1 = beforeRegistration;
                  _context7.next = 5;
                  return res.json();

                case 5:
                  _context7.t2 = _context7.sent;
                  _context7.t3 = (0, _context7.t1)(_context7.t2);
                  (0, _context7.t0)(_context7.t3);
                  _context7.next = 25;
                  break;

                case 10:
                  if (!(res.status === 400)) {
                    _context7.next = 24;
                    break;
                  }

                  _context7.next = 13;
                  return res.json();

                case 13:
                  _context7.t4 = _context7.sent;

                  if (_context7.t4) {
                    _context7.next = 16;
                    break;
                  }

                  _context7.t4 = {};

                case 16:
                  err = _context7.t4;
                  buf = {};

                  dispatch(userError(err));
                  Object.keys(err).map(function (a) {
                    buf[a] = {
                      value: data[a] || '',
                      errors: [new Error(intl.formatMessage({
                        id: err[a] && err[a][0] && L[err[a][0]] && L[err[a][0]] || err[a] && err[a][0] || 'err'
                      }))]
                    };
                    return '';
                  });
                  setFields(buf);
                  if (!buf.name && !buf.email && !buf.phone) {
                    enqueueNotification(L.DEFAULT_ERROR_MESSAGE[locale]);
                  }
                  _context7.next = 25;
                  break;

                case 24:
                  enqueueNotification(L.DEFAULT_ERROR_MESSAGE[locale]);

                case 25:
                case 'end':
                  return _context7.stop();
              }
            }
          }, _callee7, _this);
        }));

        return function (_x8) {
          return _ref26.apply(this, arguments);
        };
      }()).catch(function (err) {
        enqueueNotification(L.DEFAULT_ERROR_MESSAGE[locale]);
      });
    });
  };
};
var userAuthorize = function userAuthorize(data, _ref27) {
  var setFields = _ref27.setFields,
      modal = _ref27.modal,
      enqueueNotification = _ref27.enqueueNotification,
      intl = _ref27.intl,
      allDat = _objectWithoutProperties(_ref27, ['setFields', 'modal', 'enqueueNotification', 'intl']);

  return function (dispatch, getState, _ref28) {
    var fetch = _ref28.fetch;

    var _getState6 = getState(),
        locale = _getState6.globals.locale;

    var buf = {};
    __WEBPACK_IMPORTED_MODULE_3_shared_helpers_google__["a" /* getGoogleCaptchaToken */]('authorize').then(function (gtoken) {
      fetch(__WEBPACK_IMPORTED_MODULE_10_shared_constants_api__["a" /* default */].USERS_AUTHORIZE, {
        method: 'POST',
        headers: { gtoken: gtoken },
        body: JSON.stringify({
          thing: __WEBPACK_IMPORTED_MODULE_13_shared_modules__["j" /* phoneNormalize */](data.thing),
          password: data.password
        })
      }).then(function () {
        var _ref29 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(response) {
          var res;
          return regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  if (!(response.status === 200)) {
                    _context8.next = 7;
                    break;
                  }

                  _context8.next = 3;
                  return response.json();

                case 3:
                  res = _context8.sent;

                  dispatch(user_userLogin(res.token, null, modal, enqueueNotification));
                  _context8.next = 9;
                  break;

                case 7:
                  if (allDat.registrationForm) {
                    buf.password = {
                      value: data.password || '',
                      errors: [new Error(intl.formatMessage({
                        id: 'Неверный пароль'
                      }))]
                    };
                  } else if (allDat.recoveryForm) {
                    buf.password = {
                      value: data.password || '',
                      errors: [new Error(intl.formatMessage({
                        id: 'Неверный пароль'
                      }))]
                    };
                  } else {
                    buf.password = {
                      value: data.password || '',
                      errors: [new Error(intl.formatMessage({
                        id: 'Неверный пароль'
                      }))]
                    };
                  }
                  setFields(buf);

                case 9:
                case 'end':
                  return _context8.stop();
              }
            }
          }, _callee8, _this);
        }));

        return function (_x9) {
          return _ref29.apply(this, arguments);
        };
      }()).catch(function (err) {
        enqueueNotification(L.DEFAULT_ERROR_MESSAGE[locale]);
      });
    });
  };
};


var userRecovery = function userRecovery(_ref30, _ref31) {
  var userCheckCode = _ref30.userCheckCode,
      thing = _ref30.thing;
  var setFields = _ref31.setFields,
      intl = _ref31.intl,
      registrationForm = _ref31.registrationForm,
      nameFields = _ref31.nameFields;
  return function (dispatch, getState, _ref32) {
    var fetch = _ref32.fetch;

    if (!registrationForm) {
      dispatch(beforeRegistration({}));
    }

    var _getState7 = getState(),
        locale = _getState7.globals.locale;

    __WEBPACK_IMPORTED_MODULE_3_shared_helpers_google__["a" /* getGoogleCaptchaToken */]('recovery').then(function (gtoken) {
      fetch(__WEBPACK_IMPORTED_MODULE_10_shared_constants_api__["a" /* default */].USERS_RECOVERY, {
        method: 'POST',
        headers: { gtoken: gtoken },
        body: JSON.stringify({
          thing: __WEBPACK_IMPORTED_MODULE_13_shared_modules__["j" /* phoneNormalize */](thing)
        })
      }).then(function () {
        var _ref33 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(res) {
          var checkCodeUser, err, setEror;
          return regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  if (!(res.status === 200)) {
                    _context9.next = 6;
                    break;
                  }

                  dispatch(__WEBPACK_IMPORTED_MODULE_4_shared_actions_notifications__["a" /* enqueueNotification */](L.USER_RECOVERY_MESSAGE(__WEBPACK_IMPORTED_MODULE_13_shared_modules__["j" /* phoneNormalize */](thing))[locale]));
                  checkCodeUser = userCheckCode ? 'checkCodeUser' : 'userRecovery';

                  if (!registrationForm) {
                    dispatch(beforeRegistration(_defineProperty({}, nameFields || checkCodeUser, true)));
                  }
                  _context9.next = 14;
                  break;

                case 6:
                  _context9.next = 8;
                  return res.json();

                case 8:
                  _context9.t0 = _context9.sent;

                  if (_context9.t0) {
                    _context9.next = 11;
                    break;
                  }

                  _context9.t0 = {};

                case 11:
                  err = _context9.t0;

                  setEror = function setEror(text) {
                    setFields(_defineProperty({}, nameFields || 'emailAndPhone', {
                      value: thing || '',
                      errors: [new Error(intl.formatMessage({ id: text }))]
                    }));
                  };

                  if (err.non_field_errors && err.non_field_errors[0] && L[err.non_field_errors[0]]) {
                    setEror(L[err.non_field_errors[0]]);
                  } else if (err.non_field_errors && err.non_field_errors[0] && typeof err.non_field_errors[0] === 'string') {
                    setEror(err.non_field_errors[0]);
                  } else {
                    setEror(intl.formatMessage({
                      id: 'Ошибка'
                    }));
                  }

                case 14:
                case 'end':
                  return _context9.stop();
              }
            }
          }, _callee9, _this);
        }));

        return function (_x10) {
          return _ref33.apply(this, arguments);
        };
      }()).catch(function (err) {
        dispatch(__WEBPACK_IMPORTED_MODULE_4_shared_actions_notifications__["a" /* enqueueNotification */](L.DEFAULT_ERROR_MESSAGE[locale]));
      });
    });
  };
};
var userVerifyMail = function userVerifyMail(_ref34) {
  var enqueueNotification = _ref34.enqueueNotification;
  return function (dispatch, getState, _ref35) {
    var fetch = _ref35.fetch;

    var _getState8 = getState(),
        locale = _getState8.globals.locale,
        email = _getState8.user.user.email;
    // getGoogleCaptchaToken('verify').then(token => {


    fetch(__WEBPACK_IMPORTED_MODULE_10_shared_constants_api__["a" /* default */].USERS_VERIFY_RESEND, {
      method: 'POST',
      headers: {},
      body: JSON.stringify({
        email: email
      })
    }).then(function () {
      var _ref36 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(res) {
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (res.status === 200) {
                  enqueueNotification(L.USER_RECOVERY_VERIFY(email)[locale]);
                  dispatch(beforeRegistration({ userRecovery: true }));
                } else {
                  enqueueNotification('Error');
                }

              case 1:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this);
      }));

      return function (_x11) {
        return _ref36.apply(this, arguments);
      };
    }()).catch(function (err) {
      enqueueNotification(L.DEFAULT_ERROR_MESSAGE[locale]);
    });
    // });
  };
};
var userVerifyCode = function userVerifyCode(_ref37) {
  var fetch = _ref37.fetch,
      dispatch = _ref37.store.dispatch,
      _ref37$query = _ref37.query;
  _ref37$query = _ref37$query === undefined ? {} : _ref37$query;
  var code = _ref37$query.code;

  dispatch(beforeRegistration({}));
  fetch(__WEBPACK_IMPORTED_MODULE_10_shared_constants_api__["a" /* default */].USERS_VERIFY_GET, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      code: code
    })
  }).then(function () {
    var _ref38 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(res) {
      var user;
      return regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              if (!(res.status === 200)) {
                _context11.next = 8;
                break;
              }

              _context11.next = 3;
              return res.json();

            case 3:
              _context11.t0 = _context11.sent;

              if (_context11.t0) {
                _context11.next = 6;
                break;
              }

              _context11.t0 = {};

            case 6:
              user = _context11.t0;
              return _context11.abrupt('return', dispatch(beforeRegistration({ mailVerify: user.email })));

            case 8:
              return _context11.abrupt('return', false);

            case 9:
            case 'end':
              return _context11.stop();
          }
        }
      }, _callee11, _this);
    }));

    return function (_x12) {
      return _ref38.apply(this, arguments);
    };
  }());
};
var userCheckCode = function userCheckCode(_ref39, _ref40) {
  var callback = _ref39.callback,
      thing = _ref39.thing,
      registrationBool = _ref39.registration;
  var intl = _ref40.intl,
      setFields = _ref40.setFields,
      nameFields = _ref40.nameFields;
  return function (dispatch, getState, _ref41) {
    var fetch = _ref41.fetch;

    if (false) {
      return null;
    }
    var obj = {};
    if (__WEBPACK_IMPORTED_MODULE_8_validator___default.a.isEmail(thing)) {
      obj.existsEmail = thing;
    }
    if (__WEBPACK_IMPORTED_MODULE_7_shared_constants_regexp__["b" /* default */].phone.test(thing)) {
      obj.existsPhone = thing;
    }
    obj.existsNot = true;

    var _getState9 = getState(),
        locale = _getState9.globals.locale;

    if (registrationBool) {
      dispatch(beforeRegistration(obj));
      return callback();
    }

    return __WEBPACK_IMPORTED_MODULE_3_shared_helpers_google__["a" /* getGoogleCaptchaToken */]('checkCode').then(function (gtoken) {
      return fetch(__WEBPACK_IMPORTED_MODULE_10_shared_constants_api__["a" /* default */].USERS_USER_CHECK_CODE, {
        method: 'POST',
        headers: { gtoken: gtoken },
        body: JSON.stringify({
          thing: __WEBPACK_IMPORTED_MODULE_13_shared_modules__["j" /* phoneNormalize */](thing)
        })
      }).then(function () {
        var _ref42 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(res) {
          var resAnswer, exists, passwordAssigned;
          return regeneratorRuntime.wrap(function _callee12$(_context12) {
            while (1) {
              switch (_context12.prev = _context12.next) {
                case 0:
                  if (!(res.status === 200)) {
                    _context12.next = 15;
                    break;
                  }

                  _context12.next = 3;
                  return res.json();

                case 3:
                  _context12.t0 = _context12.sent;

                  if (_context12.t0) {
                    _context12.next = 6;
                    break;
                  }

                  _context12.t0 = {};

                case 6:
                  resAnswer = _context12.t0;
                  exists = resAnswer.exists, passwordAssigned = resAnswer.password_assigned;

                  if (!nameFields) {
                    _context12.next = 10;
                    break;
                  }

                  return _context12.abrupt('return', dispatch(beforeRegistration(resAnswer)));

                case 10:
                  if (exists) {
                    _context12.next = 12;
                    break;
                  }

                  return _context12.abrupt('return', dispatch(beforeRegistration(obj)));

                case 12:
                  if (passwordAssigned) {
                    _context12.next = 14;
                    break;
                  }

                  return _context12.abrupt('return', userRecovery({ thing: thing, userCheckCode: true }, { intl: intl, setFields: setFields })(dispatch, getState, {
                    fetch: fetch
                  }));

                case 14:
                  return _context12.abrupt('return', dispatch(beforeRegistration({ checkCodeUser: true })));

                case 15:
                  dispatch(beforeRegistration({}));
                  return _context12.abrupt('return', dispatch(__WEBPACK_IMPORTED_MODULE_4_shared_actions_notifications__["a" /* enqueueNotification */](L.DEFAULT_ERROR_MESSAGE[locale])));

                case 17:
                case 'end':
                  return _context12.stop();
              }
            }
          }, _callee12, _this);
        }));

        return function (_x13) {
          return _ref42.apply(this, arguments);
        };
      }()).catch(function (err) {
        dispatch(__WEBPACK_IMPORTED_MODULE_4_shared_actions_notifications__["a" /* enqueueNotification */](L.DEFAULT_ERROR_MESSAGE[locale]));
      }).finally(function () {
        callback();
      });
    });
  };
};
var changePassword = function changePassword(_ref43, _ref44) {
  var callback = _ref43.callback,
      data = _ref43.data;
  var intl = _ref44.intl,
      setFields = _ref44.setFields;
  return function (dispatch, getState, _ref45) {
    var fetch = _ref45.fetch;

    var _getState10 = getState(),
        locale = _getState10.globals.locale,
        token = _getState10.user.token;

    return fetch(__WEBPACK_IMPORTED_MODULE_10_shared_constants_api__["a" /* default */].CHANGE_USER_PASSWORD, {
      method: 'PUT',
      headers: {
        Authorization: 'JWT ' + token
      },
      body: JSON.stringify(data)
    }).then(function () {
      var _ref46 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(res) {
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                if (!(res.status === 200)) {
                  _context13.next = 4;
                  break;
                }

                dispatch(__WEBPACK_IMPORTED_MODULE_4_shared_actions_notifications__["a" /* enqueueNotification */](intl.formatMessage({ id: 'Новый пароль успешно сохранен' })));
                callback();
                return _context13.abrupt('return', dispatch(beforeRegistration()));

              case 4:
                if (!(res.status === 400)) {
                  _context13.next = 8;
                  break;
                }

                if (data.old_password) {
                  _context13.next = 7;
                  break;
                }

                return _context13.abrupt('return', dispatch(__WEBPACK_IMPORTED_MODULE_4_shared_actions_notifications__["a" /* enqueueNotification */](L.DEFAULT_ERROR_MESSAGE[locale])));

              case 7:
                return _context13.abrupt('return', setFields({
                  oldPassword: {
                    value: data.old_password,
                    errors: [new Error(intl.formatMessage({ id: 'Неверный пароль' }))]
                  }
                }));

              case 8:
                return _context13.abrupt('return', dispatch(__WEBPACK_IMPORTED_MODULE_4_shared_actions_notifications__["a" /* enqueueNotification */](L.DEFAULT_ERROR_MESSAGE[locale])));

              case 9:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, _this);
      }));

      return function (_x14) {
        return _ref46.apply(this, arguments);
      };
    }()).catch(function (err) {
      dispatch(__WEBPACK_IMPORTED_MODULE_4_shared_actions_notifications__["a" /* enqueueNotification */](L.DEFAULT_ERROR_MESSAGE[locale]));
    });
  };
};
var logistics = function logistics(data) {
  return function (dispatch, getState, _ref47) {
    var fetch = _ref47.fetch;

    var _getState11 = getState(),
        fingerprint = _getState11.globals.fingerprint;

    fetch(__WEBPACK_IMPORTED_MODULE_10_shared_constants_api__["a" /* default */].USERS_LOGISTICS, {
      method: 'POST',
      headers: {},
      body: JSON.stringify(_extends({ fingerprint: fingerprint }, data))
    });
  };
};

var getSingleAuthToken = function getSingleAuthToken(data) {
  return function (dispatch, getState, _ref48) {
    var fetch = _ref48.fetch;
    return fetch(__WEBPACK_IMPORTED_MODULE_10_shared_constants_api__["a" /* default */].USERS_AUTHORIZE_TOKEN, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    }).then(function () {
      var _ref49 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(response) {
        var res;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                if (!(response.status === 200)) {
                  _context14.next = 5;
                  break;
                }

                _context14.next = 3;
                return response.json();

              case 3:
                res = _context14.sent;

                dispatch(setSession(res.token));

              case 5:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, _this);
      }));

      return function (_x15) {
        return _ref49.apply(this, arguments);
      };
    }());
  };
};

var renderRecaptchaV2 = function renderRecaptchaV2(id) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_3_shared_helpers_google__["b" /* getGoogleCaptchaTokenV2 */](id, function (gr) {
      dispatch(beforeRegistration({ recaptchaReady: true, gr: gr }));
    }, function (gtokenv2) {
      dispatch(beforeRegistration({ gtokenv2: gtokenv2 }));
    });
  };
};

/***/ }),

/***/ 482:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return selectedActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return setData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return _clearSelected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return resetAll; });
/* unused harmony export setResults */
/* unused harmony export setCounts */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return setFormVocabulary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return resultsThunks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return transportSetThunks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return carSetThunks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return transportFillThunks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return dataThunks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return carFormFillThunks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return motoSetThunks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return motoFormFillThunks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return commercialSetThunks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return commercialFormFillThunks; });
/* unused harmony export dealerCarsThunks */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return dealersSetThunks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return dealersFormFillThunks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return sparesSetThunks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return sparesFormFillThunks; });
/* unused harmony export otherTransportSetThunks */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return setTransportResults; });
/* unused harmony export setTransportType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_snakecase_keys__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_snakecase_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_snakecase_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_modules__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_constants_actionTypes__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_actions_partsForm__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_constants_json_customs_json__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_constants_json_customs_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_shared_constants_json_customs_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_helpers_urls__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_helpers_search__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_constants_json_currency_json__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_constants_json_currency_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_shared_constants_json_currency_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_constants_adverts__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_advertForm__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants_api__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helpers_arrays__ = __webpack_require__(104);
var _this = this;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable import/prefer-default-export */

















var sluggifiedCurrency = __WEBPACK_IMPORTED_MODULE_10_shared_constants_json_currency_json___default.a.map(function (item) {
  return _extends({}, item, { id: item.slug });
});

//
// Selected
//

// exporting selectedActions
var actions = __WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* createActions */]({
  SEARCH_FORM: {
    SELECTED: Object.keys(__WEBPACK_IMPORTED_MODULE_5_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED).reduce(function (object, field) {
      return _extends({}, object, _defineProperty({}, field, undefined));
    }, {})
  }
}, { namespace: '__' });
// exporting selectedActions like this due to an extract-hoc package bug
var selectedActions = actions.searchForm.selected;

//
// Data
//

var setData = {
  models: __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_5_shared_constants_actionTypes__["m" /* SEARCH_FORM */].DATA_MODELS_SET),
  brandToChose: __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_5_shared_constants_actionTypes__["m" /* SEARCH_FORM */].DATA_BRAND_TO_CHOSE_SET),
  modifications: __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_5_shared_constants_actionTypes__["m" /* SEARCH_FORM */].DATA_MODIFICATIONS_SET),
  equipments: __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_5_shared_constants_actionTypes__["m" /* SEARCH_FORM */].DATA_EQUIPMENTS_SET),
  prices: __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_5_shared_constants_actionTypes__["m" /* SEARCH_FORM */].DATA_PRICES_SET),
  years: __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_5_shared_constants_actionTypes__["m" /* SEARCH_FORM */].DATA_YEARS_SET),
  generations: __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_5_shared_constants_actionTypes__["m" /* SEARCH_FORM */].DATA_GENERATIONS_SET),
  series: __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_5_shared_constants_actionTypes__["m" /* SEARCH_FORM */].DATA_SERIES_SET),
  count: __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_5_shared_constants_actionTypes__["m" /* SEARCH_FORM */].DATA_COUNT_SET),
  makesCounter: __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_5_shared_constants_actionTypes__["m" /* SEARCH_FORM */].DATA_MAKES_COUNTER_SET),
  sparetypes: __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_5_shared_constants_actionTypes__["m" /* SEARCH_FORM */].DATA_SPARETYPES_SET)
};

//
// Clear
//

var _clearSelected = __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_5_shared_constants_actionTypes__["m" /* SEARCH_FORM */].CLEAR);

var resetAll = __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_5_shared_constants_actionTypes__["m" /* SEARCH_FORM */].RESET_ALL);

//
// Results
//

var setResults = __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_5_shared_constants_actionTypes__["m" /* SEARCH_FORM */].RESULTS_SET);

//
// Results
//

var setCounts = __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_5_shared_constants_actionTypes__["m" /* SEARCH_FORM */].COUNTS_SET);

//
// Vocabulary
//

var setFormVocabulary = __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_5_shared_constants_actionTypes__["m" /* SEARCH_FORM */].VOCABULARY_SET);

// Helpers for thunks

var findItemInCollection = function findItemInCollection(collection, item) {
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';
  return collection ? collection.find(function (i) {
    return i[key] === item;
  }) : item;
};

var fetchModels = function fetchModels(fetch, dispatch, make, transport) {
  return fetch(__WEBPACK_IMPORTED_MODULE_13__constants_api__["a" /* default */].CMM.modelsByMake(make.id, transport && transport.id)).then(function (r) {
    return r.json();
  }).then(function (models) {
    dispatch(setData.models(models));
  });
};

//
// Thunks
//

var set = selectedActions.set,
    toggle = selectedActions.toggle,
    clear = selectedActions.clear;


var resultsThunks = {
  searchResults: function searchResults(queries) {
    return function (dispatch, getState, _ref) {
      var fetch = _ref.fetch;

      var missingQueriesKeys = Object.keys(queries);
      var setDataLayerArr = [];
      return Promise.all(missingQueriesKeys.map(function (key) {
        return fetch(queries[key].url ? queries[key].url : __WEBPACK_IMPORTED_MODULE_13__constants_api__["a" /* default */].ADVERT.LIST + '?' + queries[key] + '&omit=' + [].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_11_shared_constants_adverts__["b" /* ANY_TYPE_OMITTED_FIELDS */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_11_shared_constants_adverts__["f" /* OMMITED_FIELDS_BY_TRANSPORT_ID */][__WEBPACK_IMPORTED_MODULE_1_query_string___default.a.parse(queries[key]).transport] || []))).then(function (r) {
          return r.json();
        }).then(function (response) {
          var result = {};
          result[key] = response;

          if (Array.isArray(response.results)) {
            response.results.map(function (a) {
              setDataLayerArr.push(a);
              return '';
            });
          }
          dispatch(__WEBPACK_IMPORTED_MODULE_4_shared_actions_globals__["j" /* setDataLayer */](__WEBPACK_IMPORTED_MODULE_3_shared_modules__["p" /* stateDataLayer */].manipulation({ data: setDataLayerArr, pagetype: 'searchresults' })));
          // dispatch(setResults(result));
          return result;
        });
      }));
    };
  },
  searchDealersResults: function searchDealersResults(query) {
    return function (dispatch, getState, _ref2) {
      var fetch = _ref2.fetch;
      return fetch(__WEBPACK_IMPORTED_MODULE_13__constants_api__["a" /* default */].DEALERS.ALL('?' + query)).then(function (r) {
        return r.json();
      }).then(function (response) {
        var result = {};
        result['dealers-AJAX'] = response;
        dispatch(setResults(result));
        Promise.resolve({});
      });
    };
  },

  searchFirmsResults: function searchFirmsResults() {
    var dataQuery = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var params = arguments[1];
    return function (dispatch, getState, _ref3) {
      var fetch = _ref3.fetch;

      var _getState = getState(),
          _getState$partsForm = _getState.partsForm;

      _getState$partsForm = _getState$partsForm === undefined ? {} : _getState$partsForm;
      var _getState$partsForm$v = _getState$partsForm.vocabulary,
          _getState$partsForm$v2 = _getState$partsForm$v.query,
          query = _getState$partsForm$v2 === undefined ? '' : _getState$partsForm$v2,
          queryobj = _getState$partsForm$v.queryobj;

      if (params && params.name === 'topFirms') {
        var _params$topMakesFilte = params.topMakesFilter,
            topMakesFilter = _params$topMakesFilte === undefined ? true : _params$topMakesFilte;
        var _queryobj$services = queryobj.services,
            services = _queryobj$services === undefined ? '' : _queryobj$services,
            _queryobj$makes = queryobj.makes,
            makes = _queryobj$makes === undefined ? '' : _queryobj$makes;

        delete queryobj.services;
        delete queryobj.makes;

        if (services) queryobj.top_services = services;
        if (makes && topMakesFilter) queryobj.top_makes = makes;
      }
      var queryRequest = __WEBPACK_IMPORTED_MODULE_1_query_string___default.a.stringify(_extends({}, dataQuery, queryobj)) || query;

      return fetch(__WEBPACK_IMPORTED_MODULE_13__constants_api__["a" /* default */].FIRMS.ALL('?' + queryRequest)).then(function (r) {
        return r.ok ? r.json() : null;
      }).then(function (response) {
        var result = {};
        result[params && params.name || 'firms'] = response;
        if (!params) {
          dispatch(__WEBPACK_IMPORTED_MODULE_6_shared_actions_partsForm__["d" /* setVocabularyField */].count(response.count));
        }
        if (params && params.count) {
          var _getState2 = getState(),
              _getState2$partsForm = _getState2.partsForm;

          _getState2$partsForm = _getState2$partsForm === undefined ? {} : _getState2$partsForm;
          var _getState2$partsForm$ = _getState2$partsForm.vocabulary.count,
              count = _getState2$partsForm$ === undefined ? 0 : _getState2$partsForm$;

          dispatch(__WEBPACK_IMPORTED_MODULE_6_shared_actions_partsForm__["d" /* setVocabularyField */].count(Number(response.length) + Number(count)));
        }
        dispatch(setResults(result));
        Promise.resolve(response);
      });
    };
  },
  searchSparesResults: function searchSparesResults(query) {
    return function (dispatch, getState, _ref4) {
      var fetch = _ref4.fetch;

      var results = getState().searchForm.results || {};
      var fieldKey = 'spares-' + query;

      if (results[fieldKey]) {
        return Promise.resolve({});
      }

      return fetch(__WEBPACK_IMPORTED_MODULE_13__constants_api__["a" /* default */].SPARE_PARTS.ALL('?' + query)).then(function (r) {
        return r.json();
      }).then(function (response) {
        dispatch(setResults(_defineProperty({}, fieldKey, response)));
        dispatch(__WEBPACK_IMPORTED_MODULE_4_shared_actions_globals__["j" /* setDataLayer */](__WEBPACK_IMPORTED_MODULE_3_shared_modules__["p" /* stateDataLayer */].manipulation({ data: response.results, pagetype: 'searchresults' })));
        Promise.resolve({});
      });
    };
  }
};

var transportSetThunks = {
  currency: function currency(_currency) {
    return function (dispatch) {
      dispatch(set.currency(_currency));
      dispatch(transportSetThunks.count());
    };
  },

  monthly: function monthly(payment) {
    return function (dispatch) {
      dispatch(set.monthly(payment));
      dispatch(transportSetThunks.count());
    };
  },

  prepaid: function prepaid(_prepaid) {
    return function (dispatch) {
      dispatch(set.prepaid(_prepaid));
      if (!_prepaid) {
        dispatch(set.make(null));
        dispatch(set.model(null));
        dispatch(set.monthly(null));
        // dispatch(setData.models(null));
      }
      dispatch(transportSetThunks.count());
    };
  },

  yearTo: function yearTo(_yearTo) {
    return function (dispatch) {
      dispatch(set.yearTo(_yearTo));
      dispatch(transportSetThunks.count());
    };
  },

  yearFrom: function yearFrom(_yearFrom) {
    return function (dispatch) {
      dispatch(set.yearFrom(_yearFrom));
      dispatch(transportSetThunks.count());
    };
  },

  fromDealer: function fromDealer(_fromDealer) {
    return function (dispatch) {
      dispatch(set.fromDealer(_fromDealer));
      dispatch(transportSetThunks.count());
    };
  },

  priceFrom: function priceFrom(_priceFrom) {
    return function (dispatch) {
      dispatch(set.priceFrom(_priceFrom));
      dispatch(transportSetThunks.count());
    };
  },

  priceTo: function priceTo(_priceTo) {
    return function (dispatch) {
      dispatch(set.priceTo(_priceTo));
      dispatch(transportSetThunks.count());
    };
  },

  powerFrom: function powerFrom(_powerFrom) {
    return function (dispatch) {
      dispatch(set.powerFrom(_powerFrom));
      dispatch(transportSetThunks.count());
    };
  },

  powerTo: function powerTo(_powerTo) {
    return function (dispatch) {
      dispatch(set.powerTo(_powerTo));
      dispatch(transportSetThunks.count());
    };
  },

  capacityFrom: function capacityFrom(_capacityFrom) {
    return function (dispatch) {
      dispatch(set.capacityFrom(_capacityFrom));
      dispatch(transportSetThunks.count());
    };
  },

  capacityTo: function capacityTo(_capacityTo) {
    return function (dispatch) {
      dispatch(set.capacityTo(_capacityTo));
      dispatch(transportSetThunks.count());
    };
  },

  mileageFrom: function mileageFrom(_mileageFrom) {
    return function (dispatch) {
      dispatch(set.mileageFrom(_mileageFrom));
      dispatch(transportSetThunks.count());
    };
  },
  company: function company(mileageFrom) {
    return function (dispatch) {
      dispatch(set.company(mileageFrom));
      dispatch(transportSetThunks.count());
    };
  },
  typeWork: function typeWork(mileageFrom) {
    return function (dispatch) {
      dispatch(set.typeWork(mileageFrom));
      dispatch(transportSetThunks.count());
    };
  },
  mileageTo: function mileageTo(_mileageTo) {
    return function (dispatch) {
      dispatch(set.mileageTo(_mileageTo));
      dispatch(transportSetThunks.count());
    };
  },

  engine: function engine(_engine) {
    return function (dispatch) {
      dispatch(set.engine(_engine));
      dispatch(transportSetThunks.count());
    };
  },

  drive: function drive(_drive) {
    return function (dispatch) {
      dispatch(set.drive(_drive));
      dispatch(transportSetThunks.count());
    };
  },

  gearbox: function gearbox(_gearbox) {
    return function (dispatch) {
      dispatch(set.gearbox(_gearbox));
      dispatch(transportSetThunks.count());
    };
  },

  category: function category(_category) {
    return function (dispatch) {
      dispatch(set.category(_category));
      dispatch(transportSetThunks.count());
    };
  },

  isCrashed: function isCrashed(_isCrashed) {
    return function (dispatch) {
      dispatch(set.isCrashed(_isCrashed));
      dispatch(transportSetThunks.count());
    };
  },

  isNotCleared: function isNotCleared(_isNotCleared) {
    return function (dispatch) {
      dispatch(set.isNotCleared(_isNotCleared));
      dispatch(transportSetThunks.count());
    };
  },

  isSaleOnCredit: function isSaleOnCredit(_isSaleOnCredit) {
    return function (dispatch) {
      dispatch(set.isSaleOnCredit(_isSaleOnCredit));
      dispatch(transportSetThunks.count());
    };
  },

  isUnderLoan: function isUnderLoan(_isUnderLoan) {
    return function (dispatch) {
      dispatch(set.isUnderLoan(_isUnderLoan));
      dispatch(transportSetThunks.count());
    };
  },

  location: function location(_location) {
    return function (dispatch) {
      dispatch(set.location(_location));
      dispatch(transportSetThunks.count());
    };
  },

  isSwap: function isSwap(_isSwap) {
    return function (dispatch) {
      dispatch(set.isSwap(_isSwap));
      dispatch(transportSetThunks.count());
    };
  },

  isRent: function isRent(_isRent) {
    return function (dispatch) {
      dispatch(set.isRent(_isRent));
      dispatch(transportSetThunks.count());
    };
  },

  isNew: function isNew(_isNew) {
    return function (dispatch) {
      dispatch(set.isNew(isNaN(_isNew) ? null : _isNew));
      dispatch(transportSetThunks.count());
    };
  },

  photos: function photos(_photos) {
    return function (dispatch) {
      dispatch(set.photos(_photos));
      dispatch(transportSetThunks.count());
    };
  },

  fromAuction: function fromAuction(_fromAuction) {
    return function (dispatch) {
      dispatch(set.fromAuction(_fromAuction));
      dispatch(transportSetThunks.count());
    };
  },

  colors: function colors(_colors) {
    return function (dispatch) {
      dispatch(toggle.colors(_colors));
      dispatch(transportSetThunks.count());
    };
  },

  clearSelected: function clearSelected() {
    return function (dispatch) {
      dispatch(_clearSelected());
      dispatch(transportSetThunks.count());
    };
  },

  abroad: function abroad(_abroad) {
    return function (dispatch) {
      dispatch(set.abroad(_abroad));

      if (_abroad && +_abroad.value) {
        dispatch(set.drivenFrom(null));
        dispatch(set.isNotCleared(__WEBPACK_IMPORTED_MODULE_7_shared_constants_json_customs_json___default.a[1]));
      }

      dispatch(transportSetThunks.count());
    };
  },

  drivenFrom: function drivenFrom(_drivenFrom) {
    return function (dispatch) {
      dispatch(set.drivenFrom(_drivenFrom));
      dispatch(transportSetThunks.count());
    };
  },

  count: function count(transferredState) {
    return function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState, _ref6) {
        var fetch = _ref6.fetch;

        var _getState3, formState, globals, location, searchQuery, query, key;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _getState3 = getState(), formState = _getState3.searchForm.selected, globals = _getState3.globals;
                location = globals && globals.location || null;
                searchQuery = _extends({}, transferredState || formState, {
                  location: formState.dealer ? null : location
                });

                // Remove location if it is county and we already set `drivenFrom` field.

                if (searchQuery.location && searchQuery.location.is_country && searchQuery.drivenFrom) {
                  searchQuery.location = null;
                }

                // const query = snakeCaseKeys(generateSearchQuery(searchQuery));
                query = __WEBPACK_IMPORTED_MODULE_9_shared_helpers_search__["d" /* getSearchQuery */](searchQuery);
                key = __WEBPACK_IMPORTED_MODULE_1_query_string___default.a.stringify(query);
                _context.prev = 6;
                _context.next = 9;
                return fetch(__WEBPACK_IMPORTED_MODULE_13__constants_api__["a" /* default */].ADVERT.COUNT + '?' + key).then(function (r) {
                  return r.json();
                }).then(function (response) {
                  dispatch(setData.count(response.count));
                });

              case 9:
                _context.next = 13;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](6);

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[6, 11]]);
      }));

      return function (_x3, _x4, _x5) {
        return _ref5.apply(this, arguments);
      };
    }();
  }
};


var carSetThunks = _extends({}, transportSetThunks, {

  make: function make(_make) {
    return function (dispatch, getState, _ref7) {
      var fetch = _ref7.fetch;

      dispatch(set.make(_make));
      dispatch(set.model(null));
      dispatch(setData.models(null));
      dispatch(setData.generations(null));
      dispatch(set.generation(null));
      dispatch(carSetThunks.count());

      if (_make && (_make.id || _make) > 0) {
        fetchModels(fetch, dispatch, _make);
      }
    };
  },

  model: function model(_model) {
    return function (dispatch, getState, _ref8) {
      var fetch = _ref8.fetch;

      dispatch(set.model(_model));
      dispatch(setData.generations(null));
      dispatch(set.generation(null));
      dispatch(carSetThunks.count());

      if (_model) {
        fetch(__WEBPACK_IMPORTED_MODULE_13__constants_api__["a" /* default */].CMM.generationsByModel(_model.id)).then(function (r) {
          return r.json();
        }).then(function (generations) {
          dispatch(setData.generations(generations));
        });
      }
    };
  },

  generation: function generation(_generation) {
    return function (dispatch) {
      dispatch(set.generation(_generation));
      dispatch(carSetThunks.count());
    };
  },

  // Other

  setSelectedOptions: function setSelectedOptions(pickedOptions) {
    return function (dispatch, getState) {
      dispatch(clear.options());

      var optionsTree = getState().searchForm.vocabulary.options;
      var normalizedOptions = __WEBPACK_IMPORTED_MODULE_12__helpers_advertForm__["j" /* normalizePlainOptionIDsToSelected */](pickedOptions, optionsTree);

      dispatch(set.options(normalizedOptions));
    };
  },

  usedWarranty: function usedWarranty(_usedWarranty) {
    return function (dispatch) {
      dispatch(set.usedWarranty(_usedWarranty));
    };
  }
});


var transportFillThunks = {
  currency: function currency(_currency2) {
    return function (dispatch) {
      var item = findItemInCollection(sluggifiedCurrency, _currency2, 'slug');
      dispatch(set.currency(item));
    };
  },

  monthly: function monthly(payment) {
    return function (dispatch) {
      dispatch(set.monthly(payment));
    };
  },

  prepaid: function prepaid(_prepaid2) {
    return function (dispatch) {
      if (!_prepaid2) dispatch(set.monthly(null));
      dispatch(set.prepaid(_prepaid2));
    };
  },

  engine: function engine(engineId) {
    return function (dispatch, getState) {
      var collection = getState().searchForm.vocabulary.engines;
      var item = findItemInCollection(collection, parseInt(engineId, 10));
      dispatch(set.engine(item));
    };
  },

  drive: function drive(driveId) {
    return function (dispatch, getState) {
      var collection = getState().searchForm.vocabulary.drives;
      var item = findItemInCollection(collection, parseInt(driveId, 10));
      dispatch(set.drive(item));
    };
  },

  gearbox: function gearbox(gearboxId) {
    return function (dispatch, getState) {
      var collection = getState().searchForm.vocabulary.gearboxes;
      var gearbox = findItemInCollection(collection, parseInt(gearboxId, 10));
      dispatch(set.gearbox(gearbox));
    };
  },

  category: function category(categoryId) {
    return function (dispatch, getState) {
      var collection = getState().searchForm.vocabulary.categories;
      var category = findItemInCollection(collection, parseFloat(categoryId));
      dispatch(set.category(category));
    };
  },

  yearTo: function yearTo(_yearTo2) {
    return function (dispatch) {
      dispatch(set.yearTo(_yearTo2));
    };
  },

  yearFrom: function yearFrom(_yearFrom2) {
    return function (dispatch) {
      dispatch(set.yearFrom(_yearFrom2));
    };
  },

  priceFrom: function priceFrom(_priceFrom2) {
    return function (dispatch) {
      dispatch(set.priceFrom(_priceFrom2));
    };
  },

  fromDealer: function fromDealer(_fromDealer2) {
    return function (dispatch) {
      dispatch(set.fromDealer(_fromDealer2));
    };
  },

  priceTo: function priceTo(_priceTo2) {
    return function (dispatch) {
      dispatch(set.priceTo(_priceTo2));
    };
  },

  powerFrom: function powerFrom(_powerFrom2) {
    return function (dispatch) {
      dispatch(set.powerFrom(_powerFrom2));
    };
  },

  powerTo: function powerTo(_powerTo2) {
    return function (dispatch) {
      dispatch(set.powerTo(_powerTo2));
    };
  },

  capacityFrom: function capacityFrom(capacityFromVal) {
    return function (dispatch, getState) {
      var collection = getState().searchForm.vocabulary.capacities;
      var capacityFrom = findItemInCollection(collection, parseFloat(capacityFromVal), 'value');
      dispatch(set.capacityFrom(capacityFrom));
    };
  },

  capacityTo: function capacityTo(capacityFromVal) {
    return function (dispatch, getState) {
      var collection = getState().searchForm.vocabulary.capacities;
      var capacityTo = findItemInCollection(collection, parseFloat(capacityFromVal), 'value');
      dispatch(set.capacityTo(capacityTo));
    };
  },

  mileageFrom: function mileageFrom(_mileageFrom2) {
    return function (dispatch) {
      dispatch(set.mileageFrom(_mileageFrom2));
    };
  },

  mileageTo: function mileageTo(_mileageTo2) {
    return function (dispatch) {
      dispatch(set.mileageTo(_mileageTo2));
    };
  },

  colors: function colors(_colors2) {
    return function (dispatch) {
      dispatch(set.colors(_colors2));
    };
  },

  ordering: function ordering(_ordering) {
    return function (dispatch) {
      dispatch(set.ordering(_ordering));
    };
  },

  period: function period(_period) {
    return function (dispatch) {
      dispatch(set.period(_period));
    };
  },

  currecny: function currecny(_currecny) {
    return function (dispatch) {
      dispatch(set.currecny(_currecny));
    };
  },

  photos: function photos(_photos2) {
    return function (dispatch) {
      dispatch(set.photos(_photos2));
    };
  },

  fromAuction: function fromAuction(_fromAuction2) {
    return function (dispatch) {
      dispatch(set.fromAuction(_fromAuction2));
    };
  },

  isSwap: function isSwap(_isSwap2) {
    return function (dispatch) {
      dispatch(set.isSwap(_isSwap2));
    };
  },

  dealer: function dealer(_dealer) {
    return function (dispatch) {
      dispatch(set.dealer(_dealer));
    };
  },

  isUnderLoan: function isUnderLoan(_isUnderLoan2) {
    return function (dispatch) {
      dispatch(set.isUnderLoan(_isUnderLoan2));
    };
  },

  isCrashed: function isCrashed(_isCrashed2) {
    return function (dispatch, getState) {
      var isNew = getState().searchForm.selected.isNew;
      if (isNew) {
        dispatch(set.isCrashed(null));
      } else {
        var collection = getState().searchForm.vocabulary.states;
        var crashedStatus = findItemInCollection(collection, _isCrashed2 ? parseInt(_isCrashed2, 0) : _isCrashed2);
        dispatch(set.isCrashed(crashedStatus));
      }
    };
  },

  isNotCleared: function isNotCleared(_isNotCleared2) {
    return function (dispatch, getState) {
      var collection = getState().searchForm.vocabulary.customs;
      var customsStatus = findItemInCollection(collection, _isNotCleared2 ? parseInt(_isNotCleared2, 0) : _isNotCleared2);
      dispatch(set.isNotCleared(customsStatus));
    };
  },

  abroad: function abroad(_abroad2) {
    return function (dispatch, getState) {
      var collection = getState().searchForm.vocabulary.abroadOptions;
      var customsStatus = findItemInCollection(collection, _abroad2 ? parseInt(_abroad2, 0) : _abroad2);
      dispatch(set.abroad(customsStatus));
    };
  },

  drivenFrom: function drivenFrom(_drivenFrom2) {
    return function (dispatch, getState) {
      var collection = getState().searchForm.vocabulary.europeanCountries;
      var customsStatus = findItemInCollection(collection, _drivenFrom2 ? parseInt(_drivenFrom2, 0) : _drivenFrom2);
      dispatch(set.drivenFrom(customsStatus));
    };
  },

  isRent: function isRent(_isRent2) {
    return function (dispatch, getState) {
      var collection = getState().searchForm.vocabulary.rent;
      var status = findItemInCollection(collection, _isRent2 ? parseInt(_isRent2, 0) : _isRent2);
      dispatch(set.isRent(status));
    };
  },

  isSaleOnCredit: function isSaleOnCredit(_isSaleOnCredit2) {
    return function (dispatch, getState) {
      var collection = getState().searchForm.vocabulary.credits;
      var status = findItemInCollection(collection, _isSaleOnCredit2 ? parseInt(_isSaleOnCredit2, 0) : _isSaleOnCredit2);
      dispatch(set.isSaleOnCredit(status));
    };
  },

  isNew: function isNew(type) {
    return function (dispatch, getState) {
      var usedWarranty = getState().searchForm.selected.usedWarranty;
      if (usedWarranty) dispatch(set.usedWarranty(null));

      if (type) dispatch(set.isCrashed(null));
      dispatch(set.isNew(type === null ? null : parseInt(type, 10)));
    };
  }
};


var dataThunks = {
  brandToChose: function brandToChose(make) {
    return function (dispatch) {
      dispatch(setData.brandToChose(make));
      dispatch(carSetThunks.make(make));
      if (!make) dispatch(_clearSelected());
    };
  }
};

// Fill form from url

var carFormFillThunks = _extends({
  make: function make(makeId) {
    return function (dispatch, getState, _ref9) {
      var fetch = _ref9.fetch;

      var collection = getState().searchForm.vocabulary.makes;
      var make = findItemInCollection(collection, parseInt(makeId, 10));
      dispatch(set.make(make));
      if (make !== undefined && (make.id || make) > 0) {
        fetchModels(fetch, dispatch, make);
      }
    };
  },

  model: function model(modelId) {
    return function (dispatch, getState, _ref10) {
      var fetch = _ref10.fetch;

      fetch(__WEBPACK_IMPORTED_MODULE_13__constants_api__["a" /* default */].CMM.modelById(modelId)).then(function (r) {
        return r.json();
      }).then(function (response) {
        if (response) {
          dispatch(set.model(response));
        }
      });
    };
  },

  generation: function generation(generationId) {
    return function (dispatch, getState, _ref11) {
      var fetch = _ref11.fetch;

      fetch(__WEBPACK_IMPORTED_MODULE_13__constants_api__["a" /* default */].CMM.generationById(generationId)).then(function (r) {
        return r.json();
      }).then(function (response) {
        if (response) {
          dispatch(set.generation(response));
        }
      });
    };
  }
}, transportFillThunks);

var motoSetThunks = _extends({}, transportSetThunks, {

  make: function make(_make2) {
    return function (dispatch, getState, _ref12) {
      var fetch = _ref12.fetch;

      dispatch(set.make(_make2));
      dispatch(set.model(null));
      dispatch(setData.models(null));
      dispatch(motoSetThunks.count());

      var transport = getState().searchForm.selected.transport || {};

      if (_make2) {
        fetchModels(fetch, dispatch, _make2, transport);
      }
    };
  },

  model: function model(_model2) {
    return function (dispatch) {
      dispatch(set.model(_model2));
      dispatch(motoSetThunks.count());
    };
  },

  transportChild: function transportChild(_transportChild) {
    return function (dispatch) {
      dispatch(set.transportChild(_transportChild));
      dispatch(motoSetThunks.count());
    };
  },

  tacts: function tacts(_tacts) {
    return function (dispatch) {
      dispatch(set.tacts(_tacts));
      dispatch(motoSetThunks.count());
    };
  },

  engineOrder: function engineOrder(_engineOrder) {
    return function (dispatch) {
      dispatch(set.engineOrder(_engineOrder));
      dispatch(motoSetThunks.count());
    };
  }
});


var motoFormFillThunks = _extends({
  make: function make(makeId) {
    return function (dispatch, getState, _ref13) {
      var fetch = _ref13.fetch;

      var collection = getState().searchForm.vocabulary.makes;
      var make = findItemInCollection(collection, parseFloat(makeId));
      dispatch(set.make(make));

      if (make) {
        fetchModels(fetch, dispatch, make);
      }
    };
  },

  model: function model(modelId) {
    return function (dispatch, getState, _ref14) {
      var fetch = _ref14.fetch;

      fetch(__WEBPACK_IMPORTED_MODULE_13__constants_api__["a" /* default */].CMM.modelById(modelId)).then(function (r) {
        return r.json();
      }).then(function (response) {
        if (response) {
          dispatch(set.model(response));
        }
      });
    };
  },

  transportChild: function transportChild(childId) {
    return function (dispatch, getState) {
      var collection = getState().searchForm.vocabulary.types;
      var transportChild = findItemInCollection(collection, parseFloat(childId));
      dispatch(set.transportChild(transportChild));
    };
  },

  tacts: function tacts(tactsId) {
    return function (dispatch, getState) {
      var collection = getState().searchForm.vocabulary.tacts;
      var tacts = findItemInCollection(collection, parseFloat(tactsId));
      dispatch(set.tacts(tacts));
    };
  },

  engineOrder: function engineOrder(engineOrderId) {
    return function (dispatch, getState) {
      var collection = getState().searchForm.vocabulary.engineOrders;
      var engineOrder = findItemInCollection(collection, parseFloat(engineOrderId));
      dispatch(set.engineOrder(engineOrder));
    };
  }

}, transportFillThunks);

var commercialSetThunks = _extends({}, transportSetThunks, {

  make: function make(_make3) {
    return function (dispatch, getState, _ref15) {
      var fetch = _ref15.fetch;

      dispatch(set.make(_make3));
      dispatch(commercialSetThunks.model(null));
      dispatch(setData.models(null));
      dispatch(commercialSetThunks.count());

      var transport = getState().searchForm.selected.transport || {};

      if (_make3) {
        fetchModels(fetch, dispatch, _make3, transport);
      }
    };
  },

  model: function model(_model3) {
    return function (dispatch) {
      dispatch(set.model(_model3));
      dispatch(commercialSetThunks.count());
    };
  },

  transportChild: function transportChild(_transportChild2) {
    return function (dispatch) {
      dispatch(set.transportChild(_transportChild2));
      dispatch(commercialSetThunks.count());
    };
  },

  ecotype: function ecotype(_ecotype) {
    return function (dispatch) {
      dispatch(set.ecotype(_ecotype));
      dispatch(commercialSetThunks.count());
    };
  },

  unloading: function unloading(_unloading) {
    return function (dispatch) {
      dispatch(set.unloading(_unloading));
      dispatch(commercialSetThunks.count());
    };
  },

  tonnageFrom: function tonnageFrom(_tonnageFrom) {
    return function (dispatch) {
      dispatch(set.tonnageFrom(_tonnageFrom));
      dispatch(commercialSetThunks.count());
    };
  },

  tonnageTo: function tonnageTo(_tonnageTo) {
    return function (dispatch) {
      dispatch(set.tonnageTo(_tonnageTo));
      dispatch(commercialSetThunks.count());
    };
  },

  capacityBodyFrom: function capacityBodyFrom(_capacityBodyFrom) {
    return function (dispatch) {
      dispatch(set.capacityBodyFrom(_capacityBodyFrom));
      dispatch(commercialSetThunks.count());
    };
  },

  capacityBodyTo: function capacityBodyTo(_capacityBodyTo) {
    return function (dispatch) {
      dispatch(set.capacityBodyTo(_capacityBodyTo));
      dispatch(commercialSetThunks.count());
    };
  },

  capacityBucketFrom: function capacityBucketFrom(_capacityBucketFrom) {
    return function (dispatch) {
      dispatch(set.capacityBucketFrom(_capacityBucketFrom));
      dispatch(commercialSetThunks.count());
    };
  },

  capacityBucketTo: function capacityBucketTo(_capacityBucketTo) {
    return function (dispatch) {
      dispatch(set.capacityBucketTo(_capacityBucketTo));
      dispatch(commercialSetThunks.count());
    };
  },

  layingWidthFrom: function layingWidthFrom(_layingWidthFrom) {
    return function (dispatch) {
      dispatch(set.layingWidthFrom(_layingWidthFrom));
      dispatch(commercialSetThunks.count());
    };
  },

  layingWidthTo: function layingWidthTo(_layingWidthTo) {
    return function (dispatch) {
      dispatch(set.layingWidthTo(_layingWidthTo));
      dispatch(commercialSetThunks.count());
    };
  },

  liftHeightFrom: function liftHeightFrom(_liftHeightFrom) {
    return function (dispatch) {
      dispatch(set.liftHeightFrom(_liftHeightFrom));
      dispatch(commercialSetThunks.count());
    };
  },

  liftHeightTo: function liftHeightTo(value) {
    return function (dispatch) {
      dispatch(set.liftHeightTo(value));
      dispatch(commercialSetThunks.count());
    };
  },

  admissionHeightFrom: function admissionHeightFrom(value) {
    return function (dispatch) {
      dispatch(set.admissionHeightFrom(value));
      dispatch(commercialSetThunks.count());
    };
  },

  admissionHeightTo: function admissionHeightTo(value) {
    return function (dispatch) {
      dispatch(set.admissionHeightTo(value));
      dispatch(commercialSetThunks.count());
    };
  },

  armBoomFrom: function armBoomFrom(value) {
    return function (dispatch) {
      dispatch(set.armBoomFrom(value));
      dispatch(commercialSetThunks.count());
    };
  },

  armBoomTo: function armBoomTo(value) {
    return function (dispatch) {
      dispatch(set.armBoomTo(value));
      dispatch(commercialSetThunks.count());
    };
  },

  depBigFrom: function depBigFrom(value) {
    return function (dispatch) {
      dispatch(set.depBigFrom(value));
      dispatch(commercialSetThunks.count());
    };
  },

  depBigTo: function depBigTo(value) {
    return function (dispatch) {
      dispatch(set.depBigTo(value));
      dispatch(commercialSetThunks.count());
    };
  },

  productivityFrom: function productivityFrom(value) {
    return function (dispatch) {
      dispatch(set.productivityFrom(value));
      dispatch(commercialSetThunks.count());
    };
  },

  productivityTo: function productivityTo(value) {
    return function (dispatch) {
      dispatch(set.productivityTo(value));
      dispatch(commercialSetThunks.count());
    };
  }
});


var commercialFormFillThunks = _extends({
  make: function make(makeId) {
    return function (dispatch, getState, _ref16) {
      var fetch = _ref16.fetch;

      var collection = getState().searchForm.vocabulary.makes;
      var make = findItemInCollection(collection, parseFloat(makeId));
      dispatch(set.make(make));

      if (make) {
        fetchModels(fetch, dispatch, make);
      }
    };
  },

  model: function model(modelId) {
    return function (dispatch, getState, _ref17) {
      var fetch = _ref17.fetch;

      fetch(__WEBPACK_IMPORTED_MODULE_13__constants_api__["a" /* default */].CMM.modelById(modelId)).then(function (r) {
        return r.json();
      }).then(function (response) {
        if (response) {
          dispatch(set.model(response));
        }
      });
    };
  },

  transportChild: function transportChild(childId) {
    return function (dispatch, getState) {
      var transport = getState().searchForm.selected.transport || {};
      var collection = transport ? getState().searchForm.vocabulary.childrenTransportTypes[transport.slug] : [];
      var transportChild = findItemInCollection(collection, parseFloat(childId));
      dispatch(set.transportChild(transportChild));
    };
  }

}, transportFillThunks, {

  ecotype: function ecotype(ecotypeId) {
    return function (dispatch, getState) {
      var collection = getState().searchForm.vocabulary.ecotypes;
      var ecotype = findItemInCollection(collection, parseFloat(ecotypeId));
      dispatch(set.ecotype(ecotype));
    };
  },

  unloading: function unloading(unloadingId) {
    return function (dispatch, getState) {
      var collection = getState().searchForm.vocabulary.unloadings;
      var unloading = findItemInCollection(collection, parseFloat(unloadingId));
      dispatch(set.unloading(unloading));
    };
  },

  tonnageFrom: function tonnageFrom(_tonnageFrom2) {
    return function (dispatch) {
      dispatch(set.tonnageFrom(_tonnageFrom2));
    };
  },

  tonnageTo: function tonnageTo(_tonnageTo2) {
    return function (dispatch) {
      dispatch(set.tonnageTo(_tonnageTo2));
    };
  },

  capacityBodyFrom: function capacityBodyFrom(value) {
    return function (dispatch) {
      dispatch(set.capacityBodyFrom(value));
    };
  },

  capacityBodyTo: function capacityBodyTo(value) {
    return function (dispatch) {
      dispatch(set.capacityBodyTo(value));
    };
  },

  capacityBucketFrom: function capacityBucketFrom(value) {
    return function (dispatch) {
      dispatch(set.capacityBucketFrom(value));
    };
  },

  capacityBucketTo: function capacityBucketTo(value) {
    return function (dispatch) {
      dispatch(set.capacityBucketTo(value));
    };
  },

  layingWidthFrom: function layingWidthFrom(value) {
    return function (dispatch) {
      dispatch(set.layingWidthFrom(value));
    };
  },

  layingWidthTo: function layingWidthTo(value) {
    return function (dispatch) {
      dispatch(set.layingWidthTo(value));
    };
  },

  liftHeightFrom: function liftHeightFrom(value) {
    return function (dispatch) {
      dispatch(set.liftHeightFrom(value));
    };
  },

  liftHeightTo: function liftHeightTo(value) {
    return function (dispatch) {
      dispatch(set.liftHeightTo(value));
    };
  },

  admissionHeightFrom: function admissionHeightFrom(value) {
    return function (dispatch) {
      dispatch(set.admissionHeightFrom(value));
    };
  },

  admissionHeightTo: function admissionHeightTo(value) {
    return function (dispatch) {
      dispatch(set.admissionHeightTo(value));
    };
  },

  armBoomFrom: function armBoomFrom(value) {
    return function (dispatch) {
      dispatch(set.armBoomFrom(value));
    };
  },

  armBoomTo: function armBoomTo(value) {
    return function (dispatch) {
      dispatch(set.armBoomTo(value));
    };
  },

  depBigFrom: function depBigFrom(value) {
    return function (dispatch) {
      dispatch(set.depBigFrom(value));
    };
  },

  depBigTo: function depBigTo(value) {
    return function (dispatch) {
      dispatch(set.depBigTo(value));
    };
  },

  productivityFrom: function productivityFrom(value) {
    return function (dispatch) {
      dispatch(set.productivityFrom(value));
    };
  },

  productivityTo: function productivityTo(value) {
    return function (dispatch) {
      dispatch(set.productivityTo(value));
    };
  }
});

//
// Dealer Cars
//


var dealerCarsThunks = {
  make: function make(_make4) {
    return function (dispatch, getState) {
      dispatch(set.make(_make4));
      dispatch(set.model(null));
      dispatch(setData.models(null));
      dispatch(set.count());

      if (_make4 && _make4.id) {
        var dealer = getState().searchForm.selected.dealer;
        var models = dealer ? dealer.models.filter(function (model) {
          return model.make === _make4.id;
        }) : [];
        dispatch(setData.models(models));
      }
    };
  }
};

//
// Dealers section
//


var dealersSetThunks = {
  hasNew: function hasNew(isNew) {
    return function (dispatch) {
      dispatch(set.hasNew(isNew));
      dispatch(dealersSetThunks.count());
    };
  },

  make: function make(_make5) {
    return function (dispatch, getState, _ref18) {
      var fetch = _ref18.fetch;

      dispatch(set.make(_make5));
      dispatch(set.model(null));
      dispatch(setData.models(null));
      dispatch(dealersSetThunks.count());

      var transport = getState().searchForm.selected.transport || {};

      if (_make5) {
        fetchModels(fetch, dispatch, _make5, transport);
      }
    };
  },

  model: function model(_model4) {
    return function (dispatch, getState, _ref19) {
      var fetch = _ref19.fetch;

      dispatch(set.model(_model4));
      dispatch(setData.generations(null));
      dispatch(dealersSetThunks.count());

      if (_model4) {
        fetch(__WEBPACK_IMPORTED_MODULE_13__constants_api__["a" /* default */].CMM.generationsByModel(_model4.id)).then(function (r) {
          return r.json();
        }).then(function (generations) {
          dispatch(setData.generations(generations));
        });
      }
    };
  },

  count: function count(transferredState) {
    return function (dispatch, getState, _ref20) {
      var fetch = _ref20.fetch;

      var _getState4 = getState(),
          formState = _getState4.searchForm.selected,
          globals = _getState4.globals;

      var location = globals && globals.location || null;

      var searchQuery = _extends({}, transferredState || formState, {
        location: formState.dealer ? null : location
      });

      var currency = searchQuery.currency,
          capacityUnit = searchQuery.capacityUnit,
          powerUnit = searchQuery.powerUnit,
          isNew = searchQuery.isNew,
          usefulParams = _objectWithoutProperties(searchQuery, ['currency', 'capacityUnit', 'powerUnit', 'isNew']);

      var query = __WEBPACK_IMPORTED_MODULE_2_snakecase_keys___default.a(__WEBPACK_IMPORTED_MODULE_8_shared_helpers_urls__["d" /* generateSearchQuery */](usefulParams));
      var key = __WEBPACK_IMPORTED_MODULE_1_query_string___default.a.stringify(query);
      fetch(__WEBPACK_IMPORTED_MODULE_13__constants_api__["a" /* default */].DEALERS.COUNT + '?' + key).then(function (r) {
        return r.json();
      }).then(function (response) {
        dispatch(setData.count(response.count));
      });
    };
  },

  powerUnit: function powerUnit(_powerUnit) {
    return function (dispatch) {
      dispatch(set.powerUnit(_powerUnit));
    };
  },

  delaer: function delaer(_delaer) {
    return function (dispatch) {
      dispatch(set.powerUnit(_delaer));
    };
  },

  tags: function tags(_tags) {
    return function (dispatch) {
      dispatch(set.tags(_tags));
    };
  },

  capacityUnit: function capacityUnit(_capacityUnit) {
    return function (dispatch) {
      dispatch(set.capacityUnit(_capacityUnit));
    };
  },

  isOfficial: function isOfficial(_isOfficial) {
    return function (dispatch) {
      dispatch(set.isOfficial(_isOfficial));
      dispatch(dealersSetThunks.count());
    };
  },

  q: function q(_q) {
    return function (dispatch) {
      dispatch(set.q(_q));
      dispatch(dealersSetThunks.count());
    };
  },

  testDrive: function testDrive(_testDrive) {
    return function (dispatch) {
      dispatch(set.testDrive(_testDrive));
      dispatch(dealersSetThunks.count());
    };
  },

  tradeIn: function tradeIn(_tradeIn) {
    return function (dispatch) {
      dispatch(set.tradeIn(_tradeIn));
      dispatch(dealersSetThunks.count());
    };
  },

  credit: function credit(_credit) {
    return function (dispatch) {
      dispatch(set.credit(_credit));
      dispatch(dealersSetThunks.count());
    };
  },

  insurance: function insurance(_insurance) {
    return function (dispatch) {
      dispatch(set.insurance(_insurance));
      dispatch(dealersSetThunks.count());
    };
  },

  accessories: function accessories(_accessories) {
    return function (dispatch) {
      dispatch(set.accessories(_accessories));
      dispatch(dealersSetThunks.count());
    };
  },

  clearSelected: function clearSelected() {
    return function (dispatch) {
      dispatch(_clearSelected());
      dispatch(dealersSetThunks.count());
    };
  }
};


var dealersFormFillThunks = {
  hasNew: function hasNew(type) {
    return function (dispatch) {
      dispatch(set.hasNew(parseInt(type, 10)));
    };
  },

  make: function make(makeId) {
    return function (dispatch, getState, _ref21) {
      var fetch = _ref21.fetch;

      var collection = getState().searchForm.vocabulary.makes;
      var make = findItemInCollection(collection, parseInt(makeId, 10));

      dispatch(set.make(make));

      if (make) {
        fetchModels(fetch, dispatch, make);
      }
    };
  },

  model: function model(modelId) {
    return function (dispatch, getState, _ref22) {
      var fetch = _ref22.fetch;

      fetch(__WEBPACK_IMPORTED_MODULE_13__constants_api__["a" /* default */].CMM.modelById(modelId)).then(function (r) {
        return r.json();
      }).then(function (response) {
        if (response) {
          dispatch(set.model(response));
        }
      });
    };
  },

  isOfficial: function isOfficial(_isOfficial2) {
    return function (dispatch) {
      dispatch(set.isOfficial(_isOfficial2));
    };
  },

  q: function q(_q2) {
    return function (dispatch) {
      dispatch(set.q(_q2));
    };
  },

  testDrive: function testDrive(_testDrive2) {
    return function (dispatch) {
      dispatch(set.testDrive(_testDrive2));
    };
  },

  tags: function tags(_tags2) {
    return function (dispatch) {
      dispatch(set.tags(_tags2));
    };
  },

  isNew: function isNew(_isNew2) {
    return function (dispatch) {
      var result = parseInt(_isNew2, 10);
      dispatch(set.isNew(isNaN(result) ? null : result));
    };
  },

  tradeIn: function tradeIn(_tradeIn2) {
    return function (dispatch) {
      dispatch(set.tradeIn(_tradeIn2));
    };
  },

  credit: function credit(_credit2) {
    return function (dispatch) {
      dispatch(set.credit(_credit2));
    };
  },

  insurance: function insurance(_insurance2) {
    return function (dispatch) {
      dispatch(set.insurance(_insurance2));
    };
  },

  accessories: function accessories(_accessories2) {
    return function (dispatch) {
      dispatch(set.accessories(_accessories2));
    };
  }
};

//
// Spares
//


var sparesSetThunks = {
  make: function make(_make6) {
    return function (dispatch, getState, _ref23) {
      var fetch = _ref23.fetch;

      dispatch(set.make(_make6));
      dispatch(set.model(null));
      dispatch(setData.models(null));
      dispatch(sparesSetThunks.count());

      if (_make6) {
        fetchModels(fetch, dispatch, _make6);
      }
    };
  },

  model: function model(_model5) {
    return function (dispatch) {
      dispatch(set.model(_model5));
      dispatch(sparesSetThunks.count());
    };
  },

  count: function count(transferredState) {
    return function (dispatch, getState, _ref24) {
      var fetch = _ref24.fetch;

      var _getState5 = getState(),
          _getState5$searchForm = _getState5.searchForm,
          formState = _getState5$searchForm.selected,
          counts = _getState5$searchForm.counts,
          globals = _getState5.globals;

      var location = globals && globals.location || null;

      var searchQuery = _extends({}, transferredState || formState, {
        location: formState.dealer ? null : location
      });

      var currency = searchQuery.currency,
          usefulParams = _objectWithoutProperties(searchQuery, ['currency']);

      var query = __WEBPACK_IMPORTED_MODULE_2_snakecase_keys___default.a(__WEBPACK_IMPORTED_MODULE_8_shared_helpers_urls__["d" /* generateSearchQuery */](usefulParams));
      var key = __WEBPACK_IMPORTED_MODULE_1_query_string___default.a.stringify(query);
      var specialKey = 'spare-' + key;
      var currentCount = counts && counts[specialKey];

      if (currentCount !== undefined && !isNaN(currentCount)) {
        dispatch(setData.count(currentCount));
      } else {
        fetch(__WEBPACK_IMPORTED_MODULE_13__constants_api__["a" /* default */].SPARE_PARTS.COUNT + '?' + key).then(function (r) {
          return r.json();
        }).then(function (response) {
          dispatch(setCounts(_defineProperty({}, specialKey, response.count)));
          dispatch(setData.count(response.count));
        });
      }
    };
  },

  yearTo: function yearTo(_yearTo3) {
    return function (dispatch) {
      dispatch(set.yearTo(_yearTo3));
      dispatch(sparesSetThunks.count());
    };
  },

  yearFrom: function yearFrom(_yearFrom3) {
    return function (dispatch) {
      dispatch(set.yearFrom(_yearFrom3));
      dispatch(sparesSetThunks.count());
    };
  },

  rubric: function rubric(section) {
    return function (dispatch, getState, _ref25) {
      var fetch = _ref25.fetch;

      dispatch(set.rubric(section));
      dispatch(setData.sparetypes(null));
      dispatch(set.sparetype(null));
      dispatch(sparesSetThunks.count());

      if (section) {
        fetch(__WEBPACK_IMPORTED_MODULE_13__constants_api__["a" /* default */].CMM.sparetypesBySection(section.id)).then(function (r) {
          return r.json();
        }).then(function (response) {
          if (response) {
            dispatch(setData.sparetypes(response));
          }
        });
      }
    };
  },

  sparetype: function sparetype(_sparetype) {
    return function (dispatch) {
      dispatch(set.sparetype(_sparetype));
      dispatch(sparesSetThunks.count());
    };
  },

  query: function query(q) {
    return function (dispatch) {
      dispatch(set.query(q));
      dispatch(sparesSetThunks.count());
    };
  },

  isUsed: function isUsed(_isUsed) {
    return function (dispatch) {
      dispatch(set.isUsed(_isUsed));
      dispatch(sparesSetThunks.count());
    };
  },

  isNew: function isNew(_isNew3) {
    return function (dispatch) {
      dispatch(set.isNew(_isNew3));
      dispatch(sparesSetThunks.count());
    };
  },

  isOriginal: function isOriginal(_isOriginal) {
    return function (dispatch) {
      dispatch(set.isOriginal(_isOriginal));
      dispatch(sparesSetThunks.count());
    };
  },

  isAnalogue: function isAnalogue(_isAnalogue) {
    return function (dispatch) {
      dispatch(set.isAnalogue(_isAnalogue));
      dispatch(sparesSetThunks.count());
    };
  },

  inStock: function inStock(_inStock) {
    return function (dispatch) {
      dispatch(set.inStock(_inStock));
      dispatch(sparesSetThunks.count());
    };
  },

  isUnderTheOrder: function isUnderTheOrder(_isUnderTheOrder) {
    return function (dispatch) {
      dispatch(set.isUnderTheOrder(_isUnderTheOrder));
      dispatch(sparesSetThunks.count());
    };
  },

  clearSelected: function clearSelected() {
    return function (dispatch) {
      dispatch(_clearSelected());
      dispatch(sparesSetThunks.count());
    };
  }
};


var sparesFormFillThunks = {
  make: function make(makeId) {
    return function (dispatch, getState, _ref26) {
      var fetch = _ref26.fetch;

      var collection = getState().searchForm.vocabulary.makes;
      var make = findItemInCollection(collection, parseInt(makeId, 10));
      dispatch(set.make(make));

      if (make) {
        fetchModels(fetch, dispatch, make);
      }
    };
  },

  model: function model(modelId) {
    return function (dispatch, getState, _ref27) {
      var fetch = _ref27.fetch;

      fetch(__WEBPACK_IMPORTED_MODULE_13__constants_api__["a" /* default */].CMM.modelById(modelId)).then(function (r) {
        return r.json();
      }).then(function (response) {
        if (response) {
          dispatch(set.model(response));
        }
      });
    };
  },

  yearTo: function yearTo(_yearTo4) {
    return function (dispatch) {
      dispatch(set.yearTo(_yearTo4));
    };
  },

  yearFrom: function yearFrom(_yearFrom4) {
    return function (dispatch) {
      dispatch(set.yearFrom(_yearFrom4));
    };
  },

  // isNew group

  isUsed: function isUsed(_isUsed2) {
    return function (dispatch) {
      if (_isUsed2) {
        dispatch(set.isNew(null));
      }
      dispatch(set.isUsed(parseFloat(_isUsed2)));
    };
  },

  isNew: function isNew(_isNew4) {
    return function (dispatch) {
      if (_isNew4) {
        dispatch(set.isUsed(null));
      }
      dispatch(set.isNew(_isNew4 === null ? null : parseInt(_isNew4, 10)));
    };
  },

  // /

  // isOriginal group

  isOriginal: function isOriginal(_isOriginal2) {
    return function (dispatch) {
      if (_isOriginal2) {
        dispatch(set.isAnalogue(null));
      }
      dispatch(set.isOriginal(parseFloat(_isOriginal2)));
    };
  },

  isAnalogue: function isAnalogue(_isAnalogue2) {
    return function (dispatch) {
      if (_isAnalogue2) {
        dispatch(set.isOriginal(null));
      }
      dispatch(set.isAnalogue(parseFloat(_isAnalogue2)));
    };
  },

  // /

  // inStock group

  inStock: function inStock(_inStock2) {
    return function (dispatch) {
      if (_inStock2) {
        dispatch(set.isUnderTheOrder(null));
      }
      dispatch(set.inStock(parseFloat(_inStock2)));
    };
  },

  isUnderTheOrder: function isUnderTheOrder(_isUnderTheOrder2) {
    return function (dispatch) {
      if (_isUnderTheOrder2) {
        dispatch(set.inStock(null));
      }
      dispatch(set.isUnderTheOrder(parseFloat(_isUnderTheOrder2)));
    };
  },

  // /

  rubric: function rubric(sectionId) {
    return function (dispatch, getState, _ref28) {
      var fetch = _ref28.fetch;

      var collection = getState().searchForm.vocabulary.rubrics;
      var rubric = findItemInCollection(collection, parseFloat(sectionId));

      dispatch(set.sparetype(null));
      dispatch(setData.sparetypes(null));
      dispatch(set.rubric(rubric));

      if (sectionId) {
        fetch(__WEBPACK_IMPORTED_MODULE_13__constants_api__["a" /* default */].CMM.sparetypesBySection(sectionId)).then(function (r) {
          return r.json();
        }).then(function (response) {
          if (response) {
            dispatch(setData.sparetypes(response));
          }
        });
      }
    };
  },

  sparetype: function sparetype(subsectionId) {
    return function (dispatch, getState, _ref29) {
      var fetch = _ref29.fetch;

      fetch(__WEBPACK_IMPORTED_MODULE_13__constants_api__["a" /* default */].CMM.sparetypesById(subsectionId)).then(function (r) {
        return r.json();
      }).then(function (response) {
        if (response && response.length > 0) {
          var subsection = response[0];
          dispatch(set.sparetype(subsection));
        }
      });
    };
  },

  query: function query(q) {
    return function (dispatch) {
      dispatch(set.query(q));
    };
  },

  firm: function firm(_firm) {
    return function (dispatch) {
      dispatch(set.firm(_firm));
    };
  }
};

//
// Other
//


var otherTransportSetThunks = {
  make: function make(_make7, transportID) {
    return function (dispatch, getState, _ref30) {
      var fetch = _ref30.fetch;

      dispatch(set.make(_make7));
      dispatch(set.model(null));
      dispatch(setData.models(null));

      if (_make7) {
        fetchModels(fetch, dispatch, _make7, { id: transportID });
      }
    };
  },

  model: function model(_model6) {
    return function (dispatch, getState, _ref31) {
      var fetch = _ref31.fetch;

      dispatch(set.model(_model6));
      dispatch(set.series(null));
      dispatch(setData.series(null));

      if (_model6) {
        fetch(__WEBPACK_IMPORTED_MODULE_13__constants_api__["a" /* default */].CMM.seriesByModel(_model6.id)).then(function (r) {
          return r.json();
        }).then(function (series) {
          dispatch(setData.series(series));
        });
      }
    };
  },

  series: function series(_series) {
    return function (dispatch, getState, _ref32) {
      var fetch = _ref32.fetch;

      dispatch(set.series(_series));
      dispatch(set.year(null));
      dispatch(setData.modifications(null));
      dispatch(setData.years(null));

      if (_series) {
        fetch(__WEBPACK_IMPORTED_MODULE_13__constants_api__["a" /* default */].CMM.modificationsBySeries(_series.id)).then(function (r) {
          return r.json();
        }).then(function (modifications) {
          var modificationsYearsUniq = new Set(modifications.map(function (modification) {
            return __WEBPACK_IMPORTED_MODULE_14__helpers_arrays__["c" /* getRange */](parseInt(modification.year_begin, 10), parseInt(modification.year_end, 10));
          }).reduce(function (result, generationYears) {
            return [].concat(_toConsumableArray(result), _toConsumableArray(generationYears));
          }, [])).toJSON();

          dispatch(setData.modifications(modifications));
          dispatch(setData.years(modificationsYearsUniq));
        });
      }
    };
  }
};
//
// moto
//


var setTransportResults = function setTransportResults(id) {
  return function (dispatch, getState, _ref33) {
    var fetch = _ref33.fetch;
    return fetch(__WEBPACK_IMPORTED_MODULE_13__constants_api__["a" /* default */].ADVERT.ALL('?transport=' + id)).then(function (r) {
      return r.json();
    }).then(function (r) {
      dispatch(setResults(r));
      dispatch(__WEBPACK_IMPORTED_MODULE_4_shared_actions_globals__["j" /* setDataLayer */](__WEBPACK_IMPORTED_MODULE_3_shared_modules__["p" /* stateDataLayer */].manipulation({ data: r.results, pagetype: 'searchresults' })));
    });
  };
};

var setTransportType = function setTransportType(transport) {
  return function (dispatch, getState) {
    var currentTransport = getState().searchForm.selected.transport;
    if (!currentTransport || currentTransport.id !== transport.id) dispatch(_clearSelected());
    dispatch(set.transport(transport));
    dispatch(transportSetThunks.count());
  };
};

/***/ }),

/***/ 484:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return clearForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return setIsEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return setIsClearBtn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return selectedActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return setData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return setFormVocabulary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return clearVocabulary; });
/* unused harmony export clearNewPhotos */
/* unused harmony export clearNewAdverts */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return carSetThunks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return otherTransportSetThunks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return setPhotosNew; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return setAdvertsNew; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return requestRemoveAdvertForm; });
/* unused harmony export requestVinAdvertForm */
/* unused harmony export requestLeasingForm */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return requestAutobooking; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_constants_advertForm__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_helpers_arrays__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_modules__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_constants_json_colors_json__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_constants_json_colors_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_shared_constants_json_colors_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_constants_api__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_advertForm__ = __webpack_require__(134);
var _this = this;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










var URL = process.env.AB_IP || process.env.API_SERVER_URL || 'http://localhost:' + (process.env.PORT || 3000);
//
// General
//

var clearForm = __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].CLEAR);
var setIsEdit = __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SET_IS_EDIT);
var setIsClearBtn = __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SET_IS_CLEAR_BTN);
//
// Selected
//

var actions = __WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* createActions */]({
  ADVERT_FORM: {
    SELECTED: Object.keys(__WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED).reduce(function (object, field) {
      return _extends({}, object, _defineProperty({}, field, undefined));
    }, {})
  }
}, { namespace: '__' });
// exporting selectedActions like this due to an extract-hoc package bug
var selectedActions = actions.advertForm.selected;

//
// Data
//

var setData = {
  models: __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].DATA_MODELS_SET),
  modifications: __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].DATA_MODIFICATIONS_SET),
  equipments: __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].DATA_EQUIPMENTS_SET),
  years: __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].DATA_YEARS_SET),
  generations: __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].DATA_GENERATIONS_SET),
  series: __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].DATA_SERIES_SET),
  drives: __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].DATA_DRIVES_SET),
  gearboxes: __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].DATA_GEARBOXES_SET),
  existingPhotos: __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].DATA_EXISTING_PHOTOS_SET),
  existingPhotosNew: __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].DATA_EXISTING_PHOTOS_SET_NEW),
  existingAdvertsNew: __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].DATA_EXISTING_ADVERTS_SET_NEW),
  newAdvert: __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].DATA_NEW_ADVERT),
  currentFormStep: __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].DATA_CURRENT_FORM_STEP),
  averagePrice: __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].DATA_AVERAGE_PRICE_SET),
  advertsAveragePrice: __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].DATA_ADVERTS_AVERAGE_PRICE_SET),
  averagePriceParams: __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].DATA_AVERAGE_PRICE_PARAMS_SET),
  showAveragePrice: __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].DATA_SHOW_AVERAGE_PRICE_SET),
  warranty: __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].DATA_WARRANTY_SET)
};

//
// Vocabulary
//

var setFormVocabulary = __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].VOCABULARY_SET);
var clearVocabulary = __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].VOCABULARY_CLEAR);

//
// Clear
//

var clearNewPhotos = __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].DATA_EXISTING_PHOTOS_SET_NEW);
var clearNewAdverts = __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].DATA_EXISTING_ADVERTS_SET_NEW);

//
// Thunks
//
var set = selectedActions.set,
    clear = selectedActions.clear,
    toggle = selectedActions.toggle;


var sharedThunks = {
  setSelectedOptions: function setSelectedOptions(pickedOptions) {
    return function (dispatch, getState) {
      dispatch(clearNewPhotos({ clear: true }));
      dispatch(clearNewAdverts({ clear: true }));
      dispatch(clear.options());
      var optionsTree = getState().advertForm.vocabulary.options;
      var normalizedOptions = __WEBPACK_IMPORTED_MODULE_7__helpers_advertForm__["j" /* normalizePlainOptionIDsToSelected */](pickedOptions, optionsTree);

      dispatch(set.options(normalizedOptions));
    };
  }
};

var carSetThunks = _extends({}, sharedThunks, {

  make: function make(_make) {
    return function (dispatch, getState, _ref) {
      var fetch = _ref.fetch;

      dispatch(set.make(_make));
      dispatch(carSetThunks.model(null));
      dispatch(setData.models(null));

      if (_make && _make.id >= 0) {
        return fetch(__WEBPACK_IMPORTED_MODULE_6_shared_constants_api__["a" /* default */].CMM.modelsByMake(_make.id)).then(function (r) {
          return r.json();
        }).then(function (models) {
          dispatch(setData.models(models.sort(__WEBPACK_IMPORTED_MODULE_3_shared_helpers_arrays__["b" /* compareByTitle */])));
        });
      }

      return Promise.resolve();
    };
  },

  model: function model(_model) {
    return function (dispatch, getState, _ref2) {
      var fetch = _ref2.fetch;

      dispatch(set.model(_model));
      dispatch(carSetThunks.year(null));
      dispatch(setData.generations(null));
      dispatch(setData.years(null));

      if (_model) {
        return fetch(__WEBPACK_IMPORTED_MODULE_6_shared_constants_api__["a" /* default */].CMM.generationsByModel(_model.id)).then(function (r) {
          return r.json();
        }).then(function (generations) {
          var generationYearsUniq = new Set(generations.map(function (generation) {
            return __WEBPACK_IMPORTED_MODULE_3_shared_helpers_arrays__["c" /* getRange */](parseInt(generation.year_begin, 10), parseInt(generation.year_end, 10));
          }).reduce(function (result, generationYears) {
            return [].concat(_toConsumableArray(result), _toConsumableArray(generationYears));
          }, [])).toJSON();

          dispatch(setData.generations(generations));
          dispatch(setData.years(generationYearsUniq));
        });
      }

      return Promise.resolve();
    };
  },

  year: function year(_year) {
    return function (dispatch) {
      dispatch(set.year(+_year));
      dispatch(carSetThunks.generation(null));
    };
  },

  generation: function generation(_generation) {
    return function (dispatch, getState, _ref3) {
      var fetch = _ref3.fetch;

      dispatch(set.generation(_generation));
      dispatch(carSetThunks.series(null));
      dispatch(set.modification(null));
      dispatch(set.capacity(null));
      dispatch(setData.series(null));
      dispatch(set.body(null));

      if (_generation && !_generation.id) {
        fetch(__WEBPACK_IMPORTED_MODULE_6_shared_constants_api__["a" /* default */].CMM.allSeries()).then(function (r) {
          return r.json();
        }).then(function (series) {
          dispatch(setData.series(series));
        });
        fetch(__WEBPACK_IMPORTED_MODULE_6_shared_constants_api__["a" /* default */].CMM.allDrives()).then(function (r) {
          return r.json();
        }).then(function (drives) {
          dispatch(setData.drives(drives));
        });
        fetch(__WEBPACK_IMPORTED_MODULE_6_shared_constants_api__["a" /* default */].CMM.allGearboxes()).then(function (r) {
          return r.json();
        }).then(function (gearboxes) {
          dispatch(setData.gearboxes(gearboxes));
        });
      } else if (_generation) {
        return fetch(__WEBPACK_IMPORTED_MODULE_6_shared_constants_api__["a" /* default */].CMM.seriesByGeneration(_generation.id)).then(function (r) {
          return r.json();
        }).then(function (series) {
          dispatch(setData.series(series));
        });
      }

      return Promise.resolve();
    };
  },

  series: function series(_series) {
    return function (dispatch, getState, _ref4) {
      var fetch = _ref4.fetch;

      dispatch(set.series(_series));
      dispatch(carSetThunks.engine(null));
      dispatch(setData.modifications(null));

      if (_series) {
        return fetch(__WEBPACK_IMPORTED_MODULE_6_shared_constants_api__["a" /* default */].CMM.modificationsBySeries(_series.id)).then(function (r) {
          return r.json();
        }).then(function (modifications) {
          dispatch(setData.modifications(modifications));
        });
      }

      return Promise.resolve();
    };
  },

  body: function body(_body) {
    return function (dispatch) {
      dispatch(set.body(_body));
    };
  },

  engine: function engine(_engine) {
    return function (dispatch) {
      dispatch(set.engine(_engine));
      dispatch(carSetThunks.drive(null));
    };
  },

  drive: function drive(_drive) {
    return function (dispatch) {
      dispatch(set.drive(_drive));
      dispatch(carSetThunks.gearbox(null));
    };
  },

  gearbox: function gearbox(_gearbox) {
    return function (dispatch) {
      dispatch(set.gearbox(_gearbox));
      dispatch(carSetThunks.modification(null));
    };
  },

  mileage: function mileage(_mileage) {
    return function (dispatch) {
      dispatch(set.mileage(_mileage));

      if (_mileage) dispatch(carSetThunks.averagePrice());
    };
  },

  averagePrice: function averagePrice() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState, _ref6) {
        var fetch = _ref6.fetch;
        var queryParams, averagePrice, advertsByAverage;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                queryParams = data || getState().advertForm.selected;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_7__helpers_advertForm__["d" /* fetchAveragePrice */](fetch, queryParams);

              case 3:
                averagePrice = _context.sent;

                dispatch(setData.averagePrice(averagePrice));

                if (!data) {
                  _context.next = 13;
                  break;
                }

                dispatch(setData.showAveragePrice(true));
                dispatch(set.regNumber(''));
                _context.next = 10;
                return __WEBPACK_IMPORTED_MODULE_7__helpers_advertForm__["b" /* fetchAdvertAverage */](fetch, data);

              case 10:
                advertsByAverage = _context.sent;


                dispatch(setData.averagePriceParams(queryParams));
                dispatch(setData.advertsAveragePrice(advertsByAverage));

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function (_x2, _x3, _x4) {
        return _ref5.apply(this, arguments);
      };
    }();
  },

  modification: function modification(_modification) {
    return function (dispatch, getState, _ref7) {
      var fetch = _ref7.fetch;

      dispatch(set.modification(_modification));
      dispatch(setData.equipments(null));
      dispatch(setData.averagePrice(null));
      dispatch(carSetThunks.equipment(null));

      if (_modification && _modification.id) {
        dispatch(set.capacity(null));
        dispatch(set.power(null));

        return Promise.all([fetch(__WEBPACK_IMPORTED_MODULE_6_shared_constants_api__["a" /* default */].CMM.equipmentsByModification(_modification.id)).then(function (r) {
          return r.json();
        }).then(function (equipments) {
          dispatch(setData.equipments(equipments));
        })]);
      }

      return Promise.resolve();
    };
  },

  equipment: function equipment(_equipment) {
    return function (dispatch) {
      dispatch(set.equipment(_equipment));
      dispatch(clear.options());
      if (_equipment && _equipment.id) {
        dispatch(carSetThunks.setSelectedOptions(Object.keys(_equipment.options).map(function (key) {
          return parseInt(key, 10);
        })));
      }
    };
  },

  abroad: function abroad(_abroad) {
    return function (dispatch, getState) {
      var _getState = getState(),
          advertForm = _getState.advertForm;

      var statuses = advertForm.vocabulary.statuses;
      var advertFields = advertForm.selected.advertFields;


      if (_abroad) {
        statuses.filter(function (status) {
          return status.isNotCompatibleWithAbroad;
        }).forEach(function (status) {
          if (!advertFields[status.id]) {
            dispatch(toggle.advertFields(status.id));
          }
        });
      }

      dispatch(set.drivenFrom(null));
      dispatch(set.abroad(_abroad));
    };
  },

  regNumber: function regNumber(_regNumber) {
    return function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState, _ref9) {
        var fetch = _ref9.fetch;
        var carParams;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                dispatch(set.regNumber(_regNumber));

                if (_regNumber) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt('return', true);

              case 3:
                _context2.next = 5;
                return fetch(__WEBPACK_IMPORTED_MODULE_6_shared_constants_api__["a" /* default */].ADVERT.PARAMS_BY_REG_NUMBER(_regNumber)).then(function (r) {
                  if (r.status === 404) {
                    dispatch(clearForm());
                    throw r.statusText;
                  }
                  return r.json();
                }).then(function (res) {
                  return {
                    make: res.make,
                    model: res.model,
                    year: res.year,
                    generation: { id: null },
                    body: res.body,
                    engine: res.engine,
                    capacity: res.capacity ? (res.capacity / 1000).toFixed(1) : null,
                    color: res.color ? __WEBPACK_IMPORTED_MODULE_5_shared_constants_json_colors_json___default.a.find(function (item) {
                      return item.id === res.color;
                    }) : null
                  };
                }).catch(function () {
                  dispatch(clearForm());
                  Promise.resolve();
                });

              case 5:
                carParams = _context2.sent;

                if (carParams) {
                  _context2.next = 8;
                  break;
                }

                return _context2.abrupt('return', false);

              case 8:
                if (!carParams.make) {
                  _context2.next = 12;
                  break;
                }

                _context2.next = 11;
                return fetch(__WEBPACK_IMPORTED_MODULE_6_shared_constants_api__["a" /* default */].ADVERT.PARAMS_BY_ID.make(carParams.make)).then(function (r) {
                  return r.json().then(function (data) {
                    return data;
                  });
                });

              case 11:
                carParams.make = _context2.sent;

              case 12:
                if (!carParams.model) {
                  _context2.next = 16;
                  break;
                }

                _context2.next = 15;
                return fetch(__WEBPACK_IMPORTED_MODULE_6_shared_constants_api__["a" /* default */].ADVERT.PARAMS_BY_ID.model(carParams.model)).then(function (r) {
                  return r.json().then(function (data) {
                    return data;
                  });
                });

              case 15:
                carParams.model = _context2.sent;

              case 16:
                if (!carParams.engine) {
                  _context2.next = 20;
                  break;
                }

                _context2.next = 19;
                return fetch(__WEBPACK_IMPORTED_MODULE_6_shared_constants_api__["a" /* default */].ADVERT.PARAMS_BY_ID.engine(carParams.engine)).then(function (r) {
                  return r.json().then(function (data) {
                    return data[0];
                  });
                });

              case 19:
                carParams.engine = _context2.sent;

              case 20:
                if (!carParams.body) {
                  _context2.next = 24;
                  break;
                }

                _context2.next = 23;
                return fetch(__WEBPACK_IMPORTED_MODULE_6_shared_constants_api__["a" /* default */].ADVERT.PARAMS_BY_ID.body(carParams.body)).then(function (r) {
                  return r.json().then(function (data) {
                    return data[0];
                  });
                });

              case 23:
                carParams.body = _context2.sent;

              case 24:

                Object.keys(carParams).map(function (key) {
                  return dispatch(set[key](carParams[key]));
                });

                return _context2.abrupt('return', true);

              case 26:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }));

      return function (_x5, _x6, _x7) {
        return _ref8.apply(this, arguments);
      };
    }();
  },

  usedWarranty: function usedWarranty(_usedWarranty) {
    return function (dispatch) {
      dispatch(set.usedWarranty(_usedWarranty));
    };
  }
});


var otherTransportSetThunks = {
  make: function make(_make2) {
    return function (dispatch, getState, _ref10) {
      var fetch = _ref10.fetch;

      dispatch(set.make(_make2));
      dispatch(set.makeTitle(null));
      dispatch(otherTransportSetThunks.model(null));
      dispatch(setData.models(null));

      if (_make2 && _make2.id >= 0) {
        return (_make2.id ? fetch(__WEBPACK_IMPORTED_MODULE_6_shared_constants_api__["a" /* default */].CMM.modelsByMake(_make2.id)).then(function (r) {
          return r.json();
        }) : Promise.resolve(null)).then(function (models) {
          if (models) {
            dispatch(setData.models([__WEBPACK_IMPORTED_MODULE_2_shared_constants_advertForm__["d" /* OTHER_ITEM */]].concat(_toConsumableArray(models.sort(__WEBPACK_IMPORTED_MODULE_3_shared_helpers_arrays__["b" /* compareByTitle */])))));
          }

          if (!models || !models.length) {
            dispatch(set.model(__WEBPACK_IMPORTED_MODULE_2_shared_constants_advertForm__["d" /* OTHER_ITEM */]));
            dispatch(setData.models([__WEBPACK_IMPORTED_MODULE_2_shared_constants_advertForm__["d" /* OTHER_ITEM */]]));
          }
        });
      }

      return Promise.resolve();
    };
  },

  model: function model(_model2) {
    return function (dispatch) {
      dispatch(set.model(_model2));
      dispatch(set.modelTitle(null));

      return Promise.resolve();
    };
  }
};
//
// Adverts
//

var setPhotosNew = function setPhotosNew(_ref11) {
  var value = _ref11.value,
      onAdd = _ref11.onAdd;
  return function (dispatch, getState, _ref12) {
    var fetch = _ref12.fetch;

    value.map(function (a, b) {
      var dat = new FormData();
      dat.append('filearg', a);
      fetch(__WEBPACK_IMPORTED_MODULE_6_shared_constants_api__["a" /* default */].ADVERT.photosNew(), {
        method: 'POST',
        body: dat
      }).then(function (packages) {
        if (packages.status === 200) {
          onAdd([a]);
          return packages.json();
        }

        return null;
      }).then(function (res) {
        if (res) {
          dispatch(setData.existingPhotosNew({ set: res }));
        }
      }).catch(function (err) {});
    });
  };
};
var setAdvertsNew = function setAdvertsNew(_ref13) {
  var formState = _ref13.formState,
      onSubmit = _ref13.onSubmit;
  return function (dispatch, getState, _ref14) {
    var fetch = _ref14.fetch;

    dispatch(setData.existingAdvertsNew({ set: formState }));

    var _getState2 = getState(),
        _getState2$advertForm = _getState2.advertForm;

    _getState2$advertForm = _getState2$advertForm === undefined ? {} : _getState2$advertForm;
    var _getState2$advertForm2 = _getState2$advertForm.data;
    _getState2$advertForm2 = _getState2$advertForm2 === undefined ? {} : _getState2$advertForm2;
    var newExistingPhotos = _getState2$advertForm2.newExistingPhotos,
        _getState2$advertForm3 = _getState2$advertForm2.newExistingAdverts,
        newExistingAdverts = _getState2$advertForm3 === undefined ? formState : _getState2$advertForm3,
        _getState2$user = _getState2.user;
    _getState2$user = _getState2$user === undefined ? {} : _getState2$user;
    var _getState2$user$user = _getState2$user.user;
    _getState2$user$user = _getState2$user$user === undefined ? {} : _getState2$user$user;
    var _getState2$user$user$ = _getState2$user$user.phones,
        phones = _getState2$user$user$ === undefined ? [] : _getState2$user$user$;

    newExistingAdverts.driven_from = Number(newExistingAdverts.driven_from);
    newExistingAdverts.photos = newExistingPhotos;
    newExistingAdverts.photosToUpdate = [];
    newExistingAdverts.photosToDelete = [];
    if (!(newExistingAdverts.phones && newExistingAdverts.phones[0])) {
      newExistingAdverts.phones = phones.map(function (dat) {
        return dat.number;
      });
    }
    // src/shared/hocs/advertForm/withPostAdvert.js
    onSubmit(_extends({}, newExistingAdverts));
  };
};
var requestRemoveAdvertForm = function requestRemoveAdvertForm(data, _ref15) {
  var enqueueNotification = _ref15.enqueueNotification,
      intl = _ref15.intl;
  return function (dispatch, getState, _ref16) {
    var fetch = _ref16.fetch;

    var _getState3 = getState(),
        locale = _getState3.globals.locale,
        token = _getState3.user.token;

    return fetch(__WEBPACK_IMPORTED_MODULE_6_shared_constants_api__["a" /* default */].SUPPORT_SET_MAIL, {
      method: 'POST',
      body: JSON.stringify(data)
    }).then(function () {
      var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(res) {
        var status, dat;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                status = res.status;
                _context3.next = 3;
                return res.json();

              case 3:
                _context3.t0 = _context3.sent;

                if (_context3.t0) {
                  _context3.next = 6;
                  break;
                }

                _context3.t0 = {};

              case 6:
                dat = _context3.t0;

                if (status === 200) {
                  enqueueNotification(intl.formatMessage({
                    id: dat.message || 'Ваше письмо отправлено в Службу поддержки'
                  }));
                } else {
                  enqueueNotification(intl.formatMessage({
                    id: dat.message || 'Извините, произошла ошибка на сервере, попробуйте повторить операцию позже'
                  }));
                }

              case 8:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this);
      }));

      return function (_x8) {
        return _ref17.apply(this, arguments);
      };
    }()).catch(function (err) {
      enqueueNotification(intl.formatMessage({
        id: 'Извините, произошла ошибка на сервере, попробуйте повторить операцию позже'
      }));
    });
  };
};
var requestVinAdvertForm = function requestVinAdvertForm(_ref18, _ref19) {
  var values = _ref18.values,
      advert = _ref18.advert,
      callback = _ref18.callback;
  var enqueueNotification = _ref19.enqueueNotification,
      intl = _ref19.intl;
  return function (dispatch, getState, _ref20) {
    var fetch = _ref20.fetch;

    var _getState4 = getState(),
        locale = _getState4.globals.locale,
        _getState4$user = _getState4.user,
        token = _getState4$user.token,
        user = _getState4$user.user;

    return fetch(__WEBPACK_IMPORTED_MODULE_6_shared_constants_api__["a" /* default */].SET_VIN, {
      method: 'POST',
      headers: {
        Authorization: 'JWT ' + token
      },
      body: JSON.stringify({
        advert: advert.id,
        user: user.id,
        vin: advert.vin,
        contact_name: values.name,
        contact_phone: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["j" /* phoneNormalize */](user.phones && user.phones[0] && user.phones[0].number || values.phone),
        contact_email: values.email,
        make: advert.make.id,
        mileage: advert.mileage,
        comment: values.comment
      })
    }).then(function () {
      var _ref21 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(res) {
        var status, dat;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                status = res.status;
                _context4.next = 3;
                return res.json();

              case 3:
                _context4.t0 = _context4.sent;

                if (_context4.t0) {
                  _context4.next = 6;
                  break;
                }

                _context4.t0 = {};

              case 6:
                dat = _context4.t0;

                if (status === 201) {
                  callback(dat.id);
                } else {
                  enqueueNotification(intl.formatMessage({
                    id: dat.message || 'Извините, произошла ошибка на сервере, попробуйте повторить операцию позже'
                  }));
                }

              case 8:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this);
      }));

      return function (_x9) {
        return _ref21.apply(this, arguments);
      };
    }()).catch(function (err) {
      enqueueNotification(intl.formatMessage({
        id: 'Извините, произошла ошибка на сервере, попробуйте повторить операцию позже'
      }));
    });
  };
};
var requestLeasingForm = function requestLeasingForm(_ref22, _ref23) {
  var values = _ref22.values,
      advert = _ref22.advert,
      callback = _ref22.callback;
  var enqueueNotification = _ref23.enqueueNotification,
      intl = _ref23.intl;
  return function () {
    var _ref24 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(dispatch, getState, _ref25) {
      var fetch = _ref25.fetch;

      var _values$email, emailUser, _values$phone, phoneUser, _values$name, nameUser, _advert$id, id, _advert$make, _advert$make$title, make, _advert$model, _advert$model$title, model, _advert$year, year, _advert$price, price, _advert$mileage, mileage, _advert$characteristi, _advert$characteristi2, _advert$characteristi3, engine, _advert$characteristi4, _advert$characteristi5, gearbox, _advert$characteristi6, _advert$characteristi7, drive, _advert$color, _advert$color$title, color, _advert$location, _advert$location$titl, location, _advert$description, description, _advert$contact_name, contactName, _advert$author$first_, firstName, _advert$photos, photos, _advert$permalink, advertUrl, isNotCleared, vab_leasing_monthly_payment, vab_leasing_months_count, _getState5, locale, _getState5$user, token, user, priceFilter, phone;

      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _values$email = values.email, emailUser = _values$email === undefined ? '' : _values$email, _values$phone = values.phone, phoneUser = _values$phone === undefined ? '' : _values$phone, _values$name = values.name, nameUser = _values$name === undefined ? '' : _values$name;
              _advert$id = advert.id, id = _advert$id === undefined ? '' : _advert$id, _advert$make = advert.make;
              _advert$make = _advert$make === undefined ? {} : _advert$make;
              _advert$make$title = _advert$make.title, make = _advert$make$title === undefined ? '' : _advert$make$title, _advert$model = advert.model;
              _advert$model = _advert$model === undefined ? {} : _advert$model;
              _advert$model$title = _advert$model.title, model = _advert$model$title === undefined ? '' : _advert$model$title, _advert$year = advert.year, year = _advert$year === undefined ? '' : _advert$year, _advert$price = advert.price, price = _advert$price === undefined ? [] : _advert$price, _advert$mileage = advert.mileage, mileage = _advert$mileage === undefined ? '' : _advert$mileage, _advert$characteristi = advert.characteristics;
              _advert$characteristi = _advert$characteristi === undefined ? {} : _advert$characteristi;
              _advert$characteristi2 = _advert$characteristi.engine;
              _advert$characteristi2 = _advert$characteristi2 === undefined ? {} : _advert$characteristi2;
              _advert$characteristi3 = _advert$characteristi2.title, engine = _advert$characteristi3 === undefined ? '' : _advert$characteristi3, _advert$characteristi4 = _advert$characteristi.gearbox;
              _advert$characteristi4 = _advert$characteristi4 === undefined ? {} : _advert$characteristi4;
              _advert$characteristi5 = _advert$characteristi4.title, gearbox = _advert$characteristi5 === undefined ? '' : _advert$characteristi5, _advert$characteristi6 = _advert$characteristi.drive;
              _advert$characteristi6 = _advert$characteristi6 === undefined ? {} : _advert$characteristi6;
              _advert$characteristi7 = _advert$characteristi6.title, drive = _advert$characteristi7 === undefined ? '' : _advert$characteristi7, _advert$color = advert.color;
              _advert$color = _advert$color === undefined ? {} : _advert$color;
              _advert$color$title = _advert$color.title, color = _advert$color$title === undefined ? '' : _advert$color$title, _advert$location = advert.location;
              _advert$location = _advert$location === undefined ? {} : _advert$location;
              _advert$location$titl = _advert$location.title, location = _advert$location$titl === undefined ? '' : _advert$location$titl, _advert$description = advert.description, description = _advert$description === undefined ? '' : _advert$description, _advert$contact_name = advert.contact_name, contactName = _advert$contact_name === undefined ? '' : _advert$contact_name, _advert$author$first_ = advert.author.first_name, firstName = _advert$author$first_ === undefined ? '' : _advert$author$first_, _advert$photos = advert.photos, photos = _advert$photos === undefined ? [] : _advert$photos, _advert$permalink = advert.permalink, advertUrl = _advert$permalink === undefined ? '' : _advert$permalink, isNotCleared = advert.is_not_cleared, vab_leasing_monthly_payment = advert.vab_leasing_monthly_payment, vab_leasing_months_count = advert.vab_leasing_months_count;
              _getState5 = getState(), locale = _getState5.globals.locale, _getState5$user = _getState5.user, token = _getState5$user.token, user = _getState5$user.user;
              priceFilter = price.filter(function (a) {
                return a.currency === 'uah';
              });
              _context7.next = 22;
              return fetch(__WEBPACK_IMPORTED_MODULE_6_shared_constants_api__["a" /* default */].GET_PHONE(id)).then(function () {
                var _ref26 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(res) {
                  return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          return _context5.abrupt('return', res.json());

                        case 1:
                        case 'end':
                          return _context5.stop();
                      }
                    }
                  }, _callee5, _this);
                }));

                return function (_x13) {
                  return _ref26.apply(this, arguments);
                };
              }()).catch(function (err) {
                enqueueNotification(intl.formatMessage({
                  id: 'Извините, произошла ошибка на сервере, попробуйте повторить операцию позже'
                }));
              });

            case 22:
              _context7.t0 = _context7.sent;

              if (_context7.t0) {
                _context7.next = 25;
                break;
              }

              _context7.t0 = [];

            case 25:
              phone = _context7.t0;
              _context7.next = 28;
              return fetch(__WEBPACK_IMPORTED_MODULE_6_shared_constants_api__["a" /* default */].LEASING, {
                method: 'POST',
                headers: {},
                body: JSON.stringify({
                  id: id,
                  make: make,
                  model: model,
                  year: year,
                  price: priceFilter && priceFilter[0] && priceFilter[0].value,
                  mileage: mileage,
                  engine: engine,
                  gearbox: gearbox,
                  drive: drive,
                  color: color,
                  custom_cleared: !isNotCleared,
                  description: description,
                  seller_name: firstName || contactName,
                  seller_phone: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["j" /* phoneNormalize */](phone[0]),
                  seller_email: '',
                  contact_name: nameUser,
                  contact_phone: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["j" /* phoneNormalize */](phoneUser),
                  contact_email: emailUser,
                  location: location,
                  photos: [].concat(_toConsumableArray(photos.map(function (a) {
                    return a.image;
                  }))),
                  advert_url: '' + URL + advertUrl,
                  vab_leasing_monthly_payment: vab_leasing_monthly_payment,
                  vab_leasing_months_count: vab_leasing_months_count
                })
              }).then(function () {
                var _ref27 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(res) {
                  var status, dat;
                  return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                      switch (_context6.prev = _context6.next) {
                        case 0:
                          status = res.status;
                          _context6.next = 3;
                          return res.json();

                        case 3:
                          _context6.t0 = _context6.sent;

                          if (_context6.t0) {
                            _context6.next = 6;
                            break;
                          }

                          _context6.t0 = {};

                        case 6:
                          dat = _context6.t0;

                          if (status === 200) {
                            callback();
                            enqueueNotification(intl.formatMessage({
                              id: dat.message || 'Успешно'
                            }));
                          } else {
                            enqueueNotification(intl.formatMessage({
                              id: dat.message || 'Извините, произошла ошибка на сервере, попробуйте повторить операцию позже'
                            }));
                          }

                        case 8:
                        case 'end':
                          return _context6.stop();
                      }
                    }
                  }, _callee6, _this);
                }));

                return function (_x14) {
                  return _ref27.apply(this, arguments);
                };
              }()).catch(function (err) {
                enqueueNotification(intl.formatMessage({
                  id: 'Извините, произошла ошибка на сервере, попробуйте повторить операцию позже'
                }));
              });

            case 28:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this);
    }));

    return function (_x10, _x11, _x12) {
      return _ref24.apply(this, arguments);
    };
  }();
};
var requestAutobooking = function requestAutobooking(_ref28, _ref29) {
  var autobookingId = _ref28.autobookingId,
      callback = _ref28.callback;
  var enqueueNotification = _ref29.enqueueNotification,
      intl = _ref29.intl;
  return function (dispatch, getState, _ref30) {
    var fetch = _ref30.fetch;

    fetch('https://autobooking.com/widgets/available/order?station_id=' + autobookingId).then(function () {
      var _ref31 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(res) {
        var status;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                status = res.status;

                if (status === 200) {
                  callback();
                } else {
                  enqueueNotification(intl.formatMessage({
                    id: 'Запись на СТО временно недоступна'
                  }));
                }

              case 2:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this);
      }));

      return function (_x15) {
        return _ref31.apply(this, arguments);
      };
    }()).catch(function (err) {
      enqueueNotification(intl.formatMessage({
        id: 'Извините, произошла ошибка на сервере, попробуйте повторить операцию позже'
      }));
    });
  };
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(250)))

/***/ }),

/***/ 485:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContextConsumer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Context = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext();

var ContextType = _extends({
  // Enables critical path CSS rendering
  // https://github.com/kriasoft/isomorphic-style-loader
  insertCss: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  // Universal HTTP client
  fetch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
}, __WEBPACK_IMPORTED_MODULE_2_react_redux__["a" /* Provider */].childContextTypes);

var ContextConsumer = Context.Consumer;

/**
 * The top-level React component setting context (global) variables
 * that can be accessed from all the child components.
 *
 * https://facebook.github.io/react/docs/context.html
 *
 * Usage example:
 *
 *   const context = {
 *     history: createBrowserHistory(),
 *     store: createStore(),
 *   };
 *
 *   ReactDOM.render(
 *     <App context={context}>
 *       <Layout>
 *         <LandingPage />
 *       </Layout>
 *     </App>,
 *     container,
 *   );
 */

var App = function (_React$PureComponent) {
  _inherits(App, _React$PureComponent);

  function App() {
    _classCallCheck(this, App);

    return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
  }

  _createClass(App, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        insertCss: this.props.context.insertCss
      };
    }

    // Using the legacy context API for isomorphic-style-loader until it gets updated

  }, {
    key: 'render',
    value: function render() {
      // NOTE: If you need to add or modify header, footer etc. of the app,
      // please do that inside the Layout component.

      var _props$context = this.props.context,
          store = _props$context.store,
          context = _objectWithoutProperties(_props$context, ['store']);

      return _jsx(Context.Provider, {
        value: context
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2_react_redux__["a" /* Provider */], {
        store: store
      }, void 0, __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.only(this.props.children)));
    }
  }]);

  return App;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

App.childContextTypes = {
  insertCss: ContextType.insertCss
};


/* harmony default export */ __webpack_exports__["b"] = (App);

/***/ }),

/***/ 488:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export redirectToLoginIfNotLoggedIn */
/* unused harmony export validateRedirectUrl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return loggedInRedirect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchJournalRubrics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isValidLeasingLocationRoute; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_network_journal__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_leasingLinksPopularCities_json__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_leasingLinksPopularCities_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shared_constants_json_leasingLinksPopularCities_json__);
var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }





var redirectToLoginIfNotLoggedIn = function redirectToLoginIfNotLoggedIn(_ref) {
  var next = _ref.next,
      store = _ref.store;

  var token = store.getState().user.token;

  if (!token) {
    return {
      redirect: '/login/'
    };
  }

  return next();
};

var validateRedirectUrl = function validateRedirectUrl(url) {
  if (!url) {
    return null;
  }

  var ALLOWED_HOSTS = ['https://sto.avtobazar.ua', 'http://sto.desktop.s3.ua', 'http://desktop.s3.ua', 'http://localhost'];

  if (!url.startsWith('/') && !ALLOWED_HOSTS.some(function (host) {
    return url.startsWith(host);
  })) {
    return null;
  }

  return url.replace(/^\/+/, '/');
};

var loggedInRedirect = function loggedInRedirect(_ref2) {
  var next = _ref2.next,
      query = _ref2.query,
      store = _ref2.store;

  var _store$getState = store.getState(),
      user = _store$getState.user;

  var redirectUrl = query.redirectUrl;


  if (user && user.token) {
    return {
      redirect: validateRedirectUrl(redirectUrl) || '/my'
    };
  }

  return next();
};

var fetchJournalRubrics = function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref4) {
    var store = _ref4.store,
        fetch = _ref4.fetch;
    var rubrics;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return store.getState().globals.journal.rubrics || __WEBPACK_IMPORTED_MODULE_1_shared_network_journal__["d" /* fetchRubrics */](fetch);

          case 2:
            rubrics = _context.sent;


            store.dispatch(__WEBPACK_IMPORTED_MODULE_0_shared_actions_globals__["h" /* journal */].setRubrics(rubrics));

            return _context.abrupt('return', undefined);

          case 5:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function fetchJournalRubrics(_x) {
    return _ref3.apply(this, arguments);
  };
}();

var isValidLeasingLocationRoute = function isValidLeasingLocationRoute(route, location) {
  if (route !== '/leasing/') return true;
  var slug = '' + route + location + '/';
  var avaliable = __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_leasingLinksPopularCities_json___default.a.items.find(function (item) {
    return item.slug === slug;
  });
  return avaliable;
};

/***/ }),

/***/ 489:
/***/ (function(module, exports) {

module.exports = {"title":"Купить в Украине автомобили в лизинг","uk_title":"Купити в Україні автомобілі в лізинг","items":[{"id":1,"title":"Авто в лизинг в Киеве","uk_title":"Авто в лізинг у Києві","slug":"/leasing/kiev/"},{"id":2,"title":"Авто в лизинг в Николаеве","uk_title":"Авто в лізинг у Миколаєві ","slug":"/leasing/nikolaev/"},{"id":3,"title":"Авто в лизинг в Виннице","uk_title":"Авто в лізинг у Вінниці","slug":"/leasing/vinnitsa/"},{"id":4,"title":"Авто в лизинг в Сумы","uk_title":"Авто в лізинг у Суми","slug":"/leasing/sumy/"},{"id":5,"title":"Авто в лизинг в Запорожье","uk_title":"Авто в лізинг у Запоріжжі","slug":"/leasing/zaporozhye/"},{"id":6,"title":"Авто в лизинг в Харькове","uk_title":"Авто в лізинг у Харкові","slug":"/leasing/kharkov/"},{"id":7,"title":"Авто в лизинг в Одессе","uk_title":"Авто в лізинг у Одесі","slug":"/leasing/odessa/"},{"id":8,"title":"Авто в лизинг в Днепре","uk_title":"Авто в лізинг у Дніпрі","slug":"/leasing/dnepr/"},{"id":9,"title":"Авто в лизинг в Херсоне","uk_title":"Авто в лізинг у Херсоні","slug":"/leasing/kherson/"},{"id":10,"title":"Авто в лизинг в Кривом роге","uk_title":"Авто в лізинг у Кривому Розі","slug":"/leasing/krivoy-rog/"},{"id":11,"title":"Авто в лизинг в Кировограде","uk_title":"Авто в лізинг у Кіровограді","slug":"/leasing/kropivnitskiy-kirovograd/"},{"id":12,"title":"Авто в лизинг в Ровно","uk_title":"Авто в лізинг у Ровно","slug":"/leasing/rovno/"},{"id":13,"title":"Авто в лизинг в Житомире","uk_title":"Авто в лізинг у Житомирі","slug":"/leasing/zhitomir/"},{"id":14,"title":"Авто в лизинг в Хмельницкий","uk_title":"Авто в лізинг у Хмельницький","slug":"/leasing/hmelnitskiy/"},{"id":15,"title":"Авто в лизинг во Львове","uk_title":"Авто в лізинг у Львові","slug":"/leasing/lvov/"},{"id":16,"title":"Авто в лизинг Черкассы","uk_title":"Авто в лізинг Черкаси","slug":"/leasing/cherkassy/"},{"id":17,"title":"Авто в лизинг Чернигов","uk_title":"Авто в лізинг Чернігів","slug":"/leasing/chernigov/"},{"id":18,"title":"Авто в лизинг в Черновцах","uk_title":"Авто в лізинг у Чернівцях","slug":"/leasing/chernovtsy/"}]}

/***/ }),

/***/ 491:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fireRTBPageView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fireRTBEvent; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var HASH = 'oZ9ydSmxeFpexElLvEco';
var ORDERID = new Date().getTime();

function getOrderId() {
  try {
    if (window && window.ga) {
      var gtms = window.ga.getAll();
      return gtms[gtms.length - 1].get('_ti');
    }
  } catch (err) {}
  return ORDERID;
}

function runScrpt() {
  var rtbhTags = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  try {
    var prefix = '';
    var key = '__rtbhouse.lid';
    var lid = window.localStorage.getItem(key);

    if (!lid) {
      lid = '';
      var pool = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      for (var i = 0; i < 20; i += 1) {
        lid += pool.charAt(Math.floor(Math.random() * pool.length));
      }window.localStorage.setItem(key, lid);
    }

    rtbhTags.push('pr_' + HASH + '_lid_' + lid);

    var ifr = document.createElement('iframe');
    var sr = encodeURIComponent(document.referrer ? document.referrer : '');
    var su = encodeURIComponent(document.location.href ? document.location.href : '');
    var ifrSrc = 'https://' + prefix + 'creativecdn.com/tags?type=iframe';
    var tmstmp = encodeURIComponent('' + Date.now());

    for (var _i = 0; _i < rtbhTags.length; _i += 1) {
      ifrSrc += '&id=' + encodeURIComponent(rtbhTags[_i]);
    }
    ifrSrc += '&su=' + su + '&sr=' + sr + '&ts=' + tmstmp;
    ifr.setAttribute('src', ifrSrc);
    ifr.setAttribute('width', '1');
    ifr.setAttribute('height', '1');
    ifr.setAttribute('scrolling', 'no');
    ifr.setAttribute('frameBorder', '0');
    ifr.setAttribute('style', 'display:none');
    ifr.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');
    if (document.body) {
      document.body.appendChild(ifr);
    } else {
      window.addEventListener('DOMContentLoaded', function () {
        document.body.appendChild(ifr);
      });
    }
  } catch (e) {}
}

function fireEvent() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var orderId = params.orderId,
      value = params.value,
      event = params.event,
      category = params.category;
  var ids = params.ids;

  if (!Array.isArray(ids)) ids = [];

  var tag = 'pr_' + HASH;

  if (category) tag += '_' + category;

  if (value) tag += '_' + (value.replace ? value.replace(/\s+/g, '') : value);else if (category === 'orderstatus2') tag += '_1';

  if (orderId) tag += '_' + orderId;
  if (event) tag += '-' + event;
  if (ids && ids.length) tag += '_' + ids.join(',');

  runScrpt([tag]);
}

function homePageView() {
  fireEvent({ category: 'home' });
}

function otherPageView(params) {
  // fireEvent({
  //   orderId: getOrderId(),
  //   ...params,
  //   event: 'websitevisit_1',
  //   category: 'orderstatus2',
  // });
  fireEvent();
}

function fireEventLeasing(params) {
  fireEvent(_extends({
    orderId: getOrderId()
  }, params, {
    event: 'leasing',
    category: 'orderstatus2'
  }));
}

function fireEventLeasingOld(params) {
  fireEvent(_extends({
    orderId: getOrderId()
  }, params, {
    event: 'leasingold',
    category: 'orderstatus2'
  }));
}

function fireEventLeasingNew(params) {
  fireEvent(_extends({
    orderId: getOrderId()
  }, params, {
    event: 'leasingnew',
    category: 'orderstatus2'
  }));
}

function fireEventTestDrive(params) {
  fireEvent(_extends({
    orderId: getOrderId()
  }, params, {
    event: 'testdrive',
    category: 'orderstatus2'
  }));
}

function fireEventTradeIn(params) {
  fireEvent(_extends({
    orderId: getOrderId()
  }, params, {
    event: 'tradein',
    category: 'orderstatus2'
  }));
}

function fireEventCallback(params) {
  fireEvent(_extends({
    orderId: getOrderId()
  }, params, {
    event: 'callback',
    category: 'orderstatus2'
  }));
}

function fireEventShownumber(params) {
  fireEvent(_extends({
    orderId: getOrderId()
  }, params, {
    event: 'shownumber',
    category: 'orderstatus2'
  }));
}

function fireEventPartsShownumber(params) {
  fireEvent(_extends({
    orderId: getOrderId()
  }, params, {
    event: 'partshownumber',
    category: 'orderstatus2'
  }));
}

function fireEventCategory(params) {
  fireEvent(_extends({}, params, { category: 'category2' }));
}

function fireEventOffer(params) {
  fireEvent(_extends({}, params, { category: 'offer' }));
}

var fireRTBPageView = function fireRTBPageView(path) {
  var pages = {
    '/': homePageView
  };
  var categories = ['avto', 'mototsikl', 'skuter', 'kvadrotsikl', 'karting', 'moped', 'baggi', 'tritsikl', 'gruzovye', 'avtobus', 'pritsepy', 'spetstehnika', 'commercial', 'moto', 'vodnyi-transport', 'snegohod', 'vezdehod'];

  if (pages[path]) return pages[path]();
  var pathes = path.trim().split('/').filter(function (str) {
    return !!str;
  });
  if (pathes && categories.includes(pathes[0])) {
    return fireEventCategory({
      value: path
    });
  }
  var lastPath = Array.isArray(pathes) && pathes.pop();
  if (lastPath && /\.html$/.test(lastPath)) {
    var adv = lastPath.match(/(\d+)-*(\d)?\.html$/);
    if (adv[1]) return fireEventOffer({ ids: [adv[1]] });
  }

  otherPageView();
};

var fireRTBEvent = function fireRTBEvent(name, params) {
  var events = {
    leasing: fireEventLeasing,
    leasingOld: fireEventLeasingOld,
    leasingNew: fireEventLeasingNew,
    formTestDrive: fireEventTestDrive,
    formTradeIn: fireEventTradeIn,
    formCallback: fireEventCallback,
    category: fireEventCategory,
    showNumber: fireEventShownumber,
    showPartsNumber: fireEventPartsShownumber
  };
  if (events[name]) events[name](params);
};

/***/ }),

/***/ 493:
/***/ (function(module, exports) {

module.exports = [{"title":"Возможен обмен","id":"is_swap"},{"title":"Безналичный расчёт","id":"is_cashless"},{"title":"Аренда","id":"is_rent"}]

/***/ }),

/***/ 494:
/***/ (function(module, exports) {

module.exports = [{"id":1,"title":"л"},{"id":0,"title":"куб. см"}]

/***/ }),

/***/ 495:
/***/ (function(module, exports) {

module.exports = [{"id":1,"title":"л.с."},{"id":0,"title":"кВт"}]

/***/ }),

/***/ 496:
/***/ (function(module, exports) {

module.exports = [{"title":"после ДТП","id":"is_crashed"},{"title":"кредитный","id":"is_under_loan"},{"title":"продажа в кредит","id":"is_sale_on_credit"},{"title":"нерастаможен","id":"is_not_cleared","isNotCompatibleWithAbroad":true},{"title":"с аукциона","id":"from_auction"},{"title":"новый","id":"is_new","forBusinessUsersOnly":true}]

/***/ }),

/***/ 497:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EVENT_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return OBJECT_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AGGREGATION_FIELDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return INTERVALS; });
var EVENT_TYPES = {
  VIEW: 'view',
  PHONE_CLICK: 'click-phone',
  REDIRECT: 'redirect'
};

var OBJECT_TYPES = {
  ADVERT: 'advert',
  AGENCY: 'agency',
  SPARE_PART: 'sparepart'
};

var AGGREGATION_FIELDS = {
  USER: 'user',
  OBJECT: 'object',
  FINGERPRINT: 'fingerprint'
};

var INTERVALS = {
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
  YEAR: 'year'
};

/***/ }),

/***/ 499:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getGoogleCaptchaToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getGoogleCaptchaTokenV2; });
var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var widgetCaptcha = false;
var getGoogleCaptchaToken = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'submit';
    var ready, gr;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(typeof window === 'undefined')) {
              _context.next = 2;
              break;
            }

            return _context.abrupt('return', Promise.resolve(''));

          case 2:
            ready = function ready(cb) {
              if (typeof grecaptcha === 'undefined') {
                var c = '___grecaptcha_cfg';
                window[c] = window[c] || {};
                (window[c].fns = window[c].fns || []).push(cb);
              } else {
                cb();
              }
            };

            gr = typeof grecaptcha === 'undefined' ? { ready: ready } : grecaptcha;
            return _context.abrupt('return', new Promise(function (resolve, reject) {
              gr.ready(function () {
                gr.execute('6LdWm20eAAAAAOdt2VXiYuupWU9DNobcIUVES4wK', { action: action }).then(resolve).catch(reject);
              });
            }));

          case 5:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function getGoogleCaptchaToken() {
    return _ref.apply(this, arguments);
  };
}();

var getGoogleCaptchaTokenV2 = function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'captcha';
    var onReady = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
    var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
    var ready, gr;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(typeof window === 'undefined' || !document.getElementById(id))) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt('return', Promise.resolve(''));

          case 2:
            ready = function ready(cb) {
              if (typeof grecaptcha === 'undefined') {
                var c = '___grecaptcha_cfg';
                window[c] = window[c] || {};
                (window[c].fns = window[c].fns || []).push(cb);
              } else {
                cb();
              }
            };

            gr = typeof grecaptcha === 'undefined' ? { ready: ready } : grecaptcha;
            return _context2.abrupt('return', new Promise(function (resolve, reject) {
              gr.ready(function () {
                try {
                  if (widgetCaptcha !== false) {
                    gr.reset(widgetCaptcha);
                    return;
                  }
                  widgetCaptcha = gr.render(id, {
                    sitekey: '6LfbjpceAAAAAKewRjU4XYRjUDIzqeSKnr0v-HWf',
                    // theme: 'dark',
                    callback: function callback(token) {
                      resolve(token);
                      cb(token);
                    },
                    'expired-callback': function expiredCallback(error) {
                      reject();
                      cb();
                    },
                    'error-callback': function errorCallback(error) {
                      reject();
                      cb();
                    }
                  });
                } catch (error) {
                  reject(error);
                }
                onReady(gr);
              });
            }));

          case 5:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function getGoogleCaptchaTokenV2() {
    return _ref2.apply(this, arguments);
  };
}();

/***/ }),

/***/ 502:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setPreviousPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setCurrentRouteName; });
/* unused harmony export setPreviousRouteName */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setCurrentPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setNextSearchItemIndex; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__ = __webpack_require__(17);
/* eslint-disable import/prefer-default-export */




var setPreviousPath = function setPreviousPath(path) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["e" /* HISTORY */].PREVIOUS_PATH_SET,
    payload: path
  };
};

var setCurrentRouteName = function setCurrentRouteName(name) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["e" /* HISTORY */].CURRENT_ROUTE_NAME_SET,
    payload: name
  };
};

var setPreviousRouteName = function setPreviousRouteName(name) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["e" /* HISTORY */].PREVIOUS_ROUTE_NAME_SET,
    payload: name
  };
};

var setCurrentPath = function setCurrentPath(path) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["e" /* HISTORY */].CURRENT_PATH_SET,
    payload: path
  };
};

var setNextSearchItemIndex = __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["e" /* HISTORY */].NEXT_SEARCH_ITEM_INDEX);

/***/ }),

/***/ 503:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  title: 'Разместить рекламу',
  route: '/advertising/',
  slug: '/advertising/',
  id: 1,
  parent: null
}, {
  title: 'Автосалонам',
  route: '/for-dealers/',
  slug: '/for-dealers/',
  id: 2,
  parent: null
}, {
  title: 'Бизнесу',
  route: '/biznes-paket/',
  slug: '/biznes-paket/',
  id: 2003180232,
  parent: null
}, {
  title: 'Запчасти',
  route: '/info-zapchasti/',
  slug: '/info-zapchasti/',
  id: 2103181339,
  parent: null
}, {
  title: 'Автосервисам',
  route: '/for-services/',
  slug: '/for-services/',
  id: 3,
  parent: null
}, {
  title: 'Услуги для частных лиц',
  route: '/for-privates/',
  slug: '/for-privates/',
  id: 2103181356,
  parent: null
}, {
  title: 'Публичный договор',
  route: '/public-contract/',
  slug: '/public-contract/',
  id: null,
  parent: null
}, {
  title: 'Правила публикации объявлений',
  route: '/advertising-conditions/',
  slug: '/advertising-conditions/',
  id: null,
  parent: null
}, {
  title: 'Политика конфиденциальности',
  route: '/law/',
  slug: '/law/',
  id: 11,
  parent: null
}, {
  title: 'О проекте',
  route: '/about/',
  slug: '/about/',
  id: 6,
  parent: null
}, {
  title: 'Помощь',
  route: '/help/',
  slug: '/help/',
  id: 4,
  parent: null
}]);

/***/ }),

/***/ 510:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/helpers/DOM.js
var isAnyPartOfElementInViewport = function isAnyPartOfElementInViewport(el) {
  if (el.style.display === 'none') {
    return false;
  }

  if (el && el.getBoundingClientRect) {
    var rect = el.getBoundingClientRect();
    // DOMRect { x: 8, y: 8, width: 100, height: 100, top: 8, right: 108, bottom: 108, left: 8 }
    var windowHeight = window.innerHeight || document.documentElement.clientHeight;
    var windowWidth = window.innerWidth || document.documentElement.clientWidth;

    // http://stackoverflow.com/questions/325933/determine-whether-two-date-ranges-overlap
    var vertInView = rect.top <= windowHeight && rect.top + rect.height >= 0;
    var horInView = rect.left <= windowWidth && rect.left + rect.width >= 0;

    return vertInView && horInView;
  }

  return false;
};

var onIdle = function onIdle(callback, ms) {
  var timeout = void 0;

  var resetTimer = function resetTimer() {
    clearTimeout(timeout);
    timeout = setTimeout(callback, ms);
  };

  window.addEventListener('scroll', resetTimer);
  window.addEventListener('mousemove', resetTimer);
  window.addEventListener('mousedown', resetTimer);
  window.addEventListener('touchstart', resetTimer);
  window.addEventListener('click', resetTimer);
  window.addEventListener('keypress', resetTimer);
};
// CONCATENATED MODULE: ./src/shared/helpers/adsAndMetrics.js
/* unused harmony export initializeAdScripts */
/* unused harmony export refreshDFPSlots */
/* unused harmony export refreshVisibleDFPSlots */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAdsContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPriceValuation; });
/* unused harmony export getAdsContextFromQuery */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_once__ = __webpack_require__(1145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_once___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_once__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable no-underscore-dangle */





var initDFP = function initDFP() {
  //
};

// export const updateBranding = cb => {
//   Array.from(document.getElementsByTagName('script')).forEach(script => {
//     if (!/a4p\.adpartner\.pro\/branding/.test(script.src)) return;
//     script.parentElement.removeChild(script);
//   });

//   const apmobhtml = document.getElementById('apmobhtml');
//   const apBrandingHtml = document.getElementById('ap_branding_html');
//   const apbranding = document.getElementById('apbranding');

//   if (apmobhtml) apmobhtml.parentElement.removeChild(apmobhtml);
//   if (apBrandingHtml) apBrandingHtml.parentElement.removeChild(apBrandingHtml);
//   if (apbranding) apbranding.style = '';

//   const div = document.createElement('div');
//   const body = document.getElementsByTagName('body')[0];
//   const script = document.createElement('script');
//   script.src = `//a4p.adpartner.pro/branding?id=7742&${Math.random()}`;
//   script.type = 'text/javascript';
//   script.async = true;
//   script.onload = cb || null;
//   div.id = 'adpartner-branding-7742';
//   div.appendChild(script);
//   body.appendChild(div);
//   console.log('updateBranding');
// };

// export const toggleHalfScreen = (show = false) => {
//   const adpartner7741 = document.getElementById('adpartner_7741');
//   if (!adpartner7741) return;
//   adpartner7741.style.display = show ? 'block' : 'none';
// };

// export const removeHalfScreen = () => {
//   Array.from(document.getElementsByTagName('script')).forEach(script => {
//     if (!/a4p\.adpartner\.pro\/media/.test(script.src)) return;
//     script.parentElement.removeChild(script);
//   });

//   const adpartner7741 = document.getElementById('adpartner_7741');
//   if (adpartner7741) adpartner7741.parentElement.removeChild(adpartner7741);
// };

// export const updateHalfScreen = cb => {
//   removeHalfScreen();
//   const body = document.getElementsByTagName('body')[0];
//   const script = document.createElement('script');
//   script.src = `//a4p.adpartner.pro/media?site_id=2370&unit_id=7741`;
//   script.type = 'text/javascript';
//   script.async = true;
//   script.onload = cb || null;
//   body.appendChild(script);
//   console.log('updateHalfScreen');
// };

var initializeAdScripts = __WEBPACK_IMPORTED_MODULE_0_lodash_once___default.a(function () {
  initDFP();
});

var refreshDFPSlots = function refreshDFPSlots() {};

var adsAndMetrics_refreshVisibleDFPSlots = function refreshVisibleDFPSlots() {
  if (true) {
    Array.from(document.querySelectorAll('.adBox')).filter(function (el) {
      return isAnyPartOfElementInViewport ||
      // If the element's display property set to 'none'
      //  match hidden nodes that are actually in the viewport by the parentNode
      el.style.display === 'none' && isAnyPartOfElementInViewport(el.parentNode);
    }).map(function (_ref) {
      var id = _ref.id;
      return id;
    });
  }
};
var getAdsContext = function getAdsContext(query) {
  var make = query.make,
      model = query.model,
      isMain = query.isMain,
      isNew = query.isNew,
      rubric = query.rubric,
      isCustomCleared = query.isCustomCleared,
      location = query.location,
      isCountry = query.isCountry,
      transport = query.transport,
      category = query.category,
      engine = query.engine,
      dealer = query.dealer,
      price = query.price,
      page = query.page,
      id = query.id;


  var locationObj = _extends({}, isCountry && location && location.slug ? { country: location.slug } : {}, !isCountry && location && location.slug ? { region: location.slug } : {});

  return _extends({}, transport && transport.slug ? { category: transport.slug } : {}, category && category.slug ? { body: category.slug } : {}, engine && engine.slug ? { fuel: engine.slug } : {}, make && make.slug ? { make: make.slug } : {}, model && model.slug ? { model: model.slug } : {}, model && model.model_class && model.model_class.slug ? { class: model.model_class.slug } : {}, rubric && rubric.slug ? { rubric: rubric.slug } : {}, dealer && dealer.slug ? { login: dealer.slug } : {}, price ? { price: price } : {}, page ? { page: page } : {}, id ? { adid: id } : {}, isMain ? { page: 'main' } : {}, locationObj, isNew !== undefined && isNew !== null ? { new_car: isNew ? 1 : 0 } : {}, isCustomCleared !== undefined && isCustomCleared !== null ? { customs: isCustomCleared ? 1 : 0 } : {});
};

var getPriceValuation = function getPriceValuation(_ref2) {
  var from = _ref2.from,
      to = _ref2.to;
  var currency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'uah';

  var course = void 0;
  if (currency === 'uah') {
    course = 1 / 26;
  } else if (currency === 'usd') {
    course = 1;
  } else if (currency === 'eur') {
    course = 26 / 32;
  }

  var usdPrice = to || from;
  var price = void 0;
  if (!course || !usdPrice) {
    return null;
  }

  if (usdPrice <= 3000) {
    price = 1;
  } else if (usdPrice <= 6000) {
    price = 2;
  } else if (usdPrice <= 7000) {
    price = 3;
  } else if (usdPrice <= 12000) {
    price = 4;
  } else if (usdPrice <= 20000) {
    price = 5;
  } else if (usdPrice <= 30000) {
    price = 6;
  } else if (usdPrice <= 40000) {
    price = 7;
  } else if (usdPrice > 50000) {
    price = 8;
  }
  if (to) {
    var priceTo = '';
    for (var a = 0, c = price; a < c; a += 1) {
      if (!priceTo) {
        priceTo = '' + (a + 1);
      } else {
        priceTo += ',' + (a + 1);
      }
    }
    return priceTo.replace(/,$/, '');
  }
  return price;
};

var getAdsContextFromQuery = function getAdsContextFromQuery(query) {
  var make = query.make,
      model = query.model,
      isNew = query.isNew,
      rubric = query.rubric,
      isCustomCleared = query.isCustomCleared,
      location = query.location,
      isCountry = query.isCountry,
      transport = query.transport,
      category = query.category,
      engine = query.engine,
      dealer = query.dealer,
      priceFrom = query.priceFrom,
      currency = query.currency,
      page = query.page,
      id = query.id;


  var locationObj = _extends({}, isCountry && location ? { country: location } : {}, !isCountry && location ? { region: location } : {});

  return _extends({}, transport ? { category: transport } : {}, category ? { body: category } : {}, engine ? { fuel: engine } : {}, make ? { make: make } : {}, model ? { model: model } : {}, model && model.model_class && model.model_class.slug ? { class: model.model_class.slug } : {}, page ? { page: page } : {}, id ? { adid: id } : {}, rubric ? { rubric: rubric } : {}, dealer ? { login: dealer } : {}, priceFrom && currency ? { price: getPriceValuation({ from: priceFrom }, currency) } : {}, locationObj, isNew !== undefined ? { new_car: isNew } : {}, isCustomCleared !== undefined ? { customs: isCustomCleared } : {});
};

/***/ }),

/***/ 513:
/***/ (function(module, exports) {

module.exports = [{"id":29834,"slug":"ar-krym","title":"АР Крым","uk_title":"АР Крим","is_city":false,"is_region":true,"is_country":false,"is_admin_center":false,"children":[{"id":115727,"slug":"alupka","title":"Алупка","uk_title":"Алупка","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115728,"slug":"alushta","title":"Алушта","uk_title":"Алушта","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115729,"slug":"armyansk","title":"Армянск","uk_title":"Армянськ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115730,"slug":"bahchisaray","title":"Бахчисарай","uk_title":"Бахчисарай","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115731,"slug":"belogorsk","title":"Белогорск","uk_title":"Білогірськ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115732,"slug":"dzhankoy","title":"Джанкой","uk_title":"Джанкой","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115733,"slug":"evpatoriya","title":"Евпатория","uk_title":"Євпаторія","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115734,"slug":"kerch","title":"Керчь","uk_title":"Керч","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115735,"slug":"krasnoperekopsk","title":"Красноперекопск","uk_title":"Красноперекопськ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115736,"slug":"saki","title":"Саки","uk_title":"Саки","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":5180,"slug":"sevastopol","title":"Севастополь","uk_title":"Севастопіль","is_city":false,"is_region":false,"is_country":false,"is_admin_center":false},{"id":2029,"slug":"simferopol","title":"Симферополь","uk_title":"Сімферополь","is_city":true,"is_region":false,"is_country":false,"is_admin_center":true},{"id":115737,"slug":"sudak","title":"Судак","uk_title":"Судак","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115738,"slug":"feodosiya","title":"Феодосия","uk_title":"Феодосія","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115739,"slug":"shchyolkino","title":"Щелкино","uk_title":"Щолкіне","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115740,"slug":"yalta","title":"Ялта","uk_title":"Ялта","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116097,"slug":"staryi-krym","title":"Старый Крым","uk_title":"Старий Крим","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false}]},{"id":116051,"slug":"vinnytska-oblast","title":"Винницкая область","uk_title":"Вінницька область","is_city":false,"is_region":true,"is_country":false,"is_admin_center":false,"children":[{"id":115914,"slug":"bar","title":"Бар","uk_title":"Бар","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115915,"slug":"bershad","title":"Бершадь","uk_title":"Бершадь","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115916,"slug":"gaysin","title":"Гайсин","uk_title":"Гайсин","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115917,"slug":"gnivan","title":"Гнивань","uk_title":"Гнівань","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115725,"slug":"zhmerinka","title":"Жмеринка","uk_title":"Жмеринка","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115918,"slug":"ilincy","title":"Ильинцы","uk_title":"Іллінці","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115655,"slug":"kazatin","title":"Казатин","uk_title":"Козятин","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115919,"slug":"kalinovka","title":"Калиновка","uk_title":"Калинівка","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115724,"slug":"ladyzhin","title":"Ладыжин","uk_title":"Ладижин","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115920,"slug":"lipovec","title":"Липовец","uk_title":"Липовець","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115921,"slug":"nemirov","title":"Немиров","uk_title":"Немирів","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115922,"slug":"pogrebishche","title":"Погребище","uk_title":"Погребище","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115923,"slug":"tulchin","title":"Тульчин","uk_title":"Тульчин","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":2028,"slug":"vinnitsa","title":"Винница","uk_title":"Вінниця","is_city":true,"is_region":false,"is_country":false,"is_admin_center":true},{"id":115726,"slug":"hmelnik","title":"Хмельник","uk_title":"Хмільник","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115924,"slug":"shargorod","title":"Шаргород","uk_title":"Шаргород","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115925,"slug":"yampol","title":"Ямполь","uk_title":"Ямпіль","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116052,"slug":"mohyliv-podilskyi","title":"Могилев-Подольский","uk_title":"Могилів-Подільський","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false}]},{"id":116053,"slug":"volynska-oblast","title":"Волынская область","uk_title":"Волинська область","is_city":false,"is_region":true,"is_country":false,"is_admin_center":false,"children":[{"id":115839,"slug":"berestechko","title":"Берестечко","uk_title":"Берестечко","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115840,"slug":"vladimir-volynskiy","title":"Владимир-Волынский","uk_title":"Володимир-Волинський","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115841,"slug":"gorohov","title":"Горохов","uk_title":"Горохів","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115842,"slug":"kamen-kashirskiy","title":"Камень-Каширский","uk_title":"Камінь-Каширський","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115843,"slug":"kivercy","title":"Киверцы","uk_title":"Ківерці","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":32011,"slug":"kovel","title":"Ковель","uk_title":"Ковель","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115844,"slug":"lyuboml","title":"Любомль","uk_title":"Любомль","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115702,"slug":"novovolynsk","title":"Нововолынск","uk_title":"Нововолинськ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115845,"slug":"rozhishche","title":"Рожище","uk_title":"Рожище","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115846,"slug":"ustilug","title":"Устилуг","uk_title":"Устилуг","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":2030,"slug":"lutsk","title":"Луцк","uk_title":"Луцьк","is_city":true,"is_region":false,"is_country":false,"is_admin_center":true}]},{"id":116054,"slug":"dnipropetrovska-oblast","title":"Днепропетровская область","uk_title":"Дніпропетровська область","is_city":false,"is_region":true,"is_country":false,"is_admin_center":false,"children":[{"id":115741,"slug":"apostolovo","title":"Апостолово","uk_title":"Апостолове","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115742,"slug":"verhovcevo","title":"Верховцево","uk_title":"Верхівцеве","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115743,"slug":"verhnedneprovsk","title":"Верхнеднепровск","uk_title":"Верхньодніпровськ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115744,"slug":"volnogorsk","title":"Вольногорск","uk_title":"Вільногірськ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":109465,"slug":"zheltye-vody","title":"Желтые Воды","uk_title":"Жовті Води","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115745,"slug":"zelenodolsk","title":"Зеленодольск","uk_title":"Зеленодольськ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":29823,"slug":"kamenskoe-dneprodzerzhinsk","title":"Каменское (Днепродзержинск)","uk_title":"Кам'янське","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":29824,"slug":"krivoy-rog","title":"Кривой Рог","uk_title":"Кривий Ріг","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115746,"slug":"marganec","title":"Марганец","uk_title":"Марганець","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":60138,"slug":"nikopol","title":"Никополь","uk_title":"Нікополь","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115747,"slug":"novomoskovsk","title":"Новомосковск","uk_title":"Новомосковськ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115156,"slug":"pavlograd","title":"Павлоград","uk_title":"Павлоград","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115749,"slug":"pereshchepino","title":"Перещепино","uk_title":"Перещепине","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115750,"slug":"pershotravensk","title":"Першотравенск","uk_title":"Першотравенськ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":2031,"slug":"dnepr-dnepropetrovsk","title":"Днепр","uk_title":"Дніпро","is_city":true,"is_region":false,"is_country":false,"is_admin_center":true},{"id":115751,"slug":"podgorodnoe","title":"Подгородное","uk_title":"Підгородне","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115748,"slug":"pokrov","title":"Покров","uk_title":"Покров","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115752,"slug":"pyatihatki","title":"Пятихатки","uk_title":"П'ятихатки","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115753,"slug":"sinelnikovo","title":"Синельниково","uk_title":"Синельникове","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115754,"slug":"ternovka","title":"Терновка","uk_title":"Тернівка","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116055,"slug":"kamianske","title":"Каменское","uk_title":"Кам'янське","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false}]},{"id":116056,"slug":"donetska-oblast","title":"Донецкая область","uk_title":"Донецька область","is_city":false,"is_region":true,"is_country":false,"is_admin_center":false,"children":[{"id":115755,"slug":"avdeevka","title":"Авдеевка","uk_title":"Авдіївка","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":114253,"slug":"bahmut-artemovsk","title":"Бахмут (Артемовск)","uk_title":"Бахмут","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115762,"slug":"belickoe","title":"Белицкое","uk_title":"Білицьке","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115763,"slug":"belozyorskoe","title":"Белозерское","uk_title":"Білозерське","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115756,"slug":"volnovaha","title":"Волноваха","uk_title":"Волноваха","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":29825,"slug":"gorlovka","title":"Горловка","uk_title":"Горлівка","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115757,"slug":"gornyak","title":"Горняк","uk_title":"Гірник","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115758,"slug":"debalcevo","title":"Дебальцево","uk_title":"Дебальцеве","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115759,"slug":"dobropole","title":"Доброполье","uk_title":"Добропілля","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115764,"slug":"dokuchaevsk","title":"Докучаевск","uk_title":"Докучаєвськ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115760,"slug":"druzhkovka","title":"Дружковка","uk_title":"Дружківка","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115765,"slug":"enakievo","title":"Енакиево","uk_title":"Єнакієве","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115761,"slug":"zheleznoe","title":"Железное","uk_title":"Залізне","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115766,"slug":"zhdanovka","title":"Ждановка","uk_title":"Жданівка","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115767,"slug":"zugres","title":"Зугрэс","uk_title":"Зугрес","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115768,"slug":"ilovaysk","title":"Иловайск","uk_title":"Іловайськ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115769,"slug":"komsomolskoe","title":"Комсомольское","uk_title":"Кальміуське","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":2032,"slug":"donetsk","title":"Донецк","uk_title":"Донецьк","is_city":true,"is_region":false,"is_country":false,"is_admin_center":true},{"id":115770,"slug":"konstantinovka","title":"Константиновка","uk_title":"Костянтинівка","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":37255,"slug":"kramatorsk","title":"Краматорск","uk_title":"Краматорськ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115771,"slug":"krasnogorovka","title":"Красногоровка","uk_title":"Красногорівка","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115772,"slug":"kirovskoe","title":"Кировское","uk_title":"Кіровське","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":29826,"slug":"makeevka","title":"Макеевка","uk_title":"Макіївка","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":29827,"slug":"mariupol","title":"Мариуполь","uk_title":"Маріуполь","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115773,"slug":"marinka","title":"Марьинка","uk_title":"Мар'їнка","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115774,"slug":"mirnograd","title":"Мирноград","uk_title":"Мирноград","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115775,"slug":"nikolaevka","title":"Николаевка","uk_title":"Миколаївка","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115776,"slug":"novogrodovka","title":"Новогродовка","uk_title":"Новогродівка","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115186,"slug":"pokrovsk","title":"Покровск","uk_title":"Покровськ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115777,"slug":"rodinskoe","title":"Родинское","uk_title":"Родинське","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115778,"slug":"svetlodarsk","title":"Светлодарск","uk_title":"Світлодарськ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115779,"slug":"svyatogorsk","title":"Святогорск","uk_title":"Святогірськ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115780,"slug":"seversk","title":"Северск","uk_title":"Сіверськ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115781,"slug":"selidovo","title":"Селидово","uk_title":"Селидове","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115782,"slug":"slavyansk","title":"Славянск","uk_title":"Слов'янськ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115783,"slug":"soledar","title":"Соледар","uk_title":"Соледар","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115784,"slug":"toreck","title":"Торецк","uk_title":"Торецьк","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115785,"slug":"ugledar","title":"Угледар","uk_title":"Вугледар","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115786,"slug":"ukrainsk","title":"Украинск","uk_title":"Українськ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115787,"slug":"chasov-yar","title":"Часов Яр","uk_title":"Часів Яр","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116057,"slug":"bakhmut","title":"Бахмут","uk_title":"Бахмут","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116058,"slug":"khartsyzk","title":"Харцызск","uk_title":"Харцизьк","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116059,"slug":"chystiakove","title":"Чистяково","uk_title":"Чистякове","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116060,"slug":"shakhtarsk","title":"Шахтерск","uk_title":"Шахтарськ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116061,"slug":"snizhne","title":"Снежное","uk_title":"Сніжне","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116062,"slug":"yasynuvata","title":"Ясиноватая","uk_title":"Ясинувата","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false}]},{"id":116063,"slug":"zhytomyrska-oblast","title":"Житомирская область","uk_title":"Житомирська область","is_city":false,"is_region":true,"is_country":false,"is_admin_center":false,"children":[{"id":115788,"slug":"andrushyovka","title":"Андрушевка","uk_title":"Андрушівка","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115789,"slug":"baranovka","title":"Барановка","uk_title":"Баранівка","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115700,"slug":"berdichev","title":"Бердичев","uk_title":"Бердичів","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":114311,"slug":"korosten","title":"Коростень","uk_title":"Коростень","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115790,"slug":"korostyshev","title":"Коростышев","uk_title":"Коростишів","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115791,"slug":"malin","title":"Малин","uk_title":"Малин","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115792,"slug":"novograd-volynskiy","title":"Новоград-Волынский","uk_title":"Новоград-Волинський","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115793,"slug":"ovruch","title":"Овруч","uk_title":"Овруч","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115794,"slug":"olevsk","title":"Олевск","uk_title":"Олевськ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115795,"slug":"radomyshl","title":"Радомышль","uk_title":"Радомишль","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115796,"slug":"chudnov","title":"Чуднов","uk_title":"Чуднів","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":2033,"slug":"zhitomir","title":"Житомир","uk_title":"Житомир","is_city":true,"is_region":false,"is_country":false,"is_admin_center":true}]},{"id":116064,"slug":"zakarpatska-oblast","title":"Закарпатская область","uk_title":"Закарпатська область","is_city":false,"is_region":true,"is_country":false,"is_admin_center":false,"children":[{"id":115975,"slug":"beregovo","title":"Берегово","uk_title":"Берегове","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":114140,"slug":"vinogradov","title":"Виноградов","uk_title":"Виноградів","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115976,"slug":"irshava","title":"Иршава","uk_title":"Іршава","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":36970,"slug":"mukachevo","title":"Мукачево","uk_title":"Мукачеве","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115977,"slug":"perechin","title":"Перечин","uk_title":"Перечин","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115978,"slug":"rahov","title":"Рахов","uk_title":"Рахів","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115979,"slug":"svalyava","title":"Свалява","uk_title":"Свалява","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":113303,"slug":"tyachev","title":"Тячев","uk_title":"Тячів","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":114257,"slug":"hust","title":"Хуст","uk_title":"Хуст","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115980,"slug":"chop","title":"Чоп","uk_title":"Чоп","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":2034,"slug":"uzhgorod","title":"Ужгород","uk_title":"Ужгород","is_city":true,"is_region":false,"is_country":false,"is_admin_center":true}]},{"id":116065,"slug":"zaporizka-oblast","title":"Запорожская область","uk_title":"Запорізька область","is_city":false,"is_region":true,"is_country":false,"is_admin_center":false,"children":[{"id":104840,"slug":"berdyansk","title":"Бердянск","uk_title":"Бердянськ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":113072,"slug":"vasilevka","title":"Васильевка","uk_title":"Василівка","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115797,"slug":"volnyansk","title":"Вольнянск","uk_title":"Вільнянськ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115798,"slug":"gulyaypole","title":"Гуляйполе","uk_title":"Гуляйполе","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115799,"slug":"dneprorudnoe","title":"Днепрорудное","uk_title":"Дніпрорудне","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115800,"slug":"kamenka-dneprovskaya","title":"Каменка-Днепровская","uk_title":"Кам'янка-Дніпровська","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":114005,"slug":"melitopol","title":"Мелитополь","uk_title":"Мелітополь","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115801,"slug":"molochansk","title":"Молочанск","uk_title":"Молочанськ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115802,"slug":"orehov","title":"Орехов","uk_title":"Оріхів","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115803,"slug":"pologi","title":"Пологи","uk_title":"Пологи","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115804,"slug":"primorsk","title":"Приморск","uk_title":"Приморськ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115805,"slug":"tokmak","title":"Токмак","uk_title":"Токмак","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":113071,"slug":"energodar","title":"Энергодар","uk_title":"Енергодар","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":2035,"slug":"zaporozhe","title":"Запорожье","uk_title":"Запоріжжя","is_city":true,"is_region":false,"is_country":false,"is_admin_center":true}]},{"id":116066,"slug":"ivano-frankivska-oblast","title":"Ивано-Франковская область","uk_title":"Івано-Франківська область","is_city":false,"is_region":true,"is_country":false,"is_admin_center":false,"children":[{"id":115806,"slug":"bolehov","title":"Болехов","uk_title":"Болехів","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115807,"slug":"burshtyn","title":"Бурштын","uk_title":"Бурштин","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115808,"slug":"galich","title":"Галич","uk_title":"Галич","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115809,"slug":"gorodenka","title":"Городенка","uk_title":"Городенка","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115810,"slug":"dolina","title":"Долина","uk_title":"Долина","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115811,"slug":"kalush","title":"Калуш","uk_title":"Калуш","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115812,"slug":"kolomyya","title":"Коломыя","uk_title":"Коломия","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115813,"slug":"kosov","title":"Косов","uk_title":"Косів","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115814,"slug":"nadvornaya","title":"Надворная","uk_title":"Надвірна","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115815,"slug":"rogatin","title":"Рогатин","uk_title":"Рогатин","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115816,"slug":"snyatyn","title":"Снятын","uk_title":"Снятин","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115817,"slug":"tlumach","title":"Тлумач","uk_title":"Тлумач","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115818,"slug":"tysmenica","title":"Тысменица","uk_title":"Тисмениця","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115819,"slug":"yaremche","title":"Яремче","uk_title":"Яремче","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":2036,"slug":"ivano-frankovsk","title":"Ивано-Франковск","uk_title":"Івано-Франківськ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":true}]},{"id":1943,"slug":"kievskaya-obl","title":"Киевская область","uk_title":"Київська область","is_city":false,"is_region":true,"is_country":false,"is_admin_center":false,"children":[{"id":116120,"slug":"makariv","is_country":false,"title":"Макаров","uk_title":"Макарів","is_region":false,"is_city":true,"is_admin_center":false},{"id":1912,"slug":"kiev","title":"Киев","uk_title":"Київ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":true},{"id":29822,"slug":"belaya-tserkov","title":"Белая Церковь","uk_title":"Біла Церква","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115714,"slug":"berezan","title":"Березань","uk_title":"Березань","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115902,"slug":"boguslav","title":"Богуслав","uk_title":"Богуслав","is_city":false,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115715,"slug":"borispol","title":"Борисполь","uk_title":"Бориспіль","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115903,"slug":"boyarka","title":"Боярка","uk_title":"Боярка","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":73371,"slug":"brovary","title":"Бровары","uk_title":"Бровари","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115703,"slug":"bucha","title":"Буча","uk_title":"Буча","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115716,"slug":"vasilkov","title":"Васильков","uk_title":"Васильків","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115904,"slug":"vyshgorod","title":"Вышгород","uk_title":"Вишгород","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115236,"slug":"vishnevoe","title":"Вишневое","uk_title":"Вишневе","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115717,"slug":"irpen","title":"Ирпень","uk_title":"Ірпінь","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115905,"slug":"kagarlyk","title":"Кагарлык","uk_title":"Кагарлик","is_city":false,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115906,"slug":"mironovka","title":"Мироновка","uk_title":"Миронівка","is_city":false,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115718,"slug":"obuhov","title":"Обухов","uk_title":"Обухів","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115719,"slug":"pereyaslav-hmelnickiy","title":"Переяслав-Хмельницкий","uk_title":"Переяслав-Хмельницкий","is_city":false,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115907,"slug":"pripyat","title":"Припять","uk_title":"Прип'ять","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115720,"slug":"rzhishchev","title":"Ржищев","uk_title":"Ржищів","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115908,"slug":"skvira","title":"Сквира","uk_title":"Сквира","is_city":false,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115721,"slug":"slavutich","title":"Славутич","uk_title":"Славутич","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115909,"slug":"tarashcha","title":"Тараща","uk_title":"Тараща","is_city":false,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115910,"slug":"tetiev","title":"Тетиев","uk_title":"Тетіїв","is_city":false,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115911,"slug":"uzin","title":"Узин","uk_title":"Узин","is_city":false,"is_region":false,"is_country":false,"is_admin_center":false},{"id":113505,"slug":"ukrainka","title":"Украинка","uk_title":"Украиїка","is_city":false,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115722,"slug":"fastov","title":"Фастов","uk_title":"Фастів","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115912,"slug":"chernobyl","title":"Чернобыль","uk_title":"Чорнобиль","is_city":false,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115913,"slug":"yagotin","title":"Яготин","uk_title":"Яготин","is_city":false,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116050,"slug":"pereiaslav","title":"Переяслав","uk_title":"Переяслав","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false}]},{"id":116067,"slug":"kirovohradska-oblast","title":"Кировоградская область","uk_title":"Кіровоградська область","is_city":false,"is_region":true,"is_country":false,"is_admin_center":false,"children":[{"id":113721,"slug":"aleksandriya","title":"Александрия","uk_title":"Олександрія","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115820,"slug":"blagoveshchenskoe","title":"Благовещенское","uk_title":"Благовіщенське","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115821,"slug":"bobrinec","title":"Бобринец","uk_title":"Бобринець","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115822,"slug":"gayvoron","title":"Гайворон","uk_title":"Гайворон","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115823,"slug":"dolinskaya","title":"Долинская","uk_title":"Долинська","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115824,"slug":"znamenka","title":"Знаменка","uk_title":"Знам'янка","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115825,"slug":"malaya-viska","title":"Малая Виска","uk_title":"Мала Виска","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115826,"slug":"novomirgorod","title":"Новомиргород","uk_title":"Новомиргород","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115827,"slug":"novoukrainka","title":"Новоукраинка","uk_title":"Новоукраїнка","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115828,"slug":"pomoshnaya","title":"Помошная","uk_title":"Помічна","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115829,"slug":"svetlovodsk","title":"Светловодск","uk_title":"Світловодськ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":2037,"slug":"kropivnitskiy-kirovograd","title":"Кропивницкий","uk_title":"Кропивницький","is_city":true,"is_region":false,"is_country":false,"is_admin_center":true}]},{"id":116068,"slug":"luhanska-oblast","title":"Луганская область","uk_title":"Луганська область","is_city":false,"is_region":true,"is_country":false,"is_admin_center":false,"children":[{"id":115830,"slug":"gorskoe","title":"Горское","uk_title":"Гірське","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115831,"slug":"zolotoe","title":"Золотое","uk_title":"Золоте","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115832,"slug":"kremennaya","title":"Кременная","uk_title":"Кремінна","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":114416,"slug":"lisichansk","title":"Лисичанск","uk_title":"Лисичанськ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115833,"slug":"novodruzhesk","title":"Новодружеск","uk_title":"Новодружеськ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115834,"slug":"popasnaya","title":"Попасная","uk_title":"Попасна","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115835,"slug":"privole","title":"Приволье","uk_title":"Привілля","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115836,"slug":"rubezhnoe","title":"Рубежное","uk_title":"Рубіжне","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115837,"slug":"svatovo","title":"Сватово","uk_title":"Сватове","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":113520,"slug":"severodonetsk","title":"Северодонецк","uk_title":"Сєвєродонецьк","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115187,"slug":"starobelsk","title":"Старобельск","uk_title":"Старобільськ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115838,"slug":"schaste","title":"Счастье","uk_title":"Щастя","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":1946,"slug":"lugansk","title":"Луганск","uk_title":"Луганськ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":true},{"id":116069,"slug":"alchevsk","title":"Алчевск","uk_title":"Алчевськ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116070,"slug":"khrustalnyi","title":"Хрустальный","uk_title":"Хрустальний","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116071,"slug":"kadiivka","title":"Кадеевка","uk_title":"Кадіївка","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116072,"slug":"dovzhansk","title":"Довжанск","uk_title":"Довжанськ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116073,"slug":"antratsyt","title":"Антрацит","uk_title":"Антрацит","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116074,"slug":"rovenky","title":"Ровеньки","uk_title":"Ровеньки","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116075,"slug":"brianka","title":"Брянка","uk_title":"Брянка","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116076,"slug":"sorokyne","title":"Сорокино","uk_title":"Сорокине","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false}]},{"id":116077,"slug":"lvivska-oblast","title":"Львовская область","uk_title":"Львівська область","is_city":false,"is_region":true,"is_country":false,"is_admin_center":false,"children":[{"id":115847,"slug":"belz","title":"Белз","uk_title":"Белз","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115848,"slug":"bobrka","title":"Бобрка","uk_title":"Бібрка","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":114079,"slug":"borislav","title":"Борислав","uk_title":"Борислав","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":113300,"slug":"brody","title":"Броды","uk_title":"Броди","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115849,"slug":"busk","title":"Буск","uk_title":"Буськ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115850,"slug":"velikie-mosty","title":"Великие Мосты","uk_title":"Великі Мости","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115851,"slug":"vinniki","title":"Винники","uk_title":"Винники","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115852,"slug":"glinyany","title":"Глиняны","uk_title":"Глиняни","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115853,"slug":"gorodok-lv","title":"Городок (Львовская обл)","uk_title":"Городок (Львівська обл)","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115854,"slug":"dobromil","title":"Добромиль","uk_title":"Добромиль","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":113746,"slug":"drogobich","title":"Дрогобыч","uk_title":"Дрогобич","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115856,"slug":"dublyany","title":"Дубляны","uk_title":"Дубляни","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115857,"slug":"zhidachov","title":"Жидачов","uk_title":"Жидачів","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115858,"slug":"zholkva","title":"Жолква","uk_title":"Жовква","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115859,"slug":"zolochev","title":"Золочев","uk_title":"Золочів","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115860,"slug":"kamenka-bugskaya","title":"Каменка-Бугская","uk_title":"Кам'янка-Бузька","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115861,"slug":"komarno","title":"Комарно","uk_title":"Комарно","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115862,"slug":"morshin","title":"Моршин","uk_title":"Моршин","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115855,"slug":"mostiska","title":"Мостиска","uk_title":"Мостиська","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115863,"slug":"nikolaev-lv","title":"Николаев, (Львовская обл)","uk_title":"Миколаїв, (Львівська обл)","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115864,"slug":"novoyavorovsk","title":"Новояворовск","uk_title":"Новояворівськ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115865,"slug":"novyy-kalinov","title":"Новый Калинов","uk_title":"Новий Калинів","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115866,"slug":"novyy-rozdol","title":"Новый Роздол","uk_title":"Новий Розділ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115867,"slug":"peremyshlyany","title":"Перемышляны","uk_title":"Перемишляни","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115868,"slug":"pustomyty","title":"Пустомыты","uk_title":"Пустомити","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115869,"slug":"rava-russkaya","title":"Рава-Русская","uk_title":"Рава-Руська","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115870,"slug":"radehov","title":"Радехов","uk_title":"Радехів","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115871,"slug":"rudki","title":"Рудки","uk_title":"Рудки","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115872,"slug":"sambor","title":"Самбор","uk_title":"Самбір","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115873,"slug":"skole","title":"Сколе","uk_title":"Сколе","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115874,"slug":"sokal","title":"Сокаль","uk_title":"Сокаль","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":2038,"slug":"lvov","title":"Львов","uk_title":"Львів","is_city":true,"is_region":false,"is_country":false,"is_admin_center":true},{"id":115875,"slug":"sosnovka","title":"Сосновка","uk_title":"Соснівка","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115876,"slug":"staryy-sambor","title":"Старый Самбор","uk_title":"Старий Самбір","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115877,"slug":"stebnik","title":"Стебник","uk_title":"Стебник","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":113299,"slug":"striy","title":"Стрый","uk_title":"Стрий","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115878,"slug":"sudovaya-vishnya","title":"Судовая Вишня","uk_title":"Судова Вишня","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115879,"slug":"truskavec","title":"Трускавец","uk_title":"Трускавець","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115880,"slug":"turka","title":"Турка","uk_title":"Турка","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115881,"slug":"ugnev","title":"Угнев","uk_title":"Угнів","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115882,"slug":"hodorov","title":"Ходоров","uk_title":"Ходорів","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115883,"slug":"hyrov","title":"Хыров","uk_title":"Хирів","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":73940,"slug":"chervonograd","title":"Червоноград","uk_title":"Червоноград","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":114301,"slug":"yavorov","title":"Яворов","uk_title":"Яворів","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false}]},{"id":116078,"slug":"mykolaivska-oblast","title":"Николаевская область","uk_title":"Миколаївська область","is_city":false,"is_region":true,"is_country":false,"is_admin_center":false,"children":[{"id":115884,"slug":"bashtanka","title":"Баштанка","uk_title":"Баштанка","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115885,"slug":"voznesensk","title":"Вознесенск","uk_title":"Вознесенськ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115886,"slug":"novaya-odessa","title":"Новая Одесса","uk_title":"Нова Одеса","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115887,"slug":"novyy-bug","title":"Новый Буг","uk_title":"Новий Буг","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115888,"slug":"ochakov","title":"Очаков","uk_title":"Очаків","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115889,"slug":"pervomaysk","title":"Первомайск","uk_title":"Первомайськ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115890,"slug":"snigiryovka","title":"Снигиревка","uk_title":"Снігурівка","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115891,"slug":"yuzhnoukrainsk","title":"Южноукраинск","uk_title":"Южноукраїнськ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":2039,"slug":"nikolaev","title":"Николаев","uk_title":"Миколаїв","is_city":true,"is_region":false,"is_country":false,"is_admin_center":true},{"id":116079,"slug":"vradiivka","title":"Врадиевка","uk_title":"Врадіївка","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116080,"slug":"kryve-ozero","title":"Кривое Озеро","uk_title":"Криве Озеро","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false}]},{"id":116081,"slug":"odeska-oblast","title":"Одесская область","uk_title":"Одеська область","is_city":false,"is_region":true,"is_country":false,"is_admin_center":false,"children":[{"id":115892,"slug":"ananev","title":"Ананьев","uk_title":"Ананьїв","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115893,"slug":"arciz","title":"Арциз","uk_title":"Арциз","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115704,"slug":"balta","title":"Балта","uk_title":"Балта","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115705,"slug":"belgorod-dnestrovskiy","title":"Белгород-Днестровский","uk_title":"Білгород-Дністровський","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115706,"slug":"belyaevka","title":"Беляевка","uk_title":"Біляївка","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115894,"slug":"berezovka","title":"Березовка","uk_title":"Березівка","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115895,"slug":"bolgrad","title":"Болград","uk_title":"Болград","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115896,"slug":"vilkovo","title":"Вилково","uk_title":"Вилкове","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":104861,"slug":"izmail","title":"Измаил","uk_title":"Ізмаїл","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115897,"slug":"kiliya","title":"Килия","uk_title":"Кілія","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115898,"slug":"kodyma","title":"Кодыма","uk_title":"Кодима","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115707,"slug":"podolsk","title":"Подольск","uk_title":"Подільськ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115899,"slug":"razdelnaya","title":"Раздельная","uk_title":"Роздільна","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115900,"slug":"reni","title":"Рени","uk_title":"Рені","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115901,"slug":"tatarbunary","title":"Татарбунары","uk_title":"Татарбунар","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115708,"slug":"teplodar","title":"Теплодар","uk_title":"Теплодар","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115709,"slug":"chernomorsk","title":"Черноморск","uk_title":"Чорноморськ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115710,"slug":"yuzhnoe","title":"Южное","uk_title":"Южне","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":1944,"slug":"odessa","title":"Одесса","uk_title":"Одеса","is_city":true,"is_region":false,"is_country":false,"is_admin_center":true}]},{"id":116082,"slug":"poltavska-oblast","title":"Полтавская область","uk_title":"Полтавська область","is_city":false,"is_region":true,"is_country":false,"is_admin_center":false,"children":[{"id":115711,"slug":"gadyach","title":"Гадяч","uk_title":"Гадяч","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115926,"slug":"globino","title":"Глобино","uk_title":"Глобине","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115712,"slug":"gorishnie-plavni","title":"Горишние Плавни","uk_title":"Горішні Плавні","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115927,"slug":"grebyonka","title":"Гребенка","uk_title":"Гребінка","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115928,"slug":"zavodskoe","title":"Заводское","uk_title":"Заводське","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115929,"slug":"zenkov","title":"Зеньков","uk_title":"Зіньків","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115930,"slug":"karlovka","title":"Карловка","uk_title":"Карлівка","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115931,"slug":"kobelyaki","title":"Кобеляки","uk_title":"Кобеляки","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":29828,"slug":"kremenchug","title":"Кременчуг","uk_title":"Кременчук","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115932,"slug":"lohvica","title":"Лохвица","uk_title":"Лохвиця","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115238,"slug":"lubny","title":"Лубны","uk_title":"Лубни","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115713,"slug":"mirgorod","title":"Миргород","uk_title":"Миргород","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115933,"slug":"piryatin","title":"Пирятин","uk_title":"Пирятин","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115934,"slug":"horol","title":"Хорол","uk_title":"Хорол","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":1945,"slug":"poltava","title":"Полтава","uk_title":"Полтава","is_city":true,"is_region":false,"is_country":false,"is_admin_center":true}]},{"id":116083,"slug":"rivnenska-oblast","title":"Ровенская область","uk_title":"Рівненська область","is_city":false,"is_region":true,"is_country":false,"is_admin_center":false,"children":[{"id":115935,"slug":"berezno","title":"Березно","uk_title":"Березне","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115941,"slug":"varash","title":"Вараш","uk_title":"Вараш","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115936,"slug":"dubrovica","title":"Дубровица","uk_title":"Дубровиця","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":113302,"slug":"dubno","title":"Дубно","uk_title":"Дубно","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115938,"slug":"zdolbunov","title":"Здолбунов","uk_title":"Здолбунів","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115939,"slug":"korec","title":"Корец","uk_title":"Корець","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115940,"slug":"kostopol","title":"Костополь","uk_title":"Костопіль","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115942,"slug":"ostrog","title":"Острог","uk_title":"Острог","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115943,"slug":"radivilov","title":"Радивилов","uk_title":"Радивилів","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115944,"slug":"sarny","title":"Сарны","uk_title":"Сарни","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":2040,"slug":"rovno","title":"Ровно","uk_title":"Рівне","is_city":true,"is_region":false,"is_country":false,"is_admin_center":true}]},{"id":116084,"slug":"sumska-oblast","title":"Сумская область","uk_title":"Сумська область","is_city":false,"is_region":true,"is_country":false,"is_admin_center":false,"children":[{"id":115945,"slug":"ahtyrka","title":"Ахтырка","uk_title":"Охтирка","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115946,"slug":"belopole","title":"Белополье","uk_title":"Білопілля","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115947,"slug":"buryn","title":"Бурынь","uk_title":"Буринь","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115948,"slug":"vorozhba","title":"Ворожба","uk_title":"Ворожба","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115949,"slug":"gluhov","title":"Глухов","uk_title":"Глухів","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115950,"slug":"druzhba","title":"Дружба","uk_title":"Дружба","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115951,"slug":"konotop","title":"Конотоп","uk_title":"Конотоп","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115952,"slug":"krolevec","title":"Кролевец","uk_title":"Кролевець","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115953,"slug":"lebedin","title":"Лебедин","uk_title":"Лебедин","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115954,"slug":"putivl","title":"Путивль","uk_title":"Путивль","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115955,"slug":"romny","title":"Ромны","uk_title":"Ромни","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115956,"slug":"seredina-buda","title":"Середина-Буда","uk_title":"Середина-Буда","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115957,"slug":"trostyanec","title":"Тростянец","uk_title":"Тростянець","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115958,"slug":"shostka","title":"Шостка","uk_title":"Шостка","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":2041,"slug":"sumy","title":"Сумы","uk_title":"Суми","is_city":true,"is_region":false,"is_country":false,"is_admin_center":true}]},{"id":116085,"slug":"ternopilska-oblast","title":"Тернопольская область","uk_title":"Тернопільська область","is_city":false,"is_region":true,"is_country":false,"is_admin_center":false,"children":[{"id":115959,"slug":"berezhany","title":"Бережаны","uk_title":"Бережани","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115960,"slug":"borshchyov","title":"Борщев","uk_title":"Борщів","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":113315,"slug":"buchach","title":"Бучач","uk_title":"Бучач","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115961,"slug":"zaleshchiki","title":"Залещики","uk_title":"Заліщики","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115962,"slug":"zbarazh","title":"Збараж","uk_title":"Збараж","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115963,"slug":"zborov","title":"Зборов","uk_title":"Зборов","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115964,"slug":"kopychincy","title":"Копычинцы","uk_title":"Копичинці","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115965,"slug":"kremenec","title":"Кременец","uk_title":"Кременець","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115966,"slug":"lanovcy","title":"Лановцы","uk_title":"Ланівці","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115967,"slug":"monastyriska","title":"Монастыриска","uk_title":"Монастириська","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115968,"slug":"podgaycy","title":"Подгайцы","uk_title":"Підгайці","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115969,"slug":"pochaev","title":"Почаев","uk_title":"Почаїв","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115970,"slug":"skalat","title":"Скалат","uk_title":"Скалат","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115971,"slug":"terebovlya","title":"Теребовля","uk_title":"Теребовля","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115972,"slug":"horostkov","title":"Хоростков","uk_title":"Хоростків","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115973,"slug":"chortkov","title":"Чортков","uk_title":"Чортків","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115974,"slug":"shumsk","title":"Шумск","uk_title":"Шумськ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":2042,"slug":"ternopol","title":"Тернополь","uk_title":"Тернопіль","is_city":true,"is_region":false,"is_country":false,"is_admin_center":true}]},{"id":116086,"slug":"kharkivska-oblast","title":"Харьковская область","uk_title":"Харківська область","is_city":false,"is_region":true,"is_country":false,"is_admin_center":false,"children":[{"id":115981,"slug":"balakleya","title":"Балаклея","uk_title":"Балаклія","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115982,"slug":"barvenkovo","title":"Барвенково","uk_title":"Барвінкове","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115983,"slug":"bogoduhov","title":"Богодухов","uk_title":"Богодухів","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115984,"slug":"valki","title":"Валки","uk_title":"Валки","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115985,"slug":"volchansk","title":"Волчанск","uk_title":"Вовчанськ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115986,"slug":"dergachi","title":"Дергачи","uk_title":"Дергачі","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115987,"slug":"zmiyov","title":"Змиев","uk_title":"Зміїв","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115988,"slug":"izyum","title":"Изюм","uk_title":"Ізюм","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115989,"slug":"krasnograd","title":"Красноград","uk_title":"Красноград","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":113298,"slug":"kupyansk","title":"Купянск","uk_title":"Куп'янськ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115990,"slug":"lozovaya","title":"Лозовая","uk_title":"Лозова","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115991,"slug":"lyubotin","title":"Люботин","uk_title":"Люботин","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115992,"slug":"merefa","title":"Мерефа","uk_title":"Мерефа","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115993,"slug":"pervomayskiy","title":"Первомайский","uk_title":"Первомайський","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115994,"slug":"pivdennoe-yuzhnoe","title":"Пивденное (Южное)","uk_title":"Південне","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115995,"slug":"chuguev","title":"Чугуев","uk_title":"Чугуїв","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":2043,"slug":"harkov","title":"Харьков","uk_title":"Харків","is_city":true,"is_region":false,"is_country":false,"is_admin_center":true},{"id":116087,"slug":"lozova","title":"Лозова","uk_title":"Лозова","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116088,"slug":"pisochyn","title":"Песочин","uk_title":"Пісочин","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false}]},{"id":116089,"slug":"khersonska-oblast","title":"Херсонская область","uk_title":"Херсонська область","is_city":false,"is_region":true,"is_country":false,"is_admin_center":false,"children":[{"id":115996,"slug":"alyoshki","title":"Алешки","uk_title":"Олешки","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116099,"slug":"novovoroncovka","is_country":false,"title":"Нововоронцовка","uk_title":"Нововоронцовка","is_region":false,"is_city":true,"is_admin_center":false},{"id":115997,"slug":"berislav","title":"Берислав","uk_title":"Берислав","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115998,"slug":"genichesk","title":"Геническ","uk_title":"Генічеськ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115999,"slug":"golaya-pristan","title":"Голая Пристань","uk_title":"Гола Пристань","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":113123,"slug":"kahovka","title":"Каховка","uk_title":"Каховка","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115643,"slug":"novaya-kahovka","title":"Новая Каховка","uk_title":"Нова Каховка","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116000,"slug":"skadovsk","title":"Скадовск","uk_title":"Скадовськ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116001,"slug":"tavriysk","title":"Таврийск","uk_title":"Таврійськ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":2044,"slug":"herson","title":"Херсон","uk_title":"Херсон","is_city":true,"is_region":false,"is_country":false,"is_admin_center":true}]},{"id":116090,"slug":"khmelnytska-oblast","title":"Хмельницкая область","uk_title":"Хмельницька область","is_city":false,"is_region":true,"is_country":false,"is_admin_center":false,"children":[{"id":116002,"slug":"volochisk","title":"Волочиск","uk_title":"Волочиськ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116003,"slug":"gorodok","title":"Городок (Хмельницкая обл)","uk_title":"Городок (Хмельницька обл)","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116004,"slug":"derazhnya","title":"Деражня","uk_title":"Деражня","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116005,"slug":"dunaevcy","title":"Дунаевцы","uk_title":"Дунаївці","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116006,"slug":"izyaslav","title":"Изяслав","uk_title":"Ізяслав","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":115237,"slug":"kamenets-podolskiy","title":"Каменец-Подольский","uk_title":"Кам'янець-Подільський","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":113747,"slug":"krasilov","title":"Красилов","uk_title":"Красилів","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116007,"slug":"neteshin","title":"Нетешин","uk_title":"Нетішин","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116008,"slug":"polonnoe","title":"Полонное","uk_title":"Полонне","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116009,"slug":"slavuta","title":"Славута","uk_title":"Славута","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116010,"slug":"starokonstantinov","title":"Староконстантинов","uk_title":"Старокостянтинів","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116011,"slug":"shepetovka","title":"Шепетовка","uk_title":"Шепетівка","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":2045,"slug":"hmelnitskiy","title":"Хмельницкий","uk_title":"Хмельницький","is_city":true,"is_region":false,"is_country":false,"is_admin_center":true}]},{"id":116091,"slug":"cherkaska-oblast","title":"Черкасская область","uk_title":"Черкаська область","is_city":false,"is_region":true,"is_country":false,"is_admin_center":false,"children":[{"id":116012,"slug":"vatutino","title":"Ватутино","uk_title":"Ватутіне","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116013,"slug":"gorodishche","title":"Городище","uk_title":"Городище","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116014,"slug":"zhashkov","title":"Жашков","uk_title":"Жашків","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116015,"slug":"zvenigorodka","title":"Звенигородка","uk_title":"Звенигородка","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116016,"slug":"zvenigorodka","title":"Золотоноша","uk_title":"Золотоноша","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116017,"slug":"kamenka","title":"Каменка","uk_title":"Кам'янка","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116018,"slug":"kanev","title":"Канев","uk_title":"Канів","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116019,"slug":"korsun-shevchenkovskiy","title":"Корсунь-Шевченковский","uk_title":"Корсунь-Шевченківський","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116020,"slug":"monastyrishche","title":"Монастырище","uk_title":"Монастирище","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":113316,"slug":"smela","title":"Смела","uk_title":"Сміла","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116021,"slug":"talnoe","title":"Тальное","uk_title":"Тальне","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":29829,"slug":"uman","title":"Умань","uk_title":"Умань","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116022,"slug":"hristinovka","title":"Христиновка","uk_title":"Христинівка","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116023,"slug":"chigirin","title":"Чигирин","uk_title":"Чигирин","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116024,"slug":"shpola","title":"Шпола","uk_title":"Шпола","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":2046,"slug":"cherkassy","title":"Черкассы","uk_title":"Черкаси","is_city":true,"is_region":false,"is_country":false,"is_admin_center":true},{"id":116092,"slug":"vatutine","title":"Ватутине","uk_title":"Ватутіне","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false}]},{"id":116093,"slug":"chernivetska-oblast","title":"Черновицкая область","uk_title":"Чернівецька область","is_city":false,"is_region":true,"is_country":false,"is_admin_center":false,"children":[{"id":116040,"slug":"vashkovcy","title":"Вашковцы","uk_title":"Вашківці","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116041,"slug":"vizhnica","title":"Вижница","uk_title":"Вижниця","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116042,"slug":"gerca","title":"Герца","uk_title":"Герца","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116043,"slug":"zastavna","title":"Заставна","uk_title":"Заставна","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116044,"slug":"kicman","title":"Кицмань","uk_title":"Кіцмань","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116045,"slug":"novodnestrovsk","title":"Новоднестровск","uk_title":"Новодністровськ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116046,"slug":"novoselica","title":"Новоселица","uk_title":"Новоселиця","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116047,"slug":"sokiryany","title":"Сокиряны","uk_title":"Сокиряни","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116048,"slug":"storozhinec","title":"Сторожинец","uk_title":"Сторожинець","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116049,"slug":"hotin","title":"Хотин","uk_title":"Хотин","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":2048,"slug":"chernovtsy","title":"Черновцы","uk_title":"Чернівці","is_city":true,"is_region":false,"is_country":false,"is_admin_center":true},{"id":116094,"slug":"krasnoilsk","title":"Красноильск","uk_title":"Красноїльськ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116095,"slug":"hlyboka","title":"Глыбокая","uk_title":"Глибока","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false}]},{"id":116096,"slug":"chernihivska-oblast","title":"Черниговская область","uk_title":"Чернігівська область","is_city":false,"is_region":true,"is_country":false,"is_admin_center":false,"children":[{"id":116025,"slug":"baturin","title":"Батурин","uk_title":"Батурин","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116026,"slug":"bahmach","title":"Бахмач","uk_title":"Бахмач","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116027,"slug":"bobrovica","title":"Бобровица","uk_title":"Бобровиця","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116028,"slug":"borzna","title":"Борзна","uk_title":"Борзна","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116029,"slug":"gorodnya","title":"Городня","uk_title":"Городня","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116030,"slug":"ichnya","title":"Ичня","uk_title":"Ічня","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116031,"slug":"koryukovka","title":"Корюковка","uk_title":"Корюківка","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116032,"slug":"mena","title":"Мена","uk_title":"Мена","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116033,"slug":"nezhin","title":"Нежин","uk_title":"Ніжин","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116034,"slug":"novgorod-severskiy","title":"Новгород-Северский","uk_title":"Новгород-Сіверський","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116035,"slug":"nosovka","title":"Носовка","uk_title":"Носівка","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116036,"slug":"ostyor","title":"Остер","uk_title":"Остер","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116037,"slug":"priluki","title":"Прилуки","uk_title":"Прилуки","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116038,"slug":"semyonovka","title":"Семеновка","uk_title":"Семенівка","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":116039,"slug":"snovsk","title":"Сновск","uk_title":"Сновськ","is_city":true,"is_region":false,"is_country":false,"is_admin_center":false},{"id":2047,"slug":"chernigov","title":"Чернигов","uk_title":"Чернігів","is_city":true,"is_region":false,"is_country":false,"is_admin_center":true}]}]

/***/ }),

/***/ 517:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/modules/googletag/GoogletagUnmount.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TargetingCheck__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_actions_globals__ = __webpack_require__(47);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };




/* harmony default export */ var GoogletagUnmount_defaultExport = (function (_ref) {
  var googletag = _ref.googletag,
      componentWillUnmount = _ref.componentWillUnmount;

  if (typeof googletag.pubads !== 'function') {
    return void 0;
  }

  if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object') {
    componentWillUnmount.map(function (_ref2) {
      var dfpNetworkId = _ref2.dfpNetworkId,
          adUnit = _ref2.adUnit,
          sizes = _ref2.sizes,
          slotId = _ref2.slotId,
          targetingArguments = _ref2.targetingArguments;

      if (window.AbStor && window.AbStor.keyTarget && window.AbStor.keyTarget[slotId]) {
        window.AbStor.keyTarget[slotId] = false;
      }
      switch (slotId) {
        case __WEBPACK_IMPORTED_MODULE_0__TargetingCheck__["a" /* defineOutOfPageSlot */].ab_mobile_web_catfish:
          __WEBPACK_IMPORTED_MODULE_0__TargetingCheck__["d" /* problemSlotFunc */]();
          break;
        case __WEBPACK_IMPORTED_MODULE_0__TargetingCheck__["c" /* problemSlot */].ab_branding_top:
          window.document.querySelectorAll('body')[0].style.background = '';
          break;
        default:
          break;
      }
    });
  }
});
// CONCATENATED MODULE: ./src/shared/modules/googletag/googletag.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TargetingCheck__ = __webpack_require__(288);
var googletag__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };






/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var _ref$slots = _ref.slots,
      slots = _ref$slots === undefined ? [] : _ref$slots,
      componentWillUnmount = _ref.componentWillUnmount,
      googletagRefresh = _ref.googletagRefresh;

  var googletagCmdInistaillArr = [];
  var googletagCmdRefreshArr = [];

  if (!((typeof window === 'undefined' ? 'undefined' : googletag__typeof(window)) === 'object' && window.googletag && window.googletag.defineSlot)) {
    return null;
  }

  if (!window.AbStor.SlotStart) {
    window.AbStor.DefineSlot = {};
    window.AbStor.KeyIdDefineSlot = {};
    window.AbStor.SetTimeoutrefresh = null;
    window.AbStor.adUnitNameId = {};
    window.AbStor.keyTarget = {};
    window.AbStor.SlotStart = false;
    window.AbStor.blockAbInstall = false;
    window.AbStor.blockAbInstallNext = false;
    window.onscroll = __WEBPACK_IMPORTED_MODULE_2__TargetingCheck__["e" /* scrollFun */];
    window.addEventListener('orientationchange', __WEBPACK_IMPORTED_MODULE_2__TargetingCheck__["e" /* scrollFun */], false);
    window.onresize = __WEBPACK_IMPORTED_MODULE_2__TargetingCheck__["e" /* scrollFun */];
  }
  if (componentWillUnmount) {
    return GoogletagUnmount_defaultExport({ googletag: window.googletag, componentWillUnmount: componentWillUnmount });
  }
  if (googletagRefresh) {
    __WEBPACK_IMPORTED_MODULE_2__TargetingCheck__["g" /* time */](0);

    return '';
  }

  var googletagCmdInistaill = function googletagCmdInistaill(data) {
    /*  window.googletag.cmd.push(() => { */
    var bul = void 0;
    data.map(function (_ref2, b) {
      var _ref2$dfpNetworkId = _ref2.dfpNetworkId,
          dfpNetworkId = _ref2$dfpNetworkId === undefined ? '' : _ref2$dfpNetworkId,
          _ref2$adUnit = _ref2.adUnit,
          adUnit = _ref2$adUnit === undefined ? '' : _ref2$adUnit,
          _ref2$sizes = _ref2.sizes,
          sizes = _ref2$sizes === undefined ? [] : _ref2$sizes,
          _ref2$slotId = _ref2.slotId,
          slotId = _ref2$slotId === undefined ? '' : _ref2$slotId,
          targetingArguments = _ref2.targetingArguments;

      var Target = __WEBPACK_IMPORTED_MODULE_2__TargetingCheck__["f" /* targetingCheck */](targetingArguments);
      var TargetingArgumentsString = Object.values(Target).join() + '___' + (window.location && window.location.href || '');
      if (!window.AbStor.DefineSlot[adUnit] && !window.AbStor.KeyIdDefineSlot[slotId] && Target && dfpNetworkId && adUnit && sizes && slotId) {
        window.AbStor.KeyIdDefineSlot[slotId] = true;
        var defineSlot = void 0;
        if (__WEBPACK_IMPORTED_MODULE_2__TargetingCheck__["a" /* defineOutOfPageSlot */][adUnit]) {
          defineSlot = window.googletag.defineOutOfPageSlot('/' + dfpNetworkId + '/' + adUnit, slotId);
        } else {
          defineSlot = window.googletag.defineSlot('/' + dfpNetworkId + '/' + adUnit, sizes, slotId);
        }
        if (!defineSlot) {
          return void 0;
        }
        if (false) {}

        bul = true;

        window.AbStor.DefineSlot[adUnit] = defineSlot.addService(window.googletag.pubads());

        Object.keys(window.AbStor.DefineSlot).map(function (a) {
          Object.entries(Target).map(function (a1) {
            window.AbStor.DefineSlot[a].setTargeting(a1[0], [a1[1]]);
            window.AbStor.keyTarget[a1[0]] = true;
            return '';
          });
          return '';
        });
        window.AbStor.adUnitNameId[adUnit] = slotId;
        window.AbStor.keyTarget[slotId] = TargetingArgumentsString;
        // window.googletag.enableServices();
      } else if (!(Target && dfpNetworkId && adUnit && sizes && slotId)) {}
      return '';
    });
    if (bul) {
      if (!window.AbStor.SlotStart) {
        window.AbStor.SlotStart = true;
        window.googletag.pubads().collapseEmptyDivs();
      }
      window.googletag.pubads().enableSingleRequest();
      window.googletag.enableServices();
      __WEBPACK_IMPORTED_MODULE_2__TargetingCheck__["g" /* time */](0);
    }
    /* }); */
  };
  var googletagCmdRefresh = function googletagCmdRefresh(data) {
    var Target = __WEBPACK_IMPORTED_MODULE_2__TargetingCheck__["f" /* targetingCheck */](data[0].targetingArguments);
    var TargetingArgumentsString = Object.values(Target).join() + '___' + (window.location && window.location.href || '');
    var buf = void 0;
    data.map(function (_ref3) {
      var _ref3$slotId = _ref3.slotId,
          slotId = _ref3$slotId === undefined ? '' : _ref3$slotId;

      if (window.AbStor.keyTarget[slotId] !== TargetingArgumentsString) {
        window.AbStor.keyTarget[slotId] = TargetingArgumentsString;
        buf = true;
      }
      return '';
    });
    if (!buf || !Target) return '';
    if (false) {}

    Object.keys(window.AbStor.DefineSlot).map(function (a) {
      window.AbStor.DefineSlot[a].clearTargeting();
      return '';
    });
    Object.keys(window.AbStor.DefineSlot).map(function (a) {
      Object.entries(Target).map(function (a1) {
        window.AbStor.DefineSlot[a].setTargeting(a1[0], [a1[1]]);
        return '';
      });
      return '';
    });
    clearTimeout(window.AbStor.SetTimeoutrefresh);
    window.AbStor.SetTimeoutrefresh = setTimeout(function () {
      __WEBPACK_IMPORTED_MODULE_2__TargetingCheck__["g" /* time */](0);
    }, 1000);
    return '';
  };

  slots.map(function (a) {
    if (window.document.getElementById(a.slotId)) {
      if (!window.AbStor.DefineSlot[a.adUnit]) {
        googletagCmdInistaillArr.push(a);
      } else {
        googletagCmdRefreshArr.push(a);
      }
    } else if (__WEBPACK_IMPORTED_MODULE_2__TargetingCheck__["a" /* defineOutOfPageSlot */].ab_mobile_web_catfish === a.slotId) {
      window.App.dispatch(__WEBPACK_IMPORTED_MODULE_0_shared_actions_globals__["b" /* bannerShow */]());
      googletagCmdInistaillArr.push(a);
    } else {}
    return '';
  });
  if (googletagCmdInistaillArr[0]) {
    googletagCmdInistaill(googletagCmdInistaillArr);
  }
  if (googletagCmdRefreshArr[0]) {
    googletagCmdRefresh(googletagCmdRefreshArr);
  }
  return '';
});

/***/ }),

/***/ 527:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/constants/search.js
var SEARCH_SNAKE_KEYS_EXCLUDE = ['prepaid_sum__gte', 'prepaid_sum__lte', 'monthly_payment__gte', 'monthly_payment__lte'];
// CONCATENATED MODULE: ./src/shared/helpers/search.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isCanBeRedirected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchVocabulary; });
/* harmony export (immutable) */ __webpack_exports__["d"] = getSearchQuery;
/* unused harmony export fetchMakesCounter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchVipCars; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchAdvertsWithOmit; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_constants_api__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_difference__ = __webpack_require__(1072);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_difference___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_difference__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_snakecase_keys__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_snakecase_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_snakecase_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_pick__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_omit__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_helpers_urls__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_constants_json_anyMake_json__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_constants_json_anyMake_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_shared_constants_json_anyMake_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_helpers_transportTypes__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_constants_adverts__ = __webpack_require__(322);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _this = this;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }













var isCanBeRedirected = function isCanBeRedirected(params) {
  if (params.seoQuery && params.seoQuery.active === true) return false;
  var urlPath = (params.url || '').split('/').filter(function (item) {
    return item;
  });
  // If this is /avto/{country} we should not fire redirect.
  if (urlPath.length === 2 && urlPath[0] === 'avto' && urlPath[1] === (params.location && params.location.slug)) {
    return false;
  }
  return true;
};

var fetchVocabulary = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(vocabulary, transportType, fetch) {
    var customVc = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var rootTransportType, slug, isMotoSearch, isAuto, missingVocabularyFields, fetchedVocabulary, mergedVocabulary;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            rootTransportType = __WEBPACK_IMPORTED_MODULE_9_shared_helpers_transportTypes__["d" /* getRootTransportType */](transportType);
            slug = rootTransportType && rootTransportType.slug;
            isMotoSearch = ['moto', 'mototsikl'].includes(slug);
            isAuto = slug === 'avto';
            // const vocabularytoFetch = ['makes', 'drives', 'engines', 'categories', 'gearboxes'];

            missingVocabularyFields = Object.keys(vocabulary).filter(function (key) {
              return !vocabulary[key] || key === 'makes' || isMotoSearch || customVc.length && customVc.includes(key);
            });


            if (isAuto) {
              missingVocabularyFields = __WEBPACK_IMPORTED_MODULE_2_lodash_difference___default.a(missingVocabularyFields, ['packages', 'rubrics', 'types', 'engineOrders', 'tacts', 'unloadings', 'options']);
            }

            _context.next = 8;
            return Promise.all(missingVocabularyFields.map(function (field) {
              return __WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].VOCABULARY[field] ? fetch(__WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].VOCABULARY[field](transportType.id)).then(function (r) {
                return r.json();
              }).then(function (response) {
                return _defineProperty({}, field, response);
              }) : Promise.resolve({});
            }));

          case 8:
            fetchedVocabulary = _context.sent;
            mergedVocabulary = fetchedVocabulary.reduce(function (results, pair) {
              return _extends({}, results, pair);
            }, {});


            if (Array.isArray(mergedVocabulary.makes)) {
              mergedVocabulary.makes.unshift(__WEBPACK_IMPORTED_MODULE_8_shared_constants_json_anyMake_json___default.a);
            }

            return _context.abrupt('return', mergedVocabulary);

          case 12:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function fetchVocabulary(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

function getSearchQuery(query) {
  var qObject = __WEBPACK_IMPORTED_MODULE_6_shared_helpers_urls__["d" /* generateSearchQuery */](query);
  if (qObject.make && qObject.make === -1) {
    delete qObject.make;
  }
  var withExcluded = __WEBPACK_IMPORTED_MODULE_4_lodash_pick___default.a(qObject, SEARCH_SNAKE_KEYS_EXCLUDE);
  var withputExcluded = __WEBPACK_IMPORTED_MODULE_5_lodash_omit___default.a(qObject, SEARCH_SNAKE_KEYS_EXCLUDE);
  var q = __WEBPACK_IMPORTED_MODULE_3_snakecase_keys___default.a(withputExcluded);
  return _extends({}, q, withExcluded);
}

var fetchMakesCounter = function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(transportId, fetch) {
    var result;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return fetch(__WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].ADVERT.MAKES_COUNT + '?transport=' + transportId).then(function (r) {
              return r.json();
            });

          case 2:
            result = _context2.sent;
            return _context2.abrupt('return', result);

          case 4:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function fetchMakesCounter(_x5, _x6) {
    return _ref3.apply(this, arguments);
  };
}();

var fetchVipCars = function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(fetch, pages) {
    var specialCars, CURRENT_TRANSPORT_ID, params, omitQuery, vipParam, q, promisesToAwait;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            specialCars = void 0;
            // const PRICE_FROM = 1000000;
            // const CARS_IN_LIST = 20;
            // const LITVA_ID = 4482;

            CURRENT_TRANSPORT_ID = 1;
            params = {
              is_vip: true,
              transport: CURRENT_TRANSPORT_ID
            };
            omitQuery = [].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_10_shared_constants_adverts__["b" /* ANY_TYPE_OMITTED_FIELDS */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_10_shared_constants_adverts__["f" /* OMMITED_FIELDS_BY_TRANSPORT_ID */][CURRENT_TRANSPORT_ID] || []));

            if (pages) params.perPage = pages;

            vipParam = getSearchQuery(params);
            q = '?omit=' + omitQuery + '&' + __WEBPACK_IMPORTED_MODULE_1_query_string___default.a.stringify(vipParam);
            promisesToAwait = [];


            promisesToAwait.push(Promise.all([fetch(__WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].ADVERT.ALL(q)).then(function (r) {
              return r && r.json && r.json();
            })]).then(function (allResults) {
              var _allResults = _slicedToArray(allResults, 1),
                  vipCars = _allResults[0];

              specialCars = {
                vipCars: vipCars,
                lowPriceCars: [],
                europeCars: []
              };
            }));
            _context3.prev = 9;
            _context3.next = 12;
            return Promise.all(promisesToAwait);

          case 12:
            _context3.next = 16;
            break;

          case 14:
            _context3.prev = 14;
            _context3.t0 = _context3['catch'](9);

          case 16:
            return _context3.abrupt('return', specialCars);

          case 17:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this, [[9, 14]]);
  }));

  return function fetchVipCars(_x7, _x8) {
    return _ref4.apply(this, arguments);
  };
}();

function parseQuery(params) {
  if (typeof params === 'string') return Object.fromEntries(new URLSearchParams(params));
  return params;
}

var fetchAdvertsWithOmit = function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(fetch, params, pages) {
    var result, CURRENT_TRANSPORT_ID, CURRENCY, paramsObject, qParams, omitQuery, q;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            result = null;
            CURRENT_TRANSPORT_ID = 1;
            CURRENCY = 'usd';
            paramsObject = parseQuery(params);
            qParams = _extends({}, paramsObject, {
              transport: paramsObject.transport || CURRENT_TRANSPORT_ID,
              currency: paramsObject.currency || CURRENCY
            });
            omitQuery = [].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_10_shared_constants_adverts__["b" /* ANY_TYPE_OMITTED_FIELDS */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_10_shared_constants_adverts__["f" /* OMMITED_FIELDS_BY_TRANSPORT_ID */][CURRENT_TRANSPORT_ID] || []));

            if (pages) qParams.perPage = pages;

            q = '?omit=' + omitQuery + '&' + __WEBPACK_IMPORTED_MODULE_1_query_string___default.a.stringify(getSearchQuery(qParams));
            // console.log(' query >> ', q);

            _context4.prev = 8;
            _context4.next = 11;
            return fetch(__WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].ADVERT.ALL(q)).then(function (r) {
              return r && r.json && r.json();
            });

          case 11:
            result = _context4.sent;
            _context4.next = 16;
            break;

          case 14:
            _context4.prev = 14;
            _context4.t0 = _context4['catch'](8);

          case 16:
            return _context4.abrupt('return', result);

          case 17:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this, [[8, 14]]);
  }));

  return function fetchAdvertsWithOmit(_x9, _x10, _x11) {
    return _ref5.apply(this, arguments);
  };
}();

/***/ }),

/***/ 562:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchRubrics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchModels; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchGenerations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchNews; });
/* unused harmony export getModels */
/* unused harmony export getGenerations */
/* unused harmony export sortVideo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_api__ = __webpack_require__(29);
var _this2 = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var fetchRubrics = function fetchRubrics(fetch) {
  return fetch(__WEBPACK_IMPORTED_MODULE_1__constants_api__["a" /* default */].JOURNAL.RUBRICS()).then(function (r) {
    return r.ok ? r.json() : [];
  }).then(function (rubrics) {
    return rubrics.filter(function (rubric) {
      return !rubric.hidden;
    });
  });
};

var fetchModels = function fetchModels(fetch, transport, make) {
  return fetch(__WEBPACK_IMPORTED_MODULE_1__constants_api__["a" /* default */].ADVERT.MODELS_COUNT + '?' + __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify({ transport: transport, make: make })).then(function (r) {
    return r.json();
  });
};

var fetchGenerations = function fetchGenerations(fetch, modelId) {
  return fetch(__WEBPACK_IMPORTED_MODULE_1__constants_api__["a" /* default */].CMM.generationsByModel(modelId)).then(function (r) {
    return r.json();
  });
};

var fetchNews = function fetchNews(_ref) {
  var fetch = _ref.fetch,
      params = _objectWithoutProperties(_ref, ['fetch']);

  return fetch(__WEBPACK_IMPORTED_MODULE_1__constants_api__["a" /* default */].JOURNAL.LIST(params)).then(function (r) {
    return r.json();
  });
};


var getModels = function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var makeId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var prefSearch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var _this = arguments[2];

    var transport, _this$props, fetch, videoFilters, _ref3, model, models;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            transport = 1;
            _this$props = _this.props, fetch = _this$props.fetch, videoFilters = _this$props.videoFilters;
            _ref3 = prefSearch && videoFilters, model = _ref3.model;
            _context.next = 5;
            return makeId && fetchModels(fetch, transport, makeId);

          case 5:
            models = _context.sent;

            // if makeId not selected we getting all videos
            if (models) _this.setState({ models: models });
            if (model && models) _this.handleModelChange(model, prefSearch);

          case 8:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this2);
  }));

  return function getModels() {
    return _ref2.apply(this, arguments);
  };
}();

var getGenerations = function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var modelId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var prefSearch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var _this = arguments[2];

    var _this$props2, fetch, videoFilters, _ref5, generation, generations;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _this$props2 = _this.props, fetch = _this$props2.fetch, videoFilters = _this$props2.videoFilters;
            _ref5 = prefSearch && videoFilters, generation = _ref5.generation;
            _context2.next = 4;
            return modelId && fetchGenerations(fetch, modelId);

          case 4:
            generations = _context2.sent;


            if (generations) _this.setState({ generations: generations });
            if (generation && generations) _this.handleGenerChange(generation, prefSearch);

          case 7:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this2);
  }));

  return function getGenerations() {
    return _ref4.apply(this, arguments);
  };
}();

var sortVideo = function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(sortRequest, setNews) {
    var videos;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return fetchNews(sortRequest);

          case 2:
            videos = _context3.sent;

            setNews(videos && videos.results || []);

          case 4:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this2);
  }));

  return function sortVideo(_x5, _x6) {
    return _ref6.apply(this, arguments);
  };
}();

/***/ }),

/***/ 563:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return postForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return patchForm; });
/* unused harmony export fetchLocations */
/* unused harmony export fetchAllCities */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fillUserData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loadFromAdvert; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_snakecase_keys__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_snakecase_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_snakecase_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_camelcase_keys__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_camelcase_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_camelcase_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_constants_api__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_partsStatuses_json__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_partsStatuses_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shared_constants_json_partsStatuses_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_helpers_common__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_actions_partsForm__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__arrays__ = __webpack_require__(104);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _this = this;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









var postForm = function postForm(fetch, token, _ref) {
  var transport = _ref.transport,
      model = _ref.model,
      advertFields = _ref.advertFields,
      subRubric = _ref.subRubric,
      photos = _ref.photos,
      photosToUpdate = _ref.photosToUpdate,
      photosToDelete = _ref.photosToDelete,
      formState = _objectWithoutProperties(_ref, ['transport', 'model', 'advertFields', 'subRubric', 'photos', 'photosToUpdate', 'photosToDelete']);

  return fetch(__WEBPACK_IMPORTED_MODULE_2_shared_constants_api__["a" /* default */].SPARE_PARTS.ALL(), {
    headers: { Authorization: 'JWT ' + token },
    method: 'POST',
    body: JSON.stringify(__WEBPACK_IMPORTED_MODULE_0_snakecase_keys___default.a(_extends({}, __WEBPACK_IMPORTED_MODULE_4_shared_helpers_common__["l" /* objectsToIDs */](_extends({}, formState, {
      photos: photos,
      vehicleType: transport
    })), {
      sparetypes: subRubric ? [subRubric.id] : [],
      models: model ? [model.id] : []
    }, advertFields)))
  }).then(function (response) {
    if (!response.ok) {
      throw new Error('Не удалось отправить форму. Попробуйте позже.');
    }

    return response;
  }).then(function (r) {
    return r.json();
  });
};


var patchForm = function patchForm(fetch, token, _ref2, id) {
  var transport = _ref2.transport,
      model = _ref2.model,
      advertFields = _ref2.advertFields,
      subRubric = _ref2.subRubric,
      photos = _ref2.photos,
      photosToUpdate = _ref2.photosToUpdate,
      photosToDelete = _ref2.photosToDelete,
      formState = _objectWithoutProperties(_ref2, ['transport', 'model', 'advertFields', 'subRubric', 'photos', 'photosToUpdate', 'photosToDelete']);

  return fetch(__WEBPACK_IMPORTED_MODULE_2_shared_constants_api__["a" /* default */].SPARE_PARTS.ITEM(id), {
    headers: { Authorization: 'JWT ' + token },
    method: 'PATCH',
    body: JSON.stringify(__WEBPACK_IMPORTED_MODULE_0_snakecase_keys___default.a(_extends({}, __WEBPACK_IMPORTED_MODULE_4_shared_helpers_common__["l" /* objectsToIDs */](_extends({}, formState, {
      photos: photos,
      vehicleType: transport
    })), {
      sparetypes: subRubric ? [subRubric.id] : [],
      models: model ? [model.id] : []
    }, advertFields)))
  }).then(function (response) {
    if (!response.ok) {
      throw new Error('Не удалось отправить форму. Попробуйте позже.');
    }

    return response;
  }).then(function (r) {
    return r.json();
  });
};

//


var fetchLocation = function fetchLocation(fetch, id) {
  return id ? fetch(__WEBPACK_IMPORTED_MODULE_2_shared_constants_api__["a" /* default */].VOCABULARY.location(id)).then(function (r) {
    return r.json();
  }) : Promise.resolve();
};

var fetchLocations = function fetchLocations(fetch) {
  return fetch(__WEBPACK_IMPORTED_MODULE_2_shared_constants_api__["a" /* default */].VOCABULARY.locations()).then(function (r) {
    return r.json();
  });
};

var fetchAllCities = function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(fetch) {
    var sort = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    var cities, _cities, result, regions;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            cities = [];
            _context.prev = 1;
            _context.next = 4;
            return fetchLocations(fetch);

          case 4:
            result = _context.sent;

            if (!(!result || !result[0] || result[0].id !== 1911)) {
              _context.next = 7;
              break;
            }

            return _context.abrupt('return', []);

          case 7:
            regions = result[0].children;

            cities = (_cities = cities).concat.apply(_cities, _toConsumableArray(regions.map(function (item) {
              return item.children;
            })));
            _context.next = 13;
            break;

          case 11:
            _context.prev = 11;
            _context.t0 = _context['catch'](1);

          case 13:
            return _context.abrupt('return', sort ? cities.sort(__WEBPACK_IMPORTED_MODULE_6__arrays__["b" /* compareByTitle */]) : cities);

          case 14:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[1, 11]]);
  }));

  return function fetchAllCities(_x) {
    return _ref3.apply(this, arguments);
  };
}();

var fillUserData = function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(fetch, store) {
    var shouldFetchLocation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var state, email, phones, location;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            state = store.getState();
            email = state.user.user.email || null;
            phones = (state.user.user.phones || []).filter(function (phone) {
              return phone.is_verified;
            }).map(function (phone) {
              return phone.number;
            });


            store.dispatch(__WEBPACK_IMPORTED_MODULE_5_shared_actions_partsForm__["b" /* partsFormActions */].partsForm.selected.set.email(email));
            store.dispatch(__WEBPACK_IMPORTED_MODULE_5_shared_actions_partsForm__["b" /* partsFormActions */].partsForm.selected.set.phones(phones));

            if (state.user.user.name) {
              store.dispatch(__WEBPACK_IMPORTED_MODULE_5_shared_actions_partsForm__["b" /* partsFormActions */].partsForm.selected.set.contactName(state.user.user.name));
            }

            if (!shouldFetchLocation) {
              _context2.next = 11;
              break;
            }

            _context2.next = 9;
            return state.advertForm.selected.location || fetchLocation(fetch, state.user.user.location);

          case 9:
            location = _context2.sent;


            if (location) {
              store.dispatch(__WEBPACK_IMPORTED_MODULE_5_shared_actions_partsForm__["b" /* partsFormActions */].partsForm.selected.set.location(location));
            }

          case 11:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function fillUserData(_x3, _x4) {
    return _ref4.apply(this, arguments);
  };
}();

/**
 *  Initializes the partsForm from an advert and user data.
 *  If false is returned then the user doesn't have rights to edit the advert.
 *
 * @param fetch
 * @param store
 * @param thisAdvert
 * @returns {Promise<boolean>}
 */
var loadFromAdvert = function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(fetch, store, thisAdvert) {
    var selectedActions, _camelcaseKeys, transport, rubric, make, sparetypes, models, price, camelcasedAdvert, _store$getState, user, priceValue;

    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            selectedActions = __WEBPACK_IMPORTED_MODULE_5_shared_actions_partsForm__["b" /* partsFormActions */].partsForm.selected;
            _camelcaseKeys = __WEBPACK_IMPORTED_MODULE_1_camelcase_keys___default.a(thisAdvert), transport = _camelcaseKeys.vehicleType, rubric = _camelcaseKeys.rubric, make = _camelcaseKeys.make, sparetypes = _camelcaseKeys.sparetypes, models = _camelcaseKeys.models, price = _camelcaseKeys.price, camelcasedAdvert = _objectWithoutProperties(_camelcaseKeys, ['vehicleType', 'rubric', 'make', 'sparetypes', 'models', 'price']);
            _store$getState = store.getState(), user = _store$getState.user;

            // Check if my advert

            if (!(!thisAdvert.author || thisAdvert.author.id !== user.user.id)) {
              _context3.next = 5;
              break;
            }

            return _context3.abrupt('return', false);

          case 5:
            _context3.next = 7;
            return store.dispatch(__WEBPACK_IMPORTED_MODULE_5_shared_actions_partsForm__["c" /* partsFormAsyncSetActions */].transport(transport));

          case 7:
            _context3.next = 9;
            return store.dispatch(__WEBPACK_IMPORTED_MODULE_5_shared_actions_partsForm__["c" /* partsFormAsyncSetActions */].rubric(rubric));

          case 9:
            _context3.next = 11;
            return store.dispatch(__WEBPACK_IMPORTED_MODULE_5_shared_actions_partsForm__["c" /* partsFormAsyncSetActions */].make(make));

          case 11:

            if (sparetypes[0]) {
              store.dispatch(selectedActions.set.subRubric(sparetypes[0]));
            }
            if (models[0]) {
              store.dispatch(selectedActions.set.model(models[0]));
            }

            Object.keys(selectedActions.set).forEach(function (key) {
              var value = camelcasedAdvert[key];

              if (value && ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object' || Array.isArray(value)) || value && (value.id || value.id === 0)) {
                store.dispatch(selectedActions.set[key](value));
              }
            });

            fillUserData(fetch, store, false);
            priceValue = price.find(function (priceObject) {
              return priceObject.currency === camelcasedAdvert.currency.slug;
            });

            store.dispatch(selectedActions.set.price(priceValue && priceValue.value || null));

            __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_partsStatuses_json___default.a.forEach(function (status) {
              if (thisAdvert[status.id]) {
                store.dispatch(selectedActions.toggle.advertFields(status.id));
              }
            });

            return _context3.abrupt('return', true);

          case 19:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this);
  }));

  return function loadFromAdvert(_x6, _x7, _x8) {
    return _ref5.apply(this, arguments);
  };
}();


/***/ }),

/***/ 565:
/***/ (function(module, exports) {

module.exports = [{"title":"газобаллонное оборудование","id":"gas_equipment"}]

/***/ }),

/***/ 566:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__allText__ = __webpack_require__(309);
/* eslint-disable no-continue */



/* harmony default export */ __webpack_exports__["a"] = (function (data) {
  var obj = {};
  var _data$allData = data.allData,
      url = _data$allData.url,
      locale = _data$allData.locale,
      translate = _data$allData.translate;

  var page = url.split('/').filter(Boolean);
  for (var a = 0, b = Object.keys(data), c = b.length; a < c; a += 1) {
    var str = data[b[a]];
    if (/allData/.test(b[a])) continue;
    if (/isNew/.test(b[a])) {
      obj[b[a]] = str;
      continue;
    }
    if (page[0] === 'zapchasti') {
      if (__WEBPACK_IMPORTED_MODULE_0__allText__["g" /* sity */][str]) {
        obj[b[a]] = __WEBPACK_IMPORTED_MODULE_0__allText__["g" /* sity */][str][locale].genitive;
        continue;
      }
      if (/transportTitle|transportDescriptions|transportHeader|transportNextDescriptions/.test(b[a])) {
        if (__WEBPACK_IMPORTED_MODULE_0__allText__["d" /* plural */][str]) {
          obj[b[a]] = __WEBPACK_IMPORTED_MODULE_0__allText__["d" /* plural */][str][locale];
          continue;
        }
        if (data.section && str === 'легковые') {
          obj[b[a]] = ' ';
          continue;
        }
        obj[b[a]] = translate(str);
        continue;
      }
      obj[b[a]] = str;
      continue;
    }
    if (page[0] === 'avtosalony') {
      if (__WEBPACK_IMPORTED_MODULE_0__allText__["d" /* plural */][str]) {
        obj[b[a]] = __WEBPACK_IMPORTED_MODULE_0__allText__["d" /* plural */][str][locale];
        continue;
      }
      if (__WEBPACK_IMPORTED_MODULE_0__allText__["g" /* sity */][str]) {
        if (b[a] === 'cityHeader') {
          obj[b[a]] = __WEBPACK_IMPORTED_MODULE_0__allText__["g" /* sity */][str][locale].accusative;
        } else {
          obj[b[a]] = __WEBPACK_IMPORTED_MODULE_0__allText__["g" /* sity */][str][locale].genitive;
        }

        continue;
      }
      if (/transportTitle|transportDescriptions|transportHeader|transportNextDescriptions/.test(b[a])) {
        obj[b[a]] = translate(str);
        continue;
      }

      obj[b[a]] = str;
      continue;
    }
    if (page[0] === 'katalog-kompaniy') {
      if (__WEBPACK_IMPORTED_MODULE_0__allText__["g" /* sity */][str] && b[a] === 'locationAccusative') {
        obj[b[a]] = __WEBPACK_IMPORTED_MODULE_0__allText__["g" /* sity */][str][locale].accusative;
        continue;
      } else if (__WEBPACK_IMPORTED_MODULE_0__allText__["g" /* sity */][str] && b[a] !== 'regLocation') {
        obj[b[a]] = __WEBPACK_IMPORTED_MODULE_0__allText__["g" /* sity */][str][locale].genitive;
        continue;
      }
      if (/transportTitle|transportDescriptions|transportHeader|transportNextDescriptions/.test(b[a])) {
        obj[b[a]] = translate(str);
        continue;
      }
      obj[b[a]] = translate(str);
      continue;
    }
    if (/commercial|pritsepy|avtobus|spetstehnika|gruzovye|vodnyi-transport/.test(page[0])) {
      if (__WEBPACK_IMPORTED_MODULE_0__allText__["g" /* sity */][str]) {
        obj[b[a]] = __WEBPACK_IMPORTED_MODULE_0__allText__["g" /* sity */][str][locale].genitive;
        continue;
      }
      var transport = __WEBPACK_IMPORTED_MODULE_0__allText__["a" /* crutch */](data.isNew)[str];
      if (page[0] === 'commercial' && /transportTitle|transportHeader/.test(b[a])) {
        obj[b[a]] = translate('коммерческий транспорт');
        continue;
      } else if (page[0] === 'commercial' && /transportDescriptions/.test(b[a])) {
        obj[b[a]] = translate('коммерческого транспорта');
        continue;
      }
      if (/transportCategoryTitle/.test(b[a]) && transport && transport[locale].pluralTransport) {
        obj[b[a]] = transport[locale].pluralTransport;
        continue;
      }
      if (transport && transport[locale]) {
        obj[b[a]] = transport[locale][b[a]];
        continue;
      }
      if (__WEBPACK_IMPORTED_MODULE_0__allText__["e" /* pluralCrutch */][str]) {
        obj[b[a]] = __WEBPACK_IMPORTED_MODULE_0__allText__["e" /* pluralCrutch */][str][locale];
        continue;
      }
      if (/transportTitle|transportDescriptions|transportHeader|transportNextDescriptions/.test(b[a])) {
        obj[b[a]] = translate(str);
        continue;
      }
    }
    if (page[0] === 'avto') {
      if (__WEBPACK_IMPORTED_MODULE_0__allText__["g" /* sity */][str]) {
        obj[b[a]] = __WEBPACK_IMPORTED_MODULE_0__allText__["g" /* sity */][str][locale].genitive;
        continue;
      }
      var _transport = __WEBPACK_IMPORTED_MODULE_0__allText__["a" /* crutch */](data.isNew)[str];
      if (_transport && _transport[locale]) {
        obj[b[a]] = _transport[locale][b[a]];
        continue;
      }
      obj[b[a]] = translate(str);
      continue;
    }
    if (/moto|mototsikl|skuter|karting|kvadrotsikl|moped|baggi|tritsikl/.test(page[0])) {
      if (__WEBPACK_IMPORTED_MODULE_0__allText__["g" /* sity */][str]) {
        obj[b[a]] = __WEBPACK_IMPORTED_MODULE_0__allText__["g" /* sity */][str][locale].genitive;
        continue;
      }
      var _transport2 = __WEBPACK_IMPORTED_MODULE_0__allText__["a" /* crutch */](data.isNew)[str];
      if (_transport2 && _transport2[locale]) {
        obj[b[a]] = _transport2[locale][b[a]];
        continue;
      }
      obj[b[a]] = translate(str);
      continue;
    }
    obj[b[a]] = str;
  }

  return obj;
});

/***/ }),

/***/ 570:
/***/ (function(module, exports) {

module.exports = {"default":[{"title":"По актуальности"},{"id":"price","title":"По цене (дешевле – дороже)"},{"id":"-price","title":"По цене (дороже – дешевле)"},{"id":"-year","title":"По году (новые – старые)"},{"id":"year","title":"По году (старые – новые)"},{"id":"mileage","title":"По пробегу"}],"spares":[{"title":"По актуальности"},{"id":"price","title":"По цене (дешевле – дороже)"},{"id":"-price","title":"По цене (дороже – дешевле)"},{"id":"-year_to","title":"По году (новые – старые)"},{"id":"year_to","title":"По году (старые – новые)"},{"id":"date_published","title":"По публикации (свежее - старше)"},{"id":"-date_published","title":"По публикации (старше - свежее)"}],"mobile":[{"title":"По актуальности"},{"value":"price","title":"Самые дешевые"},{"value":"-price","title":"Самые дорогие"},{"value":"-year","title":"Самые новые"},{"value":"year","title":"Самые старые"},{"value":"mileage","title":"По пробегу"}]}

/***/ }),

/***/ 574:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(575);
module.exports = __webpack_require__(774);


/***/ }),

/***/ 774:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/metaBuilder.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_query_string__);


/* harmony default export */ var metaBuilder_defaultExport = (function (route) {
  var isPageWithPaging = !!route.page;
  var pageNumber = isPageWithPaging && parseFloat(route.page);
  var shouldSetNoIndex = route.shouldSetNoIndex;
  var shouldSetIndex = route.shouldSetIndex;
  var shouldCanonicalizePage = !shouldSetNoIndex && Object.keys(route.query).find(function (key) {
    return key !== 'page';
  });

  var stringifiedQuery = __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify(route.query);
  var stringifiedPrevQuery = pageNumber >= 1 ? __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify({
    page: pageNumber > 2 ? pageNumber - 1 : undefined
  }) : '';
  var stringifiedNextQuery = pageNumber && pageNumber < 100 && !route.isLastPage ? __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify({
    page: pageNumber + 1
  }) : '';

  var isAdvertPage = route.type === 'advert';

  return {
    isAdvertPage: isAdvertPage,
    pageNumber: pageNumber,
    shouldSetIndex: shouldSetIndex,
    shouldSetNoIndex: shouldSetNoIndex,
    shouldCanonicalizePage: shouldCanonicalizePage,
    stringifiedPrevQuery: stringifiedPrevQuery ? '?' + stringifiedPrevQuery : '',
    stringifiedNextQuery: stringifiedNextQuery ? '?' + stringifiedNextQuery : '',
    stringifiedQuery: stringifiedQuery ? '?' + stringifiedQuery : ''
  };
});
// CONCATENATED MODULE: ./src/shared/classes/UnauthorizedError.js
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _extendableBuiltin(cls) {
  function ExtendableBuiltin() {
    var instance = Reflect.construct(cls, Array.from(arguments));
    Object.setPrototypeOf(instance, Object.getPrototypeOf(this));
    return instance;
  }

  ExtendableBuiltin.prototype = Object.create(cls.prototype, {
    constructor: {
      value: cls,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  if (Object.setPrototypeOf) {
    Object.setPrototypeOf(ExtendableBuiltin, cls);
  } else {
    ExtendableBuiltin.__proto__ = cls;
  }

  return ExtendableBuiltin;
}

var UnauthorizedError = function (_extendableBuiltin2) {
  _inherits(UnauthorizedError, _extendableBuiltin2);

  function UnauthorizedError() {
    var _ref;

    _classCallCheck(this, UnauthorizedError);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = UnauthorizedError.__proto__ || Object.getPrototypeOf(UnauthorizedError)).call.apply(_ref, [this].concat(args)));

    _this.message = 'UnauthorizedError';
    if (Error.captureStackTrace) {
      Error.captureStackTrace(_this, UnauthorizedError);
    }
    return _this;
  }

  return UnauthorizedError;
}(_extendableBuiltin(Error));

/* harmony default export */ var UnauthorizedError_defaultExport = (UnauthorizedError);
// CONCATENATED MODULE: ./src/shared/actions/loading.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__ = __webpack_require__(17);



var loadingStart = __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["j" /* LOADING */].START);
var loadingDone = __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["j" /* LOADING */].DONE);
var loadingSetInitial = __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["j" /* LOADING */].SET_INITIAL);

var loadingDoneAndSetInitial = function loadingDoneAndSetInitial() {
  return function (dispatch) {
    dispatch(loadingDone());
    dispatch(loadingSetInitial());
  };
};
// CONCATENATED MODULE: ./src/createFetch.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var createFetch_createFetch401Wrapper = function createFetch401Wrapper(fetchFunction) {
  return function (url, options) {
    if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window.App && window.App.dispatch && typeof window.App.dispatch === 'function') {
      window.App.dispatch(loadingStart());
    }
    // console.time(url);
    return fetchFunction(url, options).then(function (response) {
      if (response.status === 401) {
        throw new UnauthorizedError_defaultExport('UnauthorizedError');
      }

      return response;
    }).finally(function () {
      // console.timeEnd(url);
      if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window.App && window.App.dispatch && typeof window.App.dispatch === 'function') {
        window.App.dispatch(loadingDone());
      }
    });
  };
};

/**
 * Creates a wrapper function around the HTML5 Fetch API that provides
 * default arguments to fetch(...) and is intended to reduce the amount
 * of boilerplate code in the application.
 * https://developer.mozilla.org/docs/Web/API/Fetch_API/Using_Fetch
 */
function createFetch(fetch, _ref) {
  var baseUrl = _ref.baseUrl,
      defaultAuth = _ref.defaultAuth;

  // NOTE: Tweak the default options to suite your application needs
  var defaults = {
    mode: baseUrl ? 'cors' : 'same-origin',
    // credentials: baseUrl ? 'include' : 'same-origin',
    credentials: 'omit',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      cookie: null
    },
    cache: 'no-store'
  };

  return createFetch_createFetch401Wrapper(function (url, options) {
    var isFormData = typeof window !== 'undefined' && options && options.body instanceof FormData;

    var _defaults$headers = defaults.headers,
        defaultContentType = _defaults$headers['Content-Type'],
        defaultHeaders = _objectWithoutProperties(_defaults$headers, ['Content-Type']);

    var encodedURI = '' + baseUrl + encodeURI(decodeURIComponent(url));

    return url.startsWith('/graphql') || url.startsWith('/api') ? fetch(encodedURI, _extends({}, defaults, url.startsWith('/graphql') ? { method: 'POST' } : {}, options, {
      headers: _extends({}, defaultHeaders, isFormData ? {} : { 'Content-Type': defaultContentType }, options && options.headers, defaultAuth || options && options.headers && options.headers.Authorization ? {
        Authorization: [options && options.headers && options.headers.Authorization, defaultAuth].filter(function (x) {
          if (x === 'JWT ') {
            return false;
          }
          if (!x) {
            return false;
          }
          return true;
        }).join(', ')
      } : {})
    })) : fetch(url, options);
  });
}

/* harmony default export */ var createFetch_defaultExport = (createFetch);
// CONCATENATED MODULE: ./src/shared/store/createHelpers.js
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function createGraphqlRequest(fetch) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(query, variables) {
      var fetchConfig, resp;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              fetchConfig = {
                method: 'post',
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ query: query, variables: variables }),
                credentials: 'include'
              };
              _context.next = 3;
              return fetch('/graphql', fetchConfig);

            case 3:
              resp = _context.sent;

              if (!(resp.status !== 200)) {
                _context.next = 6;
                break;
              }

              throw new Error(resp.statusText);

            case 6:
              return _context.abrupt('return', resp.json());

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function graphqlRequest(_x, _x2) {
      return _ref.apply(this, arguments);
    }

    return graphqlRequest;
  }();
}

function createHelpers(_ref2) {
  var fetch = _ref2.fetch,
      history = _ref2.history;

  return {
    fetch: fetch,
    history: history,
    graphqlRequest: createGraphqlRequest(fetch)
  };
}
// CONCATENATED MODULE: ./src/shared/store/logger/logger.client.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_logger__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_logger__);


function logger_client_createLogger() {
  return __WEBPACK_IMPORTED_MODULE_0_redux_logger__["createLogger"]({
    collapsed: true
  });
}
// CONCATENATED MODULE: ./src/shared/store/configureStore.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_thunk__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_thunk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_thunk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_localstorage__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_localstorage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_localstorage__);
var configureStore__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var configureStore__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* global __DEV__ */







var APP = "desktop";

var noOp = function noOp(x) {
  return x;
};

function configureStore(initialState, rootReducer, helpersConfig) {
  var helpers = createHelpers(helpersConfig);
  var middleware = [__WEBPACK_IMPORTED_MODULE_1_redux_thunk___default.a.withExtraArgument(helpers)];

  var enhancer =  true ? __WEBPACK_IMPORTED_MODULE_2_redux_localstorage___default.a(['advertForm', 'partsForm', 'user'], {
    slicer: function slicer() {
      return function (_ref) {
        var advertForm = _ref.advertForm,
            partsForm = _ref.partsForm,
            user = _ref.user;
        return {
          advertForm: {
            selected: configureStore__extends({}, advertForm.selected, {
              photos: []
            }),
            data: {
              newExistingPhotos: advertForm.data.newExistingPhotos ? [].concat(_toConsumableArray(advertForm.data.newExistingPhotos)) : [],
              currentFormStep: user && user.token ? advertForm.data.currentFormStep : ''
            }
          },
          user: {
            token: user.token,
            user: user.user,
            error: user.error,
            balance: user.balance
          },
          partsForm: !partsForm || partsForm.isEdit ? {} : configureStore__extends({}, partsForm, {
            selected: configureStore__extends({}, partsForm.selected, {
              photos: []
            })
          })
        };
      };
    }
  }) : noOp;

  if (false) {
    middleware.push(createLogger());

    // https://github.com/zalmoxisus/redux-devtools-extension#redux-devtools-extension
    var devToolsExtension = noOp;
    if (process.env.BROWSER && window.devToolsExtension) {
      devToolsExtension = window.devToolsExtension();
    }

    enhancer = compose(enhancer, applyMiddleware.apply(undefined, middleware), devToolsExtension);
  } else {
    enhancer = __WEBPACK_IMPORTED_MODULE_0_redux__["d" /* compose */](enhancer, __WEBPACK_IMPORTED_MODULE_0_redux__["a" /* applyMiddleware */].apply(undefined, middleware));
  }

  // See https://github.com/rackt/redux/releases/tag/v3.1.0
  var store = __WEBPACK_IMPORTED_MODULE_0_redux__["e" /* createStore */](rootReducer, initialState, enhancer, (typeof window === 'undefined' ? 'undefined' : configureStore__typeof(window)) === 'object' && window._REDUX_DEVTOOLS_EXTENSION_ && window.__REDUX_DEVTOOLS_EXTENSION__());

  // Hot reload reducers (requires Webpack or Browserify HMR to be enabled)
  if (false) {
    module.hot.accept('../../' + APP + '/reducers', function () {
      return (
        // eslint-disable-next-line global-require, import/no-dynamic-require
        store.replaceReducer(require('../../' + APP + '/reducers/index').default)
      );
    });
  }

  return store;
}
// CONCATENATED MODULE: ./src/shared/reducers/advertForm.js
/* harmony import */ var advertForm___WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_currency_json__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_currency_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shared_constants_json_currency_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_mileageUnits_json__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_mileageUnits_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shared_constants_json_mileageUnits_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_sortable_hoc__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_sortable_hoc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_sortable_hoc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_constants_json_capacityUnits_json__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_constants_json_capacityUnits_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_shared_constants_json_capacityUnits_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_constants_json_powerUnits_json__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_constants_json_powerUnits_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_shared_constants_json_powerUnits_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_constants_json_engineFeatures_json__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_constants_json_engineFeatures_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_shared_constants_json_engineFeatures_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_constants_json_statuses_json__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_constants_json_statuses_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_shared_constants_json_statuses_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_helpers_advertForm__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_constants_advertForm__ = __webpack_require__(192);
var advertForm__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function advertForm__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }













var ADVERT_FORM_SELECTED = 'ADVERT_FORM__SELECTED__';

var immutablySetField = function immutablySetField(state, field, value) {
  return advertForm__extends({}, state, _defineProperty({}, field, value));
};
var immutablySetDecimalField = function immutablySetDecimalField(state, field, value, intLength, decimalLength) {
  return immutablySetField(state, field, __WEBPACK_IMPORTED_MODULE_9_shared_helpers_advertForm__["k" /* parseDecimal */](value, intLength, decimalLength));
};

var arrayToPicked = function arrayToPicked(array) {
  return array.reduce(function (object, field) {
    return advertForm__extends({}, object, _defineProperty({}, field, true));
  }, {});
};

var advertForm_initialState = {
  selected: {
    id: 0,
    active: 0,
    transport: null,
    make: null,
    model: null,
    year: null,
    series: null,
    engine: null,
    drive: null,
    gearbox: null,
    modification: null,
    equipment: null,
    color: null,
    mileage: null,
    vin: null,
    price: null,
    generation: null,
    description: null,
    location: null,
    contactName: null,
    email: null,
    photos: [],
    phones: [],
    colorFeatures: {},
    options: {},
    advertFields: {},
    mileageUnit: __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_mileageUnits_json___default.a[0],
    currency: __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_currency_json___default.a[1],
    abroad: false,
    drivenFrom: null,
    video: null,
    regNumber: '',
    usedWarranty: null,
    // Moto
    category: null,
    engineOrder: null,
    tacts: null,
    capacity: null,
    capacityUnit: null,
    power: null,
    powerUnit: null,
    // Truck
    cabin: null,
    unloading: null,
    ecotype: null,
    cabinSuspension: null,
    chassisSuspension: null,
    // Bus
    seats: null,
    // Technics
    tonnage: null,
    capacityBody: null,
    axises: null,
    dimensionWidth: null,
    dimensionHeight: null,
    dimensionLength: null,
    dimensionWeight: null,
    capacityBucket: null,
    layingWidth: null,
    liftHeight: null,
    admissionHeight: null,
    armBoom: null,
    depBig: null,
    productivity: null,
    // Trailer
    capacityBodyType: __WEBPACK_IMPORTED_MODULE_5_shared_constants_json_capacityUnits_json___default.a[0],
    suspension: null,
    brakes: null,
    //
    clarifyPrice: false,
    clarifyPriceLink: '',
    //
    modelTitle: null,
    makeTitle: null,
    // Water
    overallLength: null,
    dryWeight: null,
    draft: null,
    displacement: null,
    fuelTank: null,
    waterTank: null,
    seaworthinessClass: null
  },
  data: {
    models: null,
    modifications: null,
    equipments: null,
    generations: null,
    existingPhotos: [],
    newExistingPhotos: [],
    years: null,
    series: null,
    body: null,
    averagePrice: undefined,
    advertsAveragePrice: null,
    averagePriceParams: null,
    showAveragePrice: false,
    warranty: null,
    newAdvert: {},
    currentFormStep: __WEBPACK_IMPORTED_MODULE_10_shared_constants_advertForm__["a" /* FORM_STEPS */].MAIN
  },
  vocabulary: {
    statuses: __WEBPACK_IMPORTED_MODULE_8_shared_constants_json_statuses_json___default.a,
    currency: __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_currency_json___default.a,
    mileageUnits: __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_mileageUnits_json___default.a,
    capacityUnits: __WEBPACK_IMPORTED_MODULE_5_shared_constants_json_capacityUnits_json___default.a,
    powerUnits: __WEBPACK_IMPORTED_MODULE_6_shared_constants_json_powerUnits_json___default.a,
    engineFeatures: __WEBPACK_IMPORTED_MODULE_7_shared_constants_json_engineFeatures_json___default.a,
    // avto
    europeanCountries: null,
    //
    makes: null,
    colors: null,
    colorFeatures: null,
    options: null,
    priceStatuses: null,
    locations: null,
    services: null,
    // Moto
    categories: null,
    engines: null,
    engineOrders: null,
    drives: null,
    gearboxes: null,
    tacts: null,
    // Trucks
    cabins: null,
    unloadings: null,
    ecotypes: null,
    cabinSuspensions: null,
    chassisSuspensions: null,
    // Trailers
    suspensions: null,
    brakes: null,
    // Water
    overallLength: null,
    dryWeight: null,
    draft: null,
    displacement: null,
    fuelTank: null,
    waterTank: null,
    seaworthinessClasses: null
  },
  isEdit: null,
  isClearBtn: false // - for show/hide clear button in header
};

var data = function data() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : advertForm_initialState.data;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].CLEAR:
      return advertForm_initialState.data;

    case __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].DATA_MODELS_SET:
      return immutablySetField(state, 'models', action.payload);

    case __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].DATA_MODIFICATIONS_SET:
      return immutablySetField(state, 'modifications', action.payload);

    case __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].DATA_EQUIPMENTS_SET:
      return immutablySetField(state, 'equipments', action.payload);

    case __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].DATA_EXISTING_PHOTOS_SET:
      return immutablySetField(state, 'existingPhotos', action.payload);

    case __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].DATA_EXISTING_PHOTOS_SET_NEW:
      if ('set' in action.payload) {
        var len = state.newExistingPhotos.length;
        return immutablySetField(state, 'newExistingPhotos', [].concat(advertForm__toConsumableArray(state.newExistingPhotos), [{
          image: action.payload.set,
          order: len + 1,
          total: len
        }]));
      }
      if ('rewrite' in action.payload) {
        return immutablySetField(state, 'newExistingPhotos', action.payload.rewrite);
      }
      if ('delete' in action.payload) {
        var newExistingPhotos = state.newExistingPhotos;
        newExistingPhotos.splice(action.payload.delete, 1);
        return immutablySetField(state, 'newExistingPhotos', newExistingPhotos);
      }
      if ('sort' in action.payload) {
        var sort = action.payload.sort;
        var sortingPhotos = __WEBPACK_IMPORTED_MODULE_4_react_sortable_hoc__["arrayMove"](state.newExistingPhotos, sort.oldIndex, sort.newIndex);

        for (var a = 0; a < sortingPhotos.length; a += 1) {
          sortingPhotos[a].order = a;
        }
        return immutablySetField(state, 'newExistingPhotos', sortingPhotos);
      }
      if ('clear' in action.payload) {
        return immutablySetField(state, 'newExistingPhotos', []);
      }
      return state;

    case __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].DATA_EXISTING_ADVERTS_SET_NEW:
      if ('set' in action.payload) {
        return immutablySetField(state, 'newExistingAdverts', action.payload.set);
      }
      if ('clear' in action.payload) {
        return immutablySetField(state, 'newExistingAdverts', {});
      }
      return state;

    case __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].DATA_NEW_ADVERT:
      if ('set' in action.payload) {
        return immutablySetField(state, 'newAdvert', action.payload.set);
      }
      if ('clear' in action.payload) {
        return immutablySetField(state, 'newAdvert', null);
      }
      return state;

    case __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].DATA_CURRENT_FORM_STEP:
      if ('set' in action.payload) {
        return immutablySetField(state, 'currentFormStep', action.payload.set);
      }
      if ('clear' in action.payload) {
        return immutablySetField(state, 'currentFormStep', '');
      }
      return state;

    case __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].DATA_YEARS_SET:
      return immutablySetField(state, 'years', action.payload);

    case __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].DATA_GENERATIONS_SET:
      return immutablySetField(state, 'generations', action.payload);

    case __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].DATA_SERIES_SET:
      return immutablySetField(state, 'series', action.payload);

    case __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].DATA_AVERAGE_PRICE_SET:
      return immutablySetField(state, 'averagePrice', action.payload);

    case __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].DATA_ADVERTS_AVERAGE_PRICE_SET:
      return immutablySetField(state, 'advertsAveragePrice', action.payload);

    case __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].DATA_AVERAGE_PRICE_PARAMS_SET:
      return immutablySetField(state, 'averagePriceParams', action.payload);

    case __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].DATA_WARRANTY_SET:
      return immutablySetField(state, 'warranty', action.payload);

    case __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].DATA_SHOW_AVERAGE_PRICE_SET:
      return immutablySetField(state, 'showAveragePrice', action.payload);

    default:
      return state;
  }
};

var vocabulary = function vocabulary() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : advertForm_initialState.vocabulary;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].VOCABULARY_SET:
      {
        return advertForm__extends({}, state, action.payload);
      }

    case __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].VOCABULARY_CLEAR:
      {
        return advertForm_initialState.vocabulary;
      }

    default:
      return state;
  }
};

var selected = function selected() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : advertForm_initialState.selected;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].CLEAR:
      {
        return advertForm__extends({}, advertForm_initialState.selected, {
          transport: state.transport,
          phones: state.phones
        });
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__ID:
      {
        return immutablySetField(state, 'id', action.payload);
      }
    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__ACTIVE:
      {
        return immutablySetField(state, 'active', action.payload);
      }
    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__TRANSPORT:
      {
        return immutablySetField(state, 'transport', action.payload);
      }
    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__MAKE:
      {
        return immutablySetField(state, 'make', action.payload);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__MODEL:
      {
        return immutablySetField(state, 'model', action.payload);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__YEAR:
      {
        return immutablySetField(state, 'year', action.payload);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__GENERATION:
      {
        return immutablySetField(state, 'generation', action.payload);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__SERIES:
      {
        return immutablySetField(state, 'series', action.payload);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__BODY:
      {
        return immutablySetField(state, 'body', action.payload);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__MILEAGE_UNIT:
      {
        return immutablySetField(state, 'mileageUnit', action.payload);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__CURRENCY:
      {
        return immutablySetField(state, 'currency', action.payload);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__ENGINE:
      {
        return immutablySetField(state, 'engine', action.payload);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__DRIVE:
      {
        return immutablySetField(state, 'drive', action.payload);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__GEARBOX:
      {
        return immutablySetField(state, 'gearbox', action.payload);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__MODIFICATION:
      {
        return immutablySetField(state, 'modification', action.payload);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__EQUIPMENT:
      {
        return immutablySetField(state, 'equipment', action.payload);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__VIDEO:
      {
        return immutablySetField(state, 'video', action.payload || null);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.ADD__PHOTOS:
      {
        return immutablySetField(state, 'photos', [].concat(advertForm__toConsumableArray(state.photos), [action.payload]));
      }
    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.REMOVE__PHOTOS:
      {
        return immutablySetField(state, 'photos', state.photos.filter(function (p) {
          return p.id !== action.payload;
        }));
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__COLOR:
      {
        return immutablySetField(state, 'color', action.payload);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__LOCATION:
      {
        return immutablySetField(state, 'location', action.payload);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__ABROAD:
      {
        return immutablySetField(state, 'abroad', !!action.payload);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__DRIVEN_FROM:
      {
        return immutablySetField(state, 'drivenFrom', action.payload);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__CONTACT_NAME:
      {
        return immutablySetField(state, 'contactName', action.payload || null);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__EMAIL:
      {
        return immutablySetField(state, 'email', action.payload || null);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__COLOR_FEATURES:
      {
        return immutablySetField(state, 'colorFeatures', arrayToPicked(action.payload.map(function (item) {
          return item.id;
        })));
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__PHONES:
      {
        return immutablySetField(state, 'phones', Array.isArray(action.payload) ? action.payload : state.phones);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__OPTIONS:
      {
        var newOptions = advertForm__extends({}, state.options);

        Object.keys(action.payload).forEach(function (key) {
          // Probably should write that in an immutable way
          delete newOptions[key];
          if (action.payload[key]) {
            newOptions[key] = action.payload[key];
          }
        });

        return advertForm__extends({}, state, {
          options: newOptions
        });
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.CLEAR__OPTIONS:
      {
        return immutablySetField(state, 'options', advertForm_initialState.selected.options);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__MILEAGE:
      {
        return advertForm__extends({}, state, {
          mileage: __WEBPACK_IMPORTED_MODULE_9_shared_helpers_advertForm__["k" /* parseDecimal */](action.payload || null, 5, 0)
        });
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__VIN:
      {
        return advertForm__extends({}, state, {
          vin: action.payload ? ('' + action.payload).toUpperCase() : null
        });
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__DESCRIPTION:
      {
        return advertForm__extends({}, state, {
          description: action.payload || null
        });
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__PRICE:
      {
        return advertForm__extends({}, state, {
          price: parseInt(action.payload, 10) || null
        });
      }

    // Clarify price
    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__CLARIFY_PRICE_LINK:
      {
        return immutablySetField(state, 'clarifyPriceLink', action.payload);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__CLARIFY_PRICE:
      {
        return immutablySetField(state, 'clarifyPrice', !!action.payload);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.TOGGLE__CLARIFY_PRICE:
      {
        return advertForm__extends({}, state, {
          clarifyPrice: !state.clarifyPrice,
          clarifyPriceLink: ''
        });
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.TOGGLE__COLOR_FEATURES:
      {
        var colorFeatures = state.colorFeatures;


        return advertForm__extends({}, state, {
          colorFeatures: advertForm__extends({}, colorFeatures, _defineProperty({}, action.payload, !colorFeatures[action.payload]))
        });
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.TOGGLE__STATUSES:
      {
        return advertForm__extends({}, state, {
          statuses: advertForm__extends({}, state.statuses, _defineProperty({}, action.payload, !state.statuses[action.payload]))
        });
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.TOGGLE__ADVERT_FIELDS:
      {
        var advertFields = state.advertFields;


        return advertForm__extends({}, state, {
          advertFields: advertForm__extends({}, advertFields, _defineProperty({}, action.payload, !advertFields[action.payload]))
        });
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.ADD__PHONE:
      {
        var phone = action.payload;
        var phones = state.phones;


        return advertForm__extends({}, state, {
          phones: phones.includes(phone) ? phones : [].concat(advertForm__toConsumableArray(phones), [phone])
        });
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.REMOVE__PHONE:
      {
        return advertForm__extends({}, state, {
          phones: state.phones.filter(function (phone) {
            return phone !== action.payload;
          })
        });
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__MODEL_TITLE:
      {
        return immutablySetField(state, 'modelTitle', action.payload || null);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__MAKE_TITLE:
      {
        return immutablySetField(state, 'makeTitle', action.payload || null);
      }

    // Moto

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__CATEGORY:
      {
        return immutablySetField(state, 'category', action.payload);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__ENGINE_ORDER:
      {
        return immutablySetField(state, 'engineOrder', action.payload);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__TACTS:
      {
        return immutablySetField(state, 'tacts', action.payload);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__CAPACITY:
      {
        return immutablySetDecimalField(state, 'capacity', parseFloat(action.payload) || null, 5, 1);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__CAPACITY_UNIT:
      {
        return immutablySetField(state, 'capacityUnit', action.payload);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__POWER:
      {
        return immutablySetDecimalField(state, 'power', parseFloat(action.payload) || null, 5, 2);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__POWER_UNIT:
      {
        return immutablySetField(state, 'powerUnit', action.payload);
      }

    // Truck

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__CABIN:
      {
        return immutablySetField(state, 'cabin', action.payload);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__UNLOADING:
      {
        return immutablySetField(state, 'unloading', action.payload);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__ECOTYPE:
      {
        return immutablySetField(state, 'ecotype', action.payload);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__CABIN_SUSPENSION:
      {
        return immutablySetField(state, 'cabinSuspension', action.payload);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__CHASSIS_SUSPENSION:
      {
        return immutablySetField(state, 'chassisSuspension', action.payload);
      }

    // Bus

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__SEATS:
      {
        return immutablySetField(state, 'seats', action.payload);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__RANGE_TYPE:
      {
        return immutablySetField(state, 'rangeTypes', action.payload);
      }

    // Technics

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__TONNAGE:
      {
        return immutablySetDecimalField(state, 'tonnage', parseFloat(action.payload) || null, 2, 2);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__CAPACITY_BODY:
      {
        return immutablySetDecimalField(state, 'capacityBody', parseFloat(action.payload) || null, 5, 2);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__AXISES:
      {
        return immutablySetField(state, 'axises', parseInt(action.payload, 10) || null);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__DIMENSION_WIDTH:
      {
        return immutablySetDecimalField(state, 'dimensionWidth', parseFloat(action.payload) || null, 3, 2);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__DIMENSION_HEIGHT:
      {
        return immutablySetDecimalField(state, 'dimensionHeight', parseFloat(action.payload) || null, 3, 2);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__DIMENSION_LENGTH:
      {
        return immutablySetDecimalField(state, 'dimensionLength', parseFloat(action.payload) || null, 3, 2);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__DIMENSION_WEIGHT:
      {
        return immutablySetDecimalField(state, 'dimensionWeight', parseFloat(action.payload) || null, 3, 2);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__CAPACITY_BUCKET:
      {
        return immutablySetDecimalField(state, 'capacityBucket', parseFloat(action.payload) || null, 3, 2);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__LAYING_WIDTH:
      {
        return immutablySetDecimalField(state, 'layingWidth', parseFloat(action.payload) || null, 3, 2);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__LIFT_HEIGHT:
      {
        return immutablySetDecimalField(state, 'liftHeight', parseFloat(action.payload) || null, 3, 2);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__ADMISSION_HEIGHT:
      {
        return immutablySetDecimalField(state, 'admissionHeight', parseFloat(action.payload) || null, 3, 2);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__ARM_BOOM:
      {
        return immutablySetDecimalField(state, 'armBoom', parseFloat(action.payload) || null, 3, 2);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__DEP_BIG:
      {
        return immutablySetDecimalField(state, 'depBig', parseFloat(action.payload) || null, 3, 2);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__PRODUCTIVITY:
      {
        return immutablySetDecimalField(state, 'productivity', parseFloat(action.payload) || null, 7, 2);
      }

    // Trailers

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__CAPACITY_BODY_TYPE:
      {
        return immutablySetField(state, 'capacityBodyType', action.payload);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__SUSPENSION:
      {
        return immutablySetField(state, 'suspension', action.payload);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__BRAKES:
      {
        return immutablySetField(state, 'brakes', action.payload);
      }

    // Water

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__OVERALL_LENGTH:
      {
        return immutablySetDecimalField(state, 'overallLength', parseFloat(action.payload) || null, 3, 2);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__DRY_WEIGHT:
      {
        return immutablySetDecimalField(state, 'dryWeight', parseFloat(action.payload) || null, 3, 3);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__DRAFT:
      {
        return immutablySetDecimalField(state, 'draft', parseFloat(action.payload) || null, 3, 2);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__DISPLACEMENT:
      {
        return immutablySetDecimalField(state, 'displacement', parseFloat(action.payload) || null, 7, 1);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__FUEL_TANK:
      {
        return immutablySetDecimalField(state, 'fuelTank', parseFloat(action.payload) || null, 3, 2);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__WATER_TANK:
      {
        return immutablySetDecimalField(state, 'waterTank', parseFloat(action.payload) || null, 3, 2);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__SEAWORTHINESS_CLASS:
      {
        return immutablySetField(state, 'seaworthinessClass', action.payload);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__REG_NUMBER:
      {
        return immutablySetField(state, 'regNumber', action.payload);
      }

    case '' + ADVERT_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SELECTED.SET__USED_WARRANTY:
      {
        return immutablySetField(state, 'usedWarranty', action.payload);
      }

    default:
      return state;
  }
};

var isEdit = function isEdit() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : advertForm_initialState.isEdit;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SET_IS_EDIT:
      return !!action.payload;

    default:
      return state;
  }
};

var isClearBtn = function isClearBtn() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : advertForm_initialState.isClearBtn;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1_shared_constants_actionTypes__["a" /* ADVERT_FORM */].SET_IS_CLEAR_BTN:
      return !!action.payload;

    default:
      return state;
  }
};

/* harmony default export */ var advertForm_defaultExport = (advertForm___WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */]({
  selected: selected,
  data: data,
  vocabulary: vocabulary,
  isEdit: isEdit,
  isClearBtn: isClearBtn
}));
// CONCATENATED MODULE: ./src/shared/reducers/partsForm.js
/* harmony import */ var partsForm___WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fromPairs__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fromPairs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_fromPairs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_actions_partsForm__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_constants_json_transportTypes_json__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_constants_json_transportTypes_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_shared_constants_json_transportTypes_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_constants_json_currency_json__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_constants_json_currency_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_shared_constants_json_currency_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_helpers_locale__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_constants_json_partsStatuses_json__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_constants_json_partsStatuses_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_shared_constants_json_partsStatuses_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_constants_json_partsSellingTypes_json__ = __webpack_require__(1149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_constants_json_partsSellingTypes_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_shared_constants_json_partsSellingTypes_json__);
var _extends5;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var partsForm__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function partsForm__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function partsForm__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








// import CITIES from 'shared/constants/json/cities.json';



var selectedPairs = Object.entries(__WEBPACK_IMPORTED_MODULE_3_shared_actions_partsForm__["b" /* partsFormActions */].partsForm.selected.set);
var vocabularyPairs = Object.entries(__WEBPACK_IMPORTED_MODULE_3_shared_actions_partsForm__["b" /* partsFormActions */].partsForm.vocabulary);
var selectedActions = __WEBPACK_IMPORTED_MODULE_3_shared_actions_partsForm__["b" /* partsFormActions */].partsForm.selected;

var partsForm_immutablySetField = function immutablySetField(state, field, value) {
  return partsForm__extends({}, state, partsForm__defineProperty({}, field, value));
};

var partsForm_initialState = {
  selected: partsForm__extends({}, __WEBPACK_IMPORTED_MODULE_2_lodash_fromPairs___default.a(selectedPairs.map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
        key = _ref2[0];

    return [key, null];
  })), {
    photos: [],
    phones: [],
    currency: __WEBPACK_IMPORTED_MODULE_5_shared_constants_json_currency_json___default.a.find(function (currencyItem) {
      return currencyItem.slug === 'usd';
    }),
    advertFields: {}
  }),
  vocabulary: partsForm__extends({}, __WEBPACK_IMPORTED_MODULE_2_lodash_fromPairs___default.a(vocabularyPairs.map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 1),
        key = _ref4[0];

    return [key, null];
  })), {
    //
    transports: __WEBPACK_IMPORTED_MODULE_4_shared_constants_json_transportTypes_json___default.a.filter(function (type) {
      return type.parents.length === 0;
    }),
    currency: __WEBPACK_IMPORTED_MODULE_5_shared_constants_json_currency_json___default.a,
    locations: __WEBPACK_IMPORTED_MODULE_6_shared_helpers_locale__["b" /* getAllLocations */](true),
    statuses: __WEBPACK_IMPORTED_MODULE_7_shared_constants_json_partsStatuses_json___default.a,
    sellingTypes: __WEBPACK_IMPORTED_MODULE_8_shared_constants_json_partsSellingTypes_json___default.a
  }),
  isEdit: false
};

var partsForm_selected = __WEBPACK_IMPORTED_MODULE_1_redux_actions__["d" /* handleActions */](partsForm__extends(partsForm__defineProperty({}, __WEBPACK_IMPORTED_MODULE_3_shared_actions_partsForm__["b" /* partsFormActions */].partsForm.clear, function () {
  return partsForm_initialState.selected;
}), __WEBPACK_IMPORTED_MODULE_2_lodash_fromPairs___default.a(selectedPairs.map(function (_ref5) {
  var _ref6 = _slicedToArray(_ref5, 2),
      key = _ref6[0],
      value = _ref6[1];

  return [
  // toString() of the action creator gives us an action type string
  value, function (state, action) {
    return partsForm_immutablySetField(state, key, action.payload);
  }];
})), (_extends5 = {}, partsForm__defineProperty(_extends5, selectedActions.add.photos, function (state, action) {
  return partsForm_immutablySetField(state, 'photos', [].concat(partsForm__toConsumableArray(state.photos), [action.payload]));
}), partsForm__defineProperty(_extends5, selectedActions.remove.photos, function (state, action) {
  return partsForm_immutablySetField(state, 'photos', state.photos.filter(function (p) {
    return p.id !== action.payload;
  }));
}), partsForm__defineProperty(_extends5, selectedActions.add.phones, function (state, action) {
  return partsForm_immutablySetField(state, 'phones', state.phones.includes(action.payload) ? state.phones : [].concat(partsForm__toConsumableArray(state.phones), [action.payload]));
}), partsForm__defineProperty(_extends5, selectedActions.remove.phones, function (state, action) {
  return partsForm_immutablySetField(state, 'phones', state.phones.filter(function (phone) {
    return phone !== action.payload;
  }));
}), partsForm__defineProperty(_extends5, selectedActions.toggle.advertFields, function (state, action) {
  return partsForm_immutablySetField(state, 'advertFields', partsForm__extends({}, state.advertFields, partsForm__defineProperty({}, action.payload, !state.advertFields[action.payload])));
}), _extends5)), partsForm_initialState.selected);

var partsForm_vocabulary = __WEBPACK_IMPORTED_MODULE_1_redux_actions__["d" /* handleActions */](partsForm__extends(partsForm__defineProperty({}, __WEBPACK_IMPORTED_MODULE_3_shared_actions_partsForm__["b" /* partsFormActions */].partsForm.clear, function () {
  return partsForm_initialState.vocabulary;
}), __WEBPACK_IMPORTED_MODULE_2_lodash_fromPairs___default.a(vocabularyPairs.map(function (_ref7) {
  var _ref8 = _slicedToArray(_ref7, 2),
      key = _ref8[0],
      value = _ref8[1];

  return [value, function (state, action) {
    return partsForm_immutablySetField(state, key, action.payload);
  }];
}))), partsForm_initialState.vocabulary);

var partsForm_isEdit = __WEBPACK_IMPORTED_MODULE_1_redux_actions__["c" /* handleAction */](__WEBPACK_IMPORTED_MODULE_3_shared_actions_partsForm__["b" /* partsFormActions */].partsForm.isEdit, function (state, action) {
  return action.payload;
}, partsForm_initialState.isEdit);

/* harmony default export */ var partsForm_defaultExport = (partsForm___WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */]({
  selected: partsForm_selected,
  vocabulary: partsForm_vocabulary,
  isEdit: partsForm_isEdit
}));
// CONCATENATED MODULE: ./src/shared/reducers/searchForm.js
/* harmony import */ var searchForm___WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_concat__ = __webpack_require__(1150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_currency_json__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_currency_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shared_constants_json_currency_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_constants_json_mileageUnits_json__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_constants_json_mileageUnits_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_shared_constants_json_mileageUnits_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_constants_json_dealers_json__ = __webpack_require__(1151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_constants_json_dealers_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_shared_constants_json_dealers_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_constants_json_wheels_json__ = __webpack_require__(1152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_constants_json_wheels_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_shared_constants_json_wheels_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_constants_json_states_json__ = __webpack_require__(1153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_constants_json_states_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_shared_constants_json_states_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_constants_json_busTypes_json__ = __webpack_require__(1154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_constants_json_busTypes_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_shared_constants_json_busTypes_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_constants_json_truckTypes_json__ = __webpack_require__(1155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_constants_json_truckTypes_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_shared_constants_json_truckTypes_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_constants_json_trailerTypes_json__ = __webpack_require__(1156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_constants_json_trailerTypes_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_shared_constants_json_trailerTypes_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_constants_json_technicsTypes_json__ = __webpack_require__(1157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_constants_json_technicsTypes_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_shared_constants_json_technicsTypes_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_constants_json_waterTypes_json__ = __webpack_require__(1158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_constants_json_waterTypes_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_shared_constants_json_waterTypes_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_constants_json_customs_json__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_constants_json_customs_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_shared_constants_json_customs_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_shared_constants_json_colors_json__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_shared_constants_json_colors_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_shared_constants_json_colors_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_shared_constants_json_ecoTypes_json__ = __webpack_require__(1159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_shared_constants_json_ecoTypes_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_shared_constants_json_ecoTypes_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_shared_constants_json_rent_json__ = __webpack_require__(1160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_shared_constants_json_rent_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_shared_constants_json_rent_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_shared_constants_json_credit_json__ = __webpack_require__(1161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_shared_constants_json_credit_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_shared_constants_json_credit_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_shared_constants_json_ordering_json__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_shared_constants_json_ordering_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_shared_constants_json_ordering_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_shared_constants_json_periods_json__ = __webpack_require__(1162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_shared_constants_json_periods_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_shared_constants_json_periods_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_shared_constants_json_capacities_json__ = __webpack_require__(1163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_shared_constants_json_capacities_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_shared_constants_json_capacities_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_shared_constants_json_abroadOptions_json__ = __webpack_require__(1164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_shared_constants_json_abroadOptions_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_shared_constants_json_abroadOptions_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_shared_constants_json_countries_json__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_shared_constants_json_countries_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_shared_constants_json_countries_json__);
var searchForm__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function searchForm__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

























var SEARCH_FORM_SELECTED = 'SEARCH_FORM__SELECTED__';
var sluggifiedCurrency = __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_currency_json___default.a.map(function (item) {
  return searchForm__extends({}, item, { id: item.slug });
});
var IS_MOBILE = "desktop" === 'mobile';

var searchForm_initialState = {
  selected: {
    make: null,
    makes: null,
    model: null,
    yearTo: null,
    yearFrom: null,
    priceFrom: null,
    priceTo: null,
    prepaid: null,
    monthly: null,
    powerFrom: null,
    powerTo: null,
    capacityFrom: null,
    capacityTo: null,
    mileageFrom: null,
    company: null,
    typeWork: null,
    mileageTo: null,
    engine: null,
    drive: null,
    gearbox: null,
    usedWarranty: null,
    // modification: null,
    category: null,
    colors: [],
    generation: null,
    // description: null,
    location: null,
    // colorFeatures: {},
    // statuses: {},
    options: {},
    ordering: __WEBPACK_IMPORTED_MODULE_18_shared_constants_json_ordering_json___default.a.default[0],
    period: __WEBPACK_IMPORTED_MODULE_19_shared_constants_json_periods_json___default.a[0],
    powerUnit: 1,
    capacityUnit: 1,
    isCrashed: null,
    isNotCleared: null,
    isSaleOnCredit: null,
    isUnderLoan: null,
    isSwap: null,
    isRent: null,
    isNew: null,
    hasNew: null,
    transport: null,
    mileageUnit: __WEBPACK_IMPORTED_MODULE_4_shared_constants_json_mileageUnits_json___default.a[0],
    currency: IS_MOBILE ? sluggifiedCurrency[1] : sluggifiedCurrency[0],
    dealer: null,
    firm: null,
    photos: null, // null - all, 1-with, 0-without
    fromAuction: null,
    engineOrder: null,
    tacts: null,
    transportChild: null,
    ecotype: null,
    unloading: null,
    tonnageFrom: null,
    tonnageTo: null,
    fromDealer: null,

    // technics
    capacityBodyFrom: null,
    capacityBodyTo: null,
    capacityBucketFrom: null,
    capacityBucketTo: null,
    layingWidthFrom: null,
    layingWidthTo: null,
    liftHeightFrom: null,
    liftHeightTo: null,
    admissionHeightFrom: null,
    admissionHeightTo: null,
    armBoomFrom: null,
    armBoomTo: null,
    depBigFrom: null,
    depBigTo: null,
    productivityFrom: null,
    productivityTo: null,

    // dealers fields
    isOfficial: null,
    q: null,
    query: null,
    testDrive: null,
    tradeIn: null,
    credit: null,
    insurance: null,
    accessories: null,
    tags: null,

    // spares fields
    rubric: null,
    sparetype: null,
    isUsed: null,
    isOriginal: null,
    isAnalogue: null,
    abroad: null,
    inStock: null,
    isUnderTheOrder: null,

    // avto
    drivenFrom: null

    // wheel: wheels[0],
    // state: states[0],
    // credit: credits[0],
    // rent: rent[0],
    // customs: customs[0],
  },
  counts: {},
  results: {},
  data: {
    make: null,
    models: null,
    brandToChose: null,
    // modifications: null,
    // equipments: null,
    generations: null,
    types: null,
    // existingPhotos: [],
    // prices: null,
    // series: null,
    sparetypes: null,
    count: 0
  },
  vocabulary: {
    makes: null,
    categories: null,
    // colorFeatures: null,
    options: null,
    engines: null,
    drives: null,
    gearboxes: null,
    priceStatuses: null,
    statuses: null,
    locations: null,
    packages: null,
    rubrics: null,
    // avto
    // todo: refactor this logic. We need countries from may be driven cars, but not "europeanCountries".
    europeanCountries: __WEBPACK_IMPORTED_MODULE_22_shared_constants_json_countries_json___default.a.filter(function (country) {
      return country.isEuropean || country.isUsa || country.includeInDrivenFrom;
    }),
    // Moto
    types: null,
    childrenTransportTypes: {
      avtobus: __WEBPACK_IMPORTED_MODULE_8_shared_constants_json_busTypes_json___default.a,
      gruzovye: __WEBPACK_IMPORTED_MODULE_9_shared_constants_json_truckTypes_json___default.a,
      pritsepy: __WEBPACK_IMPORTED_MODULE_10_shared_constants_json_trailerTypes_json___default.a,
      spetstehnika: __WEBPACK_IMPORTED_MODULE_11_shared_constants_json_technicsTypes_json___default.a,
      'vodnyi-transport': __WEBPACK_IMPORTED_MODULE_12_shared_constants_json_waterTypes_json___default.a
    },
    engineOrders: null,
    tacts: null,
    // other
    ecotypes: __WEBPACK_IMPORTED_MODULE_15_shared_constants_json_ecoTypes_json___default.a,
    unloadings: null,
    //
    years: Array.from(new Array(50), function (val, index) {
      return new Date().getFullYear() - index;
    }),
    colors: __WEBPACK_IMPORTED_MODULE_14_shared_constants_json_colors_json___default.a,
    capacities: __WEBPACK_IMPORTED_MODULE_20_shared_constants_json_capacities_json___default.a,
    ordering: __WEBPACK_IMPORTED_MODULE_18_shared_constants_json_ordering_json___default.a,
    periods: __WEBPACK_IMPORTED_MODULE_19_shared_constants_json_periods_json___default.a,
    credits: __WEBPACK_IMPORTED_MODULE_17_shared_constants_json_credit_json___default.a,
    rent: __WEBPACK_IMPORTED_MODULE_16_shared_constants_json_rent_json___default.a,
    states: __WEBPACK_IMPORTED_MODULE_7_shared_constants_json_states_json___default.a,
    customs: __WEBPACK_IMPORTED_MODULE_13_shared_constants_json_customs_json___default.a,
    dealers: __WEBPACK_IMPORTED_MODULE_5_shared_constants_json_dealers_json___default.a,
    wheels: __WEBPACK_IMPORTED_MODULE_6_shared_constants_json_wheels_json___default.a,
    currency: __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_currency_json___default.a,
    mileageUnits: __WEBPACK_IMPORTED_MODULE_4_shared_constants_json_mileageUnits_json___default.a,
    abroadOptions: __WEBPACK_IMPORTED_MODULE_21_shared_constants_json_abroadOptions_json___default.a
  }
};

var searchForm_immutablySetField = function immutablySetField(state, field, value) {
  return searchForm__extends({}, state, searchForm__defineProperty({}, field, value));
};

var searchForm_data = function data() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : searchForm_initialState.data;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].DATA_BRAND_TO_CHOSE_SET:
      return searchForm_immutablySetField(state, 'brandToChose', action.payload);

    case __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].DATA_MODELS_SET:
      return searchForm_immutablySetField(state, 'models', action.payload);

    case __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].DATA_MODIFICATIONS_SET:
      return searchForm_immutablySetField(state, 'modifications', action.payload);

    case __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].DATA_PRICES_SET:
      return searchForm_immutablySetField(state, 'prices', action.payload);

    case __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].DATA_YEARS_SET:
      return searchForm_immutablySetField(state, 'years', action.payload);

    case __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].DATA_GENERATIONS_SET:
      return searchForm_immutablySetField(state, 'generations', action.payload);

    case __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].DATA_SERIES_SET:
      return searchForm_immutablySetField(state, 'series', action.payload);

    case __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].DATA_DRIVES_SET:
      return searchForm_immutablySetField(state, 'drives', action.payload);

    case __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].DATA_GEARBOXES_SET:
      return searchForm_immutablySetField(state, 'gearboxes', action.payload);

    case __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].DATA_COUNT_SET:
      return searchForm_immutablySetField(state, 'count', action.payload);

    case __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].DATA_MAKES_COUNTER_SET:
      return searchForm_immutablySetField(state, 'makesCounter', action.payload);

    case __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].DATA_SPARETYPES_SET:
      return searchForm_immutablySetField(state, 'sparetypes', action.payload);

    case __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].RESET_ALL:
      {
        return searchForm__extends({}, state, searchForm_initialState.data);
      }

    default:
      return state;
  }
};

var searchForm_vocabulary = function vocabulary() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : searchForm_initialState.vocabulary;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].VOCABULARY_SET:
      {
        return searchForm__extends({}, state, action.payload);
      }

    case __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].RESET_ALL:
      {
        return searchForm__extends({}, state, searchForm_initialState.vocabulary);
      }

    default:
      return state;
  }
};

var results = function results() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : searchForm_initialState.results;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].RESULTS_SET:
      {
        return searchForm__extends({}, state, action.payload);
      }

    default:
      return state;
  }
};

var counts = function counts() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : searchForm_initialState.counts;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].COUNTS_SET:
      {
        return searchForm__extends({}, state, action.payload);
      }

    default:
      return state;
  }
};

var searchForm_selected = function selected() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : searchForm_initialState.selected;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].CLEAR:
      {
        var isNew = state.isNew,
            transport = state.transport,
            fromDealer = state.fromDealer;

        return searchForm__extends({}, state, searchForm_initialState.selected, { isNew: isNew, transport: transport, fromDealer: fromDealer });
      }

    case __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].RESET_ALL:
      {
        return searchForm__extends({}, state, searchForm_initialState.selected);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__MAKE:
      {
        return searchForm_immutablySetField(state, 'make', action.payload);
      }
    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__MAKES:
      {
        return searchForm_immutablySetField(state, 'makes', action.payload);
      }
    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__MODEL:
      {
        return searchForm_immutablySetField(state, 'model', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__YEAR_FROM:
      {
        return searchForm_immutablySetField(state, 'yearFrom', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__YEAR_TO:
      {
        return searchForm_immutablySetField(state, 'yearTo', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__CAPACITY_BODY_FROM:
      {
        return searchForm_immutablySetField(state, 'capacityBodyFrom', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__CAPACITY_BODY_TO:
      {
        return searchForm_immutablySetField(state, 'capacityBodyTo', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__CAPACITY_BUCKET_FROM:
      {
        return searchForm_immutablySetField(state, 'capacityBucketFrom', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__CAPACITY_BUCKET_TO:
      {
        return searchForm_immutablySetField(state, 'capacityBucketTo', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__LAYING_WIDTH_FROM:
      {
        return searchForm_immutablySetField(state, 'layingWidthFrom', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__LAYING_WIDTH_TO:
      {
        return searchForm_immutablySetField(state, 'layingWidthTo', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__LIFT_HEIGHT_FROM:
      {
        return searchForm_immutablySetField(state, 'liftHeightFrom', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__LIFT_HEIGHT_TO:
      {
        return searchForm_immutablySetField(state, 'liftHeightTo', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__ADMISSION_HEIGHT_FROM:
      {
        return searchForm_immutablySetField(state, 'admissionHeightFrom', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__ADMISSION_HEIGHT_TO:
      {
        return searchForm_immutablySetField(state, 'admissionHeightTo', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__ARM_BOOM_FROM:
      {
        return searchForm_immutablySetField(state, 'armBoomFrom', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__ARM_BOOM_TO:
      {
        return searchForm_immutablySetField(state, 'armBoomTo', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__DEP_BIG_FROM:
      {
        return searchForm_immutablySetField(state, 'depBigFrom', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__DEP_BIG_TO:
      {
        return searchForm_immutablySetField(state, 'depBigTo', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__PRODUCTIVITY_FROM:
      {
        return searchForm_immutablySetField(state, 'productivityFrom', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__PRODUCTIVITY_TO:
      {
        return searchForm_immutablySetField(state, 'productivityTo', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__TONNAGE_FROM:
      {
        return searchForm_immutablySetField(state, 'tonnageFrom', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__TONNAGE_TO:
      {
        return searchForm_immutablySetField(state, 'tonnageTo', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__CAPACITY_TO:
      {
        return searchForm_immutablySetField(state, 'capacityTo', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__CAPACITY_FROM:
      {
        return searchForm_immutablySetField(state, 'capacityFrom', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__CAPACITY_UNIT:
      {
        return searchForm_immutablySetField(state, 'capacityUnit', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__POWER_UNIT:
      {
        return searchForm_immutablySetField(state, 'powerUnit', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__GENERATION:
      {
        return searchForm_immutablySetField(state, 'generation', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__SERIES:
      {
        return searchForm_immutablySetField(state, 'series', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__BODY:
      {
        return searchForm_immutablySetField(state, 'body', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__MILEAGE_UNIT:
      {
        return searchForm_immutablySetField(state, 'mileageUnit', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__CATEGORY:
      {
        return searchForm_immutablySetField(state, 'category', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__CURRENCY:
      {
        return searchForm_immutablySetField(state, 'currency', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__ENGINE:
      {
        return searchForm_immutablySetField(state, 'engine', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__DRIVE:
      {
        return searchForm_immutablySetField(state, 'drive', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__GEARBOX:
      {
        return searchForm_immutablySetField(state, 'gearbox', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__MODIFICATION:
      {
        return searchForm_immutablySetField(state, 'modification', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__EQUIPMENT:
      {
        return searchForm_immutablySetField(state, 'equipment', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__COLOR:
      {
        return searchForm_immutablySetField(state, 'color', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__LOCATION:
      {
        return searchForm_immutablySetField(state, 'location', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__DEALER:
      {
        return searchForm_immutablySetField(state, 'dealer', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__FIRM:
      {
        return searchForm_immutablySetField(state, 'firm', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__IS_RENT:
      {
        return searchForm_immutablySetField(state, 'isRent', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__IS_SWAP:
      {
        return searchForm_immutablySetField(state, 'isSwap', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__IS_CRASHED:
      {
        return searchForm_immutablySetField(state, 'isCrashed', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__IS_NOT_CLEARED:
      {
        return searchForm_immutablySetField(state, 'isNotCleared', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__IS_UNDER_LOAN:
      {
        return searchForm_immutablySetField(state, 'isUnderLoan', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__IS_SALE_ON_CREDIT:
      {
        return searchForm_immutablySetField(state, 'isSaleOnCredit', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__TRANSPORT:
      {
        return searchForm_immutablySetField(state, 'transport', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__IS_NEW:
      {
        return searchForm_immutablySetField(state, 'isNew', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__FROM_DEALER:
      {
        return searchForm_immutablySetField(state, 'fromDealer', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__HAS_NEW:
      {
        return searchForm_immutablySetField(state, 'hasNew', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__IS_USED:
      {
        return searchForm_immutablySetField(state, 'isUsed', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__TAGS:
      {
        return searchForm_immutablySetField(state, 'tags', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__IS_ORIGINAL:
      {
        return searchForm_immutablySetField(state, 'isOriginal', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__IS_ANALOGUE:
      {
        return searchForm_immutablySetField(state, 'isAnalogue', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__ABROAD:
      {
        return searchForm_immutablySetField(state, 'abroad', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__ECOTYPE:
      {
        return searchForm_immutablySetField(state, 'ecotype', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__IN_STOCK:
      {
        return searchForm_immutablySetField(state, 'inStock', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__IS_UNDER_THE_ORDER:
      {
        return searchForm_immutablySetField(state, 'isUnderTheOrder', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__FROM_AUCTION:
      {
        return searchForm_immutablySetField(state, 'fromAuction', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__PHOTOS:
      {
        return searchForm_immutablySetField(state, 'photos', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__ENGINE_ORDER:
      {
        return searchForm_immutablySetField(state, 'engineOrder', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__TACTS:
      {
        return searchForm_immutablySetField(state, 'tacts', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__TRANSPORT_CHILD:
      {
        return searchForm_immutablySetField(state, 'transportChild', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__IS_PHOTOS:
      {
        return searchForm_immutablySetField(state, 'photos', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__ORDERING:
      {
        return searchForm_immutablySetField(state, 'ordering', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__PERIOD:
      {
        return searchForm_immutablySetField(state, 'period', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__UNLOADING:
      {
        return searchForm_immutablySetField(state, 'unloading', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__RUBRIC:
      {
        return searchForm_immutablySetField(state, 'rubric', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__SPARETYPE:
      {
        return searchForm_immutablySetField(state, 'sparetype', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__DRIVEN_FROM:
      {
        return searchForm_immutablySetField(state, 'drivenFrom', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__OPTIONS:
      {
        var newOptions = searchForm__extends({}, state.options);

        Object.keys(action.payload).forEach(function (key) {
          // Probably should write that in an immutable way
          delete newOptions[key];
          if (action.payload[key]) {
            newOptions[key] = action.payload[key];
          }
        });

        return searchForm__extends({}, state, {
          options: newOptions
        });
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.CLEAR__OPTIONS:
      {
        return searchForm_immutablySetField(state, 'options', searchForm_initialState.selected.options);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__MILEAGE_FROM:
      {
        return searchForm__extends({}, state, {
          mileageFrom: parseInt(action.payload, 10) || null
        });
      }
    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__COMPANY:
      {
        return searchForm__extends({}, state, {
          company: action.payload || null
        });
      }
    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__TYPE_WORK:
      {
        return searchForm__extends({}, state, {
          typeWork: action.payload || null
        });
      }
    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__MILEAGE_TO:
      {
        return searchForm__extends({}, state, {
          mileageTo: parseInt(action.payload, 10) || null
        });
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__PRICE_FROM:
      {
        return searchForm__extends({}, state, {
          priceFrom: parseInt(action.payload, 10) || null
        });
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__MONTHLY:
      {
        return searchForm__extends({}, state, {
          monthly: parseInt(action.payload, 10) || null
        });
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__PREPAID:
      {
        return searchForm__extends({}, state, {
          prepaid: parseInt(action.payload, 10) || null
        });
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__PRICE_TO:
      {
        return searchForm__extends({}, state, {
          priceTo: parseInt(action.payload, 10) || null
        });
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__POWER_TO:
      {
        return searchForm__extends({}, state, {
          powerTo: parseInt(action.payload, 10) || null
        });
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__POWER_FROM:
      {
        return searchForm__extends({}, state, {
          powerFrom: parseInt(action.payload, 10) || null
        });
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__COLORS:
      {
        var Сolors = __WEBPACK_IMPORTED_MODULE_1_lodash_concat___default.a(action.payload).map(function (item) {
          return parseInt(item, 10);
        });

        return searchForm__extends({}, state, {
          colors: Сolors
        });
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.TOGGLE__COLORS:
      {
        var _olors = state.colors;


        var index = __WEBPACK_IMPORTED_MODULE_14_shared_constants_json_colors_json___default.a.indexOf(action.payload);
        if (index !== -1) {
          _olors.splice(index, 1);
        } else {
          _olors.push(action.payload);
        }

        return searchForm__extends({}, state, {
          colors: _olors
        });
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.TOGGLE__STATUSES:
      {
        var statuses = state.statuses;


        return searchForm__extends({}, state, {
          statuses: searchForm__extends({}, statuses, searchForm__defineProperty({}, action.payload, !statuses[action.payload]))
        });
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.TOGGLE__PRICE_STATUSES:
      {
        var priceStatuses = state.priceStatuses;


        return searchForm__extends({}, state, {
          priceStatuses: searchForm__extends({}, priceStatuses, searchForm__defineProperty({}, action.payload, !priceStatuses[action.payload]))
        });
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__IS_OFFICIAL:
      {
        return searchForm_immutablySetField(state, 'isOfficial', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__Q:
      {
        return searchForm_immutablySetField(state, 'q', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__QUERY:
      {
        return searchForm_immutablySetField(state, 'query', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__TEST_DRIVE:
      {
        return searchForm_immutablySetField(state, 'testDrive', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__TRADE_IN:
      {
        return searchForm_immutablySetField(state, 'tradeIn', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__CREDIT:
      {
        return searchForm_immutablySetField(state, 'credit', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__INSURANCE:
      {
        return searchForm_immutablySetField(state, 'insurance', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__ACCESSORIES:
      {
        return searchForm_immutablySetField(state, 'accessories', action.payload);
      }

    case '' + SEARCH_FORM_SELECTED + __WEBPACK_IMPORTED_MODULE_2_shared_constants_actionTypes__["m" /* SEARCH_FORM */].SELECTED.SET__USED_WARRANTY:
      {
        return searchForm_immutablySetField(state, 'usedWarranty', action.payload);
      }

    default:
      return state;
  }
};

/* harmony default export */ var searchForm_defaultExport = (searchForm___WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */]({
  selected: searchForm_selected,
  data: searchForm_data,
  results: results,
  counts: counts,
  vocabulary: searchForm_vocabulary
}));
// CONCATENATED MODULE: ./src/shared/reducers/user.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_constants_actionTypes__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_modules__ = __webpack_require__(103);
var user__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function user__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }




var user_initialState = {
  token: '',
  user: {},
  error: {},
  showSaveSearchBtn: false,
  savedSearches: null,
  balance: {
    isFetching: false,
    amount: null
  }
};

function user() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : user_initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0_shared_constants_actionTypes__["n" /* USER */].SET_SESSION:
      return user__extends({}, state, {
        token: action.payload
      });

    case __WEBPACK_IMPORTED_MODULE_0_shared_constants_actionTypes__["n" /* USER */].SET_USER:
      {
        return user__extends({}, state, {
          user: user__extends({}, state.user, action.payload)
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0_shared_constants_actionTypes__["n" /* USER */].SET_PHONE:
      {
        var thatPhones = state.user.phones.filter(function (phone) {
          return phone.number !== action.payload.number;
        });
        var phones = [].concat(user__toConsumableArray(thatPhones), [action.payload]).map(function (dat) {
          return user__extends({}, dat, {
            number: __WEBPACK_IMPORTED_MODULE_1_shared_modules__["j" /* phoneNormalize */](dat.number)
          });
        });
        return user__extends({}, state, {
          user: user__extends({}, state.user, {
            phones: phones
          })
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0_shared_constants_actionTypes__["n" /* USER */].ERROR:
      {
        return user__extends({}, state, {
          error: action.payload
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0_shared_constants_actionTypes__["n" /* USER */].REMOVE_PHONE:
      {
        return user__extends({}, state, {
          user: user__extends({}, state.user, {
            phones: state.user.phones.filter(function (phone) {
              if (phone.number === action.payload.number) {
                return false;
              }
              return phone.id !== action.payload;
            })
          })
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0_shared_constants_actionTypes__["n" /* USER */].SET_BALANCE:
      return user__extends({}, state, {
        balance: user__extends({}, state.balance, {
          amount: action.payload
        })
      });

    case __WEBPACK_IMPORTED_MODULE_0_shared_constants_actionTypes__["n" /* USER */].SET_BALANCE_IS_FETCHING:
      return user__extends({}, state, {
        balance: user__extends({}, state.balance, {
          isFetching: !!action.payload
        })
      });

    case __WEBPACK_IMPORTED_MODULE_0_shared_constants_actionTypes__["n" /* USER */].LOGOUT:
      {
        return user_initialState;
      }
    case __WEBPACK_IMPORTED_MODULE_0_shared_constants_actionTypes__["n" /* USER */].REGISTRATION:
      {
        return user__extends({}, state, {
          user: action.payload
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0_shared_constants_actionTypes__["n" /* USER */].BEFORE_REGISTRATION:
      {
        return user__extends({}, state, {
          beforeRegistration: action.payload ? user__extends({}, state.beforeRegistration, action.payload) : {}
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0_shared_constants_actionTypes__["n" /* USER */].SET_SAVED_SEARCHES:
      return user__extends({}, state, {
        savedSearches: action.payload
      });

    case __WEBPACK_IMPORTED_MODULE_0_shared_constants_actionTypes__["n" /* USER */].SET_SHOW_SAVE_SEARCH_BTN:
      return user__extends({}, state, {
        showSaveSearchBtn: action.payload
      });

    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/shared/reducers/history.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__ = __webpack_require__(17);
var history__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var history_initialState = {
  previousPath: null,
  currentPath: null,
  previousRouteName: null,
  currentRouteName: null,
  nextSearchItemIndex: null
};

var history = function history() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : history_initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["e" /* HISTORY */].CURRENT_PATH_SET:
      return history__extends({}, state, { currentPath: action.payload });

    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["e" /* HISTORY */].PREVIOUS_ROUTE_NAME_SET:
      return history__extends({}, state, { previousRouteName: action.payload });

    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["e" /* HISTORY */].CURRENT_ROUTE_NAME_SET:
      return history__extends({}, state, { currentRouteName: action.payload });

    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["e" /* HISTORY */].PREVIOUS_PATH_SET:
      return history__extends({}, state, { previousPath: action.payload });

    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["e" /* HISTORY */].NEXT_SEARCH_ITEM_INDEX:
      return history__extends({}, state, { nextSearchItemIndex: action.payload });

    default:
      return state;
  }
};

/* harmony default export */ var history_defaultExport = (history);
// CONCATENATED MODULE: ./src/shared/reducers/homeSpecialCars.js
/* harmony import */ var homeSpecialCars___WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__ = __webpack_require__(17);
var homeSpecialCars__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var homeSpecialCars_initialState = null;

var homeSpecialCars = function homeSpecialCars() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : homeSpecialCars_initialState;
  var action = arguments[1];

  switch (action.type) {
    case homeSpecialCars___WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["h" /* HOME_SPECIAL_CARS */].SET:
      return homeSpecialCars__extends({}, action.payload);
    default:
      return state;
  }
};

/* harmony default export */ var homeSpecialCars_defaultExport = (homeSpecialCars);
// CONCATENATED MODULE: ./src/shared/reducers/homeNews.js
/* harmony import */ var homeNews___WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__ = __webpack_require__(17);
function homeNews__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



var homeNews_initialState = null;

var homeNews = function homeNews() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : homeNews_initialState;
  var action = arguments[1];

  switch (action.type) {
    case homeNews___WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["g" /* HOME_NEWS */].SET:
      return [].concat(homeNews__toConsumableArray(action.payload));
    default:
      return state;
  }
};

/* harmony default export */ var homeNews_defaultExport = (homeNews);
// CONCATENATED MODULE: ./src/shared/reducers/homeCounters.js
/* harmony import */ var homeCounters___WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__ = __webpack_require__(17);
var homeCounters__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var homeCounters_initialState = null;

var homeCounters = function homeCounters() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : homeCounters_initialState;
  var action = arguments[1];

  switch (action.type) {
    case homeCounters___WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["f" /* HOME_COUNTERS */].SET:
      return homeCounters__extends({}, action.payload);
    default:
      return state;
  }
};

/* harmony default export */ var homeCounters_defaultExport = (homeCounters);
// CONCATENATED MODULE: ./src/shared/reducers/advertTopCars.js
/* harmony import */ var advertTopCars___WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__ = __webpack_require__(17);
var advertTopCars__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var advertTopCars_initialState = null;

var advertTopCars = function advertTopCars() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : advertTopCars_initialState;
  var action = arguments[1];

  switch (action.type) {
    case advertTopCars___WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["b" /* ADVERT_TOP_CARS */].SET:
      return advertTopCars__extends({}, state, action.payload);
    default:
      return state;
  }
};

/* harmony default export */ var advertTopCars_defaultExport = (advertTopCars);
// CONCATENATED MODULE: ./src/shared/reducers/motoAdverts.js
/* harmony import */ var motoAdverts___WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__ = __webpack_require__(17);
var motoAdverts__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var motoAdverts_initialState = null;

var motoAdverts = function motoAdverts() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : motoAdverts_initialState;
  var action = arguments[1];

  switch (action.type) {
    case motoAdverts___WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["k" /* MOTO_SET_ADVERTS */].SET:
      return motoAdverts__extends({}, state, action.payload);
    default:
      return state;
  }
};

/* harmony default export */ var motoAdverts_defaultExport = (motoAdverts);
// CONCATENATED MODULE: ./src/shared/reducers/globals.js
/* harmony import */ var globals___WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__ = __webpack_require__(17);
var globals__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _handleActions, _handleActions2;

var globals__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function globals__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var createNoopReducer = function createNoopReducer(defaultValue) {
  return function (state) {
    return state || defaultValue;
  };
};

var globals_initialState = {
  location: null,
  locale: null,
  ratio: null,
  stateDataLayer: [],
  banner: {
    slot_1: false,
    bannerNotErr: {}
  },
  fingerprint: '',
  redirectUrl: '',
  targeting: {},
  isBot: false,
  paymentModalId: '',
  dealerSlug: null,
  journal: {
    rubrics: null,
    news: null,
    videoTopics: [],
    videoOrderBy: {
      id: 'new',
      title: 'Самые новые',
      slug: 'new'
    },
    videoFilters: {
      make: null,
      model: null,
      generation: null,
      topic: null
    },
    selVideoParams: null,
    selVideoData: null
  },
  seoSearchUrlResponse: null,
  seoText: null,
  promoteInSocial: 0,
  insurance: {
    regions: null,
    filters: null,
    selectedValues: {},
    selectedOffer: null,
    offersData: null,
    orderWithHash: null,
    orders: [],
    isNumberBlock: false,
    editOrder: null,
    fillData: null,
    makes: [],
    isShowConfirmModal: false
  },
  isApprovePub: false
};

function insurance() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : globals_initialState.insurance;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["d" /* GLOBALS */].SET_SELECTED_OFFER:
      return globals__extends({}, state, {
        selectedOffer: action.payload
      });
    case __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["d" /* GLOBALS */].SET_INSURANCE_MAKES:
      return globals__extends({}, state, {
        makes: action.payload
      });
    case __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["d" /* GLOBALS */].SET_FILL_DATA:
      return globals__extends({}, state, {
        fillData: action.payload
      });
    case __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["d" /* GLOBALS */].SET_ORDER_WITH_HASH:
      return globals__extends({}, state, {
        orderWithHash: action.payload
      });
    case __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["d" /* GLOBALS */].SET_SELECTED_VALUES:
      return globals__extends({}, state, {
        selectedValues: action.payload
      });
    case __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["d" /* GLOBALS */].SET_OFFERS_DATA:
      return globals__extends({}, state, {
        offersData: action.payload
      });
    case __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["d" /* GLOBALS */].SET_INSURANCE_REGIONS:
      return globals__extends({}, state, {
        regions: action.payload
      });
    case __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["d" /* GLOBALS */].SET_INSURANCE_ORDERS:
      return globals__extends({}, state, {
        orders: action.payload
      });
    case __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["d" /* GLOBALS */].SET_IS_NUMBER_BLOCK:
      return globals__extends({}, state, {
        isNumberBlock: action.payload
      });
    case __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["d" /* GLOBALS */].SET_SHOW_CONFIRM_MODAL:
      return globals__extends({}, state, {
        isShowConfirmModal: action.payload
      });
    case __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["d" /* GLOBALS */].SET_ORDER_FOR_EDIT:
      return globals__extends({}, state, {
        editOrder: action.payload
      });
    case __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["d" /* GLOBALS */].SET_INSURANCE_FILTERS:
      return globals__extends({}, state, {
        filters: action.payload
      });
    default:
      return state;
  }
}

var journal = globals___WEBPACK_IMPORTED_MODULE_0_redux_actions__["d" /* handleActions */]((_handleActions = {}, globals__defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_2_shared_actions_globals__["h" /* journal */].setRubrics, function (state, action) {
  return globals__extends({}, state, { rubrics: action.payload });
}), globals__defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["i" /* JOURNAL */].SET_NEWS, function (state, action) {
  return globals__extends({}, state, { news: action.payload });
}), globals__defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["i" /* JOURNAL */].SET_VIDEO_TOPICS, function (state, action) {
  return globals__extends({}, state, { videoTopics: action.payload });
}), globals__defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["i" /* JOURNAL */].SET_VIDEO_HEAD_FILTER, function (state, action) {
  return globals__extends({}, state, {
    videoOrderBy: action.payload
  });
}), globals__defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["i" /* JOURNAL */].SET_VIDEO_FILTERS, function (state, action) {
  return globals__extends({}, state, { videoFilters: action.payload });
}), globals__defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["i" /* JOURNAL */].SET_SELECTED_VIDEO_PARAMS, function (state, action) {
  return globals__extends({}, state, {
    selVideoParams: action.payload
  });
}), globals__defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["i" /* JOURNAL */].SET_SELECTED_VIDEO_DATA, function (state, action) {
  return globals__extends({}, state, {
    selVideoData: action.payload
  });
}), _handleActions), globals_initialState.journal);

var promoteInSocial = globals___WEBPACK_IMPORTED_MODULE_0_redux_actions__["c" /* handleAction */](__WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["d" /* GLOBALS */].PROMOTE_IN_SOCIAL_SET, function (state, action) {
  return action.payload;
}, globals_initialState.promoteInSocial);
var fingerprint = globals___WEBPACK_IMPORTED_MODULE_0_redux_actions__["c" /* handleAction */](__WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["d" /* GLOBALS */].FINGERPRINT_SET, function (state, action) {
  return action.payload;
}, globals_initialState.fingerprint);
var redirectUrl = globals___WEBPACK_IMPORTED_MODULE_0_redux_actions__["c" /* handleAction */](__WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["d" /* GLOBALS */].SET_REDIRECT_URL, function (state, action) {
  return action.payload;
}, globals_initialState.redirectUrl);
var globals_location = globals___WEBPACK_IMPORTED_MODULE_0_redux_actions__["c" /* handleAction */](__WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["d" /* GLOBALS */].LOCATION_SET, function (state, action) {
  return action.payload;
}, globals_initialState.location);
var ratio = globals___WEBPACK_IMPORTED_MODULE_0_redux_actions__["c" /* handleAction */](__WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["d" /* GLOBALS */].RATIO_SET, function (state, action) {
  return action.payload;
}, globals_initialState.ratio);
var targeting = globals___WEBPACK_IMPORTED_MODULE_0_redux_actions__["c" /* handleAction */](__WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["d" /* GLOBALS */].TARGETING_ARGUMENTS_SET, function (state, action) {
  return globals__extends({}, state, { targetingSlot: action.payload });
}, globals_initialState.targeting);
var seoSearchUrlResponse = globals___WEBPACK_IMPORTED_MODULE_0_redux_actions__["c" /* handleAction */](__WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["d" /* GLOBALS */].SEO_SEARCH_URLS, function (state, action) {
  return action.payload;
}, globals_initialState.targeting);
var paymentModalId = globals___WEBPACK_IMPORTED_MODULE_0_redux_actions__["c" /* handleAction */](__WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["d" /* GLOBALS */].PAYMENT_SET_MODAL, function (state, action) {
  return action.payload;
}, globals_initialState.paymentModalId);
var seoText = globals___WEBPACK_IMPORTED_MODULE_0_redux_actions__["c" /* handleAction */](__WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["d" /* GLOBALS */].SEO_TEXT_SET, function (state, action) {
  return globals__extends({}, action.payload);
}, globals_initialState.seoSearchUrlResponse);
var stateDataLayer = globals___WEBPACK_IMPORTED_MODULE_0_redux_actions__["c" /* handleAction */](__WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["d" /* GLOBALS */].DATA_LAYER_SET, function (state, action) {
  var payload = globals__extends({}, action.payload);
  if ((typeof window === 'undefined' ? 'undefined' : globals__typeof(window)) === 'object' && window.dataLayer && Array.isArray(window.dataLayer)) {
    if (payload && 'url' in payload) {
      delete payload.url;
    }
    window.dataLayer.push(payload);
  }
  return globals__extends({}, state, payload);
}, globals_initialState.stateDataLayer);
var banner = globals___WEBPACK_IMPORTED_MODULE_0_redux_actions__["d" /* handleActions */]((_handleActions2 = {}, globals__defineProperty(_handleActions2, __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["d" /* GLOBALS */].BANNER_SHOW, function (state) {
  return globals__extends({}, state, { slot_1: true });
}), globals__defineProperty(_handleActions2, __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["d" /* GLOBALS */].BANNER_UPDATE, function (state, action) {
  var _action$payload = action.payload,
      id = _action$payload.id,
      addComponent = _action$payload.addComponent,
      deleteComponent = _action$payload.deleteComponent;

  var localState = globals__extends({}, state);
  if (deleteComponent) {
    localState.bannerNotErr[id] = false;
  }
  if (addComponent) {
    localState.bannerNotErr[id] = true;
  }
  return localState;
}), globals__defineProperty(_handleActions2, __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["d" /* GLOBALS */].BANNER_HIDE, function (state) {
  return globals__extends({}, state, { slot_1: false });
}), _handleActions2), globals_initialState.banner);

var dealerSlug = globals___WEBPACK_IMPORTED_MODULE_0_redux_actions__["c" /* handleAction */](__WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["d" /* GLOBALS */].DEALER_SLUG_SET, function (state, action) {
  return action.payload;
}, globals_initialState.dealerSlug);

var isApprovePub = globals___WEBPACK_IMPORTED_MODULE_0_redux_actions__["c" /* handleAction */](__WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["d" /* GLOBALS */].SET_IS_APPROVE_PUB, function (state, action) {
  return action.payload;
}, globals_initialState.isApprovePub);

/* harmony default export */ var globals_defaultExport = (__WEBPACK_IMPORTED_MODULE_1_redux__["c" /* combineReducers */]({
  location: globals_location,
  locale: createNoopReducer(globals_initialState.locale),
  targeting: targeting,
  seoSearchUrlResponse: seoSearchUrlResponse,
  stateDataLayer: stateDataLayer,
  ratio: ratio,
  banner: banner,
  fingerprint: fingerprint,
  redirectUrl: redirectUrl,
  isBot: createNoopReducer(globals_initialState.isBot),
  journal: journal,
  seoText: seoText,
  paymentModalId: paymentModalId,
  promoteInSocial: promoteInSocial,
  dealerSlug: dealerSlug,
  insurance: insurance,
  isApprovePub: isApprovePub
}));
// CONCATENATED MODULE: ./src/shared/reducers/favorites.js
/* harmony import */ var favorites___WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__ = __webpack_require__(17);
function favorites__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



var favorites_initialState = null;

var favorites = function favorites() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : favorites_initialState;
  var action = arguments[1];

  var safeState = state || [];

  switch (action.type) {
    case favorites___WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["c" /* FAVORITES */].SET:
      return [].concat(favorites__toConsumableArray(action.payload));
    case favorites___WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["c" /* FAVORITES */].ADD:
      return [].concat(favorites__toConsumableArray(safeState.filter(function (item) {
        return item !== action.payload;
      })), [action.payload]);
    case favorites___WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["c" /* FAVORITES */].REMOVE:
      return [].concat(favorites__toConsumableArray(safeState.filter(function (item) {
        return item !== action.payload;
      })));
    default:
      return state;
  }
};

/* harmony default export */ var favorites_defaultExport = (favorites);
// CONCATENATED MODULE: ./src/shared/reducers/notifications.js
/* harmony import */ var notifications___WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__ = __webpack_require__(17);
function notifications__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



var notifications_initialState = [];

var notifications = function notifications() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : notifications_initialState;
  var action = arguments[1];

  switch (action.type) {
    case notifications___WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["l" /* NOTIFICATIONS */].ENQUEUE:
      return [].concat(notifications__toConsumableArray(state), [action.payload]);

    case notifications___WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["l" /* NOTIFICATIONS */].SHIFT:
      return state.slice(1);

    default:
      return state;
  }
};

/* harmony default export */ var notifications_defaultExport = (notifications);
// CONCATENATED MODULE: ./src/shared/reducers/loading.js
/* harmony import */ var loading___WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__ = __webpack_require__(17);
var loading__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var loading_initialState = {
  start: false,
  done: false
};

var loading = function loading() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : loading_initialState;
  var action = arguments[1];

  switch (action.type) {
    case loading___WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["j" /* LOADING */].START:
      return loading__extends({}, state, {
        start: true,
        done: false
      });
    case loading___WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["j" /* LOADING */].DONE:
      return loading__extends({}, state, {
        start: false,
        done: true
      });
    case loading___WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["j" /* LOADING */].SET_INITIAL:
      return loading_initialState;
    default:
      return state;
  }
};

/* harmony default export */ var loading_defaultExport = (loading);
// CONCATENATED MODULE: ./src/desktop/reducers/index.js
/* harmony import */ var reducers___WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(67);
















/* harmony default export */ var reducers_defaultExport = (reducers___WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */]({
  advertForm: advertForm_defaultExport,
  partsForm: partsForm_defaultExport,
  searchForm: searchForm_defaultExport,
  user: user,
  history: history_defaultExport,
  homeSpecialCars: homeSpecialCars_defaultExport,
  homeNews: homeNews_defaultExport,
  homeCounters: homeCounters_defaultExport,
  advertTopCars: advertTopCars_defaultExport,
  motoAdverts: motoAdverts_defaultExport,
  globals: globals_defaultExport,
  notifications: notifications_defaultExport,
  favorites: favorites_defaultExport,
  loading: loading_defaultExport
}));
// CONCATENATED MODULE: ./src/DOMUtils.js


function updateTag(tagName, keyName, keyValue, attrName, attrValue) {
  var node = document.head.querySelector(tagName + '[' + keyName + '="' + keyValue + '"]');
  if (node && node.getAttribute(attrName) === attrValue) return;

  // Remove and create a new tag in order to make it work with bookmarks in Safari
  if (node && node.parentNode) {
    node.parentNode.removeChild(node);
  }
  if (typeof attrValue === 'string') {
    var nextNode = document.createElement(tagName);
    nextNode.setAttribute(keyName, keyValue);
    nextNode.setAttribute(attrName, attrValue);
    document.head.appendChild(nextNode);
  }
}

function updateMeta(name, content) {
  updateTag('meta', 'name', name, 'content', content);
}

function updateCustomMeta(property, content) {
  updateTag('meta', 'property', property, 'content', content);
}

function updateLink(rel, href) {
  updateTag('link', 'rel', rel, 'href', href);
}

function updateAlternateLink(lang, attrValue) {
  var node = document.head.querySelector('link[hrefLang="' + lang + '"]');
  if (node && node.getAttribute('link') === attrValue) return;

  // Remove and create a new tag in order to make it work with bookmarks in Safari
  if (node && node.parentNode) {
    node.parentNode.removeChild(node);
  }
  if (typeof attrValue === 'string') {
    var nextNode = document.createElement('link');
    nextNode.setAttribute('hrefLang', lang);
    nextNode.setAttribute('rel', 'alternate');
    nextNode.setAttribute('href', attrValue);
    document.head.appendChild(nextNode);
  }
}

function deleteTag(tagName, keyName, keyValue) {
  var node = document.head.querySelector(tagName + '[' + keyName + '="' + keyValue + '"]');
  if (node && node.parentNode) {
    node.parentNode.removeChild(node);
  }
}

function deleteLink(rel) {
  deleteTag('link', 'rel', rel);
}
// CONCATENATED MODULE: ./src/createRouter.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_universal_router__ = __webpack_require__(1165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_universal_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_universal_router__);




function createRouter(routes) {
  return new __WEBPACK_IMPORTED_MODULE_0_universal_router___default.a(routes, {
    resolveRoute: function resolveRoute(context, params) {
      if (typeof context.route.load === 'function') {
        return context.route.load().then(function (action) {
          return action.default && action.default(context, params);
        });
      }
      if (typeof context.route.action === 'function') {
        return context.route.action(context, params);
      }
      return null;
    }
  });
}
// CONCATENATED MODULE: ./src/desktop/routes/index.js
/* harmony import */ var routes___WEBPACK_IMPORTED_MODULE_0_query_string__ = __webpack_require__(33);
/* harmony import */ var routes___WEBPACK_IMPORTED_MODULE_0_query_string___default = __webpack_require__.n(routes___WEBPACK_IMPORTED_MODULE_0_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_helpers_routes__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_constants_locale__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_actions_history__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_actions_user__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_constants_staticPagesNavigation__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_constants_url__ = __webpack_require__(329);
function routes__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function routes__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* global __DEV__ */
/* eslint-disable global-require */










// Hacking due to a webpack bug.
// https://github.com/gaearon/react-hot-loader/issues/324
if (false) {
  // require('./add-parts');
  // require('./add');
  // require('./edit');
  // require('./login');
  // require('./advert');
  // require('./search');
  // require('./dealer');
  // require('./dealers');
  // require('./profile/my');
  // require('./profile/favorites');
  // require('./profile/billing');
  // require('./not-found');
  // require('./home');
  // require('./firms');
  // require('./firms/firm');
  // require('./invoice');
  // require('./auto-parts');
  // require('./journal/news-page');
  // require('./journal/news');
}

var searchPages = ['avto', 'mototsikl', 'skuter', 'kvadrotsikl', 'karting', 'moped', 'baggi', 'tritsikl', 'gruzovye', 'avtobus', 'pritsepy', 'spetstehnika', 'vodnyi-transport'].map(function (item) {
  return {
    path: '/' + item,
    name: 'search',
    children: [{
      path: '',
      name: item,
      load: function load() {
        return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 3317));
      }
    }, {
      path: '*',
      load: function load() {
        return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 3317));
      }
    }]
  };
});

var avtosalonyPages = ['mototsikl', 'pritsepy', 'avtobus', 'spetstehnika', 'gruzovye'].map(function (item) {
  return {
    path: '/' + item,
    name: 'dealers-' + item,
    children: [{
      path: '',
      name: item,
      load: function load() {
        return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 3318));
      }
    }, {
      path: '*',
      load: function load() {
        return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 3318));
      }
    }]
  };
});

var sparesPages = ['mototsikl', 'pritsepy', 'avtobus', 'spetstehnika', 'gruzovye'].map(function (item) {
  return {
    path: '/' + item,
    name: 'spares-' + item,
    children: [{
      path: '',
      name: item,
      load: function load() {
        return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 3319));
      }
    }, {
      path: '*',
      load: function load() {
        return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 3319));
      }
    }]
  };
});

var pages = __WEBPACK_IMPORTED_MODULE_6_shared_constants_staticPagesNavigation__["a" /* default */].map(function (_ref) {
  var slug = _ref.slug;
  return {
    path: '/' + slug.replace(/\//g, ''),
    load: function load() {
      return __webpack_require__(1232)("./" + slug.replace(/\//g, ''));
    }
  };
});

// The top-level (parent) route
var routes = {
  path: [].concat(routes__toConsumableArray(__WEBPACK_IMPORTED_MODULE_3_shared_constants_locale__["a" /* AVAILABLE_LOCALES */].slice(1).map(function (locale) {
    return '/' + locale;
  })), ['/']),

  // Keep in mind, routes are evaluated in order
  children: [{
    path: '/:locationSlug?',
    load: function load() {
      return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 3320));
    }
  }].concat(routes__toConsumableArray(pages), [{
    path: '/add/zapchasti',
    load: function load() {
      return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 3321));
    }
  }, {
    path: '/add/:transportSlug?',
    load: function load() {
      return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 3322));
    }
  }, {
    path: '/addv2/:transportSlug?',
    load: function load() {
      return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 3323));
    }
  }, {
    path: '/moto/:locationSlug?',
    load: function load() {
      return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 3324));
    }
  }, {
    path: '/commercial/:locationSlug?',
    load: function load() {
      return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 3325));
    }
  }], routes__toConsumableArray(searchPages), [{
    path: '/avtosalony',
    children: [{
      path: '',
      name: 'dealers',
      load: function load() {
        return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 3318));
      }
    }].concat(routes__toConsumableArray(avtosalonyPages), [{
      path: '*',
      name: 'dealers',
      load: function load() {
        return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 3318));
      }
    }, {
      path: '/:slug',
      // name: 'dealer',
      // load: () => import(/* webpackChunkName: 'dealer' */ './dealer'),
      children: [{
        path: '',
        name: 'dealer',
        load: function load() {
          return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 3326));
        }
      }, {
        path: '/blog',
        name: 'dealer-blog',
        load: function load() {
          return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 3327));
        }
      }, {
        path: '/about',
        name: 'dealer-about',
        load: function load() {
          return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 3328));
        }
      }]
    }])
  }, {
    path: '/edit/:id',
    name: 'edit',
    load: function load() {
      return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 3329));
    }
  }, {
    path: '/edit-parts/:id',
    name: 'edit',
    load: function load() {
      return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 3330));
    }
  }, {
    path: __WEBPACK_IMPORTED_MODULE_7_shared_constants_url__["a" /* default */].registration(),
    action: __WEBPACK_IMPORTED_MODULE_1_shared_helpers_routes__["c" /* loggedInRedirect */],
    children: [{
      path: '/',
      load: function load() {
        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 3331));
      }
    }]
  }, {
    path: __WEBPACK_IMPORTED_MODULE_7_shared_constants_url__["a" /* default */].login(),
    action: __WEBPACK_IMPORTED_MODULE_1_shared_helpers_routes__["c" /* loggedInRedirect */],
    children: [{
      path: '/',
      load: function load() {
        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 3331));
      }
    }]
  }, {
    path: __WEBPACK_IMPORTED_MODULE_7_shared_constants_url__["a" /* default */].recovery(),
    action: __WEBPACK_IMPORTED_MODULE_1_shared_helpers_routes__["c" /* loggedInRedirect */],
    children: [{
      path: '/',
      load: function load() {
        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 3331));
      }
    }]
  }, {
    path: '/profile',
    load: function load() {
      return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 3332));
    }
  }, {
    path: __WEBPACK_IMPORTED_MODULE_7_shared_constants_url__["a" /* default */].verify(),
    children: [{
      path: '',
      load: function load() {
        return __webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, 3331));
      }
    }]
  }, {
    path: '/katalog-kompaniy',
    children: [{
      path: '',
      load: function load() {
        return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 3333));
      }
    }, {
      path: '*',
      load: function load() {
        return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 3333));
      }
    }, {
      path: '/:id',
      children: [{
        path: '/:tab?',
        load: function load() {
          return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 3334));
        }
      }]
    }]
  }, {
    path: '/dialogs',
    children: [{
      path: '',
      load: function load() {
        return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 3335));
      }
    }, {
      path: '/:dialogId',
      load: function load() {
        return __webpack_require__.e/* import() */(25/* duplicate */).then(__webpack_require__.bind(null, 3335));
      }
    }]
  }, {
    path: '/service',
    children: [{
      path: '/ocenka-avto',
      load: function load() {
        return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 3336));
      }
    }, {
      path: '/prygon-avto',
      load: function load() {
        return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 3337));
      }
    }, {
      path: '/search-subscriptions',
      load: function load() {
        return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, 3338));
      }
    }, {
      path: '/:id',
      children: [{
        path: '/:tab?',
        load: function load() {
          return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 3339));
        }
      }]
    }, {
      path: '/',
      load: function load() {
        return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 3336));
      }
    }]
  }, {
    path: '/my',
    children: [{
      path: '',
      load: function load() {
        return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 3340));
      }
    }, {
      path: '/:type',
      load: function load() {
        return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 3340));
      }
    }]
  }, {
    path: '/zapchasti',
    children: [].concat(routes__toConsumableArray(sparesPages), [{
      path: '',
      load: function load() {
        return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 3319));
      }
    }, {
      path: '*',
      load: function load() {
        return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 3319));
      }
    }, {
      path: '/:id',
      load: function load() {
        return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 3341));
      }
    }])
  }, {
    path: '/billing',
    load: function load() {
      return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 3342));
    }
  }, {
    path: '/insurance',
    children: [{
      path: '',
      load: function load() {
        return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 3343));
      }
    }, {
      path: '/by-car-number',
      load: function load() {
        return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, 3344));
      }
    }, {
      path: '/by-car-parameters',
      load: function load() {
        return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 3345));
      }
    }, {
      path: '/registration-form',
      load: function load() {
        return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 3346));
      }
    }, {
      path: '/orders',
      load: function load() {
        return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, 3347));
      }
    }]
  }, {
    path: '/favorites/:transportSlug?',
    load: function load() {
      return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 3348));
    }
  }, {
    path: '/zhurnal',
    action: __WEBPACK_IMPORTED_MODULE_1_shared_helpers_routes__["a" /* fetchJournalRubrics */],
    children: [{
      path: '/video',
      load: function load() {
        return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 3349));
      }
    }, {
      path: '/video/*',
      load: function load() {
        return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 3349));
      }
    }, {
      path: '/:rubricSeoSlug?',
      load: function load() {
        return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 3350));
      }
    }, {
      path: '/:id',
      load: function load() {
        return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 3351));
      }
    }]
  }, {
    path: '/leasing',
    // action: fetchJournalRubrics,
    children: [{
      path: '/*',
      load: function load() {
        return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 3352));
      }
    }]
  }, {
    path: '/my-searches',
    load: function load() {
      return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 3353));
    }
  }, {
    path: '/:id',
    load: function load() {
      return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 3354));
    }
  },
  // {
  //   path: '/:slug/:advertId',
  //   name: 'dealer-advert',
  //   load: () => import(/* webpackChunkName: 'dealer' */ './dealer-page/advert'),
  // },

  {
    path: '/invoice',
    load: function load() {
      return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, 3355));
    }
  },

  // Wildcard routes, e.g. { path: '*', ... } (must go last)
  {
    path: '*',
    load: function load() {
      return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 3356));
    }
  }]),

  action: function action(_ref2) {
    var _this = this;

    var next = _ref2.next,
        store = _ref2.store,
        url = _ref2.url,
        query = _ref2.query,
        translate = _ref2.translate;
    return routes__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var route, pageTitlePart, previousPath, stringifiedQuery, newPath;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return next();

            case 3:
              route = _context.sent;


              // Provide default values for title, description etc.
              pageTitlePart = route.page > 1 ? ' - ' + translate('страница') + ' ' + route.page : '';


              route.title = '' + (route.title || 'avtobazar.ua') + pageTitlePart;
              route.description = '' + (route.description || '') + pageTitlePart;
              route.url = url || '';
              route.query = query || {};

              // History
              previousPath = store.getState().history.currentPath;
              stringifiedQuery = routes___WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify(query);
              newPath = '' + url + (stringifiedQuery && '?' + stringifiedQuery);


              if (newPath !== previousPath) {
                if (previousPath) {
                  store.dispatch(__WEBPACK_IMPORTED_MODULE_4_shared_actions_history__["d" /* setPreviousPath */](previousPath));
                }
                store.dispatch(__WEBPACK_IMPORTED_MODULE_4_shared_actions_history__["a" /* setCurrentPath */](newPath));
                store.dispatch(__WEBPACK_IMPORTED_MODULE_4_shared_actions_history__["b" /* setCurrentRouteName */](route.routeName || null));
              }

              return _context.abrupt('return', route);

            case 16:
              _context.prev = 16;
              _context.t0 = _context['catch'](0);

              if (!(_context.t0 instanceof UnauthorizedError_defaultExport)) {
                _context.next = 21;
                break;
              }

              store.dispatch(__WEBPACK_IMPORTED_MODULE_5_shared_actions_user__["t" /* userLogout */]());

              return _context.abrupt('return', { redirect: '/login' });

            case 21:
              throw _context.t0;

            case 22:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 16]]);
    }))();
  }
};

// The error page is available by permanent url for development mode
if (false) {
  routes.children.unshift({
    path: '/error',
    action: require('./error').default
  });
}

/* harmony default export */ var routes_defaultExport = (routes);
// CONCATENATED MODULE: ./src/desktop/client.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_whatwg_fetch__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_deep_force_update__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_deep_force_update___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_deep_force_update__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_history_PathUtils__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_history_PathUtils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_history_PathUtils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl_locale_data_ru__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl_locale_data_ru___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_intl_locale_data_ru__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl_locale_data_uk__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl_locale_data_uk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_intl_locale_data_uk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_js_cookie__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__sentry_react__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_components_App__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_helpers_rtbHouse__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_select__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_share__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_share___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react_share__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_buffer__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_buffer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_buffer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_lazyload__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_sticky__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_sticky___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react_sticky__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_input_mask__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_scroll__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_react_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__history__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__shared_constants_locale__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__shared_helpers_locale__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__shared_helpers_common__ = __webpack_require__(184);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var client__this = this;

var client__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Re-render the app when window.location changes
var onLocationChange = function () {
  var _ref2 = client__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(location, action) {
    var body, brandingLink, pageWrapperEl, fakeSubHeader, dealerRootPath, host, appHost, locationPath, route, errorMesg;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            // Remember the latest scroll position for the previous location
            scrollPositionsHistory[currentLocation.key] = {
              scrollX: window.pageXOffset,
              scrollY: window.pageYOffset
            };
            // Delete stored scroll position for next page if any
            if (action === 'PUSH') {
              delete scrollPositionsHistory[location.key];
            }
            currentLocation = location;

            // Clear branding
            body = document.getElementsByTagName('body')[0];

            body.style.cssText = {};
            brandingLink = document.getElementById('takeover_Skin');

            if (brandingLink) {
              brandingLink.remove();
            }

            pageWrapperEl = document.getElementById('pageWrapperId');

            if (pageWrapperEl) {
              pageWrapperEl.style.cssText = {};
            }

            fakeSubHeader = document.getElementById('fakeSubHeader');

            if (fakeSubHeader) {
              fakeSubHeader.style.cssText = {};
            }

            _context2.next = 13;
            return loadLocalePromise;

          case 13:
            _context2.prev = 13;

            /*
            Далі описан брудний хак, який потрібен для роботоздатності персональних субдоменів салонів и фірм.
            Персональні сторінки салонів доступні по шляху /<dealer_slug>/. Для кожного салону ми заводимо
            субдомен. Таким чином, нам потрібно щоб сайт салона був за адресою <dealer_slug>.ab.ua, а не за адресою
            <dealer_slug>.ab.ua/<dealer_slug>.
            Для цього в конфігі субдомену для `location /` прописан proxy_pass на /<dealer_slug>. І все працює добре, але
            спочатку віддається потрібна сторінка салону, а потім з'являється інша сторінка ab.ua.
            На прикладі сторінки about: спочатку ми бачимо сторінку /<dealer_slug>/about, а потім /about.
            Пролема в тому, що першу сторінку віддає сервер. На сервер потрапляє правильний шлях, який описан в proxy_pass.
            Далі спрацьовує роутинг клієнта, але урл в нас не /<dealer_slug>/about, а /about. Тому і завантажується
            зовсім інша сторінка.
             Для вирішення цієї проблеми було зроблено наступний хак:
            * в конфігі nginx додається header dealer-slug з потрібним слагом салона;
            * в src/server.js цей хідер записується в store.globals;
            * нижче в коді цей слаг додається до поточного шляху, щоб визначити корректний клієнтський роут.
            * на сторінках салонів about, blog, advert, news, при наявності в сторі dealerSlug, з поточного урла
            прибирається слаг салона, щоб усі посилання були /about, а не <dealer_slug>/about.
            */
            dealerRootPath = client_dealerSlug ? '/' + client_dealerSlug : '';

            // Когда открывается страница под не "родным" доменом, скрипт не должен выполнятся.
            // Сделано, чтобы избежать редиректа, описание проблемы: https://github.com/remix-run/react-router/issues/5801

            host = window && window.location && window.location.host;
            appHost = window && window.App && window.App.host;

            if (!(host !== appHost && host !== 'avtobazar.ua')) {
              _context2.next = 19;
              break;
            }

            return _context2.abrupt('return', false);

          case 19:

            // Traverses the list of routes in the order they are defined until
            // it finds the first route that matches provided URL path string
            // and whose action method returns anything other than `undefined`.
            locationPath = location.pathname && location.pathname.startsWith(dealerRootPath) ? location.pathname : '' + dealerRootPath + location.pathname;
            _context2.next = 22;
            return router.resolve(client__extends({}, context, {
              path: locationPath,
              query: __WEBPACK_IMPORTED_MODULE_4_query_string___default.a.parse(location.search),
              translate: client_translate
            }));

          case 22:
            route = _context2.sent;

            if (!(currentLocation.key !== location.key)) {
              _context2.next = 25;
              break;
            }

            return _context2.abrupt('return', true);

          case 25:
            if (!route.redirect) {
              _context2.next = 28;
              break;
            }

            __WEBPACK_IMPORTED_MODULE_26__history__["a" /* default */].replace(route.redirect);
            return _context2.abrupt('return', true);

          case 28:

            __WEBPACK_IMPORTED_MODULE_13_shared_helpers_rtbHouse__["b" /* fireRTBPageView */](locationPath);

            appInstance = __WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.hydrate(_jsx(__WEBPACK_IMPORTED_MODULE_6_react_intl__["b" /* IntlProvider */], {
              locale: locale,
              messages: client__extends({}, messages, metaTegs)
            }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_12_shared_components_App__["b" /* default */], {
              context: context
            }, void 0, route.component)), container, function () {
              return onRenderComplete(route, location);
            });
            _context2.next = 38;
            break;

          case 32:
            _context2.prev = 32;
            _context2.t0 = _context2['catch'](13);
            errorMesg = _context2.t0 && _context2.t0.messages || '';

            if (true) {
              _context2.next = 37;
              break;
            }

            throw _context2.t0;

          case 37:

            // Do a full page reload if error occurs during client-side navigation
            if (action && currentLocation.key === location.key) {
              window.location.reload();
            }

          case 38:
            return _context2.abrupt('return', false);

          case 39:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this, [[13, 32]]);
  }));

  return function onLocationChange(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();

// Handle client-side navigation by using HTML5 History API
// For more information visit https://github.com/mjackson/history#readme


function client__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function client__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/* eslint-disable no-unused-vars */
/* global __DEV__ */
















// For vendor.js





















if (!false && window.App.sentryDSN) {
  __WEBPACK_IMPORTED_MODULE_11__sentry_react__["b" /* init */]({ dsn: window.App.sentryDSN });
}

var originalConsoleError = function originalConsoleError() {};

console.error = function () {};

__WEBPACK_IMPORTED_MODULE_32__shared_helpers_common__["c" /* disableReactIntlLocaleErrors */](console);
var router = createRouter(routes_defaultExport);
var fetch = createFetch_defaultExport(self.fetch, {
  baseUrl: window.App.apiUrl,
  /* Basic authorization  */
  defaultAuth: '' /* window.App.defaultAuth */
});

// GTM

// Intl
var _window$App$state$glo = window.App.state.globals,
    locale = _window$App$state$glo.locale,
    client_dealerSlug = _window$App$state$glo.dealerSlug;

var messages = {};
var client_translate = null;
var metaTegs = {};

var loadLocalePromise = client__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
  return regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return __webpack_require__(1233)("./" + locale + '.json');

        case 2:
          messages = _context.sent;
          _context.next = 5;
          return __webpack_require__(1234)("./" + locale + '.json');

        case 5:
          metaTegs = _context.sent;

          client_translate = __WEBPACK_IMPORTED_MODULE_31__shared_helpers_locale__["a" /* curriedTranslate */](client__extends({}, messages, metaTegs));

        case 7:
        case 'end':
          return _context.stop();
      }
    }
  }, _callee, client__this);
}))();

/* eslint-disable global-require */

/* cookies for Rete scripts */
__WEBPACK_IMPORTED_MODULE_10_js_cookie__["set"]('rete-force-tracking', 'true');

// Global (context) variables that can be easily accessed from any React component
// https://facebook.github.io/react/docs/context.html
var client_store = configureStore(window.App.state, reducers_defaultExport, { history: __WEBPACK_IMPORTED_MODULE_26__history__["a" /* default */], fetch: fetch });
var context = {
  // Enables critical path CSS rendering
  // https://github.com/kriasoft/isomorphic-style-loader
  insertCss: function insertCss() {
    for (var _len = arguments.length, styles = Array(_len), _key = 0; _key < _len; _key++) {
      styles[_key] = arguments[_key];
    }

    // eslint-disable-next-line no-underscore-dangle
    var removeCss = styles.map(function (x) {
      return x._insertCss();
    });
    return function () {
      removeCss.forEach(function (f) {
        return f();
      });
    };
  },
  // Universal HTTP client
  fetch: fetch,
  // Initialize a new Redux store
  // http://redux.js.org/docs/basics/UsageWithReact.html
  store: client_store,
  storeSubscription: null
};

// Locale
__WEBPACK_IMPORTED_MODULE_6_react_intl__["c" /* addLocaleData */]([].concat(client__toConsumableArray(__WEBPACK_IMPORTED_MODULE_7_react_intl_locale_data_ru___default.a), client__toConsumableArray(__WEBPACK_IMPORTED_MODULE_8_react_intl_locale_data_uk___default.a)));
window.App.dispatch = client_store.dispatch;
window.App.getState = client_store.getState;
if (!window.AbStor) window.AbStor = {};
// Fingerprint
client_store.dispatch(__WEBPACK_IMPORTED_MODULE_25__shared_actions_globals__["l" /* setFingerprint */]());

// Switch off the native scroll restoration behavior and handle it manually
// https://developers.google.com/web/updates/2015/09/history-api-scroll-restoration
var scrollPositionsHistory = {};
if (window.history && 'scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

var onRenderComplete = function initialRenderComplete() {
  var elem = document.getElementById('css');
  if (elem && elem.parentNode) elem.parentNode.removeChild(elem);
  onRenderComplete = function renderComplete(route, location) {
    document.title = route.title;
    updateCustomMeta('og:title', route.title);
    updateMeta('description', route.description);
    updateCustomMeta('og:description', route.description);

    var _metaBuilder = metaBuilder_defaultExport(route),
        isAdvertPage = _metaBuilder.isAdvertPage,
        pageNumber = _metaBuilder.pageNumber,
        shouldSetIndex = _metaBuilder.shouldSetIndex,
        shouldSetNoIndex = _metaBuilder.shouldSetNoIndex,
        stringifiedPrevQuery = _metaBuilder.stringifiedPrevQuery,
        stringifiedNextQuery = _metaBuilder.stringifiedNextQuery,
        stringifiedQuery = _metaBuilder.stringifiedQuery;

    var _window$location = window.location,
        protocol = _window$location.protocol,
        host = _window$location.host;

    var origin = protocol + '//' + host;
    var routeUrl = ('' + (route.url || '') + (isAdvertPage ? '' : '/')).replace('//', '/');

    // set or remove 'next' and 'prev' meta links
    if (pageNumber && stringifiedNextQuery) {
      updateLink('next', '' + origin + routeUrl + stringifiedNextQuery);
    } else {
      deleteLink('next');
    }
    if (pageNumber && pageNumber !== 1) {
      updateLink('prev', '' + origin + routeUrl + stringifiedPrevQuery);
    } else {
      deleteLink('prev');
    }
    // set or remove 'noindex' meta links
    if (shouldSetNoIndex) {
      updateMeta('robots', 'noindex, nofollow');
    } else if (shouldSetIndex) {
      updateMeta('robots', 'index, follow');
    } else {
      deleteTag('meta', 'name', 'robots');
    }
    // set or remove 'alternate' meta links
    __WEBPACK_IMPORTED_MODULE_30__shared_constants_locale__["a" /* AVAILABLE_LOCALES */].forEach(function (lang) {
      return updateAlternateLink(lang, '' + origin + __WEBPACK_IMPORTED_MODULE_31__shared_helpers_locale__["h" /* toLocalized */](__WEBPACK_IMPORTED_MODULE_31__shared_helpers_locale__["e" /* removeLocaleFromHref */](routeUrl), lang) + stringifiedQuery);
    });

    updateCustomMeta('og:url', '' + origin + routeUrl);
    // Update necessary tags in <head> at runtime here, ie:
    // updateMeta('keywords', route.keywords);
    updateCustomMeta('og:image', route.ogImage);
    // updateLink('canonical', route.canonicalUrl);
    // etc.

    var scrollX = 0;
    var scrollY = 0;
    var pos = scrollPositionsHistory[location.key];
    if (pos) {
      scrollX = pos.scrollX;
      scrollY = pos.scrollY;
    } else {
      var targetHash = location.hash.substr(1);
      if (targetHash) {
        var target = document.getElementById(targetHash);
        if (target && target.getBoundingClientRect && typeof target.getBoundingClientRect === 'function' && target.getBoundingClientRect() && target.getBoundingClientRect().top) {
          scrollY = window.pageYOffset + target.getBoundingClientRect().top;
        }
      }
    }

    // Restore the scroll position if it was saved into the state
    // or scroll to the given #hash anchor
    // or scroll to top of the page
    window.scrollTo(scrollX, scrollY);

    // Google Analytics tracking. Don't send 'pageview' event after
    // the initial rendering, as it was already sent
    if (window.ga && __WEBPACK_IMPORTED_MODULE_5_history_PathUtils___default.a) {
      window.ga('send', 'pageview', __WEBPACK_IMPORTED_MODULE_5_history_PathUtils___default.a.createPath(location));
    }
  };
};

var container = document.getElementById('app');
var appInstance = void 0;
var currentLocation = __WEBPACK_IMPORTED_MODULE_26__history__["a" /* default */].location;__WEBPACK_IMPORTED_MODULE_26__history__["a" /* default */].listen(onLocationChange);
onLocationChange(currentLocation);

// Enable Hot Module Replacement (HMR)
if (false) {
  module.hot.accept('./routes', function () {
    if (appInstance) {
      // Force-update the whole tree, including components that refuse to update
      deepForceUpdate(appInstance);
    }

    onLocationChange(currentLocation);
  });
}

/***/ }),

/***/ 783:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 791:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 798:
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},[574]);


// WEBPACK FOOTER //
// client.dbf8cba8.js